webpackJsonp([1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(565);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	exports.default = ErrorNotification;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/no-array-index-key */
	function ErrorNotification(props) {
	  return _jsx('div', {
	    className: 'notification is-danger',
	    role: 'alert'
	  }, void 0, props.dismissible && _jsx('button', {
	    className: 'delete',
	    'aria-label': 'Close',
	    onClick: function onClick() {
	      return props.onClose && props.onClose();
	    }
	  }), props.errors.map(function (error, i) {
	    return _jsx('p', {}, i, error.message);
	  }));
	}

/***/ },
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LOCAL_LOGOUT = exports.CONCEDO_CHECK = exports.CONCEDO_LOGIN = exports.RESET_RESULTANT_COHORTS = exports.GENERATE_RESOURCES = exports.RESET_SIMULATION_DASHBOARD = exports.TOGGLE_SIMULATION_STATUS = exports.GET_SIMULATION_REPORT = exports.SIMULATION_DASHBOARD = exports.DELETE_TOKEN = exports.DEACTIVATE_TOKEN = exports.ACTIVATE_TOKEN = exports.ADD_NEW_TOKEN = exports.GET_TOKEN_LIST = exports.SIMULATION_TAXI_TYPES = exports.RESOURCE_CREATION_ERROR = exports.SIMULATION_GET_REPORT = exports.START_SIMULATION = exports.FORWARD_GEO = exports.REVERSE_GEO = exports.VALIDATE_TOKEN = exports.LOGOUT = exports.LOGIN = exports.UNSET_ACTIVE_BOOKING = exports.SET_ACTIVE_BOOKING = exports.UNSET_NEWLY_CREATED_BOOKING = exports.DRIVER_DRAG = exports.CLOSE_DRIVER_FARE_MODAL = exports.SHOW_DRIVER_FARE_MODAL = exports.SHOW_DRIVER_LOCATION_MODAL = exports.SHOW_DRIVER_EDIT_MODAL = exports.SHOW_DRIVERS_MODAL = exports.SHOW_PASSENGER_EDIT_MODAL = exports.SHOW_PASSENGERS_MODAL = undefined;
	exports.showPassengersModal = showPassengersModal;
	exports.showPassengerEditModal = showPassengerEditModal;
	exports.showDriversModal = showDriversModal;
	exports.showDriverEditModal = showDriverEditModal;
	exports.showDriverLocationModal = showDriverLocationModal;
	exports.showDriverFareModal = showDriverFareModal;
	exports.closeDriverFareModal = closeDriverFareModal;
	exports.driverDrag = driverDrag;
	exports.unsetNewlyCreatedBooking = unsetNewlyCreatedBooking;
	exports.setActiveBooking = setActiveBooking;
	exports.unsetActiveBooking = unsetActiveBooking;
	exports.login = login;
	exports.logout = logout;
	exports.validateToken = validateToken;
	exports.reverseGeo = reverseGeo;
	exports.forwardGeo = forwardGeo;
	exports.startSimulation = startSimulation;
	exports.simulationReportLoad = simulationReportLoad;
	exports.resourceCreationError = resourceCreationError;
	exports.getTaxiTypes = getTaxiTypes;
	exports.getTokenList = getTokenList;
	exports.addNewToken = addNewToken;
	exports.activateToken = activateToken;
	exports.deactivateToken = deactivateToken;
	exports.deleteToken = deleteToken;
	exports.getSimulations = getSimulations;
	exports.getSimulationReport = getSimulationReport;
	exports.toggleSimulationStatus = toggleSimulationStatus;
	exports.resetSimulationDashboard = resetSimulationDashboard;
	exports.generateResources = generateResources;
	exports.resetResultantCohorts = resetResultantCohorts;
	exports.loginWithConcedo = loginWithConcedo;
	exports.checkConcedoToken = checkConcedoToken;
	exports.simpleLogout = simpleLogout;
	
	var _apiMiddleware = __webpack_require__(35);
	
	var _mapboxMiddleware = __webpack_require__(200);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SHOW_PASSENGERS_MODAL = exports.SHOW_PASSENGERS_MODAL = 'SHOW_PASSENGERS_MODAL';
	function showPassengersModal(show) {
	  return {
	    type: SHOW_PASSENGERS_MODAL,
	    payload: show
	  };
	}
	
	var SHOW_PASSENGER_EDIT_MODAL = exports.SHOW_PASSENGER_EDIT_MODAL = 'SHOW_PASSENGER_EDIT_MODAL';
	function showPassengerEditModal(passengerID) {
	  return {
	    type: SHOW_PASSENGER_EDIT_MODAL,
	    payload: passengerID
	  };
	}
	
	var SHOW_DRIVERS_MODAL = exports.SHOW_DRIVERS_MODAL = 'SHOW_DRIVERS_MODAL';
	function showDriversModal(show) {
	  return {
	    type: SHOW_DRIVERS_MODAL,
	    payload: show
	  };
	}
	
	var SHOW_DRIVER_EDIT_MODAL = exports.SHOW_DRIVER_EDIT_MODAL = 'SHOW_DRIVER_EDIT_MODAL';
	function showDriverEditModal(driverID) {
	  return {
	    type: SHOW_DRIVER_EDIT_MODAL,
	    payload: driverID
	  };
	}
	
	var SHOW_DRIVER_LOCATION_MODAL = exports.SHOW_DRIVER_LOCATION_MODAL = 'SHOW_DRIVER_LOCATION_MODAL';
	function showDriverLocationModal(driverID) {
	  return {
	    type: SHOW_DRIVER_LOCATION_MODAL,
	    payload: driverID
	  };
	}
	
	var SHOW_DRIVER_FARE_MODAL = exports.SHOW_DRIVER_FARE_MODAL = 'SHOW_DRIVER_FARE_MODAL';
	function showDriverFareModal(driverID, bookingID) {
	  return {
	    type: SHOW_DRIVER_FARE_MODAL,
	    payload: {
	      driverID: driverID,
	      bookingID: bookingID
	    }
	  };
	}
	
	var CLOSE_DRIVER_FARE_MODAL = exports.CLOSE_DRIVER_FARE_MODAL = 'CLOSE_DRIVER_FARE_MODAL';
	function closeDriverFareModal() {
	  return {
	    type: CLOSE_DRIVER_FARE_MODAL,
	    payload: null
	  };
	}
	
	var DRIVER_DRAG = exports.DRIVER_DRAG = 'DRIVER_DRAG';
	function driverDrag(driverID) {
	  return {
	    type: DRIVER_DRAG,
	    payload: driverID
	  };
	}
	
	var UNSET_NEWLY_CREATED_BOOKING = exports.UNSET_NEWLY_CREATED_BOOKING = 'UNSET_NEWLY_CREATED_BOOKING';
	function unsetNewlyCreatedBooking() {
	  return {
	    type: UNSET_NEWLY_CREATED_BOOKING,
	    payload: null
	  };
	}
	
	var SET_ACTIVE_BOOKING = exports.SET_ACTIVE_BOOKING = 'SET_ACTIVE_BOOKING';
	function setActiveBooking(booking) {
	  return {
	    type: SET_ACTIVE_BOOKING,
	    payload: booking
	  };
	}
	
	var UNSET_ACTIVE_BOOKING = exports.UNSET_ACTIVE_BOOKING = 'UNSET_ACTIVE_BOOKING';
	function unsetActiveBooking() {
	  return {
	    type: UNSET_ACTIVE_BOOKING,
	    payload: null
	  };
	}
	
	var LOGIN = exports.LOGIN = 'LOGIN';
	function login(username, password) {
	  return {
	    type: LOGIN,
	    payload: {
	      method: 'POST',
	      url: '/tokens/new',
	      data: {
	        username: username,
	        password: password
	      }
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var LOGOUT = exports.LOGOUT = 'LOGOUT';
	function logout() {
	  return {
	    type: LOGOUT,
	    payload: {
	      method: 'DELETE',
	      url: '/tokens/delete'
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var VALIDATE_TOKEN = exports.VALIDATE_TOKEN = 'VALIDATE_TOKEN';
	function validateToken() {
	  return {
	    type: VALIDATE_TOKEN,
	    payload: {
	      method: 'POST',
	      url: '/tokens/validate'
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var REVERSE_GEO = exports.REVERSE_GEO = 'REVERSE_GEO';
	function reverseGeo(location) {
	  return {
	    type: REVERSE_GEO,
	    payload: {
	      query: 'reverseGeocode',
	      params: {
	        query: location,
	        limit: 1
	      }
	    },
	    meta: _defineProperty({}, _mapboxMiddleware.MAPBOX_REQUEST, true)
	  };
	}
	
	var FORWARD_GEO = exports.FORWARD_GEO = 'FORWARD_GEO';
	function forwardGeo(locationQuery, city, loc) {
	  return {
	    type: FORWARD_GEO,
	    payload: {
	      query: 'forwardGeocode',
	      params: {
	        query: locationQuery,
	        limit: 5,
	        countries: [city],
	        proximity: loc
	      }
	    },
	    meta: _defineProperty({}, _mapboxMiddleware.MAPBOX_REQUEST, true)
	  };
	}
	
	var START_SIMULATION = exports.START_SIMULATION = 'START_SIMULATION';
	function startSimulation(simulation) {
	  return {
	    type: START_SIMULATION,
	    payload: {
	      method: 'POST',
	      url: '/simulations/',
	      data: {
	        passengers: simulation.numPassengers,
	        drivers: simulation.numDrivers,
	        cityCode: simulation.city,
	        cohortID: simulation.cohortID,
	        timeout: simulation.timeout,
	        locationDistributor: simulation.locationDistributor,
	        taxiTypeDistribution: simulation.taxiTypeDistribution
	      }
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var SIMULATION_GET_REPORT = exports.SIMULATION_GET_REPORT = 'SIMULATION_GET_REPORT';
	function simulationReportLoad(successfulRides, totalBookings, successRate, allocationRate, passengerIDs, driverIDs, errors, timeoutEvent, bookings) {
	  return {
	    type: SIMULATION_GET_REPORT,
	    payload: {
	      successfulRides: successfulRides,
	      totalBookings: totalBookings,
	      successRate: successRate,
	      allocationRate: allocationRate,
	      passengerIDs: passengerIDs,
	      driverIDs: driverIDs,
	      errors: errors,
	      timeoutEvent: timeoutEvent,
	      bookings: bookings
	    }
	  };
	}
	
	var RESOURCE_CREATION_ERROR = exports.RESOURCE_CREATION_ERROR = 'RESOURCE_CREATION_ERROR';
	function resourceCreationError() {
	  return {
	    type: RESOURCE_CREATION_ERROR,
	    payload: null
	  };
	}
	
	var SIMULATION_TAXI_TYPES = exports.SIMULATION_TAXI_TYPES = 'SIMULATION_TAXI_TYPES';
	function getTaxiTypes(cityCode) {
	  return {
	    type: SIMULATION_TAXI_TYPES,
	    payload: {
	      method: 'GET',
	      url: '/simulations/available-taxi-types/'.concat(cityCode)
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var GET_TOKEN_LIST = exports.GET_TOKEN_LIST = 'GET_TOKEN_LIST';
	function getTokenList() {
	  return {
	    type: GET_TOKEN_LIST,
	    payload: {
	      method: 'GET',
	      url: '/tokens/'
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var ADD_NEW_TOKEN = exports.ADD_NEW_TOKEN = 'ADD_NEW_TOKEN';
	function addNewToken() {
	  return {
	    type: ADD_NEW_TOKEN,
	    payload: {
	      method: 'PUT',
	      url: '/tokens/add'
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var ACTIVATE_TOKEN = exports.ACTIVATE_TOKEN = 'ACTIVATE_TOKEN';
	function activateToken(token) {
	  return {
	    type: ACTIVATE_TOKEN,
	    payload: {
	      method: 'POST',
	      url: '/tokens/activate',
	      data: {
	        tokenID: token
	      }
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var DEACTIVATE_TOKEN = exports.DEACTIVATE_TOKEN = 'DEACTIVATE_TOKEN';
	function deactivateToken(token) {
	  return {
	    type: DEACTIVATE_TOKEN,
	    payload: {
	      method: 'POST',
	      url: '/tokens/deactivate',
	      data: {
	        tokenID: token
	      }
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var DELETE_TOKEN = exports.DELETE_TOKEN = 'DELETE_TOKEN';
	function deleteToken(token) {
	  return {
	    type: DELETE_TOKEN,
	    payload: {
	      method: 'DELETE',
	      url: '/tokens/remove',
	      data: {
	        tokenID: token
	      }
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var SIMULATION_DASHBOARD = exports.SIMULATION_DASHBOARD = 'SIMULATION_DASHBOARD';
	function getSimulations(status, searchLimit, exclusiveStartKey) {
	  return {
	    type: SIMULATION_DASHBOARD,
	    payload: {
	      method: 'POST',
	      url: '/simulations/dashboard?status=' + status.toString(10),
	      data: {
	        limit: searchLimit,
	        startKey: exclusiveStartKey
	      }
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var GET_SIMULATION_REPORT = exports.GET_SIMULATION_REPORT = 'GET_SIMULATION_REPORT';
	function getSimulationReport(simulationID) {
	  return {
	    type: GET_SIMULATION_REPORT,
	    payload: {
	      method: 'GET',
	      url: '/simulations/report/' + simulationID
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var TOGGLE_SIMULATION_STATUS = exports.TOGGLE_SIMULATION_STATUS = 'TOGGLE_SIMULATION_STATUS';
	function toggleSimulationStatus(status, searchLimit) {
	  return {
	    type: TOGGLE_SIMULATION_STATUS,
	    payload: {
	      method: 'POST',
	      url: '/simulations/dashboard?status=' + status.toString(10),
	      data: {
	        limit: searchLimit
	      }
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var RESET_SIMULATION_DASHBOARD = exports.RESET_SIMULATION_DASHBOARD = 'RESET_SIMULATION_DASHBOARD';
	function resetSimulationDashboard() {
	  return {
	    type: RESET_SIMULATION_DASHBOARD,
	    payload: null
	  };
	}
	
	var GENERATE_RESOURCES = exports.GENERATE_RESOURCES = 'GENERATE_RESOURCES';
	function generateResources(resourceGenerateRequest) {
	  var isShortLived = resourceGenerateRequest.shortLived === '0';
	  return {
	    type: GENERATE_RESOURCES,
	    payload: {
	      method: 'POST',
	      url: '/resources/create',
	      data: {
	        name: resourceGenerateRequest.name,
	        passengers: resourceGenerateRequest.numPassengers,
	        drivers: resourceGenerateRequest.numDrivers,
	        cityCode: resourceGenerateRequest.cityCode,
	        shortLived: isShortLived
	      }
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var RESET_RESULTANT_COHORTS = exports.RESET_RESULTANT_COHORTS = ' RESET_RESULTANT_COHORTS';
	function resetResultantCohorts() {
	  return {
	    type: RESET_RESULTANT_COHORTS,
	    payload: null
	  };
	}
	
	var CONCEDO_LOGIN = exports.CONCEDO_LOGIN = 'CONCEDO_LOGIN';
	function loginWithConcedo(authToken) {
	  return {
	    type: CONCEDO_LOGIN,
	    payload: {
	      method: 'POST',
	      url: '/concedo/new',
	      data: {
	        authToken: authToken
	      }
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var CONCEDO_CHECK = exports.CONCEDO_CHECK = 'CONCEDO_CHECK';
	function checkConcedoToken(concedoToken) {
	  return {
	    type: CONCEDO_CHECK,
	    payload: {
	      method: 'POST',
	      url: '/concedo/check',
	      data: {
	        concedoToken: concedoToken
	      }
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var LOCAL_LOGOUT = exports.LOCAL_LOGOUT = 'LOCAL_LOGOUT';
	function simpleLogout() {
	  return {
	    type: LOCAL_LOGOUT,
	    payload: null
	  };
	}

/***/ },
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DOWNLOAD_COHORT_YAML = exports.GET_COHORT_STATUS = exports.GET_COHORTS = exports.COHORT_DRIVER_UPDATE = exports.COHORT_DRIVER_ASSOCIATE = exports.COHORT_PASSENGER_UPDATE = exports.COHORT_PASSENGER_ASSOCIATE = exports.UNSET_COHORT = exports.COHORT_DELETE = exports.COHORT_GET = exports.COHORT_CREATE = undefined;
	exports.cohortCreate = cohortCreate;
	exports.cohortGet = cohortGet;
	exports.cohortDeleteInstant = cohortDeleteInstant;
	exports.cohortDelete = cohortDelete;
	exports.unsetCohort = unsetCohort;
	exports.cohortPassengerAssociateInstant = cohortPassengerAssociateInstant;
	exports.cohortPassengerAssociate = cohortPassengerAssociate;
	exports.cohortPassengerUpdate = cohortPassengerUpdate;
	exports.cohortDriverAssociateInstant = cohortDriverAssociateInstant;
	exports.cohortDriverAssociate = cohortDriverAssociate;
	exports.cohortDriverUpdate = cohortDriverUpdate;
	exports.getCohorts = getCohorts;
	exports.getCohorStatus = getCohorStatus;
	exports.downloadCohortYaml = downloadCohortYaml;
	
	var _reactGa = __webpack_require__(78);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _apiMiddleware = __webpack_require__(35);
	
	var _gaUtils = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var COHORT_CREATE = exports.COHORT_CREATE = 'COHORT_CREATE';
	function cohortCreate(cohortName) {
	  _reactGa2.default.event({
	    category: _gaUtils.COHORTS,
	    action: _gaUtils.COHORTS_ACTIONS.COHORT_CREATE
	  });
	  return {
	    type: COHORT_CREATE,
	    payload: {
	      method: 'POST',
	      url: '/cohorts/', // Trailing slash is needed.
	      data: {
	        paxType: 0,
	        name: cohortName
	      }
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var COHORT_GET = exports.COHORT_GET = 'COHORT_GET';
	function cohortGet(cohortID) {
	  var _meta2;
	
	  _reactGa2.default.event({
	    category: _gaUtils.COHORTS,
	    action: _gaUtils.COHORTS_ACTIONS.COHORT_GET
	  });
	  return {
	    type: COHORT_GET,
	    payload: {
	      method: 'GET',
	      url: '/cohorts/' + cohortID
	    },
	    meta: (_meta2 = {}, _defineProperty(_meta2, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta2, 'cohortID', cohortID), _meta2)
	  };
	}
	
	var COHORT_DELETE = exports.COHORT_DELETE = 'COHORT_DELETE';
	function cohortDeleteInstant(cohortID) {
	  return {
	    type: COHORT_DELETE,
	    payload: {
	      cohortID: cohortID
	    }
	  };
	}
	
	function cohortDelete(cohortID) {
	  var _meta3;
	
	  _reactGa2.default.event({
	    category: _gaUtils.COHORTS,
	    action: _gaUtils.COHORTS_ACTIONS.COHORT_DELETE
	  });
	  return {
	    type: COHORT_DELETE,
	    payload: {
	      method: 'DELETE',
	      url: '/cohorts/' + cohortID
	    },
	    meta: (_meta3 = {}, _defineProperty(_meta3, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta3, 'cohortID', cohortID), _meta3)
	  };
	}
	
	var UNSET_COHORT = exports.UNSET_COHORT = 'UNSET_COHORT';
	function unsetCohort(cohortID) {
	  _reactGa2.default.event({
	    category: _gaUtils.COHORTS,
	    action: _gaUtils.COHORTS_ACTIONS.UNSET_COHORT
	  });
	  return {
	    type: UNSET_COHORT,
	    payload: {
	      cohortID: cohortID
	    }
	  };
	}
	
	var COHORT_PASSENGER_ASSOCIATE = exports.COHORT_PASSENGER_ASSOCIATE = 'COHORT_PASSENGER_ASSOCIATE';
	function cohortPassengerAssociateInstant(cohortID, passengerID, passenger) {
	  return {
	    type: COHORT_PASSENGER_ASSOCIATE,
	    payload: {
	      cohortID: cohortID,
	      passengerID: passengerID,
	      passenger: passenger
	    }
	  };
	}
	
	function cohortPassengerAssociate(cohortID, passenger) {
	  var _meta4;
	
	  _reactGa2.default.event({
	    category: _gaUtils.COHORTS,
	    action: _gaUtils.COHORTS_ACTIONS.COHORT_PASSENGER_ASSOCIATE
	  });
	  return {
	    type: COHORT_PASSENGER_ASSOCIATE,
	    payload: {
	      method: 'POST',
	      url: '/cohorts/' + cohortID + '/passengers',
	      data: {
	        passengerID: passenger.cohortPassengerID,
	        apiToken: passenger.apiToken || ''
	      }
	    },
	    meta: (_meta4 = {}, _defineProperty(_meta4, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta4, 'cohortID', cohortID), _defineProperty(_meta4, 'passenger', passenger), _meta4)
	  };
	}
	
	var COHORT_PASSENGER_UPDATE = exports.COHORT_PASSENGER_UPDATE = 'COHORT_PASSENGER_UPDATE';
	function cohortPassengerUpdate(cohortID, passengerID, passenger) {
	  _reactGa2.default.event({
	    category: _gaUtils.COHORTS,
	    action: _gaUtils.COHORTS_ACTIONS.COHORT_PASSENGER_UPDATE
	  });
	  return {
	    type: COHORT_PASSENGER_UPDATE,
	    payload: {
	      cohortID: cohortID,
	      passengerID: passengerID,
	      passenger: passenger
	    }
	  };
	}
	
	var COHORT_DRIVER_ASSOCIATE = exports.COHORT_DRIVER_ASSOCIATE = 'COHORT_DRIVER_ASSOCIATE';
	function cohortDriverAssociateInstant(cohortID, driverID, driver) {
	  return {
	    type: COHORT_DRIVER_ASSOCIATE,
	    payload: {
	      cohortID: cohortID,
	      driverID: driverID,
	      driver: driver
	    }
	  };
	}
	
	function cohortDriverAssociate(cohortID, driver) {
	  var _meta5;
	
	  _reactGa2.default.event({
	    category: _gaUtils.COHORTS,
	    action: _gaUtils.COHORTS_ACTIONS.COHORT_DRIVER_ASSOCIATE
	  });
	  return {
	    type: COHORT_DRIVER_ASSOCIATE,
	    payload: {
	      method: 'POST',
	      url: '/cohorts/' + cohortID + '/drivers',
	      data: {
	        driverID: driver.cohortDriverID,
	        imei: driver.imei,
	        deviceID: driver.deviceID
	      }
	    },
	    meta: (_meta5 = {}, _defineProperty(_meta5, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta5, 'cohortID', cohortID), _defineProperty(_meta5, 'driver', driver), _meta5)
	  };
	}
	
	var COHORT_DRIVER_UPDATE = exports.COHORT_DRIVER_UPDATE = 'COHORT_DRIVER_UPDATE';
	function cohortDriverUpdate(cohortID, driverID, driver) {
	  _reactGa2.default.event({
	    category: _gaUtils.COHORTS,
	    action: _gaUtils.COHORTS_ACTIONS.COHORT_DRIVER_UPDATE
	  });
	  return {
	    type: COHORT_DRIVER_UPDATE,
	    payload: {
	      cohortID: cohortID,
	      driver: driver,
	      driverID: driverID
	    }
	  };
	}
	
	var GET_COHORTS = exports.GET_COHORTS = 'GET_COHORTS';
	function getCohorts(limit, lastOffset, initial) {
	  var _meta6;
	
	  var lastKey = lastOffset || '';
	  return {
	    type: GET_COHORTS,
	    payload: {
	      method: 'GET',
	      url: '/users/cohorts?limit=' + limit + '&lastOffset=' + lastKey
	    },
	    meta: (_meta6 = {}, _defineProperty(_meta6, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta6, 'initial', initial), _meta6)
	  };
	}
	
	var GET_COHORT_STATUS = exports.GET_COHORT_STATUS = 'GET_COHORT_STATUS';
	function getCohorStatus(cohortID, status, error) {
	  return {
	    type: GET_COHORT_STATUS,
	    payload: {
	      cohortID: cohortID,
	      status: status,
	      error: error
	    }
	  };
	}
	
	var DOWNLOAD_COHORT_YAML = exports.DOWNLOAD_COHORT_YAML = 'DOWNLOAD_COHORT_YAML';
	function downloadCohortYaml(cohortID) {
	  var _meta7;
	
	  return {
	    type: DOWNLOAD_COHORT_YAML,
	    payload: {
	      method: 'GET',
	      url: '/cohorts/yaml/' + cohortID
	    },
	    meta: (_meta7 = {}, _defineProperty(_meta7, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta7, 'cohortID', cohortID), _meta7)
	  };
	}

/***/ },
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ESCAPE_KEYCODE = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = withEscapeToDismiss;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ESCAPE_KEYCODE = exports.ESCAPE_KEYCODE = 27;
	
	function withEscapeToDismiss() {
	  return function (DecoratedComponent) {
	    return function (_Component) {
	      _inherits(_class2, _Component);
	
	      function _class2(props) {
	        _classCallCheck(this, _class2);
	
	        var _this = _possibleConstructorReturn(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).call(this, props));
	
	        _this.onEscapePressed = _this.onEscapePressed.bind(_this);
	        return _this;
	      }
	
	      _createClass(_class2, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          window.addEventListener('keydown', this.onEscapePressed, false);
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          window.removeEventListener('keydown', this.onEscapePressed, false);
	        }
	      }, {
	        key: 'onEscapePressed',
	        value: function onEscapePressed(event) {
	          if (event.keyCode === ESCAPE_KEYCODE) {
	            this.props.handleClose();
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(DecoratedComponent, this.props);
	        }
	      }]);
	
	      return _class2;
	    }(_react.Component);
	  };
	}

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FAILURE = exports.SUCCESS = exports.REQUEST = exports.API_REQUEST = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _axios = __webpack_require__(170);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _config = __webpack_require__(32);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _grabStorage = __webpack_require__(124);
	
	var _grabStorage2 = _interopRequireDefault(_grabStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeRequest(request, accessToken) {
	  if (false) {
	    var _ret = function () {
	      /* eslint-disable global-require */
	      var mocks = require('../mocks').default;
	
	      return {
	        v: new Promise(function (resolve, reject) {
	          setTimeout(function () {
	            var requestUrl = request.method + ' ' + request.url;
	            if (request.mock.fail) {
	              reject({
	                status: request.mock.status,
	                message: mocks[requestUrl + '#fail']
	              });
	            } else {
	              resolve(mocks[requestUrl]);
	            }
	          }, request.mock.delay);
	        })
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	
	  var req = _lodash2.default.cloneDeep(request);
	  req.url = _config2.default.API_BASE_URL + request.url;
	  req.headers = {
	    'Content-Type': 'application/json'
	  };
	
	  if (accessToken) {
	    req.headers.Authorization = accessToken;
	  }
	
	  return (0, _axios2.default)(req).then(function (response) {
	    return response.data;
	  });
	}
	
	var API_REQUEST = exports.API_REQUEST = Symbol('API_REQUEST');
	var REQUEST = exports.REQUEST = '_REQUEST';
	var SUCCESS = exports.SUCCESS = '_SUCCESS';
	var FAILURE = exports.FAILURE = '_FAILURE';
	
	exports.default = function (store) {
	  return function (next) {
	    return function (action) {
	      if (!action.meta || !action.meta[API_REQUEST]) {
	        // Non-api request action
	        return next(action);
	      }
	
	      // type     is the base action type that will trigger
	      // payload  is the request body to be processed
	      var type = action.type,
	          payload = action.payload,
	          meta = action.meta;
	
	      // Swap the action content and structured api results
	
	      function constructActionWith(data) {
	        var finalAction = _extends({}, action, data);
	        delete finalAction[API_REQUEST];
	        return finalAction;
	      }
	
	      // Propagate the start of the request.
	      next(constructActionWith({
	        type: type + REQUEST,
	        payload: payload,
	        meta: _extends({}, meta, {
	          requestStatus: REQUEST
	        })
	      }));
	
	      // Get the access token from store.
	      var accessToken = '';
	      if (_lodash2.default.get(store.getState(), 'app.user.accessToken')) {
	        accessToken = store.getState().app.user.accessToken;
	      }
	
	      // Propagate the response of the request.
	      return makeRequest(payload, accessToken).then(function (response) {
	        return next(constructActionWith({
	          type: type + SUCCESS,
	          payload: response,
	          meta: _extends({}, meta, {
	            requestStatus: SUCCESS,
	            request: payload
	          })
	        }));
	      }, function (error) {
	        return next(constructActionWith({
	          type: type + FAILURE,
	          payload: error,
	          meta: _extends({}, meta, {
	            requestStatus: FAILURE,
	            request: payload
	          })
	        }));
	      });
	    };
	  };
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_REWARD_TYPE = exports.REWARD_TYPES = exports.PAYMENT_TYPES = exports.DEFAULT_PAYMENT_TYPE = exports.DRIVER_BEHAVIOUR_PARAMS = exports.DRIVER_BEHAVIOUR_TYPES = exports.DRIVER_BEHAVIOURS_NAMES = exports.DRIVER_BEHAVIOURS = exports.PASSENGER_BEHAVIOUR_PARAMS = exports.PASSENGER_BEHAVIOUR_TYPES = exports.PASSENGER_BEHAVIOURS_NAMES = exports.PASSENGER_BEHAVIOURS = undefined;
	
	var _PASSENGER_BEHAVIOURS, _PASSENGER_BEHAVIOUR_, _DRIVER_BEHAVIOURS_NA, _DRIVER_BEHAVIOUR_PAR;
	
	exports.millisecondsToSeconds = millisecondsToSeconds;
	exports.secondsToMilliseconds = secondsToMilliseconds;
	exports.inputConvertToBooleanValue = inputConvertToBooleanValue;
	exports.inputConvertToSafeValue = inputConvertToSafeValue;
	exports.hasPassengerBehaviour = hasPassengerBehaviour;
	exports.hasDriverBehaviour = hasDriverBehaviour;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function millisecondsToSeconds(value) {
	  var parsedValue = parseFloat(value);
	  return value != null && _lodash2.default.isNumber(parsedValue) && !_lodash2.default.isNaN(parsedValue) ? parsedValue / 1000 : value;
	}
	
	function secondsToMilliseconds(value) {
	  var parsedValue = parseFloat(value);
	  if (value == null) {
	    return '';
	  }
	  return value != null && _lodash2.default.isNumber(parsedValue) && !_lodash2.default.isNaN(parsedValue) ? parsedValue * 1000 : value;
	}
	
	function inputConvertToBooleanValue(value) {
	  return !!value;
	}
	
	function inputConvertToSafeValue(value) {
	  return value != null ? value : '';
	}
	
	var PASSENGER_BEHAVIOURS = exports.PASSENGER_BEHAVIOURS = {
	  MANUAL: '',
	  ALWAYS_BOOK: 'ALWAYS_BOOK',
	  ALWAYS_CANCEL: 'ALWAYS_CANCEL'
	};
	
	var PASSENGER_BEHAVIOURS_NAMES = exports.PASSENGER_BEHAVIOURS_NAMES = (_PASSENGER_BEHAVIOURS = {}, _defineProperty(_PASSENGER_BEHAVIOURS, PASSENGER_BEHAVIOURS.MANUAL, 'Manual'), _defineProperty(_PASSENGER_BEHAVIOURS, PASSENGER_BEHAVIOURS.ALWAYS_BOOK, 'Always Book'), _defineProperty(_PASSENGER_BEHAVIOURS, PASSENGER_BEHAVIOURS.ALWAYS_CANCEL, 'Always Cancel'), _PASSENGER_BEHAVIOURS);
	
	var PASSENGER_BEHAVIOUR_TYPES = exports.PASSENGER_BEHAVIOUR_TYPES = [{
	  name: PASSENGER_BEHAVIOURS_NAMES[PASSENGER_BEHAVIOURS.MANUAL],
	  value: PASSENGER_BEHAVIOURS.MANUAL
	}, {
	  name: PASSENGER_BEHAVIOURS_NAMES[PASSENGER_BEHAVIOURS.ALWAYS_BOOK],
	  value: PASSENGER_BEHAVIOURS.ALWAYS_BOOK
	}, {
	  name: PASSENGER_BEHAVIOURS_NAMES[PASSENGER_BEHAVIOURS.ALWAYS_CANCEL],
	  value: PASSENGER_BEHAVIOURS.ALWAYS_CANCEL
	}];
	
	function hasPassengerBehaviour(behaviourType) {
	  return !!behaviourType && behaviourType !== PASSENGER_BEHAVIOURS.MANUAL;
	}
	
	var bookingInterval = {
	  name: 'bookingInterval',
	  type: 'number',
	  hint: 'Interval (sec) between creating bookings. Min: 1s',
	  renderValue: millisecondsToSeconds,
	  processValue: secondsToMilliseconds,
	  validate: function validate(value) {
	    var parsedValue = parseFloat(value);
	    return _lodash2.default.isFinite(parsedValue) && parsedValue >= 1.0;
	  }
	};
	
	var pickUpLatitude = {
	  name: 'pickUpLatitude',
	  type: 'number',
	  hint: 'Pick Up Lat. Required',
	  renderValue: inputConvertToSafeValue,
	  processValue: parseFloat,
	  validate: function validate(value) {
	    return value != null && value !== '';
	  }
	};
	
	var pickUpLongitude = {
	  name: 'pickUpLongitude',
	  type: 'number',
	  hint: 'Pick Up Lon. Required',
	  renderValue: inputConvertToSafeValue,
	  processValue: parseFloat,
	  validate: function validate(value) {
	    return value != null && value !== '';
	  }
	};
	
	var dropOffLatitude = {
	  name: 'dropOffLatitude',
	  type: 'number',
	  hint: 'Drop Off Lat. Required',
	  renderValue: inputConvertToSafeValue,
	  processValue: parseFloat,
	  validate: function validate(value) {
	    return value != null && value !== '';
	  }
	};
	
	var dropOffLongitude = {
	  name: 'dropOffLongitude',
	  type: 'number',
	  hint: 'Drop Off Lon. Required',
	  renderValue: inputConvertToSafeValue,
	  processValue: parseFloat,
	  validate: function validate(value) {
	    return value != null && value !== '';
	  }
	};
	
	var taxiTypeID = {
	  name: 'taxiTypeID',
	  type: 'string',
	  hint: 'Taxi Type ID. Required. Must be a number',
	  renderValue: inputConvertToSafeValue,
	  processValue: _lodash2.default.identity,
	  validate: function validate(value) {
	    return (/^\d+$/.test(value)
	    );
	  }
	};
	
	var PASSENGER_BEHAVIOUR_PARAMS = exports.PASSENGER_BEHAVIOUR_PARAMS = (_PASSENGER_BEHAVIOUR_ = {}, _defineProperty(_PASSENGER_BEHAVIOUR_, PASSENGER_BEHAVIOURS.MANUAL, []), _defineProperty(_PASSENGER_BEHAVIOUR_, PASSENGER_BEHAVIOURS.ALWAYS_BOOK, [bookingInterval, pickUpLatitude, pickUpLongitude, dropOffLatitude, dropOffLongitude, taxiTypeID]), _defineProperty(_PASSENGER_BEHAVIOUR_, PASSENGER_BEHAVIOURS.ALWAYS_CANCEL, [bookingInterval, pickUpLatitude, pickUpLongitude, dropOffLatitude, dropOffLongitude, taxiTypeID]), _PASSENGER_BEHAVIOUR_);
	
	var DRIVER_BEHAVIOURS = exports.DRIVER_BEHAVIOURS = {
	  MANUAL: '',
	  ALWAYS_BID: 'ALWAYS_BID',
	  ALWAYS_DECLINE: 'ALWAYS_DECLINE',
	  ALWAYS_CANCEL: 'ALWAYS_CANCEL'
	};
	
	var DRIVER_BEHAVIOURS_NAMES = exports.DRIVER_BEHAVIOURS_NAMES = (_DRIVER_BEHAVIOURS_NA = {}, _defineProperty(_DRIVER_BEHAVIOURS_NA, DRIVER_BEHAVIOURS.MANUAL, 'Manual'), _defineProperty(_DRIVER_BEHAVIOURS_NA, DRIVER_BEHAVIOURS.ALWAYS_BID, 'Always Bid'), _defineProperty(_DRIVER_BEHAVIOURS_NA, DRIVER_BEHAVIOURS.ALWAYS_DECLINE, 'Always Decline'), _defineProperty(_DRIVER_BEHAVIOURS_NA, DRIVER_BEHAVIOURS.ALWAYS_CANCEL, 'Always Cancel'), _DRIVER_BEHAVIOURS_NA);
	
	var DRIVER_BEHAVIOUR_TYPES = exports.DRIVER_BEHAVIOUR_TYPES = [{
	  name: DRIVER_BEHAVIOURS_NAMES[DRIVER_BEHAVIOURS.MANUAL],
	  value: DRIVER_BEHAVIOURS.MANUAL
	}, {
	  name: DRIVER_BEHAVIOURS_NAMES[DRIVER_BEHAVIOURS.ALWAYS_BID],
	  value: DRIVER_BEHAVIOURS.ALWAYS_BID
	}, {
	  name: DRIVER_BEHAVIOURS_NAMES[DRIVER_BEHAVIOURS.ALWAYS_DECLINE],
	  value: DRIVER_BEHAVIOURS.ALWAYS_DECLINE
	}, {
	  name: DRIVER_BEHAVIOURS_NAMES[DRIVER_BEHAVIOURS.ALWAYS_CANCEL],
	  value: DRIVER_BEHAVIOURS.ALWAYS_CANCEL
	}];
	
	function hasDriverBehaviour(behaviourType) {
	  return !!behaviourType && behaviourType !== DRIVER_BEHAVIOURS.MANUAL;
	}
	
	var loiterRadius = {
	  name: 'loiterRadius',
	  type: 'number',
	  hint: 'The radius in KM that the driver will loiter around the centre',
	  renderValue: inputConvertToSafeValue,
	  processValue: parseFloat
	};
	
	var DRIVER_BEHAVIOUR_PARAMS = exports.DRIVER_BEHAVIOUR_PARAMS = (_DRIVER_BEHAVIOUR_PAR = {}, _defineProperty(_DRIVER_BEHAVIOUR_PAR, DRIVER_BEHAVIOURS.MANUAL, [loiterRadius]), _defineProperty(_DRIVER_BEHAVIOUR_PAR, DRIVER_BEHAVIOURS.ALWAYS_BID, [loiterRadius, {
	  name: 'pickUpDelay',
	  type: 'number',
	  hint: 'Delay (sec) between awarded and picking up',
	  renderValue: millisecondsToSeconds,
	  processValue: secondsToMilliseconds
	}, {
	  name: 'sendImHereNotification',
	  type: 'boolean',
	  renderValue: millisecondsToSeconds,
	  processValue: inputConvertToBooleanValue
	}, {
	  name: 'dropOffDelay',
	  type: 'number',
	  hint: 'Delay (sec) between picking up and dropping off',
	  renderValue: millisecondsToSeconds,
	  processValue: secondsToMilliseconds
	}, {
	  name: 'completeJobDelay',
	  type: 'number',
	  hint: 'Delay (sec) between dropping off and completing the job',
	  renderValue: millisecondsToSeconds,
	  processValue: secondsToMilliseconds
	}]), _defineProperty(_DRIVER_BEHAVIOUR_PAR, DRIVER_BEHAVIOURS.ALWAYS_DECLINE, [loiterRadius]), _defineProperty(_DRIVER_BEHAVIOUR_PAR, DRIVER_BEHAVIOURS.ALWAYS_CANCEL, [loiterRadius, {
	  name: 'cancelDelay',
	  type: 'number',
	  hint: 'Delay (sec) between awarded and cancelling the job',
	  renderValue: millisecondsToSeconds,
	  processValue: secondsToMilliseconds
	}]), _DRIVER_BEHAVIOUR_PAR);
	
	var DEFAULT_PAYMENT_TYPE = exports.DEFAULT_PAYMENT_TYPE = 'CASH';
	
	var PAYMENT_TYPES = exports.PAYMENT_TYPES = [{
	  name: 'CASH',
	  display: 'Cash'
	}, {
	  name: 'CREDIT',
	  display: 'Credit'
	}, {
	  name: 'VISA',
	  display: 'Visa'
	}, {
	  name: 'MASTERCARD',
	  display: 'MasterCard'
	}, {
	  name: 'ALIPAY',
	  display: 'Alipay'
	}, {
	  name: 'Android Pay',
	  display: 'Android Pay'
	}, {
	  name: 'PayLater',
	  display: 'PayLater'
	}];
	
	var REWARD_TYPES = exports.REWARD_TYPES = [{
	  name: 'promotionCode',
	  display: 'Promo Code'
	}, {
	  name: 'rewardID',
	  display: 'Reward ID'
	}];
	
	var DEFAULT_REWARD_TYPE = exports.DEFAULT_REWARD_TYPE = REWARD_TYPES[0].name;

/***/ },
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RESET_ALL_STATE = exports.RESET_ERROR_STATE = exports.RESET_REQUEST_STATE = undefined;
	exports.resetRequestState = resetRequestState;
	exports.resetErrorState = resetErrorState;
	exports.resetAllState = resetAllState;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RESET_REQUEST_STATE = exports.RESET_REQUEST_STATE = 'RESET_REQUEST_STATE';
	function resetRequestState(domain) {
	  return {
	    type: RESET_REQUEST_STATE,
	    payload: _lodash2.default.isArray(domain) ? domain : [domain]
	  };
	}
	
	var RESET_ERROR_STATE = exports.RESET_ERROR_STATE = 'RESET_ERROR_STATE';
	function resetErrorState(domain) {
	  return {
	    type: RESET_ERROR_STATE,
	    payload: _lodash2.default.isArray(domain) ? domain : [domain]
	  };
	}
	
	var RESET_ALL_STATE = exports.RESET_ALL_STATE = 'RESET_ALL_STATE';
	function resetAllState() {
	  return {
	    type: RESET_ALL_STATE,
	    payload: null
	  };
	}

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.COHORT_PAX_TYPES = undefined;
	exports.entityURLForCohort = entityURLForCohort;
	
	var _config = __webpack_require__(32);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable import/prefer-default-export */
	function entityURLForCohort() {
	  // In future when the URL is cohort-specific, pass in cohortID and add more custom logic.
	  return _config2.default.GAMMA_URL;
	}
	var COHORT_PAX_TYPES = exports.COHORT_PAX_TYPES = [{
	  name: 'Passenger',
	  value: 0
	}, {
	  name: 'Charice',
	  value: 1
	}];

/***/ },
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DRIVER_BATCH_SET_LOCATION = exports.DRIVER_BOOKING_DELETE = exports.DRIVER_BOOKING_STATE_CHANGE = exports.DRIVER_BOOKING_NEW = exports.DRIVER_BOOKING_DROP_OFF = exports.DRIVER_BOOKING_ADDITIONAL_DROP_OFF = exports.DRIVER_BOOKING_PICK_UP = exports.DRIVER_BOOKING_CANCEL = exports.DRIVER_BOOKING_BID = exports.DRIVER_SET_LOCATION = exports.DRIVER_SET_AUTO_ACCEPT = exports.DRIVER_SET_AVAILABILITY = exports.DRIVER_DELETE = exports.DRIVER_LOGOUT = exports.DRIVER_LOGIN = undefined;
	exports.driverLoginInstant = driverLoginInstant;
	exports.driverLogin = driverLogin;
	exports.driverLogoutInstant = driverLogoutInstant;
	exports.driverLogout = driverLogout;
	exports.driverDeleteInstant = driverDeleteInstant;
	exports.driverDelete = driverDelete;
	exports.driverSetAvailabilityInstant = driverSetAvailabilityInstant;
	exports.driverSetAvailability = driverSetAvailability;
	exports.driverSetAutoAcceptInstant = driverSetAutoAcceptInstant;
	exports.driverSetAutoAccept = driverSetAutoAccept;
	exports.driverSetLocationInstant = driverSetLocationInstant;
	exports.driverSetLocation = driverSetLocation;
	exports.driverBookingBid = driverBookingBid;
	exports.driverBookingCancel = driverBookingCancel;
	exports.driverBookingPickUp = driverBookingPickUp;
	exports.driverBookingAdditionalDropOff = driverBookingAdditionalDropOff;
	exports.driverBookingDropOff = driverBookingDropOff;
	exports.driverBookingNew = driverBookingNew;
	exports.driverBookingStateChange = driverBookingStateChange;
	exports.driverBookingDelete = driverBookingDelete;
	exports.batchDriverSetLocation = batchDriverSetLocation;
	
	var _reactGa = __webpack_require__(78);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _apiMiddleware = __webpack_require__(35);
	
	var _gaUtils = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DRIVER_LOGIN = exports.DRIVER_LOGIN = 'DRIVER_LOGIN';
	function driverLoginInstant(cohortID, driverID, behaviour) {
	  return {
	    type: DRIVER_LOGIN,
	    payload: {
	      cohortID: cohortID,
	      driverID: driverID,
	      behaviour: behaviour
	    }
	  };
	}
	
	function driverLogin(cohortID, driverID, driver, location) {
	  var _meta;
	
	  _reactGa2.default.event({
	    category: _gaUtils.DRIVERS,
	    action: _gaUtils.DRIVERS_ACTIONS.DRIVER_LOGIN
	  });
	  return {
	    type: DRIVER_LOGIN,
	    payload: {
	      method: 'POST',
	      url: '/drivers/' + driverID + '/login',
	      data: {
	        behaviour: driver.behaviour,
	        longitude: location[0],
	        latitude: location[1]
	      }
	    },
	    meta: (_meta = {}, _defineProperty(_meta, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta, 'cohortID', cohortID), _defineProperty(_meta, 'driverID', driverID), _meta)
	  };
	}
	
	var DRIVER_LOGOUT = exports.DRIVER_LOGOUT = 'DRIVER_LOGOUT';
	function driverLogoutInstant(cohortID, driverID) {
	  return {
	    type: DRIVER_LOGOUT,
	    payload: {
	      cohortID: cohortID,
	      driverID: driverID
	    }
	  };
	}
	
	function driverLogout(cohortID, driverID) {
	  var _meta2;
	
	  _reactGa2.default.event({
	    category: _gaUtils.DRIVERS,
	    action: _gaUtils.DRIVERS_ACTIONS.DRIVER_LOGOUT
	  });
	  return {
	    type: DRIVER_LOGOUT,
	    payload: {
	      method: 'POST',
	      url: '/drivers/' + driverID + '/logout'
	    },
	    meta: (_meta2 = {}, _defineProperty(_meta2, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta2, 'cohortID', cohortID), _defineProperty(_meta2, 'driverID', driverID), _meta2)
	  };
	}
	
	var DRIVER_DELETE = exports.DRIVER_DELETE = 'DRIVER_DELETE';
	function driverDeleteInstant(cohortID, driverID) {
	  return {
	    type: DRIVER_DELETE,
	    payload: {
	      cohortID: cohortID,
	      driverID: driverID
	    }
	  };
	}
	
	function driverDelete(cohortID, driverID) {
	  var _meta3;
	
	  _reactGa2.default.event({
	    category: _gaUtils.DRIVERS,
	    action: _gaUtils.DRIVERS_ACTIONS.DRIVER_DELETE
	  });
	  return {
	    type: DRIVER_DELETE,
	    payload: {
	      method: 'DELETE',
	      url: '/drivers/' + driverID
	    },
	    meta: (_meta3 = {}, _defineProperty(_meta3, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta3, 'cohortID', cohortID), _defineProperty(_meta3, 'driverID', driverID), _meta3)
	  };
	}
	
	var DRIVER_SET_AVAILABILITY = exports.DRIVER_SET_AVAILABILITY = 'DRIVER_SET_AVAILABILITY';
	function driverSetAvailabilityInstant(cohortID, driverID, availability) {
	  return {
	    type: DRIVER_SET_AVAILABILITY,
	    payload: {
	      availability: availability,
	      cohortID: cohortID,
	      driverID: driverID
	    }
	  };
	}
	
	function driverSetAvailability(cohortID, driverID, availability) {
	  var _meta4;
	
	  _reactGa2.default.event({
	    category: _gaUtils.DRIVERS,
	    action: _gaUtils.DRIVERS_ACTIONS.DRIVER_SET_AVAILABILITY
	  });
	  return {
	    type: DRIVER_SET_AVAILABILITY,
	    payload: {
	      method: 'PUT',
	      url: '/drivers/' + driverID + '/availability',
	      data: {
	        availability: availability
	      }
	    },
	    meta: (_meta4 = {}, _defineProperty(_meta4, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta4, 'cohortID', cohortID), _defineProperty(_meta4, 'driverID', driverID), _defineProperty(_meta4, 'availability', availability), _meta4)
	  };
	}
	
	var DRIVER_SET_AUTO_ACCEPT = exports.DRIVER_SET_AUTO_ACCEPT = 'DRIVER_SET_AUTO_ACCEPT';
	function driverSetAutoAcceptInstant(cohortID, driverID, isTurnedOn) {
	  return {
	    type: DRIVER_SET_AUTO_ACCEPT,
	    payload: {
	      isTurnedOn: isTurnedOn,
	      cohortID: cohortID,
	      driverID: driverID
	    }
	  };
	}
	
	function driverSetAutoAccept(cohortID, driverID, isTurnedOn) {
	  var _meta5;
	
	  _reactGa2.default.event({
	    category: _gaUtils.DRIVERS,
	    action: _gaUtils.DRIVERS_ACTIONS.DRIVER_SET_AUTO_ACCEPT
	  });
	  return {
	    type: DRIVER_SET_AUTO_ACCEPT,
	    payload: {
	      method: 'POST',
	      url: '/drivers/' + driverID + '/auto-accept',
	      data: {
	        isTurnedOn: isTurnedOn
	      }
	    },
	    meta: (_meta5 = {}, _defineProperty(_meta5, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta5, 'cohortID', cohortID), _defineProperty(_meta5, 'driverID', driverID), _defineProperty(_meta5, 'isTurnedOn', isTurnedOn), _meta5)
	  };
	}
	
	var DRIVER_SET_LOCATION = exports.DRIVER_SET_LOCATION = 'DRIVER_SET_LOCATION';
	function driverSetLocationInstant(cohortID, driverID, location, selfGenerated) {
	  // selfGenerated flag differentiates the source of the event trigger (websocket / ui)
	  return {
	    type: DRIVER_SET_LOCATION,
	    payload: {
	      location: location,
	      cohortID: cohortID,
	      driverID: driverID,
	      selfGenerated: selfGenerated
	    }
	  };
	}
	
	function driverSetLocation(cohortID, driverID, location) {
	  var _meta6;
	
	  _reactGa2.default.event({
	    category: _gaUtils.DRIVERS,
	    action: _gaUtils.DRIVERS_ACTIONS.DRIVER_SET_LOCATION
	  });
	  return {
	    type: DRIVER_SET_LOCATION,
	    payload: {
	      method: 'PUT',
	      url: '/drivers/' + driverID + '/location',
	      data: {
	        longitude: location[0],
	        latitude: location[1]
	      }
	    },
	    meta: (_meta6 = {}, _defineProperty(_meta6, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta6, 'cohortID', cohortID), _defineProperty(_meta6, 'driverID', driverID), _meta6)
	  };
	}
	
	var DRIVER_BOOKING_BID = exports.DRIVER_BOOKING_BID = 'DRIVER_BOOKING_BID';
	function driverBookingBid(driverID, bookingID) {
	  _reactGa2.default.event({
	    category: _gaUtils.DRIVERS,
	    action: _gaUtils.DRIVERS_ACTIONS.DRIVER_BOOKING_BID
	  });
	  return {
	    type: DRIVER_BOOKING_BID,
	    payload: {
	      method: 'POST',
	      url: '/drivers/' + driverID + '/bookings/' + bookingID + '/bid'
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var DRIVER_BOOKING_CANCEL = exports.DRIVER_BOOKING_CANCEL = 'DRIVER_BOOKING_CANCEL';
	function driverBookingCancel(driverID, bookingID) {
	  _reactGa2.default.event({
	    category: _gaUtils.DRIVERS,
	    action: _gaUtils.DRIVERS_ACTIONS.DRIVER_BOOKING_CANCEL
	  });
	  return {
	    type: DRIVER_BOOKING_CANCEL,
	    payload: {
	      method: 'POST',
	      url: '/drivers/' + driverID + '/bookings/' + bookingID + '/cancel'
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var DRIVER_BOOKING_PICK_UP = exports.DRIVER_BOOKING_PICK_UP = 'DRIVER_BOOKING_PICK_UP';
	function driverBookingPickUp(driverID, bookingID) {
	  _reactGa2.default.event({
	    category: _gaUtils.DRIVERS,
	    action: _gaUtils.DRIVERS_ACTIONS.DRIVER_BOOKING_PICK_UP
	  });
	  return {
	    type: DRIVER_BOOKING_PICK_UP,
	    payload: {
	      method: 'POST',
	      url: '/drivers/' + driverID + '/bookings/' + bookingID + '/pick_up'
	    },
	    meta: _defineProperty({}, _apiMiddleware.API_REQUEST, true)
	  };
	}
	
	var DRIVER_BOOKING_ADDITIONAL_DROP_OFF = exports.DRIVER_BOOKING_ADDITIONAL_DROP_OFF = 'DRIVER_BOOKING_ADDITIONAL_DROP_OFF';
	function driverBookingAdditionalDropOff(driverID, bookingID, fare, bookingFee, otherFees, dropOffNumber) {
	  var _meta10;
	
	  _reactGa2.default.event({
	    category: _gaUtils.DRIVERS,
	    action: _gaUtils.DRIVERS_ACTIONS.DRIVER_BOOKING_DROP_OFF
	  });
	  return {
	    type: DRIVER_BOOKING_ADDITIONAL_DROP_OFF,
	    payload: {
	      method: 'POST',
	      url: '/drivers/' + driverID + '/bookings/' + bookingID + '/drop_off',
	      data: {
	        dropOffNumber: dropOffNumber,
	        fare: fare,
	        bookingFee: bookingFee,
	        otherFees: otherFees
	      }
	    },
	    meta: (_meta10 = {}, _defineProperty(_meta10, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta10, 'driverID', driverID), _defineProperty(_meta10, 'bookingID', bookingID), _meta10)
	  };
	}
	
	var DRIVER_BOOKING_DROP_OFF = exports.DRIVER_BOOKING_DROP_OFF = 'DRIVER_BOOKING_DROP_OFF';
	function driverBookingDropOff(driverID, bookingID, fare, bookingFee, otherFees) {
	  var _meta11;
	
	  _reactGa2.default.event({
	    category: _gaUtils.DRIVERS,
	    action: _gaUtils.DRIVERS_ACTIONS.DRIVER_BOOKING_DROP_OFF
	  });
	  return {
	    type: DRIVER_BOOKING_DROP_OFF,
	    payload: {
	      method: 'POST',
	      url: '/drivers/' + driverID + '/bookings/' + bookingID + '/drop_off',
	      data: {
	        fare: fare,
	        bookingFee: bookingFee,
	        otherFees: otherFees
	      }
	    },
	    meta: (_meta11 = {}, _defineProperty(_meta11, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta11, 'driverID', driverID), _defineProperty(_meta11, 'bookingID', bookingID), _meta11)
	  };
	}
	
	var DRIVER_BOOKING_NEW = exports.DRIVER_BOOKING_NEW = 'DRIVER_BOOKING_NEW';
	function driverBookingNew(cohortID, driverID, bookingID, booking) {
	  _reactGa2.default.event({
	    category: _gaUtils.DRIVERS,
	    action: _gaUtils.DRIVERS_ACTIONS.DRIVER_BOOKING_NEW
	  });
	  return {
	    type: DRIVER_BOOKING_NEW,
	    payload: {
	      cohortID: cohortID,
	      driverID: driverID,
	      bookingID: bookingID,
	      booking: booking
	    }
	  };
	}
	
	var DRIVER_BOOKING_STATE_CHANGE = exports.DRIVER_BOOKING_STATE_CHANGE = 'DRIVER_BOOKING_STATE_CHANGE';
	function driverBookingStateChange(cohortID, driverID, bookingID, state) {
	  _reactGa2.default.event({
	    category: _gaUtils.DRIVERS,
	    action: _gaUtils.DRIVERS_ACTIONS.DRIVER_BOOKING_STATE_CHANGE
	  });
	  return {
	    type: DRIVER_BOOKING_STATE_CHANGE,
	    payload: {
	      cohortID: cohortID,
	      driverID: driverID,
	      bookingID: bookingID,
	      state: state
	    }
	  };
	}
	
	var DRIVER_BOOKING_DELETE = exports.DRIVER_BOOKING_DELETE = 'DRIVER_BOOKING_DELETE';
	function driverBookingDelete(cohortID, driverID, bookingID) {
	  _reactGa2.default.event({
	    category: _gaUtils.DRIVERS,
	    action: _gaUtils.DRIVERS_ACTIONS.DRIVER_BOOKING_DELETE
	  });
	  return {
	    type: DRIVER_BOOKING_DELETE,
	    payload: {
	      cohortID: cohortID,
	      driverID: driverID,
	      bookingID: bookingID
	    }
	  };
	}
	
	var DRIVER_BATCH_SET_LOCATION = exports.DRIVER_BATCH_SET_LOCATION = 'DRIVER_BATCH_SET_LOCATION';
	function batchDriverSetLocation(cohortID, driverLocations) {
	  return {
	    type: DRIVER_BATCH_SET_LOCATION,
	    payload: {
	      cohortID: cohortID,
	      driverLocations: driverLocations
	    }
	  };
	}

/***/ },
/* 59 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.libraryPassengerAdd = libraryPassengerAdd;
	exports.libraryPassengerDelete = libraryPassengerDelete;
	exports.libraryDriverAdd = libraryDriverAdd;
	exports.libraryDriverDelete = libraryDriverDelete;
	exports.libraryMerchantAdd = libraryMerchantAdd;
	exports.libraryMerchantDelete = libraryMerchantDelete;
	var LIBRARY_PASSENGER_ADD = exports.LIBRARY_PASSENGER_ADD = 'LIBRARY_PASSENGER_ADD';
	function libraryPassengerAdd(cohortPassenger) {
	  return {
	    type: LIBRARY_PASSENGER_ADD,
	    payload: cohortPassenger
	  };
	}
	
	var LIBRARY_PASSENGER_DELETE = exports.LIBRARY_PASSENGER_DELETE = 'LIBRARY_PASSENGER_DELETE';
	function libraryPassengerDelete(cohortPassengerID) {
	  return {
	    type: LIBRARY_PASSENGER_DELETE,
	    payload: {
	      cohortPassengerID: cohortPassengerID
	    }
	  };
	}
	
	var LIBRARY_DRIVER_ADD = exports.LIBRARY_DRIVER_ADD = 'LIBRARY_DRIVER_ADD';
	function libraryDriverAdd(cohortDriver) {
	  return {
	    type: LIBRARY_DRIVER_ADD,
	    payload: cohortDriver
	  };
	}
	
	var LIBRARY_DRIVER_DELETE = exports.LIBRARY_DRIVER_DELETE = 'LIBRARY_DRIVER_DELETE';
	function libraryDriverDelete(cohortDriverID) {
	  return {
	    type: LIBRARY_DRIVER_DELETE,
	    payload: {
	      cohortDriverID: cohortDriverID
	    }
	  };
	}
	
	var LIBRARY_MERCHANT_ADD = exports.LIBRARY_MERCHANT_ADD = 'LIBRARY_MERCHANT_ADD';
	function libraryMerchantAdd(cohortMerchant) {
	  return {
	    type: LIBRARY_MERCHANT_ADD,
	    payload: cohortMerchant
	  };
	}
	
	var LIBRARY_MERCHANT_DELETE = exports.LIBRARY_MERCHANT_DELETE = 'LIBRARY_MERCHANT_DELETE';
	function libraryMerchantDelete(cohortMerchantID) {
	  return {
	    type: LIBRARY_MERCHANT_DELETE,
	    payload: {
	      cohortMerchantID: cohortMerchantID
	    }
	  };
	}

/***/ },
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _propertyUtils = __webpack_require__(506);
	
	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	
	var getComputedStyleX = void 0;
	
	function force(x, y) {
	  return x + y;
	}
	
	function css(el, name, v) {
	  var value = v;
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }
	    return undefined;
	  }
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value = value + 'px';
	    }
	    el.style[name] = value;
	    return undefined;
	  }
	  return getComputedStyleX(el, name);
	}
	
	function getClientPosition(elem) {
	  var box = void 0;
	  var x = void 0;
	  var y = void 0;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	  box = elem.getBoundingClientRect();
	
	  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = box.left;
	  y = box.top;
	
	  // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getScroll(w, top) {
	  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	  var method = 'scroll' + (top ? 'Top' : 'Left');
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    // ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	function _getComputedStyle(elem, name, cs) {
	  var computedStyle = cs;
	  var val = '';
	  var d = elem.ownerDocument;
	  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
	
	  // https://github.com/kissyteam/kissy/issues/61
	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	
	  return val;
	}
	
	var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';
	
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
	
	  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT];
	
	    // prevent flashing of content
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
	
	    // Put in the new values to get a computed value out
	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX;
	
	    // Revert the changed values
	    style[LEFT] = left;
	
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	  return ret === '' ? 'auto' : ret;
	}
	
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	
	function getOffsetDirection(dir, option) {
	  if (dir === 'left') {
	    return option.useCssRight ? 'right' : dir;
	  }
	  return option.useCssBottom ? 'bottom' : dir;
	}
	
	function oppositeOffsetDirection(dir) {
	  if (dir === 'left') {
	    return 'right';
	  } else if (dir === 'right') {
	    return 'left';
	  } else if (dir === 'top') {
	    return 'bottom';
	  } else if (dir === 'bottom') {
	    return 'top';
	  }
	}
	
	// 设置 elem 相对 elem.ownerDocument 的坐标
	function setLeftTop(elem, offset, option) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	  var presetH = -999;
	  var presetV = -999;
	  var horizontalProperty = getOffsetDirection('left', option);
	  var verticalProperty = getOffsetDirection('top', option);
	  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
	  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
	
	  if (horizontalProperty !== 'left') {
	    presetH = 999;
	  }
	
	  if (verticalProperty !== 'top') {
	    presetV = 999;
	  }
	  var originalTransition = '';
	  var originalOffset = getOffset(elem);
	  if ('left' in offset || 'top' in offset) {
	    originalTransition = (0, _propertyUtils.getTransitionProperty)(elem) || '';
	    (0, _propertyUtils.setTransitionProperty)(elem, 'none');
	  }
	  if ('left' in offset) {
	    elem.style[oppositeHorizontalProperty] = '';
	    elem.style[horizontalProperty] = presetH + 'px';
	  }
	  if ('top' in offset) {
	    elem.style[oppositeVerticalProperty] = '';
	    elem.style[verticalProperty] = presetV + 'px';
	  }
	  var old = getOffset(elem);
	  var originalStyle = {};
	  for (var key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      var dir = getOffsetDirection(key, option);
	      var preset = key === 'left' ? presetH : presetV;
	      var off = originalOffset[key] - old[key];
	      if (dir === key) {
	        originalStyle[dir] = preset + off;
	      } else {
	        originalStyle[dir] = preset - off;
	      }
	    }
	  }
	  css(elem, originalStyle);
	  // force relayout
	  force(elem.offsetTop, elem.offsetLeft);
	  if ('left' in offset || 'top' in offset) {
	    (0, _propertyUtils.setTransitionProperty)(elem, originalTransition);
	  }
	  var ret = {};
	  for (var _key in offset) {
	    if (offset.hasOwnProperty(_key)) {
	      var _dir = getOffsetDirection(_key, option);
	      var _off = offset[_key] - originalOffset[_key];
	      if (_key === _dir) {
	        ret[_dir] = originalStyle[_dir] + _off;
	      } else {
	        ret[_dir] = originalStyle[_dir] - _off;
	      }
	    }
	  }
	  css(elem, ret);
	}
	
	function setTransform(elem, offset) {
	  var originalOffset = getOffset(elem);
	  var originalXY = (0, _propertyUtils.getTransformXY)(elem);
	  var resultXY = { x: originalXY.x, y: originalXY.y };
	  if ('left' in offset) {
	    resultXY.x = originalXY.x + offset.left - originalOffset.left;
	  }
	  if ('top' in offset) {
	    resultXY.y = originalXY.y + offset.top - originalOffset.top;
	  }
	  (0, _propertyUtils.setTransformXY)(elem, resultXY);
	}
	
	function setOffset(elem, offset, option) {
	  if (option.useCssRight || option.useCssBottom) {
	    setLeftTop(elem, offset, option);
	  } else if (option.useCssTransform && (0, _propertyUtils.getTransformName)() in document.body.style) {
	    setTransform(elem, offset, option);
	  } else {
	    setLeftTop(elem, offset, option);
	  }
	}
	
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	
	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;
	
	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name = void 0;
	
	  // Remember the old values, and insert the new ones
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }
	
	  callback.call(elem);
	
	  // Revert the old values
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}
	
	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop = void 0;
	  var j = void 0;
	  var i = void 0;
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = void 0;
	        if (prop === 'border') {
	          cssProp = '' + prop + which[i] + 'Width';
	        } else {
	          cssProp = prop + which[i];
	        }
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	  return value;
	}
	
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	function isWindow(obj) {
	  // must use == for ie8
	  /* eslint eqeqeq:0 */
	  return obj !== null && obj !== undefined && obj == obj.window;
	}
	
	var domUtils = {};
	
	each(['Width', 'Height'], function (name) {
	  domUtils['doc' + name] = function (refWin) {
	    var d = refWin.document;
	    return Math.max(
	    // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement['scroll' + name],
	    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body['scroll' + name], domUtils['viewport' + name](d));
	  };
	
	  domUtils['viewport' + name] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = 'client' + name;
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop];
	    // 标准模式取 documentElement
	    // backcompat 取 body
	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	function getWH(elem, name, ex) {
	  var extra = ex;
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
	  var computedStyle = getComputedStyleX(elem);
	  var isBorderBox = isBorderBoxFn(elem, computedStyle);
	  var cssBoxValue = 0;
	  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
	    borderBoxValue = undefined;
	    // Fall back to computed then un computed css if necessary
	    cssBoxValue = getComputedStyleX(elem, name);
	    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    }
	    // Normalize '', auto, and prepare for extra
	    cssBoxValue = parseFloat(cssBoxValue) || 0;
	  }
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
	    }
	    return cssBoxValue;
	  } else if (borderBoxValueOrIsBorderBox) {
	    if (extra === BORDER_INDEX) {
	      return val;
	    }
	    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle));
	  }
	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
	}
	
	var cssShow = {
	  position: 'absolute',
	  visibility: 'hidden',
	  display: 'block'
	};
	
	// fix #119 : https://github.com/kissyteam/kissy/issues/119
	function getWHIgnoreDisplay() {
	  for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var val = void 0;
	  var elem = args[0];
	  // in case elem is window
	  // elem.offsetWidth === undefined
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	  return val;
	}
	
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	  domUtils['outer' + first] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	
	  domUtils[name] = function (elem, v) {
	    var val = v;
	    if (val !== undefined) {
	      if (elem) {
	        var computedStyle = getComputedStyleX(elem);
	        var isBorderBox = isBorderBoxFn(elem);
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
	        }
	        return css(elem, name, val);
	      }
	      return undefined;
	    }
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	
	function mix(to, from) {
	  for (var i in from) {
	    if (from.hasOwnProperty(i)) {
	      to[i] = from[i];
	    }
	  }
	  return to;
	}
	
	var utils = {
	  getWindow: function getWindow(node) {
	    if (node && node.document && node.setTimeout) {
	      return node;
	    }
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	  offset: function offset(el, value, option) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value, option || {});
	    } else {
	      return getOffset(el);
	    }
	  },
	
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var i = void 0;
	    var ret = {};
	    for (i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }
	    var overflow = obj.overflow;
	    if (overflow) {
	      for (i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }
	    return ret;
	  },
	
	  mix: mix,
	  getWindowScrollLeft: function getWindowScrollLeft(w) {
	    return getScrollLeft(w);
	  },
	  getWindowScrollTop: function getWindowScrollTop(w) {
	    return getScrollTop(w);
	  },
	  merge: function merge() {
	    var ret = {};
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    for (var i = 0; i < args.length; i++) {
	      utils.mix(ret, args[i]);
	    }
	    return ret;
	  },
	
	  viewportWidth: 0,
	  viewportHeight: 0
	};
	
	mix(utils, domUtils);
	
	exports["default"] = utils;
	module.exports = exports['default'];

/***/ },
/* 69 */,
/* 70 */,
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PASSENGER_CHANGE_DESTINATION = exports.PASSENGER_GET_NEARBY_TAXI_TYPES = exports.PASSENGER_BOOKING_DELETE = exports.PASSENGER_BOOKING_STATE_CHANGE = exports.PASSENGER_BOOKING_NEW = exports.PASSENGER_DELETE = exports.PASSENGER_BOOKING_CANCEL = exports.PASSENGER_BOOKING_GET = exports.PASSENGER_BOOKING_CREATE = exports.PASSENGER_LOGOUT = exports.PASSENGER_LOGIN = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.passengerLoginInstant = passengerLoginInstant;
	exports.passengerLogin = passengerLogin;
	exports.passengerLogoutInstant = passengerLogoutInstant;
	exports.passengerLogout = passengerLogout;
	exports.passengerBookingCreate = passengerBookingCreate;
	exports.passengerBookingGet = passengerBookingGet;
	exports.passengerBookingCancel = passengerBookingCancel;
	exports.passengerDeleteInstant = passengerDeleteInstant;
	exports.passengerDelete = passengerDelete;
	exports.passengerBookingNew = passengerBookingNew;
	exports.passengerBookingStateChange = passengerBookingStateChange;
	exports.passengerBookingDelete = passengerBookingDelete;
	exports.passengerGetNearbyTaxiTypes = passengerGetNearbyTaxiTypes;
	exports.passengerChangeDestination = passengerChangeDestination;
	
	var _bookingUtils = __webpack_require__(73);
	
	var _reactGa = __webpack_require__(78);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _immutable = __webpack_require__(22);
	
	var _gaUtils = __webpack_require__(127);
	
	var _apiMiddleware = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var PASSENGER_LOGIN = exports.PASSENGER_LOGIN = 'PASSENGER_LOGIN';
	function passengerLoginInstant(cohortID, passengerID, behaviour) {
	  return {
	    type: PASSENGER_LOGIN,
	    payload: {
	      cohortID: cohortID,
	      passengerID: passengerID,
	      behaviour: behaviour
	    }
	  };
	}
	
	function passengerLogin(cohortID, passengerID, passenger) {
	  var _meta;
	
	  _reactGa2.default.event({
	    category: _gaUtils.PASSENGERS,
	    action: _gaUtils.PASSENGERS_ACTIONS.PASSENGER_LOGIN
	  });
	  return {
	    type: PASSENGER_LOGIN,
	    payload: {
	      method: 'POST',
	      url: '/passengers/' + passengerID + '/login',
	      data: {
	        behaviour: passenger.behaviour
	      }
	    },
	    meta: (_meta = {}, _defineProperty(_meta, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta, 'cohortID', cohortID), _defineProperty(_meta, 'passengerID', passengerID), _meta)
	  };
	}
	
	var PASSENGER_LOGOUT = exports.PASSENGER_LOGOUT = 'PASSENGER_LOGOUT';
	function passengerLogoutInstant(cohortID, passengerID) {
	  return {
	    type: PASSENGER_LOGOUT,
	    payload: {
	      cohortID: cohortID,
	      passengerID: passengerID
	    }
	  };
	}
	
	function passengerLogout(cohortID, passengerID) {
	  var _meta2;
	
	  _reactGa2.default.event({
	    category: _gaUtils.PASSENGERS,
	    action: _gaUtils.PASSENGERS_ACTIONS.PASSENGER_LOGOUT
	  });
	  return {
	    type: PASSENGER_LOGOUT,
	    payload: {
	      method: 'POST',
	      url: '/passengers/' + passengerID + '/logout'
	    },
	    meta: (_meta2 = {}, _defineProperty(_meta2, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta2, 'cohortID', cohortID), _defineProperty(_meta2, 'passengerID', passengerID), _meta2)
	  };
	}
	
	var PASSENGER_BOOKING_CREATE = exports.PASSENGER_BOOKING_CREATE = 'PASSENGER_BOOKING_CREATE';
	function passengerBookingCreate(cohortID, passengerID, booking, pois) {
	  var _meta3;
	
	  _reactGa2.default.event({
	    category: _gaUtils.PASSENGERS,
	    action: _gaUtils.PASSENGERS_ACTIONS.PASSENGER_BOOKING_CREATE
	  });
	
	  var bkgReq = (0, _bookingUtils.toBookingRequestV2)(booking, pois);
	  return {
	    type: PASSENGER_BOOKING_CREATE,
	    payload: {
	      method: 'POST',
	      url: '/passengers/' + passengerID + '/bookings/multi-stop',
	      data: bkgReq
	    },
	    meta: (_meta3 = {}, _defineProperty(_meta3, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta3, 'cohortID', cohortID), _defineProperty(_meta3, 'passengerID', passengerID), _defineProperty(_meta3, 'booking', _extends({}, bkgReq, {
	      passengerID: passengerID
	    })), _meta3)
	  };
	}
	
	var PASSENGER_BOOKING_GET = exports.PASSENGER_BOOKING_GET = 'PASSENGER_BOOKING_GET';
	function passengerBookingGet(cohortID, passengerID, bookingID) {
	  var _meta4;
	
	  _reactGa2.default.event({
	    category: _gaUtils.PASSENGERS,
	    action: _gaUtils.PASSENGERS_ACTIONS.PASSENGER_BOOKING_GET
	  });
	  return {
	    type: PASSENGER_BOOKING_GET,
	    payload: {
	      method: 'GET',
	      url: '/passengers/' + passengerID + '/bookings/' + bookingID
	    },
	    meta: (_meta4 = {}, _defineProperty(_meta4, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta4, 'cohortID', cohortID), _defineProperty(_meta4, 'passengerID', passengerID), _defineProperty(_meta4, 'bookingID', bookingID), _meta4)
	  };
	}
	
	var PASSENGER_BOOKING_CANCEL = exports.PASSENGER_BOOKING_CANCEL = 'PASSENGER_BOOKING_CANCEL';
	function passengerBookingCancel(cohortID, passengerID, bookingID) {
	  var _meta5;
	
	  _reactGa2.default.event({
	    category: _gaUtils.PASSENGERS,
	    action: _gaUtils.PASSENGERS_ACTIONS.PASSENGER_BOOKING_CANCEL
	  });
	  return {
	    type: PASSENGER_BOOKING_CANCEL,
	    payload: {
	      method: 'POST',
	      url: '/passengers/' + passengerID + '/bookings/' + bookingID + '/cancel'
	    },
	    meta: (_meta5 = {}, _defineProperty(_meta5, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta5, 'cohortID', cohortID), _defineProperty(_meta5, 'passengerID', passengerID), _defineProperty(_meta5, 'bookingID', bookingID), _meta5)
	  };
	}
	
	var PASSENGER_DELETE = exports.PASSENGER_DELETE = 'PASSENGER_DELETE';
	function passengerDeleteInstant(cohortID, passengerID) {
	  return {
	    type: PASSENGER_DELETE,
	    payload: {
	      cohortID: cohortID,
	      passengerID: passengerID
	    }
	  };
	}
	
	function passengerDelete(cohortID, passengerID) {
	  var _meta6;
	
	  _reactGa2.default.event({
	    category: _gaUtils.PASSENGERS,
	    action: _gaUtils.PASSENGERS_ACTIONS.PASSENGER_DELETE
	  });
	  return {
	    type: PASSENGER_DELETE,
	    payload: {
	      method: 'DELETE',
	      url: '/passengers/' + passengerID
	    },
	    meta: (_meta6 = {}, _defineProperty(_meta6, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta6, 'cohortID', cohortID), _defineProperty(_meta6, 'passengerID', passengerID), _meta6)
	  };
	}
	
	var PASSENGER_BOOKING_NEW = exports.PASSENGER_BOOKING_NEW = 'PASSENGER_BOOKING_NEW';
	function passengerBookingNew(cohortID, passengerID, bookingID, booking) {
	  _reactGa2.default.event({
	    category: _gaUtils.PASSENGERS,
	    action: _gaUtils.PASSENGERS_ACTIONS.PASSENGER_BOOKING_NEW
	  });
	  return {
	    type: PASSENGER_BOOKING_NEW,
	    payload: {
	      cohortID: cohortID,
	      passengerID: passengerID,
	      bookingID: bookingID,
	      booking: booking
	    }
	  };
	}
	
	var PASSENGER_BOOKING_STATE_CHANGE = exports.PASSENGER_BOOKING_STATE_CHANGE = 'PASSENGER_BOOKING_STATE_CHANGE';
	function passengerBookingStateChange(cohortID, passengerID, bookingID, state) {
	  _reactGa2.default.event({
	    category: _gaUtils.PASSENGERS,
	    action: _gaUtils.PASSENGERS_ACTIONS.PASSENGER_BOOKING_STATE_CHANGE
	  });
	  return {
	    type: PASSENGER_BOOKING_STATE_CHANGE,
	    payload: {
	      cohortID: cohortID,
	      passengerID: passengerID,
	      bookingID: bookingID,
	      state: state
	    }
	  };
	}
	
	var PASSENGER_BOOKING_DELETE = exports.PASSENGER_BOOKING_DELETE = 'PASSENGER_BOOKING_DELETE';
	function passengerBookingDelete(cohortID, passengerID, bookingID) {
	  _reactGa2.default.event({
	    category: _gaUtils.PASSENGERS,
	    action: _gaUtils.PASSENGERS_ACTIONS.PASSENGER_BOOKING_DELETE
	  });
	  return {
	    type: PASSENGER_BOOKING_DELETE,
	    payload: {
	      cohortID: cohortID,
	      passengerID: passengerID,
	      bookingID: bookingID
	    }
	  };
	}
	
	var PASSENGER_GET_NEARBY_TAXI_TYPES = exports.PASSENGER_GET_NEARBY_TAXI_TYPES = 'PASSENGER_GET_NEARBY_TAXI_TYPES';
	function passengerGetNearbyTaxiTypes(passengerID, pickUpPoint) {
	  var _meta7;
	
	  return {
	    type: PASSENGER_GET_NEARBY_TAXI_TYPES,
	    payload: {
	      method: 'GET',
	      url: '/passengers/' + passengerID + '/nearby-taxi-types',
	      params: {
	        latitude: pickUpPoint[1],
	        longitude: pickUpPoint[0]
	      }
	    },
	    meta: (_meta7 = {}, _defineProperty(_meta7, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta7, 'passengerID', passengerID), _defineProperty(_meta7, 'pickUpPoint', pickUpPoint), _meta7)
	  };
	}
	
	var PASSENGER_CHANGE_DESTINATION = exports.PASSENGER_CHANGE_DESTINATION = 'PASSENGER_CHANGE_DESTINATION';
	function passengerChangeDestination(cohortID, passengerID, bookingID, dest) {
	  var _meta8;
	
	  var dropoffPoint = {
	    latitude: dest[0],
	    longitude: dest[1],
	    // TODO: to be removed once the backend is fixed
	    address: 'address',
	    keywords: 'keywords'
	  };
	
	  return {
	    type: PASSENGER_CHANGE_DESTINATION,
	    payload: {
	      method: 'POST',
	      url: '/passengers/' + passengerID + '/bookings/' + bookingID + '/change_destination',
	      data: {
	        updatedDestination: dropoffPoint
	      }
	    },
	    meta: (_meta8 = {}, _defineProperty(_meta8, _apiMiddleware.API_REQUEST, true), _defineProperty(_meta8, 'dropoffPoint', dropoffPoint), _defineProperty(_meta8, 'passengerID', passengerID), _defineProperty(_meta8, 'bookingID', bookingID), _defineProperty(_meta8, 'cohortID', cohortID), _meta8)
	  };
	}

/***/ },
/* 72 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bookingStateMapping;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// BookingStateUNKNOWN refers to an unknown booking state.
	var BOOKING_STATE_UNKNOWN = exports.BOOKING_STATE_UNKNOWN = 0;
	// BOOKING_STATE_NEW refers to a new booking.
	var BOOKING_STATE_NEW = exports.BOOKING_STATE_NEW = 1;
	// BOOKING_STATE_SURFACED refers to a booking broadcasted to all nominated drivers.
	var BOOKING_STATE_SURFACED = exports.BOOKING_STATE_SURFACED = 2;
	// BOOKING_STATE_BID refers to a booking which was bid by the given driver.
	var BOOKING_STATE_BID = exports.BOOKING_STATE_BID = 3;
	// BOOKING_STATE_DECLINED refers to a booking which was declined by the given driver.
	var BOOKING_STATE_DECLINED = exports.BOOKING_STATE_DECLINED = 4;
	// BOOKING_STATE_UNREAD is the same as the `bookingCandidateStateUnread` state.
	var BOOKING_STATE_UNREAD = exports.BOOKING_STATE_UNREAD = 5;
	// BOOKING_STATE_IGNORED refers to an assignment booking which was ignored by the given driver.
	var BOOKING_STATE_IGNORED = exports.BOOKING_STATE_IGNORED = 6;
	// BOOKING_STATE_BID_CANCELLED refers to a booking where the bid was cancelled by the given driver.
	var BOOKING_STATE_BID_CANCELLED = exports.BOOKING_STATE_BID_CANCELLED = 7;
	// BOOKING_STATE_JOB_CANCELLED refers to a booking which was cancelled by the passenger.
	var BOOKING_STATE_JOB_CANCELLED = exports.BOOKING_STATE_JOB_CANCELLED = 8;
	// BOOKING_STATE_CONFIRMED refers to a booking where the awarded
	// message has been sent to the given driver.
	// Booking Service uses CONFIRMED to indicate the driver is AWARDED.
	var BOOKING_STATE_CONFIRMED = exports.BOOKING_STATE_CONFIRMED = 9;
	// BOOKING_STATE_AWARDED refers to a booking which was awarded to the given driver.
	var BOOKING_STATE_AWARDED = exports.BOOKING_STATE_AWARDED = 10;
	// BOOKING_STATE_ADVANCE_AWARDED refers to a booking which was awarded in
	// advance to the given driver.
	var BOOKING_STATE_ADVANCE_AWARDED = exports.BOOKING_STATE_ADVANCE_AWARDED = 11;
	// BOOKING_STATE_REJECTED refers to a booking which was not assigned to the given driver.
	var BOOKING_STATE_REJECTED = exports.BOOKING_STATE_REJECTED = 12;
	// BOOKING_STATE_CLOSED is the same as the `bookingCandidateStateClosed` state.
	var BOOKING_STATE_CLOSED = exports.BOOKING_STATE_CLOSED = 13;
	// BOOKING_STATE_PICKING_UP refers to a booking which the driver is
	// travelling to pick up the passenger.
	var BOOKING_STATE_PICKING_UP = exports.BOOKING_STATE_PICKING_UP = 14;
	// BOOKING_STATE_DROPPING_OFF refers to a booking which the driver is travelling
	// to the passenger's destination.
	var BOOKING_STATE_DROPPING_OFF = exports.BOOKING_STATE_DROPPING_OFF = 15;
	// BOOKING_STATE_COMPLETED refers to a booking which was completed.
	var BOOKING_STATE_COMPLETED = exports.BOOKING_STATE_COMPLETED = 16;
	// BOOKING_STATE_DRIVER_CANCELLED refers to a booking which was cancelled by the driver.
	var BOOKING_STATE_DRIVER_CANCELLED = exports.BOOKING_STATE_DRIVER_CANCELLED = 17;
	// BOOKING_STATE_UNALLOCATED refers to a booking which was not assigned to any driver.
	var BOOKING_STATE_UNALLOCATED = exports.BOOKING_STATE_UNALLOCATED = 18;
	// BOOKING_STATE_RECYCLE refers to a booking which was recycled (change to another strategy)
	// if there is no candidate found during nomination.
	var BOOKING_STATE_RECYCLE = exports.BOOKING_STATE_RECYCLE = 19;
	
	var bookingStateMapping = exports.bookingStateMapping = (_bookingStateMapping = {}, _defineProperty(_bookingStateMapping, BOOKING_STATE_UNKNOWN, 'UNKNOWN'), _defineProperty(_bookingStateMapping, BOOKING_STATE_NEW, 'NEW'), _defineProperty(_bookingStateMapping, BOOKING_STATE_SURFACED, 'SURFACED'), _defineProperty(_bookingStateMapping, BOOKING_STATE_BID, 'BID'), _defineProperty(_bookingStateMapping, BOOKING_STATE_DECLINED, 'DECLINED'), _defineProperty(_bookingStateMapping, BOOKING_STATE_UNREAD, 'UNREAD'), _defineProperty(_bookingStateMapping, BOOKING_STATE_IGNORED, 'IGNORED'), _defineProperty(_bookingStateMapping, BOOKING_STATE_BID_CANCELLED, 'BID_CANCELLED'), _defineProperty(_bookingStateMapping, BOOKING_STATE_JOB_CANCELLED, 'JOB_CANCELLED'), _defineProperty(_bookingStateMapping, BOOKING_STATE_CONFIRMED, 'CONFIRMED'), _defineProperty(_bookingStateMapping, BOOKING_STATE_AWARDED, 'AWARDED'), _defineProperty(_bookingStateMapping, BOOKING_STATE_ADVANCE_AWARDED, 'ADVANCE_AWARDED'), _defineProperty(_bookingStateMapping, BOOKING_STATE_REJECTED, 'REJECTED'), _defineProperty(_bookingStateMapping, BOOKING_STATE_CLOSED, 'CLOSED'), _defineProperty(_bookingStateMapping, BOOKING_STATE_PICKING_UP, 'PICKING_UP'), _defineProperty(_bookingStateMapping, BOOKING_STATE_DROPPING_OFF, 'DROPPING_OFF'), _defineProperty(_bookingStateMapping, BOOKING_STATE_COMPLETED, 'COMPLETED'), _defineProperty(_bookingStateMapping, BOOKING_STATE_DRIVER_CANCELLED, 'DRIVER_CANCELLED'), _defineProperty(_bookingStateMapping, BOOKING_STATE_UNALLOCATED, 'UNALLOCATED'), _defineProperty(_bookingStateMapping, BOOKING_STATE_RECYCLE, 'RECYCLED'), _bookingStateMapping);
	
	var BOOKING_MARKER_PICKUP = exports.BOOKING_MARKER_PICKUP = 1;
	var BOOKING_MARKER_DROPOFF = exports.BOOKING_MARKER_DROPOFF = 2;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bookingStateString = bookingStateString;
	exports.canBookingBeBid = canBookingBeBid;
	exports.canBookingBeCancelledByPassenger = canBookingBeCancelledByPassenger;
	exports.canBookingBeCancelledByDriver = canBookingBeCancelledByDriver;
	exports.canBookingBePickedUp = canBookingBePickedUp;
	exports.canBookingBeDroppedOff = canBookingBeDroppedOff;
	exports.toBookingRequestV2 = toBookingRequestV2;
	exports.containsAdditionalDropOff = containsAdditionalDropOff;
	exports.canDestinationBeChanged = canDestinationBeChanged;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _immutable = __webpack_require__(22);
	
	var _bookings = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function bookingStateString(bookingState) {
	  if (typeof bookingState === 'number' && bookingState > 0) {
	    return _bookings.bookingStateMapping[bookingState];
	  }
	  return _bookings.bookingStateMapping[_bookings.BOOKING_STATE_UNKNOWN];
	}
	function canBookingBeBid(state) {
	  // TODO: Check which booking states can be bid for.
	  var BIDDABLE_BOOKING_STATES = [_bookings.BOOKING_STATE_UNKNOWN, _bookings.BOOKING_STATE_NEW, _bookings.BOOKING_STATE_SURFACED, _bookings.BOOKING_STATE_RECYCLE];
	  return _lodash2.default.includes(BIDDABLE_BOOKING_STATES, state);
	}
	
	function canBookingBeCancelledByPassenger(state) {
	  var PASSENGER_CANCELLABLE_BOOKING_STATES = [_bookings.BOOKING_STATE_UNKNOWN, _bookings.BOOKING_STATE_NEW, _bookings.BOOKING_STATE_SURFACED, _bookings.BOOKING_STATE_BID, _bookings.BOOKING_STATE_DECLINED, _bookings.BOOKING_STATE_UNREAD, _bookings.BOOKING_STATE_IGNORED, _bookings.BOOKING_STATE_CONFIRMED, _bookings.BOOKING_STATE_AWARDED, _bookings.BOOKING_STATE_ADVANCE_AWARDED, _bookings.BOOKING_STATE_PICKING_UP, _bookings.BOOKING_STATE_RECYCLE];
	  return _lodash2.default.includes(PASSENGER_CANCELLABLE_BOOKING_STATES, state);
	}
	
	function canBookingBeCancelledByDriver(state) {
	  var DRIVER_CANCELLABLE_BOOKING_STATES = [_bookings.BOOKING_STATE_CONFIRMED, _bookings.BOOKING_STATE_AWARDED, _bookings.BOOKING_STATE_ADVANCE_AWARDED, _bookings.BOOKING_STATE_PICKING_UP];
	  return _lodash2.default.includes(DRIVER_CANCELLABLE_BOOKING_STATES, state);
	}
	
	function canBookingBePickedUp(state) {
	  // TODO: Check which booking states can be picked up.
	  var PICKUPABLE_BOOKING_STATES = [_bookings.BOOKING_STATE_PICKING_UP];
	  return _lodash2.default.includes(PICKUPABLE_BOOKING_STATES, state);
	}
	
	function canBookingBeDroppedOff(state) {
	  // TODO: Check which booking states can be dropped off.
	  var DROPOFFABLE_BOOKING_STATES = [_bookings.BOOKING_STATE_DROPPING_OFF];
	  return _lodash2.default.includes(DROPOFFABLE_BOOKING_STATES, state);
	}
	
	function toBookingRequestV2(bookingRequest, pois) {
	  var pickupLocationKey = (0, _immutable.List)([bookingRequest.pickUpLongitude, bookingRequest.pickUpLatitude]);
	
	  var itinerary = [{
	    latitude: bookingRequest.pickUpLatitude,
	    longitude: bookingRequest.pickUpLongitude,
	    address: pois.get(pickupLocationKey) || '',
	    keywords: pois.get(pickupLocationKey) || ''
	  }];
	
	  _lodash2.default.each(bookingRequest.extraDropOffs, function (drop) {
	    if (!_lodash2.default.isEmpty(drop)) {
	      var extraDropKey = (0, _immutable.List)(drop);
	      itinerary.push({
	        latitude: drop[1],
	        longitude: drop[0],
	        address: pois.get(extraDropKey) || '',
	        keywords: pois.get(extraDropKey) || ''
	      });
	    }
	  });
	
	  var dropOffLocationKey = (0, _immutable.List)([bookingRequest.dropOffLongitude, bookingRequest.dropOffLatitude]);
	
	  itinerary.push({
	    latitude: bookingRequest.dropOffLatitude,
	    longitude: bookingRequest.dropOffLongitude,
	    address: pois.get(dropOffLocationKey) || '',
	    keywords: pois.get(dropOffLocationKey) || ''
	  });
	
	  return {
	    taxiTypeID: bookingRequest.taxiTypeID,
	    paymentType: bookingRequest.paymentType,
	    remarks: bookingRequest.remarks,
	    itinerary: itinerary
	  };
	}
	
	function containsAdditionalDropOff(booking) {
	  return (booking.itinerary || []).length > 2;
	}
	
	function canDestinationBeChanged(state) {
	  return state === _bookings.BOOKING_STATE_DROPPING_OFF;
	}

/***/ },
/* 74 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.roundCoordinate = roundCoordinate;
	exports.extendBounds = extendBounds;
	exports.getBoundsZoomLevel = getBoundsZoomLevel;
	function roundCoordinate(value) {
	  return parseFloat(value.toFixed(6));
	}
	
	function extendBounds(markers) {
	  var extent = [[-Infinity, -Infinity], [Infinity, Infinity]];
	  markers.forEach(function (marker) {
	    if (marker[0] > extent[0][0]) {
	      extent[0][0] = marker[0];
	    }
	
	    if (marker[0] < extent[1][0]) {
	      extent[1][0] = marker[0];
	    }
	
	    if (marker[1] > extent[0][1]) {
	      extent[0][1] = marker[1];
	    }
	
	    if (marker[1] < extent[1][1]) {
	      extent[1][1] = marker[1];
	    }
	  });
	
	  // https://github.com/uber/react-map-gl/issues/83
	  return [[extent[0][1], extent[0][0]], [extent[1][1], extent[1][0]]];
	}
	
	function getBoundsZoomLevel(width, height, bounds) {
	  // We have to defined our own function to calculate zoom level given some bounds
	  // because react-map-gl's MapGL.fitBounds gives `NaN` for zoom.
	  // http://stackoverflow.com/a/13274361/1751946
	  var WORLD_DIM = { height: 256, width: 256 };
	  var ZOOM_MAX = 21;
	  // Mapbox zoom level is different from Google's. This value is arbitrarily determined.
	  var OFFSET = 2;
	
	  function latRad(lat) {
	    var sin = Math.sin(lat * Math.PI / 180);
	    var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
	    return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
	  }
	
	  function zoom(mapPx, worldPx, fraction) {
	    return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
	  }
	
	  var ne = bounds[0];
	  var sw = bounds[1];
	
	  var latFraction = (latRad(ne[1]) - latRad(sw[1])) / Math.PI;
	
	  var lngDiff = ne[0] - sw[0];
	  var lngFraction = (lngDiff < 0 ? lngDiff + 360 : lngDiff) / 360;
	
	  var latZoom = zoom(height, WORLD_DIM.height, latFraction);
	  var lngZoom = zoom(width, WORLD_DIM.width, lngFraction);
	
	  return Math.min(latZoom, lngZoom, ZOOM_MAX) - OFFSET;
	}

/***/ },
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  API_ORIGIN: 'https://api.mapbox.com',
	  EVENT_PROGRESS_DOWNLOAD: 'downloadProgress',
	  EVENT_PROGRESS_UPLOAD: 'uploadProgress',
	  EVENT_ERROR: 'error',
	  EVENT_RESPONSE: 'response',
	  ERROR_HTTP: 'HttpError',
	  ERROR_REQUEST_ABORTED: 'RequestAbortedError'
	};


/***/ },
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ },
/* 113 */,
/* 114 */,
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(454);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 116 */,
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(118)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 118 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 119 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 120 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _memorystorage = __webpack_require__(418);
	
	var _memorystorage2 = _interopRequireDefault(_memorystorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fallbackStorage() {
	  if (true) {
	    console.warn('[grab-storage]', 'Using `MemoryStorage` due to `window.localStorage` is not supported.');
	  }
	
	  return new _memorystorage2.default();
	}
	
	function GrabStorage() {
	  var storage = null;
	
	  if (!storage) {
	    // Occurs when it's a browser environment
	    // Using global variable `__USE_MEMORY_STORAGE__` for testing purpose
	    if (typeof window !== 'undefined' && !window.__USE_MEMORY_STORAGE__) {
	      var KEY = 'grab_storage_supported_' + Math.random();
	
	      try {
	        window.localStorage.setItem(KEY, 'true');
	
	        if (window.localStorage.getItem(KEY) !== 'true') {
	          throw new Error('Unable to use `window.localStorage`.');
	        }
	
	        window.localStorage.removeItem(KEY);
	        storage = window.localStorage;
	      } catch (err) {
	        // Occurs when the browser(i.e. Safari) is in private mode.
	        storage = fallbackStorage();
	      }
	    } else {
	      // Occurs when it's a Node environment.
	      storage = fallbackStorage();
	    }
	  }
	
	  return storage;
	}
	
	exports.default = new GrabStorage();

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _libraryUtils = __webpack_require__(36);
	
	var _InputLocation = __webpack_require__(198);
	
	var _InputLocation2 = _interopRequireDefault(_InputLocation);
	
	var _mapUtils = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NUMERICAL_FIELDS = ['latitude', 'longitude'];
	
	var _ref = _jsx('div', {
	  className: 'notification is-warning',
	  role: 'alert'
	}, void 0, 'These drivers have to exist in the driver databases of the respective environments.');
	
	var _ref2 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'name'
	}, void 0, 'Name');
	
	var _ref3 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'driver-id'
	}, void 0, 'Driver ID');
	
	var _ref4 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'imei'
	}, void 0, 'IMEI');
	
	var _ref5 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'device-id'
	}, void 0, 'Device ID');
	
	var _ref6 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'location'
	}, void 0, 'Latitude / Longitude');
	
	var _ref7 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'behaviour'
	}, void 0, 'Behaviour');
	
	var _ref8 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'behaviour-parameters'
	}, void 0, 'Behaviour Parameters');
	
	var DriverForm = (_temp = _class = function (_Component) {
	  _inherits(DriverForm, _Component);
	
	  function DriverForm(props) {
	    _classCallCheck(this, DriverForm);
	
	    var _this = _possibleConstructorReturn(this, (DriverForm.__proto__ || Object.getPrototypeOf(DriverForm)).call(this, props));
	
	    var value = _lodash2.default.cloneDeep(_this.props.defaultValue || {});
	    NUMERICAL_FIELDS.forEach(function (field) {
	      if (_lodash2.default.isNumber(value[field])) {
	        value[field] = value[field].toString();
	      }
	    });
	    if (value.behaviour.params) {
	      _libraryUtils.DRIVER_BEHAVIOUR_PARAMS[value.behaviour.type].forEach(function (fieldObject) {
	        value.behaviour.params[fieldObject.name] = fieldObject.renderValue(value.behaviour.params[fieldObject.name]);
	      });
	    }
	    _this.state = {
	      value: value,
	      driverIDValid: true,
	      imeiValid: true,
	      locationValid: true
	    };
	    return _this;
	  }
	
	  _createClass(DriverForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      navigator.geolocation.getCurrentPosition(function (position) {
	        if (_this2.state.value.latitude == null && _this2.state.value.longitude == null) {
	          _this2.setState({
	            value: _lodash2.default.merge(_this2.state.value, {
	              latitude: (0, _mapUtils.roundCoordinate)(position.coords.latitude),
	              longitude: (0, _mapUtils.roundCoordinate)(position.coords.longitude)
	            })
	          }, function () {
	            _this2.setState({ locationValid: _this2.location.isValid() });
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      var value = _lodash2.default.cloneDeep(this.state.value);
	      NUMERICAL_FIELDS.forEach(function (field) {
	        if (value[field]) {
	          value[field] = parseFloat(value[field]);
	        }
	      });
	      var behaviourType = _lodash2.default.get(this.state.value, 'behaviour.type');
	      if (value.behaviour.params) {
	        _libraryUtils.DRIVER_BEHAVIOUR_PARAMS[behaviourType].forEach(function (fieldObject) {
	          var fieldName = fieldObject.name;
	          if (value.behaviour.params[fieldName] !== '' && value.behaviour.params[fieldName] != null) {
	            value.behaviour.params[fieldName] = fieldObject.processValue(value.behaviour.params[fieldName]);
	          } else {
	            delete value.behaviour.params[fieldName];
	          }
	        });
	      }
	      return value;
	    }
	  }, {
	    key: 'isValid',
	    value: function isValid() {
	      var driverIDValid = this.state.value.cohortDriverID != null && this.state.value.cohortDriverID !== '';
	      var imeiValid = this.state.value.imei != null && this.state.value.imei !== '';
	      var locationValid = this.location.isValid();
	      this.setState({
	        driverIDValid: driverIDValid,
	        imeiValid: imeiValid,
	        locationValid: locationValid
	      });
	      return driverIDValid && imeiValid && locationValid;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var behaviourType = _lodash2.default.get(this.state.value, 'behaviour.type');
	      return _jsx('div', {
	        role: 'form'
	      }, void 0, _ref, _jsx('div', {
	        className: 'control is-grouped'
	      }, void 0, _jsx('p', {
	        className: 'control is-expanded'
	      }, void 0, _ref2, _jsx('input', {
	        className: 'input',
	        type: 'text',
	        id: 'name',
	        placeholder: 'For your own reference. E.g. Hannah Test Account',
	        value: this.state.value.name || '',
	        onChange: function onChange(event) {
	          _this3.setState(_lodash2.default.merge(_this3.state, {
	            value: {
	              name: event.target.value
	            }
	          }));
	        }
	      }))), _jsx('div', {
	        className: 'control is-grouped'
	      }, void 0, _jsx('p', {
	        className: 'control is-expanded'
	      }, void 0, _ref3, _jsx('input', {
	        className: (0, _classnames2.default)('input', { 'is-danger': !this.state.driverIDValid }),
	        type: 'text',
	        id: 'driver-id',
	        value: this.state.value.cohortDriverID || '',
	        disabled: this.props.disableLoginFields,
	        onChange: function onChange(event) {
	          _this3.setState(_lodash2.default.merge(_this3.state, {
	            value: {
	              cohortDriverID: event.target.value
	            }
	          }), function () {
	            _this3.setState({
	              driverIDValid: _this3.state.value.cohortDriverID != null && _this3.state.value.cohortDriverID !== ''
	            });
	          });
	        }
	      })), _jsx('p', {
	        className: 'control is-expanded'
	      }, void 0, _ref4, _jsx('input', {
	        className: (0, _classnames2.default)('input', { 'is-danger': !this.state.imeiValid }),
	        type: this.props.disableLoginFields ? 'password' : 'text',
	        id: 'imei',
	        value: this.props.disableLoginFields ? 'REDACTEDIMEINUM' : this.state.value.imei || '',
	        disabled: this.props.disableLoginFields,
	        onChange: function onChange(event) {
	          _this3.setState(_lodash2.default.merge(_this3.state, {
	            value: {
	              imei: event.target.value
	            }
	          }), function () {
	            _this3.setState({
	              imeiValid: _this3.state.value.imei != null && _this3.state.value.imei !== ''
	            });
	          });
	        }
	      })), _jsx('p', {
	        className: 'control is-expanded'
	      }, void 0, _ref5, _jsx('input', {
	        className: 'input',
	        type: this.props.disableLoginFields ? 'password' : 'text',
	        id: 'device-id',
	        value: this.props.disableLoginFields ? 'DEVICEID' : this.state.value.deviceID || '',
	        disabled: this.props.disableLoginFields,
	        onChange: function onChange(event) {
	          _this3.setState(_lodash2.default.merge(_this3.state, {
	            value: {
	              deviceID: event.target.value
	            }
	          }));
	        }
	      }))), _jsx('div', {
	        className: 'control is-grouped'
	      }, void 0, _jsx('p', {
	        className: 'control is-expanded'
	      }, void 0, _ref6, _react2.default.createElement(_InputLocation2.default, {
	        id: 'location',
	        value: [this.state.value.longitude, this.state.value.latitude],
	        className: (0, _classnames2.default)({ 'is-danger': !this.state.locationValid })
	        // POI ID: IT.03SS0M9D7XP4B
	        , placeholder: '1.28105,103.84853',
	        ref: function ref(value) {
	          _this3.location = value;
	        },
	        onBeforeChange: function onBeforeChange() {
	          _this3.setState({ locationValid: _this3.location.isValid() });
	        },
	        onChange: function onChange(value) {
	          _this3.setState({
	            value: _lodash2.default.merge(_this3.state.value, {
	              longitude: value[0],
	              latitude: value[1]
	            })
	          });
	        }
	      }))), _ref7, _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx('span', {
	        className: 'select'
	      }, void 0, _jsx('select', {
	        id: 'behaviour',
	        value: behaviourType,
	        onChange: function onChange(event) {
	          _this3.setState(_lodash2.default.merge(_this3.state, {
	            value: {
	              behaviour: {
	                type: event.target.value
	              }
	            }
	          }));
	        }
	      }, void 0, _libraryUtils.DRIVER_BEHAVIOUR_TYPES.map(function (behaviour) {
	        return _jsx('option', {
	          value: behaviour.value
	        }, behaviour.value, behaviour.name);
	      })))), _jsx('div', {}, void 0, _ref8, _libraryUtils.DRIVER_BEHAVIOUR_PARAMS[behaviourType].map(function (field) {
	        switch (field.type) {
	          case 'number':
	            return _jsx('div', {
	              className: 'columns'
	            }, field.name, _jsx('div', {
	              className: 'column is-one-third'
	            }, void 0, _jsx('label', {
	              className: 'label',
	              htmlFor: field.name
	            }, void 0, _jsx('code', {}, void 0, field.name))), _jsx('div', {
	              className: 'column is-two-thirds'
	            }, void 0, _jsx('input', {
	              className: 'input',
	              id: field.name,
	              type: _libraryUtils.DRIVER_BEHAVIOUR_PARAMS[behaviourType][field.name],
	              placeholder: field.hint || _lodash2.default.startCase(field.name),
	              value: _lodash2.default.get(_this3.state.value, 'behaviour.params.' + field.name, ''),
	              onChange: function onChange(event) {
	                _this3.setState(_lodash2.default.merge(_this3.state, {
	                  value: {
	                    behaviour: {
	                      params: _defineProperty({}, field.name, event.target.value)
	                    }
	                  }
	                }));
	              }
	            })));
	          case 'boolean':
	            return _jsx('div', {
	              className: 'columns'
	            }, field.name, _jsx('div', {
	              className: 'column is-one-third'
	            }, void 0, _jsx('p', {
	              className: 'control'
	            }, void 0, _jsx('label', {
	              className: 'checkbox',
	              htmlFor: field.name
	            }, void 0, _jsx('code', {}, void 0, field.name)))), _jsx('div', {
	              className: 'column is-two-thirds'
	            }, void 0, _jsx('input', {
	              type: 'checkbox',
	              id: field.name,
	              checked: _lodash2.default.get(_this3.state.value, 'behaviour.params.' + field.name),
	              onChange: function onChange(event) {
	                _this3.setState(_lodash2.default.merge(_this3.state, {
	                  value: {
	                    behaviour: {
	                      params: _defineProperty({}, field.name, !!event.target.checked)
	                    }
	                  }
	                }));
	              }
	            })));
	          default:
	            return null;
	        }
	      })));
	    }
	  }]);
	
	  return DriverForm;
	}(_react.Component), _class.defaultProps = {
	  defaultValue: {
	    behaviour: {
	      type: _libraryUtils.DRIVER_BEHAVIOURS.MANUAL,
	      params: {}
	    }
	  },
	  disableLoginFields: false
	}, _temp);
	exports.default = DriverForm;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _libraryUtils = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('div', {
	  className: 'notification is-warning',
	  role: 'alert'
	}, void 0, 'These passengers have to exist in the passenger databases of the respective environments.');
	
	var _ref2 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'name'
	}, void 0, 'Name');
	
	var _ref3 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'passenger-id'
	}, void 0, 'Passenger ID');
	
	var _ref4 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'api-token'
	}, void 0, 'API Token');
	
	var _ref5 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'behaviour'
	}, void 0, 'Behaviour');
	
	var _ref6 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'behaviour-parameters'
	}, void 0, 'Behaviour Parameters');
	
	var PassengerForm = (_temp = _class = function (_Component) {
	  _inherits(PassengerForm, _Component);
	
	  function PassengerForm(props) {
	    _classCallCheck(this, PassengerForm);
	
	    var _this = _possibleConstructorReturn(this, (PassengerForm.__proto__ || Object.getPrototypeOf(PassengerForm)).call(this, props));
	
	    var value = _lodash2.default.cloneDeep(_this.props.defaultValue || {});
	    if (value.behaviour.params) {
	      _libraryUtils.PASSENGER_BEHAVIOUR_PARAMS[value.behaviour.type].forEach(function (fieldObject) {
	        value.behaviour.params[fieldObject.name] = fieldObject.renderValue(value.behaviour.params[fieldObject.name]);
	      });
	    }
	    _this.state = {
	      value: value,
	      passengerIDValid: true,
	      behaviourValid: true
	    };
	    return _this;
	  }
	
	  _createClass(PassengerForm, [{
	    key: 'getValue',
	    value: function getValue() {
	      var value = _lodash2.default.cloneDeep(this.state.value);
	      var behaviourType = _lodash2.default.get(this.state.value, 'behaviour.type');
	      if ((0, _libraryUtils.hasPassengerBehaviour)(behaviourType) && value.behaviour.params) {
	        _libraryUtils.PASSENGER_BEHAVIOUR_PARAMS[behaviourType].forEach(function (fieldObject) {
	          var fieldName = fieldObject.name;
	          if (value.behaviour.params[fieldName] !== '' && value.behaviour.params[fieldName] != null) {
	            value.behaviour.params[fieldName] = fieldObject.processValue(value.behaviour.params[fieldName]);
	          } else {
	            delete value.behaviour.params[fieldName];
	          }
	        });
	      }
	      return value;
	    }
	  }, {
	    key: 'isValid',
	    value: function isValid() {
	      var passengerIDValid = this.validatePassengerID();
	      var behaviourValid = this.validateBehaviour();
	      this.setState({
	        passengerIDValid: passengerIDValid,
	        behaviourValid: behaviourValid
	      });
	      return passengerIDValid && behaviourValid;
	    }
	  }, {
	    key: 'validatePassengerID',
	    value: function validatePassengerID() {
	      return this.props.disableLoginFields || this.state.value.cohortPassengerID != null && this.state.value.cohortPassengerID !== '';
	    }
	  }, {
	    key: 'validateBehaviour',
	    value: function validateBehaviour() {
	      var value = _lodash2.default.cloneDeep(this.state.value);
	      var behaviourType = _lodash2.default.get(value, 'behaviour.type');
	      var params = _lodash2.default.get(value, 'behaviour.params');
	
	      function validateParam(field) {
	        return _lodash2.default.get(params, field.name, false) && field.validate(params[field.name]);
	      }
	
	      return _libraryUtils.PASSENGER_BEHAVIOUR_PARAMS[behaviourType].every(validateParam);
	    }
	  }, {
	    key: 'errors',
	    value: function errors() {
	      var allErrors = [];
	      if (!this.validatePassengerID()) {
	        allErrors.push({ message: 'Invalid Passenger ID' });
	      }
	
	      if (!this.validateBehaviour()) {
	        allErrors.push({ message: 'Invalid Behaviour Params' });
	      }
	
	      return allErrors;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var behaviourType = _lodash2.default.get(this.state.value, 'behaviour.type');
	      return _jsx('div', {
	        role: 'form'
	      }, void 0, _ref, _jsx('div', {
	        className: 'control is-grouped'
	      }, void 0, _jsx('p', {
	        className: 'control is-expanded'
	      }, void 0, _ref2, _jsx('input', {
	        className: 'input',
	        type: 'text',
	        id: 'name',
	        placeholder: 'For your own reference. E.g. Hannah Test Account',
	        value: this.state.value.name || '',
	        onChange: function onChange(event) {
	          _this2.setState(_lodash2.default.merge(_this2.state, {
	            value: {
	              name: event.target.value
	            }
	          }));
	        }
	      }))), _jsx('div', {
	        className: 'control is-grouped'
	      }, void 0, _jsx('p', {
	        className: 'control is-expanded'
	      }, void 0, _ref3, _jsx('input', {
	        className: (0, _classnames2.default)('input', { 'is-danger': !this.state.passengerIDValid }),
	        type: 'text',
	        id: 'passenger-id',
	        value: this.state.value.cohortPassengerID || '',
	        disabled: this.props.disableLoginFields,
	        onChange: function onChange(event) {
	          _this2.setState(_lodash2.default.merge(_this2.state, {
	            value: {
	              cohortPassengerID: event.target.value
	            }
	          }), function () {
	            _this2.setState({
	              passengerIDValid: _this2.validatePassengerID()
	            });
	          });
	        }
	      })), _jsx('p', {
	        className: 'control is-expanded'
	      }, void 0, _ref4, _jsx('input', {
	        className: (0, _classnames2.default)('input'),
	        type: this.props.disableLoginFields ? 'password' : 'text',
	        id: 'api-token',
	        value: this.props.disableLoginFields ? 'REDACTEDREDACTEDREDACTEDAPITOKEN' : this.state.value.apiToken || '',
	        disabled: this.props.disableLoginFields,
	        onChange: function onChange(event) {
	          _this2.setState(_lodash2.default.merge(_this2.state, {
	            value: {
	              apiToken: event.target.value
	            }
	          }));
	        }
	      }))), _ref5, _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx('span', {
	        className: 'select'
	      }, void 0, _jsx('select', {
	        id: 'behaviour',
	        value: behaviourType,
	        onChange: function onChange(event) {
	          _this2.setState(_lodash2.default.merge(_this2.state, {
	            value: {
	              behaviour: {
	                type: event.target.value
	              }
	            }
	          }), function () {
	            _this2.setState({
	              behaviourValid: _this2.validateBehaviour()
	            });
	          });
	        }
	      }, void 0, _libraryUtils.PASSENGER_BEHAVIOUR_TYPES.map(function (behaviour) {
	        return _jsx('option', {
	          value: behaviour.value
	        }, behaviour.value, behaviour.name);
	      })))), (0, _libraryUtils.hasPassengerBehaviour)(behaviourType) && _jsx('div', {}, void 0, _ref6, _libraryUtils.PASSENGER_BEHAVIOUR_PARAMS[behaviourType].map(function (field) {
	        return _jsx('div', {
	          className: 'columns'
	        }, field.name, _jsx('div', {
	          className: 'column is-one-third'
	        }, void 0, _jsx('label', {
	          className: 'label',
	          htmlFor: field.name
	        }, void 0, _jsx('code', {}, void 0, field.name))), _jsx('div', {
	          className: 'column is-two-thirds'
	        }, void 0, _jsx('input', {
	          className: 'input',
	          id: field.name,
	          type: _libraryUtils.PASSENGER_BEHAVIOUR_PARAMS[behaviourType][field.name],
	          placeholder: field.hint || _lodash2.default.startCase(field.name),
	          value: _lodash2.default.get(_this2.state.value, 'behaviour.params.' + field.name, ''),
	          onChange: function onChange(event) {
	            _this2.setState(_lodash2.default.merge(_this2.state, {
	              value: {
	                behaviour: {
	                  params: _defineProperty({}, field.name, event.target.value)
	                }
	              }
	            }));
	          }
	        })));
	      })));
	    }
	  }]);
	
	  return PassengerForm;
	}(_react.Component), _class.defaultProps = {
	  defaultValue: {
	    behaviour: {
	      type: _libraryUtils.PASSENGER_BEHAVIOURS.MANUAL,
	      params: {}
	    }
	  },
	  disableLoginFields: false
	}, _temp);
	exports.default = PassengerForm;

/***/ },
/* 127 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PASSENGERS = exports.PASSENGERS = 'passengers';
	var PASSENGERS_ACTIONS = exports.PASSENGERS_ACTIONS = {
	  PASSENGER_LOGIN: 'passenger_login',
	  PASSENGER_LOGOUT: 'passenger_logout',
	  PASSENGER_BOOKING_CREATE: 'passenger_booking_create',
	  PASSENGER_BOOKING_GET: 'passenger_booking_get',
	  PASSENGER_BOOKING_CANCEL: 'passenger_booking_cancel',
	  PASSENGER_DELETE: 'passenger_delete',
	  PASSENGER_BOOKING_NEW: 'passenger_booking_new',
	  PASSENGER_BOOKING_STATE_CHANGE: 'passenger_booking_state_change',
	  PASSENGER_BOOKING_DELETE: 'passenger_booking_delete'
	};
	
	var DRIVERS = exports.DRIVERS = 'drivers';
	var DRIVERS_ACTIONS = exports.DRIVERS_ACTIONS = {
	  DRIVER_LOGIN: 'driver_login',
	  DRIVER_LOGOUT: 'driver_logout',
	  DRIVER_DELETE: 'driver_delete',
	  DRIVER_SET_AVAILABILITY: 'driver_set_availability',
	  DRIVER_SET_AUTO_ACCEPT: 'driver_set_auto_accept',
	  DRIVER_SET_LOCATION: 'driver_set_location',
	  DRIVER_BOOKING_BID: 'driver_booking_bid',
	  DRIVER_BOOKING_CANCEL: 'driver_booking_cancel',
	  DRIVER_BOOKING_PICK_UP: 'driver_booking_pick_up',
	  DRIVER_BOOKING_DROP_OFF: 'driver_booking_drop_off',
	  DRIVER_BOOKING_NEW: 'driver_booking_new',
	  DRIVER_BOOKING_STATE_CHANGE: 'driver_booking_state_change',
	  DRIVER_BOOKING_DELETE: 'driver_booking_delete'
	};
	
	var COHORTS = exports.COHORTS = 'cohorts';
	var COHORTS_ACTIONS = exports.COHORTS_ACTIONS = {
	  COHORT_CREATE: 'cohort_create',
	  COHORT_GET: 'cohort_get',
	  COHORT_DELETE: 'cohort_delete',
	  UNSET_COHORT: 'unset_cohort',
	  COHORT_PASSENGER_ASSOCIATE: 'cohort_passenger_associate',
	  COHORT_PASSENGER_UPDATE: 'cohort_passenger_update',
	  COHORT_DRIVER_ASSOCIATE_INSTANT: 'cohort_driver_associate_instant',
	  COHORT_DRIVER_ASSOCIATE: 'cohort_driver_associate',
	  COHORT_DRIVER_UPDATE: 'cohort_driver_update',
	  COHORT_MERCHANT_ASSOCIATE: 'cohort_merchant_associate',
	  COHORT_MERCHANT_UPDATE: 'cohort_merchant_update'
	};
	
	var MERCHANTS = exports.MERCHANTS = 'merchants';
	var MERCHANTS_ACTIONS = exports.MERCHANTS_ACTIONS = {
	  MERCHANT_DELETE: 'merchant_delete'
	};

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.emptyEvent = undefined;
	exports.default = handleCohortEvent;
	
	var _bookings = __webpack_require__(72);
	
	var _events = __webpack_require__(202);
	
	var _cohorts = __webpack_require__(30);
	
	var _drivers = __webpack_require__(58);
	
	var _passengers = __webpack_require__(71);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var emptyEvent = exports.emptyEvent = {
	  type: '',
	  payload: null
	};
	
	function handleCohortEvent(cohortID, eventData) {
	  var type = eventData.type,
	      params = eventData.params;
	
	  switch (type) {
	    case _events.COHORT_DELETED_EVENT:
	      {
	        return (0, _cohorts.cohortDeleteInstant)(cohortID);
	      }
	    case _events.DRIVER_NEW_EVENT:
	      {
	        var driver = params;
	        return (0, _cohorts.cohortDriverAssociateInstant)(cohortID, driver.driverID, driver);
	      }
	    case _events.DRIVER_LOGGED_IN_EVENT:
	      {
	        var event = params;
	        var driverID = event.driverID,
	            behaviour = event.behaviour;
	
	        return (0, _drivers.driverLoginInstant)(cohortID, driverID, behaviour);
	      }
	    case _events.DRIVER_LOGGED_OUT_EVENT:
	    case _events.DRIVER_DISCONNECTED_EVENT:
	      {
	        var _event = params;
	        var _driverID = _event.driverID;
	
	        return (0, _drivers.driverLogoutInstant)(cohortID, _driverID);
	      }
	    case _events.DRIVER_LOCATION_UPDATE_EVENT:
	      {
	        var _event2 = params;
	        var _driverID2 = _event2.driverID,
	            latitude = _event2.latitude,
	            longitude = _event2.longitude;
	
	        var location = [longitude, latitude];
	        return (0, _drivers.driverSetLocationInstant)(cohortID, _driverID2, location, false);
	      }
	    case _events.DRIVER_DELETED_EVENT:
	      {
	        var _event3 = params;
	        var _driverID3 = _event3.driverID;
	
	        return (0, _drivers.driverDeleteInstant)(cohortID, _driverID3);
	      }
	    case _events.PASSENGER_NEW_EVENT:
	      {
	        var passenger = params;
	        return (0, _cohorts.cohortPassengerAssociateInstant)(cohortID, passenger.passengerID, passenger);
	      }
	    case _events.PASSENGER_LOGGED_IN_EVENT:
	      {
	        var _event4 = params;
	        var passengerID = _event4.passengerID,
	            _behaviour = _event4.behaviour;
	
	        return (0, _passengers.passengerLoginInstant)(cohortID, passengerID, _behaviour);
	      }
	    case _events.PASSENGER_LOGGED_OUT_EVENT:
	      {
	        var _event5 = params;
	        var _passengerID = _event5.passengerID;
	
	        return (0, _passengers.passengerLogoutInstant)(cohortID, _passengerID);
	      }
	    case _events.PASSENGER_DELETED_EVENT:
	      {
	        var _event6 = params;
	        var _passengerID2 = _event6.passengerID;
	
	        return (0, _passengers.passengerDeleteInstant)(cohortID, _passengerID2);
	      }
	    case _events.BOOKING_DRIVER_NEW_EVENT:
	      {
	        var _event7 = params;
	        var booking = params;
	        var _driverID4 = _event7.driverID,
	            bookingID = _event7.bookingID;
	
	        return (0, _drivers.driverBookingNew)(cohortID, _driverID4, bookingID, booking);
	      }
	    case _events.BOOKING_DRIVER_BID_EVENT:
	    case _events.BOOKING_DRIVER_DECLINED_EVENT:
	    case _events.BOOKING_DRIVER_AWARDED_EVENT:
	    case _events.BOOKING_DRIVER_PICKED_UP_EVENT:
	    case _events.BOOKING_DRIVER_DROPPED_OFF_EVENT:
	    case _events.BOOKING_DRIVER_COMPLETE_EVENT:
	    case _events.BOOKING_DRIVER_CANCELLED_EVENT:
	    case _events.BOOKING_DRIVER_RECEIVED_CANCELLATION_EVENT:
	    case _events.BOOKING_DRIVER_IGNORED_EVENT:
	      {
	        var _bookingDriverEventMa;
	
	        var bookingDriverEventMap = (_bookingDriverEventMa = {}, _defineProperty(_bookingDriverEventMa, _events.BOOKING_DRIVER_BID_EVENT, _bookings.BOOKING_STATE_BID), _defineProperty(_bookingDriverEventMa, _events.BOOKING_DRIVER_DECLINED_EVENT, _bookings.BOOKING_STATE_DECLINED), _defineProperty(_bookingDriverEventMa, _events.BOOKING_DRIVER_AWARDED_EVENT, _bookings.BOOKING_STATE_PICKING_UP), _defineProperty(_bookingDriverEventMa, _events.BOOKING_DRIVER_PICKED_UP_EVENT, _bookings.BOOKING_STATE_DROPPING_OFF), _defineProperty(_bookingDriverEventMa, _events.BOOKING_DRIVER_DROPPED_OFF_EVENT, _bookings.BOOKING_STATE_DROPPING_OFF), _defineProperty(_bookingDriverEventMa, _events.BOOKING_DRIVER_COMPLETE_EVENT, _bookings.BOOKING_STATE_COMPLETED), _defineProperty(_bookingDriverEventMa, _events.BOOKING_DRIVER_CANCELLED_EVENT, _bookings.BOOKING_STATE_BID_CANCELLED), _defineProperty(_bookingDriverEventMa, _events.BOOKING_DRIVER_RECEIVED_CANCELLATION_EVENT, _bookings.BOOKING_STATE_JOB_CANCELLED), _defineProperty(_bookingDriverEventMa, _events.BOOKING_DRIVER_IGNORED_EVENT, _bookings.BOOKING_STATE_IGNORED), _bookingDriverEventMa);
	        var _event8 = params;
	        var _driverID5 = _event8.driverID,
	            _bookingID = _event8.bookingID;
	
	        return (0, _drivers.driverBookingStateChange)(cohortID, _driverID5, _bookingID, bookingDriverEventMap[type]);
	      }
	    case _events.BOOKING_PASSENGER_NEW_EVENT:
	      {
	        var _event9 = params;
	        var _booking = params;
	        var _passengerID3 = _event9.passengerID,
	            _bookingID2 = _event9.bookingID;
	
	        return (0, _passengers.passengerBookingNew)(cohortID, _passengerID3, _bookingID2, _booking);
	      }
	    case _events.BOOKING_PASSENGER_UNALLOCATED_EVENT:
	    case _events.BOOKING_PASSENGER_AWARDED_EVENT:
	    case _events.BOOKING_PASSENGER_PICKED_UP_EVENT:
	    case _events.BOOKING_PASSENGER_COMPLETED_EVENT:
	    case _events.BOOKING_PASSENGER_CANCELLED_EVENT:
	    case _events.BOOKING_PASSENGER_RECEIVED_CANCELLATION_EVENT:
	      {
	        var _bookingPassengerEven;
	
	        var bookingPassengerEventMap = (_bookingPassengerEven = {}, _defineProperty(_bookingPassengerEven, _events.BOOKING_PASSENGER_UNALLOCATED_EVENT, _bookings.BOOKING_STATE_UNALLOCATED), _defineProperty(_bookingPassengerEven, _events.BOOKING_PASSENGER_AWARDED_EVENT, _bookings.BOOKING_STATE_PICKING_UP), _defineProperty(_bookingPassengerEven, _events.BOOKING_PASSENGER_PICKED_UP_EVENT, _bookings.BOOKING_STATE_DROPPING_OFF), _defineProperty(_bookingPassengerEven, _events.BOOKING_PASSENGER_COMPLETED_EVENT, _bookings.BOOKING_STATE_COMPLETED), _defineProperty(_bookingPassengerEven, _events.BOOKING_PASSENGER_CANCELLED_EVENT, _bookings.BOOKING_STATE_JOB_CANCELLED), _defineProperty(_bookingPassengerEven, _events.BOOKING_PASSENGER_RECEIVED_CANCELLATION_EVENT, _bookings.BOOKING_STATE_JOB_CANCELLED), _bookingPassengerEven);
	        var _event10 = params;
	        var _passengerID4 = _event10.passengerID,
	            _bookingID3 = _event10.bookingID;
	
	        return (0, _passengers.passengerBookingStateChange)(cohortID, _passengerID4, _bookingID3, bookingPassengerEventMap[type]);
	      }
	    case _events.DRIVER_AVAILABILITY_UPDATE_EVENT:
	      {
	        var _event11 = params;
	        var _driverID6 = _event11.driverID,
	            availability = _event11.availability;
	
	        return (0, _drivers.driverSetAvailabilityInstant)(cohortID, _driverID6, availability);
	      }
	    case _events.DRIVER_AUTO_ACCEPT_UPDATE_EVENT:
	      {
	        var _event12 = params;
	        var _driverID7 = _event12.driverID,
	            isTurnedOn = _event12.isTurnedOn;
	
	        return (0, _drivers.driverSetAutoAcceptInstant)(cohortID, _driverID7, isTurnedOn);
	      }
	    case _events.RESOURCE_CREATION_STATUS_EVENT:
	      {
	        var _event13 = params;
	        var status = _event13.status,
	            error = _event13.error;
	
	        return (0, _cohorts.getCohorStatus)(cohortID, status, error);
	      }
	    default:
	      break;
	  }
	  return emptyEvent;
	}

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(11);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cohortUtils = __webpack_require__(52);
	
	__webpack_require__(528);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { MetricsPanel } from './metrics/MetricsPanel';
	var BookingEntity = '1';
	var PassengerEntity = '2';
	var DriverEntity = '3';
	
	var DataTable = function DataTable(props) {
	  var header = props.header,
	      body = props.body;
	
	
	  return _jsx('table', {
	    className: 'table is-bordered is-striped is-narrow is-hoverable is-fullwidth'
	  }, void 0, _jsx(DataTableHeader, {
	    cols: header
	  }), _jsx(DataTableBody, {
	    rows: body
	  }));
	};
	
	var DataTableHeader = function DataTableHeader(props) {
	  var header = props.cols;
	
	  return _jsx('thead', {}, void 0, _jsx('tr', {}, void 0, _lodash2.default.map(header, function (cell) {
	    return _jsx(TH, {}, cell, cell);
	  })));
	};
	
	var DataTableBody = function DataTableBody(props) {
	  var body = props.rows;
	
	  return _jsx('tbody', {}, void 0, _lodash2.default.map(body, function (row) {
	    return _jsx('tr', {}, void 0, _lodash2.default.map(row, function (cell) {
	      return _jsx(TD, {}, cell, cell);
	    }));
	  }));
	};
	
	var TD = function TD(props) {
	  return _jsx('td', {}, void 0, props.children);
	};
	var TH = function TH(props) {
	  return _jsx('th', {}, void 0, props.children);
	};
	
	var _ref = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-external-link'
	}));
	
	var _ref2 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-external-link'
	}));
	
	var _ref3 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-external-link'
	}));
	
	var _ref4 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-external-link'
	}));
	
	var _ref5 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-external-link'
	}));
	
	var _ref6 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-external-link'
	}));
	
	var _ref7 = _jsx('p', {
	  className: 'heading'
	}, void 0, 'Total Bookings');
	
	var _ref8 = _jsx('p', {
	  className: 'heading'
	}, void 0, 'Successful Rides');
	
	var _ref9 = _jsx('p', {
	  className: 'heading'
	}, void 0, 'Unallocated Bookings');
	
	var _ref10 = _jsx('p', {
	  className: 'heading'
	}, void 0, 'Others Bookings');
	
	var ReportContainer = function (_Component) {
	  _inherits(ReportContainer, _Component);
	
	  _createClass(ReportContainer, null, [{
	    key: 'generateEntityURLLink',
	    value: function generateEntityURLLink(entityId, entityType) {
	      switch (entityType) {
	        case BookingEntity:
	          return _jsx('a', {
	            href: (0, _cohortUtils.entityURLForCohort)() + '/bookings/' + entityId,
	            target: '_blank',
	            title: 'View Booking in Gamma',
	            'aria-label': 'View Booking in Gamma',
	            rel: 'noopener noreferrer'
	          }, void 0, _ref);
	        case DriverEntity:
	          return _jsx('a', {
	            href: (0, _cohortUtils.entityURLForCohort)() + '/drivers/' + entityId,
	            target: '_blank',
	            title: 'View Driver in Gamma',
	            'aria-label': 'View Driver in Gamma',
	            rel: 'noopener noreferrer'
	          }, void 0, _ref2);
	        case PassengerEntity:
	          return _jsx('a', {
	            href: (0, _cohortUtils.entityURLForCohort)() + '/passengers/' + entityId,
	            target: '_blank',
	            title: 'View Passenger in Gamma',
	            'aria-label': 'View Passenger in Gamma',
	            rel: 'noopener noreferrer'
	          }, void 0, _ref3);
	        default:
	          return null;
	      }
	    }
	  }]);
	
	  function ReportContainer(props) {
	    _classCallCheck(this, ReportContainer);
	
	    var _this = _possibleConstructorReturn(this, (ReportContainer.__proto__ || Object.getPrototypeOf(ReportContainer)).call(this, props));
	
	    _this.compare = function (a, b) {
	      if (a.message > b.message) {
	        return 1;
	      } else if (b.message > a.message) {
	        return -1;
	      }
	      return 0;
	    };
	
	    _this.handleResourceClick = function (event) {
	      _this.setState({ activeResourceTab: event.currentTarget.dataset.value });
	      _this.loadResourceData();
	    };
	
	    _this.state = {
	      activeResourceTab: 'bookings'
	    };
	    return _this;
	  }
	
	  _createClass(ReportContainer, [{
	    key: 'loadResourceData',
	    value: function loadResourceData() {
	      var _this2 = this;
	
	      if (!this.props.details) {
	        return null;
	      }
	      var resourceType = this.state.activeResourceTab;
	      var data = [];
	      var _props$details = this.props.details,
	          bookings = _props$details.bookings,
	          errors = _props$details.errors,
	          driverIDs = _props$details.driverIDs,
	          passengerIDs = _props$details.passengerIDs;
	
	
	      if (this.props.details && this.props.details.report) {
	        bookings = this.props.details.report.bookingIDs;
	        errors = this.props.details.report.errors;
	        driverIDs = this.props.details.report.driverIDs;
	        passengerIDs = this.props.details.report.passengerIDs;
	      }
	
	      switch (resourceType) {
	        case 'bookings':
	          data.push(_jsx(DataTable, {
	            header: ['Booking ID', 'Status', 'Gamma Info'],
	            body: _lodash2.default.map(bookings, function (state, bookingID) {
	              return [bookingID, state, _jsx('a', {
	                href: (0, _cohortUtils.entityURLForCohort)() + '/bookings/' + bookingID,
	                target: '_blank',
	                title: 'View Booking in Gamma',
	                'aria-label': 'View Booking in Gamma',
	                rel: 'noopener noreferrer'
	              }, void 0, _ref4)];
	            })
	          }));
	          break;
	        case 'pax':
	          data.push(_jsx(DataTable, {
	            header: ['No.', 'Passenger ID', 'Gamma Info'],
	            body: _lodash2.default.map(passengerIDs, function (pax, idx) {
	              return [idx + 1, pax, _jsx('a', {
	                href: (0, _cohortUtils.entityURLForCohort)() + '/passengers/' + pax,
	                target: '_blank',
	                title: 'View Passenger in Gamma',
	                'aria-label': 'View Passenger in Gamma',
	                rel: 'noopener noreferrer'
	              }, void 0, _ref5)];
	            })
	          }));
	          break;
	        case 'dax':
	          data.push(_jsx(DataTable, {
	            header: ['No.', 'Driver ID', 'Gamma Info'],
	            body: _lodash2.default.map(driverIDs, function (dax, idx) {
	              return [idx + 1, dax, _jsx('a', {
	                href: (0, _cohortUtils.entityURLForCohort)() + '/drivers/' + dax,
	                target: '_blank',
	                title: 'View Driver in Gamma',
	                'aria-label': 'View Driver in Gamma',
	                rel: 'noopener noreferrer'
	              }, void 0, _ref6)];
	            })
	          }));
	          break;
	        case 'errors':
	          {
	            // Key: 1 represents booking error
	            // Key: 2 represents passenger login error
	            // Key: 3 represents driver login error
	            var displayErrors = _lodash2.default.flatMap(errors, function (errorTypeValues, errorTypeKeys) {
	              errorTypeValues.sort(_this2.compare);
	              if (errorTypeValues.length > 0) {
	                var err = errorTypeValues[0];
	                var res = [{
	                  message: err.message,
	                  displayIds: [err.entityId, ReportContainer.generateEntityURLLink(err.entityId, errorTypeKeys)] }];
	                for (var i = 1; i < errorTypeValues.length; i += 1) {
	                  err = errorTypeValues[i];
	                  if (err.message === _lodash2.default.last(res).message) {
	                    _lodash2.default.last(res).displayIds.push(err.entityId);
	                    _lodash2.default.last(res).displayIds.push(ReportContainer.generateEntityURLLink(err.entityId, errorTypeKeys));
	                  } else {
	                    res.push({
	                      message: err.message,
	                      displayIds: [err.entityId, ReportContainer.generateEntityURLLink(err.entityId, errorTypeKeys)]
	                    });
	                  }
	                }
	                return res;
	              }
	              return [];
	            });
	            data.push(_jsx(DataTable, {
	              header: ['Error Message', 'ID'],
	              body: _lodash2.default.map(displayErrors, function (errArray) {
	                return [errArray.message, errArray.displayIds];
	              })
	            }));
	            break;
	          }
	        default:
	          break;
	      }
	      return _jsx('div', {
	        className: 'resource-viewer'
	      }, void 0, data);
	    }
	  }, {
	    key: 'calcStats',
	    value: function calcStats() {
	      var details = this.props.details;
	
	      var ans = {
	        totalBookings: 0,
	        unallocatedBookings: 0,
	        unknownBookings: 0,
	        completedBookings: 0
	      };
	
	      if (details && details.bookings) {
	        _lodash2.default.forEach(details.bookings, function (state) {
	          if (state === 'UNKNOWN') {
	            ans.unknownBookings += 1;
	          } else if (state === 'UNALLOCATED') {
	            ans.unallocatedBookings += 1;
	          } else if (state === 'COMPLETE') {
	            ans.completedBookings += 1;
	          }
	
	          ans.totalBookings += 1;
	        });
	      } else if (details && details.report) {
	        ans.totalBookings = details.report.totalBookings;
	        ans.unallocatedBookings = details.report.unallocatedBookings;
	        ans.unknownBookings = details.report.otherBookings;
	        ans.completedBookings = details.report.successfulRides;
	      }
	
	      return ans;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var setPaxActive = 'resource-header';
	      var setDaxActive = 'resource-header';
	      var setErrorsActive = 'resource-header';
	      var setBookingsActive = 'resource-header';
	      var stats = this.calcStats();
	      switch (this.state.activeResourceTab) {
	        case 'errors':
	          setErrorsActive += ' selected';
	          break;
	        case 'pax':
	          setPaxActive += ' selected';
	          break;
	        case 'dax':
	          setDaxActive = ' selected';
	          break;
	        case 'bookings':
	          setBookingsActive = ' selected';
	          break;
	        default:
	          break;
	      }
	      return _jsx('div', {
	        className: 'resource-container'
	      }, void 0, _jsx('nav', {
	        className: 'level'
	      }, void 0, _jsx('div', {
	        className: 'level-item has-text-centered'
	      }, void 0, _jsx('div', {}, void 0, _ref7, _jsx('p', {
	        className: 'title'
	      }, void 0, stats.totalBookings))), _jsx('div', {
	        className: 'level-item has-text-centered'
	      }, void 0, _jsx('div', {}, void 0, _ref8, _jsx('p', {
	        className: 'title'
	      }, void 0, stats.completedBookings))), _jsx('div', {
	        className: 'level-item has-text-centered'
	      }, void 0, _jsx('div', {}, void 0, _ref9, _jsx('p', {
	        className: 'title'
	      }, void 0, stats.unallocatedBookings))), _jsx('div', {
	        className: 'level-item has-text-centered'
	      }, void 0, _jsx('div', {}, void 0, _ref10, _jsx('p', {
	        className: 'title'
	      }, void 0, stats.unknownBookings)))), _jsx('div', {
	        className: 'htabs'
	      }, void 0, _jsx('ul', {}, void 0, _jsx('li', {
	        'data-value': 'bookings',
	        onClick: this.handleResourceClick
	      }, void 0, _jsx('div', {
	        className: setBookingsActive
	      }, 'info-header', 'Bookings')), _jsx('li', {
	        'data-value': 'pax',
	        onClick: this.handleResourceClick
	      }, void 0, _jsx('div', {
	        className: setPaxActive
	      }, 'pax-header', 'Passengers')), _jsx('li', {
	        'data-value': 'dax',
	        onClick: this.handleResourceClick
	      }, void 0, _jsx('div', {
	        className: setDaxActive
	      }, 'dax-header', 'Drivers')), _jsx('li', {
	        'data-value': 'errors',
	        onClick: this.handleResourceClick
	      }, void 0, _jsx('div', {
	        className: setErrorsActive
	      }, 'err-header', 'Errors')))), this.loadResourceData());
	    }
	  }]);
	
	  return ReportContainer;
	}(_react.Component);
	
	ReportContainer.defaultProps = {
	  report: {
	    totalBookings: 0,
	    successfulRides: 0,
	    allocationRate: 0,
	    successRate: 0,
	    errors: [],
	    passengerIDs: [],
	    driverIDs: [],
	    timeoutEvent: false,
	    bookings: {}
	  }
	};
	
	exports.default = (0, _reactRedux.connect)()(ReportContainer);

/***/ },
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(657);

/***/ },
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _check = __webpack_require__(717);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _x = __webpack_require__(719);
	
	var _x2 = _interopRequireDefault(_x);
	
	var _util = __webpack_require__(718);
	
	var _reactAddonsShallowCompare = __webpack_require__(324);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toggle = function (_Component) {
	  _inherits(Toggle, _Component);
	
	  function Toggle(props) {
	    _classCallCheck(this, Toggle);
	
	    var _this = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
	    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
	    _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
	    _this.handleFocus = _this.setState.bind(_this, { hasFocus: true }, function () {});
	    _this.handleBlur = _this.setState.bind(_this, { hasFocus: false }, function () {});
	    _this.previouslyChecked = !!(props.checked || props.defaultChecked);
	    _this.state = {
	      checked: !!(props.checked || props.defaultChecked),
	      hasFocus: false
	    };
	    return _this;
	  }
	
	  _createClass(Toggle, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ('checked' in nextProps) {
	        this.setState({ checked: !!nextProps.checked });
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      var checkbox = this.input;
	      if (event.target !== checkbox && !this.moved) {
	        this.previouslyChecked = checkbox.checked;
	        event.preventDefault();
	        checkbox.focus();
	        checkbox.click();
	        return;
	      }
	
	      this.setState({ checked: checkbox.checked });
	    }
	  }, {
	    key: 'handleTouchStart',
	    value: function handleTouchStart(event) {
	      this.startX = (0, _util.pointerCoord)(event).x;
	      this.activated = true;
	    }
	  }, {
	    key: 'handleTouchMove',
	    value: function handleTouchMove(event) {
	      if (!this.activated) return;
	      this.moved = true;
	
	      if (this.startX) {
	        var currentX = (0, _util.pointerCoord)(event).x;
	        if (this.state.checked && currentX + 15 < this.startX) {
	          this.setState({ checked: false });
	          this.startX = currentX;
	          this.activated = true;
	        } else if (currentX - 15 > this.startX) {
	          this.setState({ checked: true });
	          this.startX = currentX;
	          this.activated = currentX < this.startX + 5;
	        }
	      }
	    }
	  }, {
	    key: 'handleTouchEnd',
	    value: function handleTouchEnd(event) {
	      if (!this.moved) return;
	      var checkbox = this.input;
	      event.preventDefault();
	
	      if (this.startX) {
	        var endX = (0, _util.pointerCoord)(event).x;
	        if (this.previouslyChecked === true && this.startX + 4 > endX) {
	          if (this.previouslyChecked !== this.state.checked) {
	            this.setState({ checked: false });
	            this.previouslyChecked = this.state.checked;
	            checkbox.click();
	          }
	        } else if (this.startX - 4 < endX) {
	          if (this.previouslyChecked !== this.state.checked) {
	            this.setState({ checked: true });
	            this.previouslyChecked = this.state.checked;
	            checkbox.click();
	          }
	        }
	
	        this.activated = false;
	        this.startX = null;
	        this.moved = false;
	      }
	    }
	  }, {
	    key: 'getIcon',
	    value: function getIcon(type) {
	      var icons = this.props.icons;
	
	      if (!icons) {
	        return null;
	      }
	      return icons[type] === undefined ? Toggle.defaultProps.icons[type] : icons[type];
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          _icons = _props.icons,
	          inputProps = _objectWithoutProperties(_props, ['className', 'icons']);
	
	      var classes = (0, _classnames2.default)('react-toggle', {
	        'react-toggle--checked': this.state.checked,
	        'react-toggle--focus': this.state.hasFocus,
	        'react-toggle--disabled': this.props.disabled
	      }, className);
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes,
	          onClick: this.handleClick,
	          onTouchStart: this.handleTouchStart,
	          onTouchMove: this.handleTouchMove,
	          onTouchEnd: this.handleTouchEnd },
	        _react2.default.createElement(
	          'div',
	          { className: 'react-toggle-track' },
	          _react2.default.createElement(
	            'div',
	            { className: 'react-toggle-track-check' },
	            this.getIcon('checked')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'react-toggle-track-x' },
	            this.getIcon('unchecked')
	          )
	        ),
	        _react2.default.createElement('div', { className: 'react-toggle-thumb' }),
	        _react2.default.createElement('input', _extends({}, inputProps, {
	          ref: function ref(_ref) {
	            _this2.input = _ref;
	          },
	          onFocus: this.handleFocus,
	          onBlur: this.handleBlur,
	          className: 'react-toggle-screenreader-only',
	          type: 'checkbox' }))
	      );
	    }
	  }]);
	
	  return Toggle;
	}(_react.Component);
	
	exports.default = Toggle;
	
	
	Toggle.displayName = 'Toggle';
	
	Toggle.defaultProps = {
	  icons: {
	    checked: _react2.default.createElement(_check2.default, null),
	    unchecked: _react2.default.createElement(_x2.default, null)
	  }
	};
	
	Toggle.propTypes = {
	  checked: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  defaultChecked: _react.PropTypes.bool,
	  onChange: _react.PropTypes.func,
	  className: _react.PropTypes.string,
	  name: _react.PropTypes.string,
	  value: _react.PropTypes.string,
	  id: _react.PropTypes.string,
	  'aria-labelledby': _react.PropTypes.string,
	  'aria-label': _react.PropTypes.string,
	  icons: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.shape({
	    checked: _react.PropTypes.node,
	    unchecked: _react.PropTypes.node
	  })])
	};

/***/ },
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var parseToken = __webpack_require__(169);
	var MapiRequest = __webpack_require__(423);
	var constants = __webpack_require__(95);
	
	/**
	 * A low-level Mapbox API client. Use it to create service clients
	 * that share the same configuration.
	 *
	 * Services and `MapiRequest`s use the underlying `MapiClient` to
	 * determine how to create, send, and abort requests in a way
	 * that is appropriate to the configuration and environment
	 * (Node or the browser).
	 *
	 * @class MapiClient
	 * @property {string} accessToken - The Mapbox access token assigned
	 *   to this client.
	 */
	
	function MapiClient(options) {
	  if (!options || !options.accessToken) {
	    throw new Error('Cannot create a client without an access token');
	  }
	  // Try parsing the access token to determine right away if it's valid.
	  parseToken(options.accessToken);
	
	  this.accessToken = options.accessToken;
	  this.origin = options.origin || constants.API_ORIGIN;
	}
	
	MapiClient.prototype.createRequest = function createRequest(requestOptions) {
	  return new MapiRequest(this, requestOptions);
	};
	
	module.exports = MapiClient;


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var base64 = __webpack_require__(456);
	
	var tokenCache = {};
	
	function parseToken(token) {
	  if (tokenCache[token]) {
	    return tokenCache[token];
	  }
	
	  var parts = token.split('.');
	  var usage = parts[0];
	  var rawPayload = parts[1];
	  if (!rawPayload) {
	    throw new Error('Invalid token');
	  }
	
	  var parsedPayload = parsePaylod(rawPayload);
	
	  var result = {
	    usage: usage,
	    user: parsedPayload.u
	  };
	  if (has(parsedPayload, 'a')) result.authorization = parsedPayload.a;
	  if (has(parsedPayload, 'exp')) result.expires = parsedPayload.exp * 1000;
	  if (has(parsedPayload, 'iat')) result.created = parsedPayload.iat * 1000;
	  if (has(parsedPayload, 'scopes')) result.scopes = parsedPayload.scopes;
	  if (has(parsedPayload, 'client')) result.client = parsedPayload.client;
	  if (has(parsedPayload, 'll')) result.lastLogin = parsedPayload.ll;
	  if (has(parsedPayload, 'iu')) result.impersonator = parsedPayload.iu;
	
	  tokenCache[token] = result;
	  return result;
	}
	
	function parsePaylod(rawPayload) {
	  try {
	    return JSON.parse(base64.decode(rawPayload));
	  } catch (parseError) {
	    throw new Error('Invalid token');
	  }
	}
	
	function has(obj, key) {
	  return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	module.exports = parseToken;


/***/ },
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ function(module, exports) {

	module.exports = function(arr, obj){
	  if (arr.indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ },
/* 177 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 178 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(465);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 180 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(179)
	  , defined = __webpack_require__(178);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(68);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * 得到会导致元素显示不全的祖先元素
	 */
	
	function getOffsetParent(element) {
	  // ie 这个也不是完全可行
	  /*
	   <div style="width: 50px;height: 100px;overflow: hidden">
	   <div style="width: 50px;height: 100px;position: relative;" id="d6">
	   元素 6 高 100px 宽 50px<br/>
	   </div>
	   </div>
	   */
	  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
	  //  In other browsers it only includes elements with position absolute, relative or
	  // fixed, not elements with overflow set to auto or scroll.
	  //        if (UA.ie && ieMode < 8) {
	  //            return element.offsetParent;
	  //        }
	  // 统一的 offsetParent 方法
	  var doc = element.ownerDocument;
	  var body = doc.body;
	  var parent = void 0;
	  var positionStyle = _utils2["default"].css(element, 'position');
	  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
	
	  if (!skipStatic) {
	    return element.nodeName.toLowerCase() === 'html' ? null : element.parentNode;
	  }
	
	  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
	    positionStyle = _utils2["default"].css(parent, 'position');
	    if (positionStyle !== 'static') {
	      return parent;
	    }
	  }
	  return null;
	}
	
	exports["default"] = getOffsetParent;
	module.exports = exports['default'];

/***/ },
/* 186 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	exports.default = PowerButton;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(510);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _jsx('i', {
	  className: 'fa fa-power-off',
	  'aria-hidden': 'true'
	});
	
	function PowerButton(props) {
	  return _react2.default.createElement(
	    'span',
	    _extends({
	      role: 'button',
	      className: (0, _classnames2.default)('power-button', {
	        disabled: props.disabled,
	        active: props.active
	      }),
	      'aria-label': props.label
	    }, _lodash2.default.omit(props, ['disabled', 'active', 'className'])),
	    _ref,
	    _jsx('input', {
	      type: 'checkbox',
	      className: 'sr-only',
	      checked: props.active,
	      readOnly: true
	    })
	  );
	}

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VALID_COORDINATE = /^-?\d+(\.[\d]+)?$/;
	
	function formatLocation(value) {
	  if (value[1] != null && value[0] != null) {
	    return value[1] + ', ' + value[0];
	  }
	
	  return '';
	}
	
	function parseCoordinate(value) {
	  if (value.trim().match(VALID_COORDINATE)) {
	    return parseFloat(value);
	  }
	
	  return NaN;
	}
	
	function parseValue(value) {
	  var coordinates = value.split(/\s*,\s*/);
	  if (coordinates.length < 2) {
	    return [NaN, NaN];
	  }
	  var parsedCoordinates = coordinates.map(parseCoordinate);
	  return [parsedCoordinates[1], parsedCoordinates[0]];
	}
	
	function isValidValue(value) {
	  return !Number.isNaN(value[0]) && !Number.isNaN(value[1]);
	}
	
	var InputLocation = (_temp = _class = function (_Component) {
	  _inherits(InputLocation, _Component);
	
	  function InputLocation(props) {
	    _classCallCheck(this, InputLocation);
	
	    var _this = _possibleConstructorReturn(this, (InputLocation.__proto__ || Object.getPrototypeOf(InputLocation)).call(this, props));
	
	    _this.state = { rawValue: formatLocation(_this.props.value) };
	    return _this;
	  }
	
	  _createClass(InputLocation, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!_lodash2.default.isEqual(this.props.value, nextProps.value)) {
	        this.setValue(nextProps.value);
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return parseValue(this.state.rawValue);
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.setRawValue(formatLocation(value));
	    }
	  }, {
	    key: 'setRawValue',
	    value: function setRawValue(value, callback) {
	      this.setState({ rawValue: value }, callback);
	    }
	  }, {
	    key: 'isValid',
	    value: function isValid() {
	      return isValidValue(this.getValue());
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var _this2 = this;
	
	      this.setRawValue(event.target.value, function () {
	        if (_this2.props.onBeforeChange) {
	          _this2.props.onBeforeChange();
	        }
	
	        var values = parseValue(_this2.state.rawValue);
	        if (!isValidValue(values)) {
	          return;
	        }
	
	        if (_this2.props.onChange) {
	          _this2.props.onChange(values);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var otherProps = _lodash2.default.omit(this.props, 'value', 'onBeforeChange', 'onChange', 'className');
	      return _react2.default.createElement('input', _extends({
	        className: (0, _classnames2.default)('input', this.props.className)
	      }, otherProps, {
	        type: 'text',
	        value: this.state.rawValue,
	        onFocus: function onFocus(event) {
	          event.target.select();
	        },
	        onChange: function onChange(event) {
	          return _this3.handleChange(event);
	        }
	      }));
	    }
	  }]);
	
	  return InputLocation;
	}(_react.Component), _class.defaultProps = {
	  className: '',
	  onBeforeChange: null
	}, _temp);
	exports.default = InputLocation;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _WithEscapeToDismiss = __webpack_require__(34);
	
	var _WithEscapeToDismiss2 = _interopRequireDefault(_WithEscapeToDismiss);
	
	__webpack_require__(512);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LocationSuggestions = function LocationSuggestions(_ref) {
	  var locations = _ref.locations,
	      clickHandler = _ref.clickHandler;
	  return _jsx('nav', {
	    className: (0, _classnames2.default)('panel', {
	      'is-hidden': _lodash2.default.size(locations) === 0
	    })
	  }, void 0, _jsx('div', {
	    className: 'panel-block'
	  }, void 0, _jsx('aside', {
	    className: 'menu'
	  }, void 0, _jsx('ul', {
	    className: 'menu-list'
	  }, void 0, _lodash2.default.map(locations, function (loc, idx) {
	    return _jsx(LocationSuggestion, {
	      text: loc,
	      clickHandler: clickHandler
	    }, idx);
	  })))));
	};
	
	var LocationSuggestion = function LocationSuggestion(_ref2) {
	  var text = _ref2.text,
	      clickHandler = _ref2.clickHandler;
	  return _jsx('li', {}, void 0, _jsx('a', {
	    onClick: clickHandler
	  }, void 0, text));
	};
	
	var _ref3 = _jsx('p', {
	  className: 'modal-card-title'
	}, void 0, 'Location Suggestions');
	
	var _ref4 = _jsx('label', {
	  className: 'label sr-only',
	  htmlFor: 'address'
	}, void 0, 'Search address here');
	
	var CohortLocationModal = (_dec = (0, _WithEscapeToDismiss2.default)(), _dec(_class = function (_Component) {
	  _inherits(CohortLocationModal, _Component);
	
	  function CohortLocationModal(props) {
	    _classCallCheck(this, CohortLocationModal);
	
	    var _this = _possibleConstructorReturn(this, (CohortLocationModal.__proto__ || Object.getPrototypeOf(CohortLocationModal)).call(this, props));
	
	    _this.setLocation = function (event) {
	      if (event.target.innerText in _this.state.autocompleteLocations) {
	        _this.setState({
	          activeLocation: _this.state.autocompleteLocations[event.target.innerText],
	          activeLocationName: event.target.innerText,
	          selectedLocation: true
	        });
	      }
	    };
	
	    _this.state = {
	      activeLocation: null,
	      autocompleteLocations: null,
	      activeLocationName: '',
	      selectedLocation: false
	    };
	    return _this;
	  }
	
	  _createClass(CohortLocationModal, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      var autocompleteLocationsChanged = this.props.autoCompleteLocations !== nextProps.autoCompleteLocations;
	
	      if (autocompleteLocationsChanged) {
	        var storedLocations = _lodash2.default.reduce(nextProps.autoCompleteLocations, function (acc, loc) {
	          return _extends({}, acc, _defineProperty({}, loc.place_name, _lodash2.default.join(_lodash2.default.reverse(loc.center), ',')));
	        }, {});
	        this.setState({
	          autocompleteLocations: storedLocations
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var address = this.locationInput ? this.locationInput.value : '';
	      return _jsx('div', {
	        className: (0, _classnames2.default)('modal', {
	          'is-active': this.props.showModal
	        }),
	        role: 'dialog'
	      }, void 0, _jsx('div', {
	        className: 'modal-background',
	        onClick: function onClick() {
	          _this2.props.handleClose();
	        }
	      }), _jsx('div', {
	        className: 'modal-card'
	      }, void 0, _jsx('header', {
	        className: 'modal-card-head'
	      }, void 0, _ref3, _jsx('button', {
	        'aria-label': 'Close modal',
	        className: 'delete',
	        onClick: function onClick() {
	          _this2.props.handleClose();
	        }
	      })), _jsx('section', {
	        className: 'modal-card-body'
	      }, void 0, _jsx('div', {
	        className: 'field'
	      }, void 0, _jsx('p', {
	        className: 'control'
	      }, void 0, _ref4, _react2.default.createElement('input', {
	        id: 'address',
	        className: 'input',
	        type: 'text',
	        placeholder: 'Search address',
	        autoComplete: 'off',
	        onKeyUp: function onKeyUp(event) {
	          if (event.target.value.length !== 0) {
	            _this2.setState({
	              selectedLocation: false
	            });
	          }
	          if (event.target.value.length <= 2) {
	            _this2.setState({
	              autocompleteLocations: {}
	            });
	          }
	          if (event.target.value.length > 2) {
	            _this2.props.onAutoCompleteLocation(event.target.value);
	          }
	        },
	        onChange: function onChange(event) {
	          _this2.setState({
	            activeLocationName: event.target.value
	          });
	        },
	        ref: function ref(locationInput) {
	          _this2.locationInput = locationInput;
	        },
	        value: this.state.activeLocationName
	      })), !this.state.selectedLocation && _jsx(LocationSuggestions, {
	        clickHandler: this.setLocation,
	        locations: Object.keys(this.state.autocompleteLocations || {})
	      }))), _jsx('footer', {
	        className: 'modal-card-foot'
	      }, void 0, _jsx('button', {
	        className: 'button',
	        onClick: function onClick() {
	          _this2.props.handleClose();
	        }
	      }, void 0, 'Cancel'), _jsx('button', {
	        className: 'button is-primary',
	        'aria-label': 'Set cohort to address: ' + address,
	        onClick: function onClick() {
	          _this2.props.cohortSetLocation(_this2.state.activeLocation);
	          _this2.props.handleClose();
	        }
	      }, void 0, 'Set Location'))));
	    }
	  }]);
	
	  return CohortLocationModal;
	}(_react.Component)) || _class);
	exports.default = CohortLocationModal;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MAPBOX_REQUEST = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _apiMiddleware = __webpack_require__(35);
	
	var _geocoding = __webpack_require__(428);
	
	var _geocoding2 = _interopRequireDefault(_geocoding);
	
	var _config = __webpack_require__(32);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAPBOX_REQUEST = exports.MAPBOX_REQUEST = Symbol('MAPBOX_REQUEST');
	
	/* eslint-disable no-unused-vars */
	
	exports.default = function (store) {
	  return function (next) {
	    return function (action) {
	      if (!action.meta || !action.meta[MAPBOX_REQUEST]) {
	        // non-mapbox requests
	        return next(action);
	      }
	      var type = action.type,
	          payload = action.payload,
	          meta = action.meta;
	      var query = payload.query,
	          params = payload.params;
	
	      var geocodingClient = (0, _geocoding2.default)({ accessToken: _config2.default.MAPBOX_TOKEN });
	
	      return geocodingClient[query](params).send().then(function (response) {
	        return next({
	          type: type + _apiMiddleware.SUCCESS,
	          payload: response,
	          meta: _extends({}, meta, {
	            params: params
	          })
	        });
	      }, function (error) {
	        return next({
	          type: type + _apiMiddleware.FAILURE,
	          payload: error,
	          meta: meta
	        });
	      });
	    };
	  };
	};

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.autoAcceptValueOn = exports.autoAcceptValueNA = exports.autoAcceptValueOff = exports.defaultCohortsState = exports.defaultCohortState = exports.defaultMerchantsState = exports.defaultDriversState = exports.defaultPassengersState = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.passengerBooking = passengerBooking;
	exports.passengerBookings = passengerBookings;
	exports.passenger = passenger;
	exports.passengers = passengers;
	exports.driverBooking = driverBooking;
	exports.driverBookings = driverBookings;
	exports.driver = driver;
	
	var _bookings = __webpack_require__(72);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cohorts = __webpack_require__(30);
	
	var _passengers = __webpack_require__(71);
	
	var _drivers = __webpack_require__(58);
	
	var _apiMiddleware = __webpack_require__(35);
	
	var RequestResultCases = _interopRequireWildcard(_apiMiddleware);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var defaultPassengersState = exports.defaultPassengersState = {};
	var defaultDriversState = exports.defaultDriversState = {};
	var defaultMerchantsState = exports.defaultMerchantsState = {};
	var defaultCohortState = exports.defaultCohortState = {
	  cohortID: '',
	  passengers: defaultPassengersState,
	  drivers: defaultDriversState,
	  merchants: defaultMerchantsState
	};
	var defaultCohortsState = exports.defaultCohortsState = {};
	
	var autoAcceptValueOff = exports.autoAcceptValueOff = 0;
	var autoAcceptValueNA = exports.autoAcceptValueNA = -1;
	var autoAcceptValueOn = exports.autoAcceptValueOn = 1;
	
	function passengerBooking(state, action) {
	  switch (action.type) {
	    case _passengers.PASSENGER_BOOKING_NEW:
	      return _extends({}, state, {
	        state: _bookings.BOOKING_STATE_NEW
	      }, action.payload.booking);
	    case _passengers.PASSENGER_BOOKING_STATE_CHANGE:
	      return _extends({}, state, {
	        state: action.payload.state
	      });
	    case _passengers.PASSENGER_BOOKING_CANCEL + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        state: _bookings.BOOKING_STATE_JOB_CANCELLED
	      });
	    case _passengers.PASSENGER_BOOKING_GET + RequestResultCases.SUCCESS:
	      return _extends({}, state, action.payload);
	    case _passengers.PASSENGER_CHANGE_DESTINATION + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        itinerary: _lodash2.default.concat([_lodash2.default.first(state.itinerary)], action.meta ? _extends({}, action.meta.dropoffPoint) : _lodash2.default.last(state.itinerary))
	      });
	    default:
	      return state;
	  }
	}
	
	function passengerBookings() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _passengers.PASSENGER_BOOKING_NEW:
	      {
	        var index = _lodash2.default.findIndex(state, function (booking) {
	          return booking.bookingID === action.payload.bookingID;
	        });
	        if (index !== -1) {
	          return state;
	        }
	        return [passengerBooking(action.payload.booking, action)].concat(_toConsumableArray(state));
	      }
	    case _passengers.PASSENGER_BOOKING_STATE_CHANGE:
	      return state.map(function (booking) {
	        if (booking.bookingID === action.payload.bookingID) {
	          return passengerBooking(booking, action);
	        }
	        return booking;
	      });
	    case _passengers.PASSENGER_BOOKING_GET + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_BOOKING_CANCEL + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_CHANGE_DESTINATION + RequestResultCases.SUCCESS:
	      return state.map(function (booking) {
	        if (action.meta && booking.bookingID === action.meta.bookingID) {
	          return passengerBooking(booking, action);
	        }
	        return booking;
	      });
	    case _passengers.PASSENGER_BOOKING_DELETE:
	      return state.filter(function (booking) {
	        return booking.bookingID !== action.payload.bookingID;
	      });
	    default:
	      return state;
	  }
	}
	
	function passenger(state, action) {
	  switch (action.type) {
	    case _cohorts.COHORT_PASSENGER_ASSOCIATE:
	      {
	        var newState = action.payload.passenger;
	        // If passenger is not logged in, do not overwrite the behaviour received
	        // from the API because it is necessarily empty.
	        if (!action.payload.passenger.loggedIn && state) {
	          newState.behaviour = state.behaviour;
	        }
	        return newState;
	      }
	    case _cohorts.COHORT_GET + RequestResultCases.SUCCESS:
	      {
	        if (!action.meta) {
	          return state;
	        }
	        var _newState = action.payload.passengers[action.meta.passengerID];
	        if (!_newState.loggedIn && state) {
	          _newState.behaviour = state.behaviour;
	        }
	        return _newState;
	      }
	    case _cohorts.COHORT_PASSENGER_UPDATE:
	      return _extends({}, state, action.payload.passenger);
	    case _passengers.PASSENGER_LOGIN:
	      return _extends({}, state, {
	        loggedIn: true,
	        behaviour: action.payload.behaviour
	      });
	    case _passengers.PASSENGER_LOGIN + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        loggedIn: true
	      });
	    case _passengers.PASSENGER_LOGOUT:
	    case _passengers.PASSENGER_LOGOUT + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        loggedIn: false
	      });
	    case _passengers.PASSENGER_BOOKING_NEW:
	    case _passengers.PASSENGER_BOOKING_GET + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_BOOKING_STATE_CHANGE:
	    case _passengers.PASSENGER_BOOKING_CANCEL + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_BOOKING_DELETE:
	    case _passengers.PASSENGER_CHANGE_DESTINATION + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        bookings: passengerBookings(state.bookings, action)
	      });
	    default:
	      return state;
	  }
	}
	
	function passengers() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultPassengersState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _cohorts.COHORT_GET + RequestResultCases.SUCCESS:
	      return _lodash2.default.mapValues(action.payload.passengers, function (pax, passengerID) {
	        if (state[passengerID]) {
	          return passenger(state[passengerID], _extends({}, action, {
	            meta: _extends({}, action.meta, {
	              passengerID: passengerID
	            })
	          }));
	        }
	        return pax;
	      });
	    case _cohorts.COHORT_PASSENGER_ASSOCIATE:
	      return _extends({}, state, _defineProperty({}, action.payload.passengerID, passenger(state[action.payload.passengerID], action)));
	    case _cohorts.COHORT_PASSENGER_ASSOCIATE + RequestResultCases.SUCCESS:
	      {
	        if (!action.meta) {
	          return state;
	        }
	        return _extends({}, state, _defineProperty({}, action.payload.passengerID, _extends({}, action.meta.passenger, {
	          passengerID: action.payload.passengerID,
	          loggedIn: false,
	          bookings: []
	        })));
	      }
	    case _passengers.PASSENGER_LOGIN + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_LOGOUT + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_BOOKING_GET + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_BOOKING_CANCEL + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_CHANGE_DESTINATION + RequestResultCases.SUCCESS:
	      if (!action.meta) {
	        return state;
	      }
	      return _extends({}, state, _defineProperty({}, action.meta.passengerID, passenger(state[action.meta.passengerID], action)));
	    case _passengers.PASSENGER_DELETE + RequestResultCases.SUCCESS:
	      if (!action.meta) {
	        return state;
	      }
	      return _lodash2.default.omit(state, action.meta.passengerID);
	    case _cohorts.COHORT_PASSENGER_UPDATE:
	    case _passengers.PASSENGER_LOGIN:
	    case _passengers.PASSENGER_LOGOUT:
	    case _passengers.PASSENGER_BOOKING_NEW:
	    case _passengers.PASSENGER_BOOKING_STATE_CHANGE:
	    case _passengers.PASSENGER_BOOKING_DELETE:
	      {
	        if (!state[action.payload.passengerID]) {
	          // Passenger does not exist.
	          return state;
	        }
	        return _extends({}, state, _defineProperty({}, action.payload.passengerID, passenger(state[action.payload.passengerID], action)));
	      }
	    case _passengers.PASSENGER_DELETE:
	      return _lodash2.default.omit(state, action.payload.passengerID);
	    default:
	      return state;
	  }
	}
	
	function driverBooking(state, action) {
	  switch (action.type) {
	    case _drivers.DRIVER_BOOKING_NEW:
	      return _extends({}, state, action.payload.booking);
	    case _drivers.DRIVER_BOOKING_STATE_CHANGE:
	      return _extends({}, state, {
	        state: action.payload.state
	      });
	    default:
	      return state;
	  }
	}
	
	function driverBookings() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _drivers.DRIVER_BOOKING_NEW:
	      {
	        var index = _lodash2.default.findIndex(state, function (booking) {
	          return booking.bookingID === action.payload.bookingID;
	        });
	        if (index !== -1) {
	          return state;
	        }
	        return [driverBooking(action.payload.booking, action)].concat(_toConsumableArray(state));
	      }
	    case _drivers.DRIVER_BOOKING_STATE_CHANGE:
	      return state.map(function (booking) {
	        if (booking.bookingID === action.payload.bookingID) {
	          return driverBooking(booking, action);
	        }
	        return booking;
	      });
	    case _drivers.DRIVER_BOOKING_DELETE:
	      return state.filter(function (booking) {
	        return booking.bookingID !== action.payload.bookingID;
	      });
	    default:
	      return state;
	  }
	}
	
	function driver(state, action, app) {
	  var autoAcceptValue = void 0;
	  switch (action.type) {
	    case _cohorts.COHORT_DRIVER_ASSOCIATE:
	      {
	        var newState = action.payload.driver;
	        // If driver is not logged in, do not overwrite the behaviour received
	        // from the API because it is necessarily empty.
	        if (!action.payload.driver.loggedIn && state) {
	          newState.behaviour = state.behaviour;
	          newState.latitude = state.latitude;
	          newState.longitude = state.longitude;
	        }
	        return newState;
	      }
	    case _cohorts.COHORT_GET + RequestResultCases.SUCCESS:
	      {
	        if (!action.meta) {
	          return state;
	        }
	        var _newState2 = action.payload.drivers[action.meta.driverID];
	        if (!_newState2.loggedIn && state) {
	          _newState2.behaviour = state.behaviour;
	          _newState2.latitude = state.latitude;
	          _newState2.longitude = state.longitude;
	          _newState2.autoAccept = state.autoAccept;
	        }
	        return _newState2;
	      }
	    case _cohorts.COHORT_DRIVER_UPDATE:
	      return _extends({}, state, action.payload.driver);
	    case _drivers.DRIVER_LOGIN:
	      return _extends({}, state, {
	        loggedIn: true,
	        available: true,
	        behaviour: action.payload.behaviour
	      });
	    case _drivers.DRIVER_LOGIN + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        loggedIn: true,
	        available: true
	      });
	    case _drivers.DRIVER_LOGOUT:
	    case _drivers.DRIVER_LOGOUT + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        loggedIn: false
	      });
	    case _drivers.DRIVER_SET_AVAILABILITY:
	      return _extends({}, state, {
	        available: action.payload.availability
	      });
	    case _drivers.DRIVER_SET_AVAILABILITY + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        available: action.meta && action.meta.availability
	      });
	    case _drivers.DRIVER_SET_AUTO_ACCEPT:
	      if (action.payload.isTurnedOn) {
	        autoAcceptValue = autoAcceptValueOn;
	      } else {
	        autoAcceptValue = autoAcceptValueOff;
	      }
	      return _extends({}, state, {
	        autoAccept: autoAcceptValue
	      });
	    case _drivers.DRIVER_SET_AUTO_ACCEPT + RequestResultCases.SUCCESS:
	      if (action.meta && action.meta.isTurnedOn) {
	        autoAcceptValue = autoAcceptValueOn;
	      } else {
	        autoAcceptValue = autoAcceptValueOff;
	      }
	      return _extends({}, state, {
	        autoAccept: autoAcceptValue
	      });
	    case _drivers.DRIVER_SET_LOCATION:
	      if (app.driverBeingDragged === action.payload.driverID && !action.payload.selfGenerated) {
	        return state;
	      }
	      return _extends({}, state, {
	        longitude: action.payload.location[0],
	        latitude: action.payload.location[1]
	      });
	    case _drivers.DRIVER_BOOKING_NEW:
	    case _drivers.DRIVER_BOOKING_STATE_CHANGE:
	    case _drivers.DRIVER_BOOKING_DELETE:
	      return _extends({}, state, {
	        bookings: driverBookings(state.bookings, action)
	      });
	    default:
	      return state;
	  }
	}
	
	function drivers() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultDriversState;
	  var action = arguments[1];
	  var app = arguments[2];
	
	  switch (action.type) {
	    case _cohorts.COHORT_GET + RequestResultCases.SUCCESS:
	      return _lodash2.default.mapValues(action.payload.drivers, function (dax, driverID) {
	        if (state[driverID]) {
	          return driver(state[driverID], _extends({}, action, {
	            meta: _extends({}, action.meta, {
	              driverID: driverID
	            })
	          }), app);
	        }
	        var resDax = dax;
	        resDax.autoAccept = -1;
	        return resDax;
	      });
	    case _cohorts.COHORT_DRIVER_ASSOCIATE:
	      return _extends({}, state, _defineProperty({}, action.payload.driverID, driver(state[action.payload.driverID], action, app)));
	    case _cohorts.COHORT_DRIVER_ASSOCIATE + RequestResultCases.SUCCESS:
	      {
	        if (!action.meta) {
	          return state;
	        }
	        return _extends({}, state, _defineProperty({}, action.payload.driverID, _extends({}, action.meta.driver, {
	          driverID: action.payload.driverID,
	          loggedIn: false,
	          available: false,
	          autoAccept: -1,
	          bookings: []
	        })));
	      }
	    case _drivers.DRIVER_LOGIN + RequestResultCases.SUCCESS:
	    case _drivers.DRIVER_LOGOUT + RequestResultCases.SUCCESS:
	    case _drivers.DRIVER_SET_AUTO_ACCEPT + RequestResultCases.SUCCESS:
	    case _drivers.DRIVER_SET_AVAILABILITY + RequestResultCases.SUCCESS:
	      if (!action.meta) {
	        return state;
	      }
	      return _extends({}, state, _defineProperty({}, action.meta.driverID, driver(state[action.meta.driverID], action, app)));
	    case _drivers.DRIVER_DELETE + RequestResultCases.SUCCESS:
	      if (!action.meta) {
	        return state;
	      }
	      return _lodash2.default.omit(state, action.meta.driverID);
	    case _cohorts.COHORT_DRIVER_UPDATE:
	    case _drivers.DRIVER_LOGIN:
	    case _drivers.DRIVER_LOGOUT:
	    case _drivers.DRIVER_SET_LOCATION:
	    case _drivers.DRIVER_SET_AVAILABILITY:
	    case _drivers.DRIVER_SET_AUTO_ACCEPT:
	    case _drivers.DRIVER_BOOKING_NEW:
	    case _drivers.DRIVER_BOOKING_STATE_CHANGE:
	    case _drivers.DRIVER_BOOKING_DELETE:
	      {
	        if (!state[action.payload.driverID]) {
	          // Driver does not exist.
	          return state;
	        }
	        return _extends({}, state, _defineProperty({}, action.payload.driverID, driver(state[action.payload.driverID], action, app)));
	      }
	    case _drivers.DRIVER_DELETE:
	      return _lodash2.default.omit(state, action.payload.driverID);
	    case _drivers.DRIVER_BATCH_SET_LOCATION:
	      {
	        var _ret = function () {
	          var newState = _extends({}, state);
	          _lodash2.default.each(action.payload.driverLocations, function (location, driverID) {
	            newState[driverID] = _extends({}, state[driverID], {
	              longitude: location[0],
	              latitude: location[1]
	            });
	          });
	
	          return {
	            v: newState
	          };
	        }();
	
	        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	      }
	    default:
	      return state;
	  }
	}
	
	function cohort() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultCohortState;
	  var action = arguments[1];
	  var app = arguments[2];
	
	  switch (action.type) {
	    case _cohorts.COHORT_CREATE + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        cohortID: action.payload.cohortID,
	        paxType: action.payload.paxType
	      });
	    case _cohorts.COHORT_GET + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        passengers: passengers(state.passengers, action),
	        drivers: drivers(state.drivers, action, app),
	        cohortID: action.meta && action.meta.cohortID,
	        paxType: action.payload.paxType
	      });
	    case _cohorts.COHORT_PASSENGER_ASSOCIATE:
	    case _cohorts.COHORT_PASSENGER_ASSOCIATE + RequestResultCases.SUCCESS:
	    case _cohorts.COHORT_PASSENGER_UPDATE:
	    case _passengers.PASSENGER_LOGIN:
	    case _passengers.PASSENGER_LOGIN + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_LOGOUT:
	    case _passengers.PASSENGER_LOGOUT + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_DELETE:
	    case _passengers.PASSENGER_DELETE + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_BOOKING_NEW:
	    case _passengers.PASSENGER_BOOKING_GET + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_BOOKING_STATE_CHANGE:
	    case _passengers.PASSENGER_BOOKING_CANCEL + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_BOOKING_DELETE:
	    case _passengers.PASSENGER_CHANGE_DESTINATION + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        passengers: passengers(state.passengers, action)
	      });
	    case _cohorts.COHORT_DRIVER_ASSOCIATE:
	    case _cohorts.COHORT_DRIVER_ASSOCIATE + RequestResultCases.SUCCESS:
	    case _cohorts.COHORT_DRIVER_UPDATE:
	    case _drivers.DRIVER_LOGIN:
	    case _drivers.DRIVER_LOGIN + RequestResultCases.SUCCESS:
	    case _drivers.DRIVER_LOGOUT:
	    case _drivers.DRIVER_LOGOUT + RequestResultCases.SUCCESS:
	    case _drivers.DRIVER_DELETE:
	    case _drivers.DRIVER_DELETE + RequestResultCases.SUCCESS:
	    case _drivers.DRIVER_SET_AVAILABILITY:
	    case _drivers.DRIVER_SET_AVAILABILITY + RequestResultCases.SUCCESS:
	    case _drivers.DRIVER_SET_AUTO_ACCEPT:
	    case _drivers.DRIVER_SET_AUTO_ACCEPT + RequestResultCases.SUCCESS:
	    case _drivers.DRIVER_BOOKING_NEW:
	    case _drivers.DRIVER_BOOKING_STATE_CHANGE:
	    case _drivers.DRIVER_BOOKING_DELETE:
	    case _drivers.DRIVER_SET_LOCATION:
	    case _drivers.DRIVER_BATCH_SET_LOCATION:
	      return _extends({}, state, {
	        drivers: drivers(state.drivers, action, app)
	      });
	    default:
	      return state;
	  }
	}
	
	function cohorts() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultCohortsState;
	  var action = arguments[1];
	  var app = arguments[2];
	
	  switch (action.type) {
	    case _cohorts.COHORT_CREATE + RequestResultCases.SUCCESS:
	      return _extends({}, state, _defineProperty({}, action.payload.cohortID, cohort(state[action.payload.cohortID], action, app)));
	    case _cohorts.COHORT_DELETE:
	      return _lodash2.default.omit(state, action.payload.cohortID);
	    // Directly remove non-existing cohorts to handle the case of fetching cohorts
	    // that existed before a server restart.
	    // TODO: When we persist cohorts data this can be removed.
	    case _cohorts.COHORT_GET + RequestResultCases.FAILURE:
	    case _cohorts.COHORT_DELETE + RequestResultCases.SUCCESS:
	      if (!action.meta) {
	        return state;
	      }
	      return _lodash2.default.omit(state, [action.meta.cohortID]);
	    case _cohorts.UNSET_COHORT:
	      return _lodash2.default.omit(state, [action.payload.cohortID]);
	    case _cohorts.COHORT_GET + RequestResultCases.SUCCESS:
	    case _cohorts.COHORT_PASSENGER_ASSOCIATE + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_LOGIN + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_LOGOUT + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_DELETE + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_BOOKING_GET + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_BOOKING_CANCEL + RequestResultCases.SUCCESS:
	    case _cohorts.COHORT_DRIVER_ASSOCIATE + RequestResultCases.SUCCESS:
	    case _drivers.DRIVER_LOGIN + RequestResultCases.SUCCESS:
	    case _drivers.DRIVER_LOGOUT + RequestResultCases.SUCCESS:
	    case _drivers.DRIVER_DELETE + RequestResultCases.SUCCESS:
	    case _drivers.DRIVER_SET_AVAILABILITY + RequestResultCases.SUCCESS:
	    case _drivers.DRIVER_SET_AUTO_ACCEPT + RequestResultCases.SUCCESS:
	    case _passengers.PASSENGER_CHANGE_DESTINATION + RequestResultCases.SUCCESS:
	      if (!action.meta) {
	        return state;
	      }
	      return _extends({}, state, _defineProperty({}, action.meta.cohortID, cohort(state[action.meta.cohortID], action, app)));
	    case _cohorts.COHORT_PASSENGER_ASSOCIATE:
	    case _cohorts.COHORT_PASSENGER_UPDATE:
	    case _cohorts.COHORT_DRIVER_ASSOCIATE:
	    case _cohorts.COHORT_DRIVER_UPDATE:
	    case _drivers.DRIVER_LOGIN:
	    case _drivers.DRIVER_LOGOUT:
	    case _drivers.DRIVER_DELETE:
	    case _drivers.DRIVER_BOOKING_NEW:
	    case _drivers.DRIVER_BOOKING_STATE_CHANGE:
	    case _drivers.DRIVER_BOOKING_DELETE:
	    case _drivers.DRIVER_SET_LOCATION:
	    case _drivers.DRIVER_SET_AVAILABILITY:
	    case _drivers.DRIVER_SET_AUTO_ACCEPT:
	    case _passengers.PASSENGER_LOGIN:
	    case _passengers.PASSENGER_LOGOUT:
	    case _passengers.PASSENGER_DELETE:
	    case _passengers.PASSENGER_BOOKING_NEW:
	    case _passengers.PASSENGER_BOOKING_STATE_CHANGE:
	    case _passengers.PASSENGER_BOOKING_DELETE:
	    case _drivers.DRIVER_BATCH_SET_LOCATION:
	      return _extends({}, state, _defineProperty({}, action.payload.cohortID, cohort(state[action.payload.cohortID], action, app)));
	    default:
	      return state;
	  }
	}
	
	exports.default = cohorts;

/***/ },
/* 202 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	// Commented out events have not been implemented.
	var COHORT_DELETED_EVENT = exports.COHORT_DELETED_EVENT = 1;
	var DRIVER_NEW_EVENT = exports.DRIVER_NEW_EVENT = 2;
	var DRIVER_LOGGED_IN_EVENT = exports.DRIVER_LOGGED_IN_EVENT = 3;
	var DRIVER_LOGGED_OUT_EVENT = exports.DRIVER_LOGGED_OUT_EVENT = 4;
	var DRIVER_LOCATION_UPDATE_EVENT = exports.DRIVER_LOCATION_UPDATE_EVENT = 5;
	var DRIVER_DISCONNECTED_EVENT = exports.DRIVER_DISCONNECTED_EVENT = 6;
	var DRIVER_DELETED_EVENT = exports.DRIVER_DELETED_EVENT = 7;
	var PASSENGER_NEW_EVENT = exports.PASSENGER_NEW_EVENT = 8;
	var PASSENGER_LOGGED_IN_EVENT = exports.PASSENGER_LOGGED_IN_EVENT = 9;
	var PASSENGER_LOGGED_OUT_EVENT = exports.PASSENGER_LOGGED_OUT_EVENT = 10;
	var PASSENGER_DELETED_EVENT = exports.PASSENGER_DELETED_EVENT = 11;
	var BOOKING_DRIVER_NEW_EVENT = exports.BOOKING_DRIVER_NEW_EVENT = 12;
	var BOOKING_DRIVER_BID_EVENT = exports.BOOKING_DRIVER_BID_EVENT = 13;
	var BOOKING_DRIVER_DECLINED_EVENT = exports.BOOKING_DRIVER_DECLINED_EVENT = 14;
	var BOOKING_DRIVER_AWARDED_EVENT = exports.BOOKING_DRIVER_AWARDED_EVENT = 15;
	// export const BOOKING_DRIVER_IM_HERE_EVENT: number = 16;
	var BOOKING_DRIVER_PICKED_UP_EVENT = exports.BOOKING_DRIVER_PICKED_UP_EVENT = 17;
	var BOOKING_DRIVER_DROPPED_OFF_EVENT = exports.BOOKING_DRIVER_DROPPED_OFF_EVENT = 18;
	var BOOKING_DRIVER_COMPLETE_EVENT = exports.BOOKING_DRIVER_COMPLETE_EVENT = 19;
	var BOOKING_DRIVER_CANCELLED_EVENT = exports.BOOKING_DRIVER_CANCELLED_EVENT = 20;
	var BOOKING_DRIVER_RECEIVED_CANCELLATION_EVENT = exports.BOOKING_DRIVER_RECEIVED_CANCELLATION_EVENT = 21;
	var BOOKING_PASSENGER_NEW_EVENT = exports.BOOKING_PASSENGER_NEW_EVENT = 22;
	var BOOKING_PASSENGER_UNALLOCATED_EVENT = exports.BOOKING_PASSENGER_UNALLOCATED_EVENT = 23;
	var BOOKING_PASSENGER_AWARDED_EVENT = exports.BOOKING_PASSENGER_AWARDED_EVENT = 24;
	var BOOKING_PASSENGER_PICKED_UP_EVENT = exports.BOOKING_PASSENGER_PICKED_UP_EVENT = 25;
	var BOOKING_PASSENGER_COMPLETED_EVENT = exports.BOOKING_PASSENGER_COMPLETED_EVENT = 26;
	var BOOKING_PASSENGER_CANCELLED_EVENT = exports.BOOKING_PASSENGER_CANCELLED_EVENT = 27;
	var BOOKING_PASSENGER_RECEIVED_CANCELLATION_EVENT = exports.BOOKING_PASSENGER_RECEIVED_CANCELLATION_EVENT = 28;
	var DRIVER_AVAILABILITY_UPDATE_EVENT = exports.DRIVER_AVAILABILITY_UPDATE_EVENT = 29;
	var BOOKING_DRIVER_IGNORED_EVENT = exports.BOOKING_DRIVER_IGNORED_EVENT = 30;
	// export const BOOKING_DRIVER_ADDITIONAL_DROPOFF_EVENT: number = 31;
	// export const SIMULATION_BOOKINGS_CREATED_EVENT: number = 32;
	var SIMULATION_BOOKINGS_COMPLETE_EVENT = exports.SIMULATION_BOOKINGS_COMPLETE_EVENT = 33;
	var SIMULATION_BOOKINGS_TIMEOUT_EVENT = exports.SIMULATION_BOOKINGS_TIMEOUT_EVENT = 34;
	// export const PASSENGERS_LOGGED_IN: number = 35;
	var SIMULATION_RESOURCE_CREATION_ERROR = exports.SIMULATION_RESOURCE_CREATION_ERROR = 36;
	var RESOURCE_CREATION_STATUS_EVENT = exports.RESOURCE_CREATION_STATUS_EVENT = 39;
	var DRIVER_AUTO_ACCEPT_UPDATE_EVENT = exports.DRIVER_AUTO_ACCEPT_UPDATE_EVENT = 40;

/***/ },
/* 203 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CitiesObject = function CitiesObject() {
	  _classCallCheck(this, CitiesObject);
	
	  this.cities = [{
	    // IT.29TV8TPSSTDV4
	    name: 'Singapore',
	    city_code: 'CITY_SG_SIN',
	    latitude: 1.347597342,
	    longitude: 103.8516846
	  }, {
	    // IT.1UN6KQ5UK1RGX
	    name: 'Kuala Lumpur',
	    city_code: 'CITY_MY_KUL',
	    latitude: 3.14711,
	    longitude: 101.7056
	  }, {
	    // IT.0V1PXXFJ65KL8
	    name: 'Ho Chi Minh',
	    city_code: 'CITY_VN_SGN',
	    latitude: 10.78595,
	    longitude: 106.6928
	  }, {
	    // FI.C2.32c9c859d8332d4036ab3e575b415e40.IT_1SVF41LOW6S6K
	    name: 'Manila',
	    city_code: 'CITY_PH_MNL',
	    latitude: 14.60126,
	    longitude: 121.0212
	  }, {
	    // IT.070BEZTZ8U4NN
	    name: 'Jakarta',
	    city_code: 'CITY_ID_CGK',
	    latitude: -6.208058364,
	    longitude: 106.85141
	  }, {
	    // FI.C2.3dd52137c3d530403baa9a20ea0c5840.IT_2CGYZO82IAYOY
	    name: 'Yangon',
	    city_code: 'CITY_MM_RGN',
	    latitude: 16.83501,
	    longitude: 96.20179
	  }, {
	    // IT.2EOZSICUB69HN
	    name: 'Hanoi',
	    city_code: 'CITY_VN_HNI',
	    latitude: 21.034136,
	    longitude: 105.851447
	  }, {
	    // IT.179UR1E96UMBO
	    name: 'Bangkok',
	    city_code: 'CITY_TH_BKK',
	    latitude: 13.74074,
	    longitude: 100.51747
	  }];
	};
	
	exports.default = CitiesObject;

/***/ },
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(28);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(75);
	
	var _DOMUtils = __webpack_require__(99);
	
	var _deprecate = __webpack_require__(55);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function startBeforeUnloadListener(getBeforeUnloadPromptMessage) {
	  function listener(event) {
	    var message = getBeforeUnloadPromptMessage();
	
	    if (typeof message === 'string') {
	      (event || window.event).returnValue = message;
	      return message;
	    }
	  }
	
	  _DOMUtils.addEventListener(window, 'beforeunload', listener);
	
	  return function () {
	    _DOMUtils.removeEventListener(window, 'beforeunload', listener);
	  };
	}
	
	/**
	 * Returns a new createHistory function that can be used to create
	 * history objects that know how to use the beforeunload event in web
	 * browsers to cancel navigation.
	 */
	function useBeforeUnload(createHistory) {
	  return function (options) {
	    var history = createHistory(options);
	
	    var stopBeforeUnloadListener = undefined;
	    var beforeUnloadHooks = [];
	
	    function getBeforeUnloadPromptMessage() {
	      var message = undefined;
	
	      for (var i = 0, len = beforeUnloadHooks.length; message == null && i < len; ++i) {
	        message = beforeUnloadHooks[i].call();
	      }return message;
	    }
	
	    function listenBeforeUnload(hook) {
	      beforeUnloadHooks.push(hook);
	
	      if (beforeUnloadHooks.length === 1) {
	        if (_ExecutionEnvironment.canUseDOM) {
	          stopBeforeUnloadListener = startBeforeUnloadListener(getBeforeUnloadPromptMessage);
	        } else {
	           false ? _warning2['default'](false, 'listenBeforeUnload only works in DOM environments') : undefined;
	        }
	      }
	
	      return function () {
	        beforeUnloadHooks = beforeUnloadHooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (beforeUnloadHooks.length === 0 && stopBeforeUnloadListener) {
	          stopBeforeUnloadListener();
	          stopBeforeUnloadListener = null;
	        }
	      };
	    }
	
	    // deprecated
	    function registerBeforeUnloadHook(hook) {
	      if (_ExecutionEnvironment.canUseDOM && beforeUnloadHooks.indexOf(hook) === -1) {
	        beforeUnloadHooks.push(hook);
	
	        if (beforeUnloadHooks.length === 1) stopBeforeUnloadListener = startBeforeUnloadListener(getBeforeUnloadPromptMessage);
	      }
	    }
	
	    // deprecated
	    function unregisterBeforeUnloadHook(hook) {
	      if (beforeUnloadHooks.length > 0) {
	        beforeUnloadHooks = beforeUnloadHooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (beforeUnloadHooks.length === 0) stopBeforeUnloadListener();
	      }
	    }
	
	    return _extends({}, history, {
	      listenBeforeUnload: listenBeforeUnload,
	
	      registerBeforeUnloadHook: _deprecate2['default'](registerBeforeUnloadHook, 'registerBeforeUnloadHook is deprecated; use listenBeforeUnload instead'),
	      unregisterBeforeUnloadHook: _deprecate2['default'](unregisterBeforeUnloadHook, 'unregisterBeforeUnloadHook is deprecated; use the callback returned from listenBeforeUnload instead')
	    });
	  };
	}
	
	exports['default'] = useBeforeUnload;
	module.exports = exports['default'];

/***/ },
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var util = {
	  isAppearSupported: function isAppearSupported(props) {
	    return props.transitionName && props.transitionAppear || props.animation.appear;
	  },
	  isEnterSupported: function isEnterSupported(props) {
	    return props.transitionName && props.transitionEnter || props.animation.enter;
	  },
	  isLeaveSupported: function isLeaveSupported(props) {
	    return props.transitionName && props.transitionLeave || props.animation.leave;
	  },
	  allowAppearCallback: function allowAppearCallback(props) {
	    return props.transitionAppear || props.animation.appear;
	  },
	  allowEnterCallback: function allowEnterCallback(props) {
	    return props.transitionEnter || props.animation.enter;
	  },
	  allowLeaveCallback: function allowLeaveCallback(props) {
	    return props.transitionLeave || props.animation.leave;
	  }
	};
	exports["default"] = util;
	module.exports = exports['default'];

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(455);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var LazyRenderBox = _react2["default"].createClass({
	  displayName: 'LazyRenderBox',
	
	  propTypes: {
	    children: _react.PropTypes.any,
	    className: _react.PropTypes.string,
	    visible: _react.PropTypes.bool,
	    hiddenClassName: _react.PropTypes.string
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    return nextProps.hiddenClassName || nextProps.visible;
	  },
	  render: function render() {
	    var _props = this.props,
	        hiddenClassName = _props.hiddenClassName,
	        visible = _props.visible,
	        props = (0, _objectWithoutProperties3["default"])(_props, ['hiddenClassName', 'visible']);
	
	
	    if (hiddenClassName || _react2["default"].Children.count(props.children) > 1) {
	      if (!visible && hiddenClassName) {
	        props.className += ' ' + hiddenClassName;
	      }
	      return _react2["default"].createElement('div', props);
	    }
	
	    return _react2["default"].Children.only(props.children);
	  }
	});
	
	exports["default"] = LazyRenderBox;
	module.exports = exports['default'];

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = addEventListenerWrap;
	
	var _addDomEventListener = __webpack_require__(436);
	
	var _addDomEventListener2 = _interopRequireDefault(_addDomEventListener);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function addEventListenerWrap(target, eventType, cb) {
	  /* eslint camelcase: 2 */
	  var callback = _reactDom2["default"].unstable_batchedUpdates ? function run(e) {
	    _reactDom2["default"].unstable_batchedUpdates(cb, e);
	  } : cb;
	  return (0, _addDomEventListener2["default"])(target, eventType, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 324 */,
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(2);
	var onElementResize = __webpack_require__(508);
	
	var defaultContainerStyle = {
	  width: '100%',
	  height: '100%',
	  padding: 0,
	  border: 0
	};
	
	function defaultGetWidth(element) {
	  return element.clientWidth;
	}
	
	function defaultGetHeight(element) {
	  return element.clientHeight;
	}
	
	/**
	 * Wraps a react component and adds properties `containerHeight` and
	 * `containerWidth`. Useful for responsive design. Properties update on
	 * window resize. **Note** that the parent element must have either a
	 * height or a width, or nothing will be rendered
	 *
	 * Can be used as a
	 * [higher-order component](http://babeljs.io/blog/2015/06/07/react-on-es6-plus/#property-initializers)
	 * or as an [ES7 class decorator](https://github.com/wycats/javascript-decorators)
	 * (see examples)
	 *
	 * @param {object} [options]
	 * @param {function} [options.getHeight] A function that is passed an element and returns element
	 * height, where element is the wrapper div. Defaults to `(element) => element.clientHeight`
	 * @param {function} [options.getWidth]  A function that is passed an element and returns element
	 * width, where element is the wrapper div. Defaults to `(element) => element.clientWidth`
	 * @param {object} [options.containerStyle] A style object for the `<div>` that will wrap your component.
	 * The dimensions of this `div` are what are passed as props to your component. The default style is
	 * `{ width: '100%', height: '100%', padding: 0, border: 0 }` which will cause the `div` to fill its
	 * parent in most cases. If you are using a flexbox layout you will want to change this default style.
	 * @param {string} [options.className] Control the class name set on the wrapper `<div>`
	 * @param {boolean} [options.elementResize=false] Set true to watch the wrapper `div` for changes in
	 * size which are not a result of window resizing - e.g. changes to the flexbox and other layout.
	 * @return {function}                   A higher-order component that can be
	 * used to enhance a react component `Dimensions()(MyComponent)`
	 *
	 * @example
	 * // ES2015
	 * import React from 'react'
	 * import Dimensions from 'react-dimensions'
	 *
	 * class MyComponent extends React.Component {
	 *   render() (
	 *     <div
	 *       containerWidth={this.props.containerWidth}
	 *       containerHeight={this.props.containerHeight}
	 *     >
	 *     </div>
	 *   )
	 * }
	 *
	 * export default Dimensions()(MyComponent) // Enhanced component
	 *
	 * @example
	 * // ES5
	 * var React = require('react')
	 * var Dimensions = require('react-dimensions')
	 *
	 * var MyComponent = React.createClass({
	 *   render: function() {(
	 *     <div
	 *       containerWidth={this.props.containerWidth}
	 *       containerHeight={this.props.containerHeight}
	 *     >
	 *     </div>
	 *   )}
	 * }
	 *
	 * module.exports = Dimensions()(MyComponent) // Enhanced component
	 *
	 */
	module.exports = function Dimensions() {
	  var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var _ref$getHeight = _ref.getHeight;
	  var getHeight = _ref$getHeight === undefined ? defaultGetHeight : _ref$getHeight;
	  var _ref$getWidth = _ref.getWidth;
	  var getWidth = _ref$getWidth === undefined ? defaultGetWidth : _ref$getWidth;
	  var _ref$containerStyle = _ref.containerStyle;
	  var containerStyle = _ref$containerStyle === undefined ? defaultContainerStyle : _ref$containerStyle;
	  var _ref$className = _ref.className;
	  var className = _ref$className === undefined ? null : _ref$className;
	  var _ref$elementResize = _ref.elementResize;
	  var elementResize = _ref$elementResize === undefined ? false : _ref$elementResize;
	
	  return function (ComposedComponent) {
	    return function (_React$Component) {
	      _inherits(DimensionsHOC, _React$Component);
	
	      function DimensionsHOC() {
	        var _Object$getPrototypeO;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, DimensionsHOC);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(DimensionsHOC)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {}, _this.updateDimensions = function () {
	          var container = _this.refs.container;
	          var containerWidth = getWidth(container);
	          var containerHeight = getHeight(container);
	
	          if (containerWidth !== _this.state.containerWidth || containerHeight !== _this.state.containerHeight) {
	            _this.setState({ containerWidth: containerWidth, containerHeight: containerHeight });
	          }
	        }, _this.onResize = function () {
	          if (_this.rqf) return;
	          _this.rqf = _this.getWindow().requestAnimationFrame(function () {
	            _this.rqf = null;
	            _this.updateDimensions();
	          });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	      // ES7 Class properties
	      // http://babeljs.io/blog/2015/06/07/react-on-es6-plus/#property-initializers
	
	
	      // Using arrow functions and ES7 Class properties to autobind
	      // http://babeljs.io/blog/2015/06/07/react-on-es6-plus/#arrow-functions
	
	
	      _createClass(DimensionsHOC, [{
	        key: 'getWindow',
	
	
	        // If the component is mounted in a different window to the javascript
	        // context, as with https://github.com/JakeGinnivan/react-popout
	        // then the `window` global will be different from the `window` that
	        // contains the component.
	        // Depends on `defaultView` which is not supported <IE9
	        value: function getWindow() {
	          return this.refs.container ? this.refs.container.ownerDocument.defaultView || window : window;
	        }
	      }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          if (!this.refs.container) {
	            throw new Error('Cannot find container div');
	          }
	          this.updateDimensions();
	          if (elementResize) {
	            // Experimental: `element-resize-event` fires when an element resizes.
	            // It attaches its own window resize listener and also uses
	            // requestAnimationFrame, so we can just call `this.updateDimensions`.
	            onElementResize(this.refs.container, this.updateDimensions);
	          } else {
	            this.getWindow().addEventListener('resize', this.onResize, false);
	          }
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          this.getWindow().removeEventListener('resize', this.onResize);
	        }
	
	        /**
	         * Returns the underlying wrapped component instance.
	         * Useful if you need to access a method or property of the component
	         * passed to react-dimensions.
	         *
	         * @return {object} The rendered React component
	         **/
	
	      }, {
	        key: 'getWrappedInstance',
	        value: function getWrappedInstance() {
	          this.refs.wrappedInstance;
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _state = this.state;
	          var containerWidth = _state.containerWidth;
	          var containerHeight = _state.containerHeight;
	
	          if (!containerWidth && !containerHeight) {
	            console.warn('Wrapper div has no height or width, try overriding style with `containerStyle` option');
	          }
	          return React.createElement(
	            'div',
	            { className: className, style: containerStyle, ref: 'container' },
	            (containerWidth || containerHeight) && React.createElement(ComposedComponent, _extends({}, this.state, this.props, {
	              updateDimensions: this.updateDimensions,
	              ref: 'wrappedInstance'
	            }))
	          );
	        }
	      }]);
	
	      return DimensionsHOC;
	    }(React.Component);
	  };
	};


/***/ },
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTIiIGhlaWdodD0iMTUwIiB2aWV3Qm94PSIwIDAgNTIgMTUwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjx0aXRsZT4xN0QyMjYzOS05MzBELTQyREEtQjE0RS1DOTBGQjI0QTJCNEY8L3RpdGxlPjxkZWZzPjxyYWRpYWxHcmFkaWVudCBmeD0iNTAlIiBmeT0iNTAlIiByPSI0NC4zMTIlIiBpZD0iYSI+PHN0b3Agb2Zmc2V0PSIwJSIvPjxzdG9wIHN0b3Atb3BhY2l0eT0iLjMzMyIgb2Zmc2V0PSI4OC44NDUlIi8+PHN0b3Agc3RvcC1vcGFjaXR5PSIwIiBvZmZzZXQ9IjEwMCUiLz48L3JhZGlhbEdyYWRpZW50PjwvZGVmcz48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik01OS42MjUgMjMuNzIzQzU5LjYyNSAxMC42MiA0Ni4yNzcgMCAyOS44MTIgMCAxMy4zNDkgMCAwIDEwLjYyIDAgMjMuNzIzYzAgMTMuMTAxIDEzLjM0OCAyMy43MjIgMjkuODEzIDIzLjcyMiAxNi40NjQgMCAyOS44MTItMTAuNjIgMjkuODEyLTIzLjcyMnoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zLjg3NSA2NikiIGZpbGw9InVybCgjYSkiIG9wYWNpdHk9Ii4zIi8+PHBhdGggZD0iTTQ4IDIxLjI4NWMwIDExLjc1Ni0yMiA3MS4zNy0yMiA3MS4zN1M0IDMzLjA0IDQgMjEuMjg0QzQgOS41MyAxMy44NSAwIDI2IDBzMjIgOS41MyAyMiAyMS4yODUiIGZpbGw9IiMwMEIxNDAiLz48L2c+PC9zdmc+"

/***/ },
/* 412 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTIiIGhlaWdodD0iMTUwIiB2aWV3Qm94PSIwIDAgNTIgMTUwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjx0aXRsZT4xN0QyMjYzOS05MzBELTQyREEtQjE0RS1DOTBGQjI0QTJCNEY8L3RpdGxlPjxkZWZzPjxyYWRpYWxHcmFkaWVudCBmeD0iNTAlIiBmeT0iNTAlIiByPSI0NC4zMTIlIiBpZD0iYSI+PHN0b3Agb2Zmc2V0PSIwJSIvPjxzdG9wIHN0b3Atb3BhY2l0eT0iLjMzMyIgb2Zmc2V0PSI4OC44NDUlIi8+PHN0b3Agc3RvcC1vcGFjaXR5PSIwIiBvZmZzZXQ9IjEwMCUiLz48L3JhZGlhbEdyYWRpZW50PjwvZGVmcz48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik01OS42MjUgMjMuNzIzQzU5LjYyNSAxMC42MiA0Ni4yNzcgMCAyOS44MTIgMCAxMy4zNDkgMCAwIDEwLjYyIDAgMjMuNzIzYzAgMTMuMTAxIDEzLjM0OCAyMy43MjIgMjkuODEzIDIzLjcyMiAxNi40NjQgMCAyOS44MTItMTAuNjIgMjkuODEyLTIzLjcyMnoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zLjg3NSA2NikiIGZpbGw9InVybCgjYSkiIG9wYWNpdHk9Ii4zIi8+PHBhdGggZD0iTTQ4IDIxLjI4NWMwIDExLjc1Ni0yMiA3MS4zNy0yMiA3MS4zN1M0IDMzLjA0IDQgMjEuMjg0QzQgOS41MyAxMy44NSAwIDI2IDBzMjIgOS41MyAyMiAyMS4yODUiIGZpbGw9IiM0QTkwRTIiLz48L2c+PC9zdmc+"

/***/ },
/* 413 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (u, m, d) {
		if (true) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return (d());}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}
		else if (typeof exports === 'object') {module.exports = d();}
		else {u[m] = d();}
	}(this, 'MemoryStorage', function() {'use strict';
	
	/*! memorystorage.js - A memory-backed implementation of the Web Storage API.
	 *
	 * @copyright Copyright 2016 by Stijn de Witt and contributors. Some rights reserved.
	 * @license Licensed under [Creative Commons Attribution 4.0 International (CC BY 4.0)](https://creativecommons.org/licenses/by/4.0/).
	 */
	
	/**
	 * Creates a new MemoryStorage object implementing the <a href="http://www.w3.org/TR/webstorage/">Web Storage API</a> using memory.
	 *
	 * <p>If no arguments are given, the created memory storage object will read from and write to the
	 * <code>global</code> memory storage. If a string argument is given, the new storage object
	 * will read from and write to it's own segment of memory. Any data written to such a memory
	 * storage object will only show up in other memory storage objects that have been created with
	 * the same id. This data will not show up in the <code>global</code> memory space. As such it
	 * is recommended to always construct a memory storage object with a unique string id as argument.</p>
	 *
	 * @param id Optional string argument used to isolate this memory storage object from others.
	 */
	function MemoryStorage(id) {
		// make sure id is assigned
		id = id || 'global'
		// try to get existing store
		var result = storage[id]
		// return it if found
		if (result) {return result}
	
		// make sure there is no harm in leaving out new in invocations to MemoryStorage
		if (! (this instanceof MemoryStorage)) {return new MemoryStorage(id);}
	
		// create a new store and save a ref to it so we can get it back later
		result = storage[id] = this;
		// create a space to store 'cloaked' key/values: items that have a key
		// that collides with Web Storage API method names.
		var cloak = {};
	
		// Allow client code to read the id
		Object.defineProperty(result, 'id', {enumerable:true, configurable:true, value:id})
	
		// Create the length property
		Object.defineProperty(result, 'length', {enumerable:true, configurable:true, get:function(){
			return enumerableKeys().length
		}})
	
		// Create API methods
		result.getItem = function MemoryStorage_getItem(key) {
			return (key in API ? cloak[key] : this[key]) || null
		}
		result.setItem = function MemoryStorage_setItem(key, val) {
			key in API ? cloak[key] = val : this[key] = val
		}
		result.removeItem = function MemoryStorage_removeItem(key) {
			key in API ? delete cloak[key] : delete this[key]
		}
		result.key = function MemoryStorage_key(idx) {
			var keys = enumerableKeys()
			return idx >= 0 && idx < keys.length ? keys[idx] : null
		}
		result.clear = function MemoryStorage_clear() {
			var keys = uncloakedKeys()
			for (var i=0,key; key=keys[i]; i++) {
				delete this[key]
			}
			keys = cloakedKeys()
			for (var i=0,key; key=keys[i]; i++) {
				delete cloak[key]
			}
		}
	
		// Wrap in ES6 Proxy if available to support Object.keys() on a MemoryStorage object
		return typeof Proxy === 'undefined' ? result : new Proxy(result, {ownKeys: function() {return enumerableKeys()}})
	
		// helper functions
		function uncloakedKeys() {return Object.keys(result).filter(function(x){return !(x in API)})}
		function cloakedKeys() {return Object.keys(cloak)}
		function enumerableKeys(){return uncloakedKeys().concat(cloakedKeys())}
	}
	
	// API methods and properties will be cloaked
	var API = {clear:1, getItem:1, id:1, key:1, length:1, removeItem:1, setItem:1}
	
	// Used to store all memorystorage objects
	var storage = {};
	
	
	return MemoryStorage;
	}));


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/**
	 * Validators are functions which assert certain type.
	 * They can return a string which can then be used
	 * to display a helpful error message.
	 * They can also return a function for a custom error message.
	 */
	var isPlainObject = __webpack_require__(622);
	var xtend = __webpack_require__(112);
	
	var DEFAULT_ERROR_PATH = 'value';
	var NEWLINE_INDENT = '\n  ';
	
	var v = {};
	
	/**
	 * Runners
	 *
	 * Take root validators and run assertion
	 */
	v.assert = function(rootValidator, options) {
	  options = options || {};
	  return function(value) {
	    var message = validate(rootValidator, value);
	    // all good
	    if (!message) {
	      return;
	    }
	
	    var errorMessage = processMessage(message, options);
	
	    if (options.apiName) {
	      errorMessage = options.apiName + ': ' + errorMessage;
	    }
	
	    throw new Error(errorMessage);
	  };
	};
	
	/**
	 * Higher Order Validators
	 *
	 * validators which take other validators as input
	 * and output a new validator
	 */
	v.shape = function shape(validatorObj) {
	  var validators = objectEntries(validatorObj);
	  return function shapeValidator(value) {
	    var validationResult = validate(v.plainObject, value);
	
	    if (validationResult) {
	      return validationResult;
	    }
	
	    var key, validator;
	    var errorMessages = [];
	
	    for (var i = 0; i < validators.length; i++) {
	      key = validators[i].key;
	      validator = validators[i].value;
	      validationResult = validate(validator, value[key]);
	
	      if (validationResult) {
	        // return [key].concat(validationResult);
	        errorMessages.push([key].concat(validationResult));
	      }
	    }
	
	    if (errorMessages.length < 2) {
	      return errorMessages[0];
	    }
	
	    // enumerate all the error messages
	    return function(options) {
	      errorMessages = errorMessages.map(function(message) {
	        var key = message[0];
	        var renderedMessage = processMessage(message, options)
	          .split('\n')
	          .join(NEWLINE_INDENT); // indents any inner nesting
	        return '- ' + key + ': ' + renderedMessage;
	      });
	
	      var objectId = options.path.join('.');
	      var ofPhrase = objectId === DEFAULT_ERROR_PATH ? '' : ' of ' + objectId;
	
	      return (
	        'The following properties' +
	        ofPhrase +
	        ' have invalid values:' +
	        NEWLINE_INDENT +
	        errorMessages.join(NEWLINE_INDENT)
	      );
	    };
	  };
	};
	
	v.strictShape = function strictShape(validatorObj) {
	  var shapeValidator = v.shape(validatorObj);
	  return function strictShapeValidator(value) {
	    var shapeResult = shapeValidator(value);
	    if (shapeResult) {
	      return shapeResult;
	    }
	
	    var invalidKeys = Object.keys(value).reduce(function(memo, valueKey) {
	      if (validatorObj[valueKey] === undefined) {
	        memo.push(valueKey);
	      }
	      return memo;
	    }, []);
	
	    if (invalidKeys.length !== 0) {
	      return function() {
	        return 'The following keys are invalid: ' + invalidKeys.join(', ');
	      };
	    }
	  };
	};
	
	v.arrayOf = function arrayOf(validator) {
	  return createArrayValidator(validator);
	};
	
	v.tuple = function tuple() {
	  var validators = Array.isArray(arguments[0])
	    ? arguments[0]
	    : Array.prototype.slice.call(arguments);
	  return createArrayValidator(validators);
	};
	
	// Currently array validation fails when the first invalid item is found.
	function createArrayValidator(validators) {
	  var validatingTuple = Array.isArray(validators);
	  var getValidator = function(index) {
	    if (validatingTuple) {
	      return validators[index];
	    }
	    return validators;
	  };
	
	  return function arrayValidator(value) {
	    var validationResult = validate(v.plainArray, value);
	    if (validationResult) {
	      return validationResult;
	    }
	
	    if (validatingTuple && value.length !== validators.length) {
	      return 'an array with ' + validators.length + ' items';
	    }
	
	    for (var i = 0; i < value.length; i++) {
	      validationResult = validate(getValidator(i), value[i]);
	      if (validationResult) {
	        return [i].concat(validationResult);
	      }
	    }
	  };
	}
	
	v.required = function required(validator) {
	  function requiredValidator(value) {
	    if (value == null) {
	      return function(options) {
	        return formatErrorMessage(
	          options,
	          isArrayCulprit(options.path)
	            ? 'cannot be undefined/null.'
	            : 'is required.'
	        );
	      };
	    }
	    return validator.apply(this, arguments);
	  }
	  requiredValidator.__required = true;
	
	  return requiredValidator;
	};
	
	v.oneOfType = function oneOfType() {
	  var validators = Array.isArray(arguments[0])
	    ? arguments[0]
	    : Array.prototype.slice.call(arguments);
	  return function oneOfTypeValidator(value) {
	    var messages = validators
	      .map(function(validator) {
	        return validate(validator, value);
	      })
	      .filter(Boolean);
	
	    // If we don't have as many messages as no. of validators,
	    // then at least one validator was ok with the value.
	    if (messages.length !== validators.length) {
	      return;
	    }
	
	    // check primitive type
	    if (
	      messages.every(function(message) {
	        return message.length === 1 && typeof message[0] === 'string';
	      })
	    ) {
	      return orList(
	        messages.map(function(m) {
	          return m[0];
	        })
	      );
	    }
	
	    // Complex oneOfTypes like
	    // `v.oneOftypes(v.shape({name: v.string})`, `v.shape({name: v.number}))`
	    // are complex ¯\_(ツ)_/¯. For the current scope only returning the longest message.
	    return messages.reduce(function(max, arr) {
	      return arr.length > max.length ? arr : max;
	    });
	  };
	};
	
	/**
	 * Meta Validators
	 * which take options as argument (not validators)
	 * and return a new primitive validator
	 */
	v.equal = function equal(compareWith) {
	  return function equalValidator(value) {
	    if (value !== compareWith) {
	      return JSON.stringify(compareWith);
	    }
	  };
	};
	
	v.oneOf = function oneOf() {
	  var options = Array.isArray(arguments[0])
	    ? arguments[0]
	    : Array.prototype.slice.call(arguments);
	  var validators = options.map(function(value) {
	    return v.equal(value);
	  });
	
	  return v.oneOfType.apply(this, validators);
	};
	
	v.range = function range(compareWith) {
	  var min = compareWith[0];
	  var max = compareWith[1];
	  return function rangeValidator(value) {
	    var validationResult = validate(v.number, value);
	
	    if (validationResult || value < min || value > max) {
	      return 'number between ' + min + ' & ' + max + ' (inclusive)';
	    }
	  };
	};
	
	/**
	 * Primitive validators
	 *
	 * simple validators which return a string or undefined
	 */
	v.any = function any() {
	  return;
	};
	
	v.boolean = function boolean(value) {
	  if (typeof value !== 'boolean') {
	    return 'boolean';
	  }
	};
	
	v.number = function number(value) {
	  if (typeof value !== 'number') {
	    return 'number';
	  }
	};
	
	v.plainArray = function plainArray(value) {
	  if (!Array.isArray(value)) {
	    return 'array';
	  }
	};
	
	v.plainObject = function plainObject(value) {
	  if (!isPlainObject(value)) {
	    return 'object';
	  }
	};
	
	v.string = function string(value) {
	  if (typeof value !== 'string') {
	    return 'string';
	  }
	};
	
	v.func = function func(value) {
	  if (typeof value !== 'function') {
	    return 'function';
	  }
	};
	
	function validate(validator, value) {
	  // assertions are optional by default unless wrapped in v.require
	  if (value == null && !validator.hasOwnProperty('__required')) {
	    return;
	  }
	
	  var result = validator(value);
	
	  if (result) {
	    return Array.isArray(result) ? result : [result];
	  }
	}
	
	function processMessage(message, options) {
	  // message array follows the convention
	  // [...path, result]
	  // path is an array of object keys / array indices
	  // result is output of the validator
	  var len = message.length;
	
	  var result = message[len - 1];
	  var path = message.slice(0, len - 1);
	
	  if (path.length === 0) {
	    path = [DEFAULT_ERROR_PATH];
	  }
	  options = xtend(options, { path: path });
	
	  return typeof result === 'function'
	    ? result(options) // allows customization of result
	    : formatErrorMessage(options, prettifyResult(result));
	}
	
	function orList(list) {
	  if (list.length < 2) {
	    return list[0];
	  }
	  if (list.length === 2) {
	    return list.join(' or ');
	  }
	  return list.slice(0, -1).join(', ') + ', or ' + list.slice(-1);
	}
	
	function prettifyResult(result) {
	  return 'must be ' + addArticle(result) + '.';
	}
	
	function addArticle(nounPhrase) {
	  if (/^an? /.test(nounPhrase)) {
	    return nounPhrase;
	  }
	  if (/^[aeiou]/i.test(nounPhrase)) {
	    return 'an ' + nounPhrase;
	  }
	  if (/^[a-z]/i.test(nounPhrase)) {
	    return 'a ' + nounPhrase;
	  }
	  return nounPhrase;
	}
	
	function formatErrorMessage(options, prettyResult) {
	  var arrayCulprit = isArrayCulprit(options.path);
	  var output = options.path.join('.') + ' ' + prettyResult;
	  var prepend = arrayCulprit ? 'Item at position ' : '';
	
	  return prepend + output;
	}
	
	function isArrayCulprit(path) {
	  return typeof path[path.length - 1] == 'number' || typeof path[0] == 'number';
	}
	
	function objectEntries(obj) {
	  return Object.keys(obj || {}).map(function(key) {
	    return { key: key, value: obj[key] };
	  });
	}
	
	v.validate = validate;
	v.processMessage = processMessage;
	
	module.exports = v;


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var browser = __webpack_require__(421);
	var MapiClient = __webpack_require__(168);
	
	function BrowserClient(options) {
	  MapiClient.call(this, options);
	}
	BrowserClient.prototype = Object.create(MapiClient.prototype);
	BrowserClient.prototype.constructor = BrowserClient;
	
	BrowserClient.prototype.sendRequest = browser.browserSend;
	BrowserClient.prototype.abortRequest = browser.browserAbort;
	
	/**
	 * Create a client for the browser.
	 *
	 * @param {Object} options
	 * @param {string} options.accessToken
	 * @param {string} [options.origin]
	 * @returns {MapiClient}
	 */
	function createBrowserClient(options) {
	  return new BrowserClient(options);
	}
	
	module.exports = createBrowserClient;


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var MapiResponse = __webpack_require__(424);
	var MapiError = __webpack_require__(422);
	var constants = __webpack_require__(95);
	var parseHeaders = __webpack_require__(425);
	
	// Keys are request IDs, values are XHRs.
	var requestsUnderway = {};
	
	function browserAbort(request) {
	  var xhr = requestsUnderway[request.id];
	  if (!xhr) return;
	  xhr.abort();
	  delete requestsUnderway[request.id];
	}
	
	function createResponse(request, xhr) {
	  return new MapiResponse(request, {
	    body: xhr.response,
	    headers: parseHeaders(xhr.getAllResponseHeaders()),
	    statusCode: xhr.status
	  });
	}
	
	function normalizeBrowserProgressEvent(event) {
	  var total = event.total;
	  var transferred = event.loaded;
	  var percent = (100 * transferred) / total;
	  return {
	    total: total,
	    transferred: transferred,
	    percent: percent
	  };
	}
	
	function sendRequestXhr(request, xhr) {
	  return new Promise(function(resolve, reject) {
	    xhr.onprogress = function(event) {
	      request.emitter.emit(
	        constants.EVENT_PROGRESS_DOWNLOAD,
	        normalizeBrowserProgressEvent(event)
	      );
	    };
	
	    var file = request.file;
	    if (file) {
	      xhr.upload.onprogress = function(event) {
	        request.emitter.emit(
	          constants.EVENT_PROGRESS_UPLOAD,
	          normalizeBrowserProgressEvent(event)
	        );
	      };
	    }
	
	    xhr.onerror = function(error) {
	      reject(error);
	    };
	
	    xhr.onabort = function() {
	      var mapiError = new MapiError({
	        request: request,
	        type: constants.ERROR_REQUEST_ABORTED
	      });
	      reject(mapiError);
	    };
	
	    xhr.onload = function() {
	      delete requestsUnderway[request.id];
	      if (xhr.status < 200 || xhr.status >= 400) {
	        var mapiError = new MapiError({
	          request: request,
	          body: xhr.response,
	          statusCode: xhr.status
	        });
	        reject(mapiError);
	        return;
	      }
	      resolve(xhr);
	    };
	
	    var body = request.body;
	
	    // matching service needs to send a www-form-urlencoded request
	    if (typeof body === 'string') {
	      xhr.send(body);
	    } else if (body) {
	      xhr.send(JSON.stringify(body));
	    } else if (file) {
	      xhr.send(file);
	    } else {
	      xhr.send();
	    }
	
	    requestsUnderway[request.id] = xhr;
	  }).then(function(xhr) {
	    return createResponse(request, xhr);
	  });
	}
	
	// The accessToken argument gives this function flexibility
	// for Mapbox's internal client.
	function createRequestXhr(request, accessToken) {
	  var url = request.url(accessToken);
	  var xhr = new window.XMLHttpRequest();
	  xhr.open(request.method, url);
	  if (request.headers) {
	    Object.keys(request.headers).forEach(function(key) {
	      xhr.setRequestHeader(key, request.headers[key]);
	    });
	  }
	  return xhr;
	}
	
	function browserSend(request) {
	  return Promise.resolve().then(function() {
	    var xhr = createRequestXhr(request, request.client.accessToken);
	    return sendRequestXhr(request, xhr);
	  });
	}
	
	module.exports = {
	  browserAbort: browserAbort,
	  sendRequestXhr: sendRequestXhr,
	  browserSend: browserSend,
	  createRequestXhr: createRequestXhr
	};


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var constants = __webpack_require__(95);
	
	/**
	 * A Mapbox API error.
	 *
	 * If there's an error during the API transaction,
	 * the Promise returned by `MapiRequest`'s [`send`](#send)
	 * method should reject with a `MapiError`.
	 *
	 * @class MapiError
	 * @hideconstructor
	 * @property {MapiRequest} request - The errored request.
	 * @property {string} type - The type of error. Usually this is `'HttpError'`.
	 *   If the request was aborted, so the error was
	 *   not sent from the server, the type will be
	 *   `'RequestAbortedError'`.
	 * @property {number} [statusCode] - The numeric status code of
	 *   the HTTP response.
	 * @property {Object | string} [body] - If the server sent a response body,
	 *   this property exposes that response, parsed as JSON if possible.
	 * @property {string} [message] - Whatever message could be derived from the
	 *   call site and HTTP response.
	 *
	 * @param {MapiRequest} options.request
	 * @param {number} [options.statusCode]
	 * @param {string} [options.body]
	 * @param {string} [options.message]
	 * @param {string} [options.type]
	 */
	function MapiError(options) {
	  var errorType = options.type || constants.ERROR_HTTP;
	
	  var body;
	  if (options.body) {
	    try {
	      body = JSON.parse(options.body);
	    } catch (e) {
	      body = options.body;
	    }
	  } else {
	    body = null;
	  }
	
	  var message = options.message || null;
	  if (!message) {
	    if (typeof body === 'string') {
	      message = body;
	    } else if (body && typeof body.message === 'string') {
	      message = body.message;
	    } else if (errorType === constants.ERROR_REQUEST_ABORTED) {
	      message = 'Request aborted';
	    }
	  }
	
	  this.message = message;
	  this.type = errorType;
	  this.statusCode = options.statusCode || null;
	  this.request = options.request;
	  this.body = body;
	}
	
	module.exports = MapiError;


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var parseToken = __webpack_require__(169);
	var xtend = __webpack_require__(112);
	var EventEmitter = __webpack_require__(509);
	var urlUtils = __webpack_require__(427);
	var constants = __webpack_require__(95);
	
	var requestId = 1;
	
	/**
	 * A Mapbox API request.
	 *
	 * Note that creating a `MapiRequest` does *not* send the request automatically.
	 * Use the request's `send` method to send it off and get a `Promise`.
	 *
	 * The `emitter` property is an `EventEmitter` that emits the following events:
	 *
	 * - `'response'` - Listeners will be called with a `MapiResponse`.
	 * - `'error'` - Listeners will be called with a `MapiError`.
	 * - `'downloadProgress'` - Listeners will be called with `ProgressEvents`.
	 * - `'uploadProgress'` - Listeners will be called with `ProgressEvents`.
	 *   Upload events are only available when the request includes a file.
	 *
	 * @class MapiRequest
	 * @property {EventEmitter} emitter - An event emitter. See above.
	 * @property {MapiClient} client - This request's `MapiClient`.
	 * @property {MapiResponse|null} response - If this request has been sent and received
	 *   a response, the response is available on this property.
	 * @property {MapiError|Error|null} error - If this request has been sent and
	 *   received an error in response, the error is available on this property.
	 * @property {boolean} aborted - If the request has been aborted
	 *   (via [`abort`](#abort)), this property will be `true`.
	 * @property {boolean} sent - If the request has been sent, this property will
	 *   be `true`. You cannot send the same request twice, so if you need to create
	 *   a new request that is the equivalent of an existing one, use
	 *   [`clone`](#clone).
	 * @property {string} path - The request's path, including colon-prefixed route
	 *   parameters.
	 * @property {string} origin - The request's origin.
	 * @property {string} method - The request's HTTP method.
	 * @property {Object} query - A query object, which will be transformed into
	 *   a URL query string.
	 * @property {Object} params - A route parameters object, whose values will
	 *   be interpolated the path.
	 * @property {Object} headers - The request's headers,
	 * @property {Object|string|null} body - Data to send with the request.
	 *   If the request has a body, it will also be sent with the header
	 *   `'Content-Type: application/json'`.
	 * @property {Blob|ArrayBuffer|string|ReadStream} file - A file to
	 *   send with the request. The browser client accepts Blobs and ArrayBuffers;
	 *   the Node client accepts strings (filepaths) and ReadStreams.
	 */
	
	/**
	 * @ignore
	 * @param {MapiClient} client
	 * @param {Object} options
	 * @param {string} options.method
	 * @param {string} options.path
	 * @param {Object} [options.query={}]
	 * @param {Object} [options.params={}]
	 * @param {string} [options.origin]
	 * @param {Object} [options.headers]
	 * @param {Object} [options.body=null]
	 * @param {Blob|ArrayBuffer|string|ReadStream} [options.file=null]
	 */
	function MapiRequest(client, options) {
	  if (!client) {
	    throw new Error('MapiRequest requires a client');
	  }
	  if (!options || !options.path || !options.method) {
	    throw new Error(
	      'MapiRequest requires an options object with path and method properties'
	    );
	  }
	
	  var defaultHeaders = {};
	  if (options.body) {
	    defaultHeaders['content-type'] = 'application/json';
	  }
	
	  var headersWithDefaults = xtend(defaultHeaders, options.headers);
	
	  // Disallows duplicate header names of mixed case,
	  // e.g. Content-Type and content-type.
	  var headers = Object.keys(headersWithDefaults).reduce(function(memo, name) {
	    memo[name.toLowerCase()] = headersWithDefaults[name];
	    return memo;
	  }, {});
	
	  this.id = requestId++;
	  this._options = options;
	
	  this.emitter = new EventEmitter();
	  this.client = client;
	  this.response = null;
	  this.error = null;
	  this.sent = false;
	  this.aborted = false;
	  this.path = options.path;
	  this.method = options.method;
	  this.origin = options.origin || client.origin;
	  this.query = options.query || {};
	  this.params = options.params || {};
	  this.body = options.body || null;
	  this.file = options.file || null;
	  this.headers = headers;
	}
	
	/**
	 * Get the URL of the request.
	 *
	 * @param {string} [accessToken] - By default, the access token of the request's
	 *   client is used.
	 * @return {string}
	 */
	MapiRequest.prototype.url = function url(accessToken) {
	  var url = urlUtils.prependOrigin(this.path, this.origin);
	  url = urlUtils.appendQueryObject(url, this.query);
	  var routeParams = this.params;
	  if (accessToken) {
	    url = urlUtils.appendQueryParam(url, 'access_token', accessToken);
	    var accessTokenOwnerId = parseToken(accessToken).user;
	    routeParams = xtend({ ownerId: accessTokenOwnerId }, routeParams);
	  }
	  url = urlUtils.interpolateRouteParams(url, routeParams);
	  return url;
	};
	
	/**
	 * Send the request. Returns a Promise that resolves with a `MapiResponse`.
	 * You probably want to use `response.body`.
	 *
	 * `send` only retrieves the first page of paginated results. You can get
	 * the next page by using the `MapiResponse`'s [`nextPage`](#nextpage)
	 * function, or iterate through all pages using [`eachPage`](#eachpage)
	 * instead of `send`.
	 *
	 * @returns {Promise<MapiResponse>}
	 */
	MapiRequest.prototype.send = function send() {
	  var self = this;
	
	  if (self.sent) {
	    throw new Error(
	      'This request has already been sent. Check the response and error properties. Create a new request with clone().'
	    );
	  }
	  self.sent = true;
	
	  return self.client.sendRequest(self).then(
	    function(response) {
	      self.response = response;
	      self.emitter.emit(constants.EVENT_RESPONSE, response);
	      return response;
	    },
	    function(error) {
	      self.error = error;
	      self.emitter.emit(constants.EVENT_ERROR, error);
	      throw error;
	    }
	  );
	};
	
	/**
	 * Abort the request.
	 *
	 * Any pending `Promise` returned by [`send`](#send) will be rejected with
	 * an error with `type: 'RequestAbortedError'`. If you've created a request
	 * that might be aborted, you need to catch and handle such errors.
	 *
	 * This method will also abort any requests created while fetching subsequent
	 * pages via [`eachPage`](#eachpage).
	 *
	 * If the request has not been sent or has already been aborted, nothing
	 * will happen.
	 */
	MapiRequest.prototype.abort = function abort() {
	  if (this._nextPageRequest) {
	    this._nextPageRequest.abort();
	    delete this._nextPageRequest;
	  }
	
	  if (this.response || this.error || this.aborted) return;
	
	  this.aborted = true;
	  this.client.abortRequest(this);
	};
	
	/**
	 * Invoke a callback for each page of a paginated API response.
	 *
	 * The callback should have the following signature:
	 *
	 * ```js
	 * (
	 *   error: MapiError,
	 *   response: MapiResponse,
	 *   next: () => void
	 * ) => void
	 * ```
	 *
	 * **The next page will not be fetched until you've invoked the
	 * `next` callback**, indicating that you're ready for it.
	 *
	 * @param {Function} callback
	 */
	MapiRequest.prototype.eachPage = function eachPage(callback) {
	  var self = this;
	
	  function handleResponse(response) {
	    function getNextPage() {
	      delete self._nextPageRequest;
	      var nextPageRequest = response.nextPage();
	      if (nextPageRequest) {
	        self._nextPageRequest = nextPageRequest;
	        getPage(nextPageRequest);
	      }
	    }
	    callback(null, response, getNextPage);
	  }
	
	  function handleError(error) {
	    callback(error, null, function() {});
	  }
	
	  function getPage(request) {
	    request.send().then(handleResponse, handleError);
	  }
	  getPage(this);
	};
	
	/**
	 * Clone this request.
	 *
	 * Each request can only be sent *once*. So if you'd like to send the
	 * same request again, clone it and send away.
	 *
	 * @returns {MapiRequest} - A new `MapiRequest` configured just like this one.
	 */
	MapiRequest.prototype.clone = function clone() {
	  return this._extend();
	};
	
	/**
	 * @ignore
	 */
	MapiRequest.prototype._extend = function _extend(options) {
	  var extendedOptions = xtend(this._options, options);
	  return new MapiRequest(this.client, extendedOptions);
	};
	
	module.exports = MapiRequest;


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var parseLinkHeader = __webpack_require__(426);
	
	/**
	 * A Mapbox API response.
	 *
	 * @class MapiResponse
	 * @property {Object} body - The response body, parsed as JSON.
	 * @property {string} rawBody - The raw response body.
	 * @property {number} statusCode - The response's status code.
	 * @property {Object} headers - The parsed response headers.
	 * @property {Object} links - The parsed response links.
	 * @property {MapiRequest} request - The response's originating `MapiRequest`.
	 */
	
	/**
	 * @ignore
	 * @param {MapiRequest} request
	 * @param {Object} responseData
	 * @param {Object} responseData.headers
	 * @param {string} responseData.body
	 * @param {number} responseData.statusCode
	 */
	function MapiResponse(request, responseData) {
	  this.request = request;
	  this.headers = responseData.headers;
	  this.rawBody = responseData.body;
	  this.statusCode = responseData.statusCode;
	  try {
	    this.body = JSON.parse(responseData.body || '{}');
	  } catch (parseError) {
	    this.body = responseData.body;
	  }
	  this.links = parseLinkHeader(this.headers.link);
	}
	
	/**
	 * Check if there is a next page that you can fetch.
	 *
	 * @returns {boolean}
	 */
	MapiResponse.prototype.hasNextPage = function hasNextPage() {
	  return !!this.links.next;
	};
	
	/**
	 * Create a request for the next page, if there is one.
	 * If there is no next page, returns `null`.
	 *
	 * @returns {MapiRequest | null}
	 */
	MapiResponse.prototype.nextPage = function nextPage() {
	  if (!this.hasNextPage()) return null;
	  return this.request._extend({
	    path: this.links.next.url
	  });
	};
	
	module.exports = MapiResponse;


/***/ },
/* 425 */
/***/ function(module, exports) {

	'use strict';
	
	function parseSingleHeader(raw) {
	  var boundary = raw.indexOf(':');
	  var name = raw
	    .substring(0, boundary)
	    .trim()
	    .toLowerCase();
	  var value = raw.substring(boundary + 1).trim();
	  return {
	    name: name,
	    value: value
	  };
	}
	
	/**
	 * Parse raw headers into an object with lowercase properties.
	 * Does not fully parse headings into more complete data structure,
	 * as larger libraries might do. Also does not deal with duplicate
	 * headers because Node doesn't seem to deal with those well, so
	 * we shouldn't let the browser either, for consistency.
	 *
	 * @param {string} raw
	 * @returns {Object}
	 */
	function parseHeaders(raw) {
	  var headers = {};
	  if (!raw) {
	    return headers;
	  }
	
	  raw
	    .trim()
	    .split(/[\r|\n]+/)
	    .forEach(function(rawHeader) {
	      var parsed = parseSingleHeader(rawHeader);
	      headers[parsed.name] = parsed.value;
	    });
	
	  return headers;
	}
	
	module.exports = parseHeaders;


/***/ },
/* 426 */
/***/ function(module, exports) {

	'use strict';
	
	// Like https://github.com/thlorenz/lib/parse-link-header but without any
	// additional dependencies.
	
	function parseParam(param) {
	  var parts = param.match(/\s*(.+)\s*=\s*"?([^"]+)"?/);
	  if (!parts) return null;
	
	  return {
	    key: parts[1],
	    value: parts[2]
	  };
	}
	
	function parseLink(link) {
	  var parts = link.match(/<?([^>]*)>(.*)/);
	  if (!parts) return null;
	
	  var linkUrl = parts[1];
	  var linkParams = parts[2].split(';');
	  var rel = null;
	  var parsedLinkParams = linkParams.reduce(function(result, param) {
	    var parsed = parseParam(param);
	    if (!parsed) return result;
	    if (parsed.key === 'rel') {
	      if (!rel) {
	        rel = parsed.value;
	      }
	      return result;
	    }
	    result[parsed.key] = parsed.value;
	    return result;
	  }, {});
	  if (!rel) return null;
	
	  return {
	    url: linkUrl,
	    rel: rel,
	    params: parsedLinkParams
	  };
	}
	
	/**
	 * Parse a Link header.
	 *
	 * @param {string} linkHeader
	 * @returns {{
	 *   [string]: {
	 *     url: string,
	 *     params: { [string]: string }
	 *   }
	 * }}
	 */
	function parseLinkHeader(linkHeader) {
	  if (!linkHeader) return {};
	
	  return linkHeader.split(/,\s*</).reduce(function(result, link) {
	    var parsed = parseLink(link);
	    if (!parsed) return result;
	    // rel value can be multiple whitespace-separated rels.
	    var splitRel = parsed.rel.split(/\s+/);
	    splitRel.forEach(function(rel) {
	      if (!result[rel]) {
	        result[rel] = {
	          url: parsed.url,
	          params: parsed.params
	        };
	      }
	    });
	    return result;
	  }, {});
	}
	
	module.exports = parseLinkHeader;


/***/ },
/* 427 */
/***/ function(module, exports) {

	'use strict';
	
	// Encode each item of an array individually. The comma
	// delimiters should not themselves be encoded.
	function encodeArray(arrayValue) {
	  return arrayValue.map(encodeURIComponent).join(',');
	}
	
	function encodeValue(value) {
	  if (Array.isArray(value)) {
	    return encodeArray(value);
	  }
	  return encodeURIComponent(String(value));
	}
	
	/**
	 * Append a query parameter to a URL.
	 *
	 * @param {string} url
	 * @param {string} key
	 * @param {string|number|boolean|Array<*>>} [value] - Provide an array
	 *   if the value is a list and commas between values need to be
	 *   preserved, unencoded.
	 * @returns {string} - Modified URL.
	 */
	function appendQueryParam(url, key, value) {
	  if (value === false || value === null) {
	    return url;
	  }
	  var punctuation = /\?/.test(url) ? '&' : '?';
	  var query = encodeURIComponent(key);
	  if (value !== undefined && value !== '' && value !== true) {
	    query += '=' + encodeValue(value);
	  }
	  return '' + url + punctuation + query;
	}
	
	/**
	 * Derive a query string from an object and append it
	 * to a URL.
	 *
	 * @param {string} url
	 * @param {Object} [queryObject] - Values should be primitives.
	 * @returns {string} - Modified URL.
	 */
	function appendQueryObject(url, queryObject) {
	  if (!queryObject) {
	    return url;
	  }
	
	  var result = url;
	  Object.keys(queryObject).forEach(function(key) {
	    var value = queryObject[key];
	    if (value === undefined) {
	      return;
	    }
	    if (Array.isArray(value)) {
	      value = value
	        .filter(function(v) {
	          return !!v;
	        })
	        .join(',');
	    }
	    result = appendQueryParam(result, key, value);
	  });
	  return result;
	}
	
	/**
	 * Prepend an origin to a URL. If the URL already has an
	 * origin, do nothing.
	 *
	 * @param {string} url
	 * @param {string} origin
	 * @returns {string} - Modified URL.
	 */
	function prependOrigin(url, origin) {
	  if (!origin) {
	    return url;
	  }
	
	  if (url.slice(0, 4) === 'http') {
	    return url;
	  }
	
	  var delimiter = url[0] === '/' ? '' : '/';
	  return '' + origin.replace(/\/$/, '') + delimiter + url;
	}
	
	/**
	 * Interpolate values into a route with express-style,
	 * colon-prefixed route parameters.
	 *
	 * @param {string} route
	 * @param {Object} [params] - Values should be primitives
	 *   or arrays of primitives. Provide an array if the value
	 *   is a list and commas between values need to be
	 *   preserved, unencoded.
	 * @returns {string} - Modified URL.
	 */
	function interpolateRouteParams(route, params) {
	  if (!params) {
	    return route;
	  }
	  return route.replace(/\/:([a-zA-Z0-9]+)/g, function(_, paramId) {
	    var value = params[paramId];
	    if (value === undefined) {
	      throw new Error('Unspecified route parameter ' + paramId);
	    }
	    var preppedValue = encodeValue(value);
	    return '/' + preppedValue;
	  });
	}
	
	module.exports = {
	  appendQueryObject: appendQueryObject,
	  appendQueryParam: appendQueryParam,
	  prependOrigin: prependOrigin,
	  interpolateRouteParams: interpolateRouteParams
	};


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(112);
	var v = __webpack_require__(433);
	var pick = __webpack_require__(431);
	var stringifyBooleans = __webpack_require__(432);
	var createServiceFactory = __webpack_require__(429);
	
	/**
	 * Geocoding API service.
	 *
	 * Learn more about this service and its responses in
	 * [the HTTP service documentation](https://www.mapbox.com/api-documentation/#geocoding).
	 */
	var Geocoding = {};
	
	var featureTypes = [
	  'country',
	  'region',
	  'postcode',
	  'district',
	  'place',
	  'locality',
	  'neighborhood',
	  'address',
	  'poi',
	  'poi.landmark'
	];
	
	/**
	 * Search for a place.
	 *
	 * See the [public documentation](https://www.mapbox.com/api-documentation/#search-for-places).
	 *
	 * @param {Object} config
	 * @param {string} config.query - A place name.
	 * @param {'mapbox.places'|'mapbox.places-permanent'} [config.mode="mapbox.places"] - Either `mapbox.places` for ephemeral geocoding, or `mapbox.places-permanent` for storing results and batch geocoding.
	 * @param {Array<string>} [config.countries] - Limits results to the specified countries.
	 *   Each item in the array should be an [ISO 3166 alpha 2 country code](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2).
	 * @param {Coordinates} [config.proximity] - Bias local results based on a provided location.
	 * @param {Array<'country'|'region'|'postcode'|'district'|'place'|'locality'|'neighborhood'|'address'|'poi'|'poi.landmark'>} [config.types] - Filter results by feature types.
	 * @param {boolean} [config.autocomplete=true] - Return autocomplete results or not.
	 * @param {BoundingBox} [config.bbox] - Limit results to a bounding box.
	 * @param {number} [config.limit=5] - Limit the number of results returned.
	 * @param {Array<string>} [config.language] - Specify the language to use for response text and, for forward geocoding, query result weighting.
	 *  Options are [IETF language tags](https://en.wikipedia.org/wiki/IETF_language_tag) comprised of a mandatory
	 *  [ISO 639-1 language code](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) and optionally one or more IETF subtags for country or script.
	 * @return {MapiRequest}
	 */
	Geocoding.forwardGeocode = function(config) {
	  v.assertShape({
	    query: v.required(v.string),
	    mode: v.oneOf('mapbox.places', 'mapbox.places-permanent'),
	    countries: v.arrayOf(v.string),
	    proximity: v.coordinates,
	    types: v.arrayOf(v.oneOf(featureTypes)),
	    autocomplete: v.boolean,
	    bbox: v.arrayOf(v.number),
	    limit: v.number,
	    language: v.arrayOf(v.string)
	  })(config);
	
	  config.mode = config.mode || 'mapbox.places';
	
	  var query = stringifyBooleans(
	    xtend(
	      { country: config.countries },
	      pick(config, [
	        'proximity',
	        'types',
	        'autocomplete',
	        'bbox',
	        'limit',
	        'language'
	      ])
	    )
	  );
	
	  return this.client.createRequest({
	    method: 'GET',
	    path: '/geocoding/v5/:mode/:query.json',
	    params: pick(config, ['mode', 'query']),
	    query: query
	  });
	};
	
	/**
	 * Search for places near coordinates.
	 *
	 * See the [public documentation](https://www.mapbox.com/api-documentation/#retrieve-places-near-a-location).
	 *
	 * @param {Object} config
	 * @param {Coordinates} config.query - Coordinates at which features will be searched.
	 * @param {'mapbox.places'|'mapbox.places-permanent'} [config.mode="mapbox.places"] - Either `mapbox.places` for ephemeral geocoding, or `mapbox.places-permanent` for storing results and batch geocoding.
	 * @param {Array<string>} [config.countries] - Limits results to the specified countries.
	 *   Each item in the array should be an [ISO 3166 alpha 2 country code](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2).
	 * @param {Array<'country'|'region'|'postcode'|'district'|'place'|'locality'|'neighborhood'|'address'|'poi'|'poi.landmark'>} [config.types] - Filter results by feature types.
	 * @param {BoundingBox} [config.bbox] - Limit results to a bounding box.
	 * @param {number} [config.limit=1] - Limit the number of results returned. If using this option, you must provide a single item for `types`.
	 * @param {Array<string>} [config.language] - Specify the language to use for response text and, for forward geocoding, query result weighting.
	 *  Options are [IETF language tags](https://en.wikipedia.org/wiki/IETF_language_tag) comprised of a mandatory
	 *  [ISO 639-1 language code](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) and optionally one or more IETF subtags for country or script.
	 * @param {'distance'|'score'} [config.reverseMode='distance'] - Set the factors that are used to sort nearby results.
	 * @return {MapiRequest}
	 */
	Geocoding.reverseGeocode = function(config) {
	  v.assertShape({
	    query: v.required(v.coordinates),
	    mode: v.oneOf('mapbox.places', 'mapbox.places-permanent'),
	    countries: v.arrayOf(v.string),
	    types: v.arrayOf(v.oneOf(featureTypes)),
	    bbox: v.arrayOf(v.number),
	    limit: v.number,
	    language: v.arrayOf(v.string),
	    reverseMode: v.oneOf('distance', 'score')
	  })(config);
	
	  config.mode = config.mode || 'mapbox.places';
	
	  var query = stringifyBooleans(
	    xtend(
	      { country: config.countries },
	      pick(config, [
	        'country',
	        'types',
	        'bbox',
	        'limit',
	        'language',
	        'reverseMode'
	      ])
	    )
	  );
	
	  return this.client.createRequest({
	    method: 'GET',
	    path: '/geocoding/v5/:mode/:query.json',
	    params: pick(config, ['mode', 'query']),
	    query: query
	  });
	};
	
	module.exports = createServiceFactory(Geocoding);


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var MapiClient = __webpack_require__(168);
	// This will create the environment-appropriate client.
	var createClient = __webpack_require__(420);
	
	function createServiceFactory(ServicePrototype) {
	  return function(clientOrConfig) {
	    var client;
	    if (MapiClient.prototype.isPrototypeOf(clientOrConfig)) {
	      client = clientOrConfig;
	    } else {
	      client = createClient(clientOrConfig);
	    }
	    var service = Object.create(ServicePrototype);
	    service.client = client;
	    return service;
	  };
	}
	
	module.exports = createServiceFactory;


/***/ },
/* 430 */
/***/ function(module, exports) {

	'use strict';
	
	function objectMap(obj, cb) {
	  return Object.keys(obj).reduce(function(result, key) {
	    result[key] = cb(key, obj[key]);
	    return result;
	  }, {});
	}
	
	module.exports = objectMap;


/***/ },
/* 431 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Create a new object by picking properties off an existing object.
	 * The second param can be overloaded as a callback for
	 * more fine grained picking of properties.
	 * @param {Object} source
	 * @param {Array<string>|function(string, Object):boolean} keys
	 * @returns {Object}
	 */
	function pick(source, keys) {
	  var filter = function(key, val) {
	    return keys.indexOf(key) !== -1 && val !== undefined;
	  };
	
	  if (typeof keys === 'function') {
	    filter = keys;
	  }
	
	  return Object.keys(source)
	    .filter(function(key) {
	      return filter(key, source[key]);
	    })
	    .reduce(function(result, key) {
	      result[key] = source[key];
	      return result;
	    }, {});
	}
	
	module.exports = pick;


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var objectMap = __webpack_require__(430);
	
	/**
	 * Stringify all the boolean values in an object, so true becomes "true".
	 *
	 * @param {Object} obj
	 * @returns {Object}
	 */
	function stringifyBoolean(obj) {
	  return objectMap(obj, function(_, value) {
	    return typeof value === 'boolean' ? JSON.stringify(value) : value;
	  });
	}
	
	module.exports = stringifyBoolean;


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var xtend = __webpack_require__(112);
	var v = __webpack_require__(419);
	
	function file(value) {
	  // If we're in a browser so Blob is available, the file must be that.
	  // In Node, however, it could be a filepath or a pipeable (Readable) stream.
	  if (typeof window !== 'undefined') {
	    if (value instanceof global.Blob || value instanceof global.ArrayBuffer) {
	      return;
	    }
	    return 'Blob or ArrayBuffer';
	  }
	  if (typeof value === 'string' || value.pipe !== undefined) {
	    return;
	  }
	  return 'Filename or Readable stream';
	}
	
	function assertShape(validatorObj, apiName) {
	  return v.assert(v.strictShape(validatorObj), apiName);
	}
	
	function date(value) {
	  var msg = 'date';
	  if (typeof value === 'boolean') {
	    return msg;
	  }
	  try {
	    var date = new Date(value);
	    if (date.getTime && isNaN(date.getTime())) {
	      return msg;
	    }
	  } catch (e) {
	    return msg;
	  }
	}
	
	function coordinates(value) {
	  return v.tuple(v.number, v.number)(value);
	}
	
	module.exports = xtend(v, {
	  file: file,
	  date: date,
	  coordinates: coordinates,
	  assertShape: assertShape
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 434 */
/***/ function(module, exports) {

	/**
	 * @ignore
	 * base event object for custom and dom event.
	 * @author yiminghe@gmail.com
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function returnFalse() {
	  return false;
	}
	
	function returnTrue() {
	  return true;
	}
	
	function EventBaseObject() {
	  this.timeStamp = Date.now();
	  this.target = undefined;
	  this.currentTarget = undefined;
	}
	
	EventBaseObject.prototype = {
	  isEventObject: 1,
	
	  constructor: EventBaseObject,
	
	  isDefaultPrevented: returnFalse,
	
	  isPropagationStopped: returnFalse,
	
	  isImmediatePropagationStopped: returnFalse,
	
	  preventDefault: function preventDefault() {
	    this.isDefaultPrevented = returnTrue;
	  },
	
	  stopPropagation: function stopPropagation() {
	    this.isPropagationStopped = returnTrue;
	  },
	
	  stopImmediatePropagation: function stopImmediatePropagation() {
	    this.isImmediatePropagationStopped = returnTrue;
	    // fixed 1.2
	    // call stopPropagation implicitly
	    this.stopPropagation();
	  },
	
	  halt: function halt(immediate) {
	    if (immediate) {
	      this.stopImmediatePropagation();
	    } else {
	      this.stopPropagation();
	    }
	    this.preventDefault();
	  }
	};
	
	exports["default"] = EventBaseObject;
	module.exports = exports["default"];

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ignore
	 * event object for dom
	 * @author yiminghe@gmail.com
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventBaseObject = __webpack_require__(434);
	
	var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);
	
	var _objectAssign = __webpack_require__(9);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var TRUE = true;
	var FALSE = false;
	var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];
	
	function isNullOrUndefined(w) {
	  return w === null || w === undefined;
	}
	
	var eventNormalizers = [{
	  reg: /^key/,
	  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
	  fix: function fix(event, nativeEvent) {
	    if (isNullOrUndefined(event.which)) {
	      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
	    }
	
	    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
	    if (event.metaKey === undefined) {
	      event.metaKey = event.ctrlKey;
	    }
	  }
	}, {
	  reg: /^touch/,
	  props: ['touches', 'changedTouches', 'targetTouches']
	}, {
	  reg: /^hashchange$/,
	  props: ['newURL', 'oldURL']
	}, {
	  reg: /^gesturechange$/i,
	  props: ['rotation', 'scale']
	}, {
	  reg: /^(mousewheel|DOMMouseScroll)$/,
	  props: [],
	  fix: function fix(event, nativeEvent) {
	    var deltaX = undefined;
	    var deltaY = undefined;
	    var delta = undefined;
	    var wheelDelta = nativeEvent.wheelDelta;
	    var axis = nativeEvent.axis;
	    var wheelDeltaY = nativeEvent.wheelDeltaY;
	    var wheelDeltaX = nativeEvent.wheelDeltaX;
	    var detail = nativeEvent.detail;
	
	    // ie/webkit
	    if (wheelDelta) {
	      delta = wheelDelta / 120;
	    }
	
	    // gecko
	    if (detail) {
	      // press control e.detail == 1 else e.detail == 3
	      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
	    }
	
	    // Gecko
	    if (axis !== undefined) {
	      if (axis === event.HORIZONTAL_AXIS) {
	        deltaY = 0;
	        deltaX = 0 - delta;
	      } else if (axis === event.VERTICAL_AXIS) {
	        deltaX = 0;
	        deltaY = delta;
	      }
	    }
	
	    // Webkit
	    if (wheelDeltaY !== undefined) {
	      deltaY = wheelDeltaY / 120;
	    }
	    if (wheelDeltaX !== undefined) {
	      deltaX = -1 * wheelDeltaX / 120;
	    }
	
	    // 默认 deltaY (ie)
	    if (!deltaX && !deltaY) {
	      deltaY = delta;
	    }
	
	    if (deltaX !== undefined) {
	      /**
	       * deltaX of mousewheel event
	       * @property deltaX
	       * @member Event.DomEvent.Object
	       */
	      event.deltaX = deltaX;
	    }
	
	    if (deltaY !== undefined) {
	      /**
	       * deltaY of mousewheel event
	       * @property deltaY
	       * @member Event.DomEvent.Object
	       */
	      event.deltaY = deltaY;
	    }
	
	    if (delta !== undefined) {
	      /**
	       * delta of mousewheel event
	       * @property delta
	       * @member Event.DomEvent.Object
	       */
	      event.delta = delta;
	    }
	  }
	}, {
	  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
	  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
	  fix: function fix(event, nativeEvent) {
	    var eventDoc = undefined;
	    var doc = undefined;
	    var body = undefined;
	    var target = event.target;
	    var button = nativeEvent.button;
	
	    // Calculate pageX/Y if missing and clientX/Y available
	    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
	      eventDoc = target.ownerDocument || document;
	      doc = eventDoc.documentElement;
	      body = eventDoc.body;
	      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	    }
	
	    // which for click: 1 === left; 2 === middle; 3 === right
	    // do not use button
	    if (!event.which && button !== undefined) {
	      if (button & 1) {
	        event.which = 1;
	      } else if (button & 2) {
	        event.which = 3;
	      } else if (button & 4) {
	        event.which = 2;
	      } else {
	        event.which = 0;
	      }
	    }
	
	    // add relatedTarget, if necessary
	    if (!event.relatedTarget && event.fromElement) {
	      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
	    }
	
	    return event;
	  }
	}];
	
	function retTrue() {
	  return TRUE;
	}
	
	function retFalse() {
	  return FALSE;
	}
	
	function DomEventObject(nativeEvent) {
	  var type = nativeEvent.type;
	
	  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';
	
	  _EventBaseObject2['default'].call(this);
	
	  this.nativeEvent = nativeEvent;
	
	  // in case dom event has been mark as default prevented by lower dom node
	  var isDefaultPrevented = retFalse;
	  if ('defaultPrevented' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
	  } else if ('getPreventDefault' in nativeEvent) {
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
	    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
	  } else if ('returnValue' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
	  }
	
	  this.isDefaultPrevented = isDefaultPrevented;
	
	  var fixFns = [];
	  var fixFn = undefined;
	  var l = undefined;
	  var prop = undefined;
	  var props = commonProps.concat();
	
	  eventNormalizers.forEach(function (normalizer) {
	    if (type.match(normalizer.reg)) {
	      props = props.concat(normalizer.props);
	      if (normalizer.fix) {
	        fixFns.push(normalizer.fix);
	      }
	    }
	  });
	
	  l = props.length;
	
	  // clone properties of the original event object
	  while (l) {
	    prop = props[--l];
	    this[prop] = nativeEvent[prop];
	  }
	
	  // fix target property, if necessary
	  if (!this.target && isNative) {
	    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
	  }
	
	  // check if target is a text node (safari)
	  if (this.target && this.target.nodeType === 3) {
	    this.target = this.target.parentNode;
	  }
	
	  l = fixFns.length;
	
	  while (l) {
	    fixFn = fixFns[--l];
	    fixFn(this, nativeEvent);
	  }
	
	  this.timeStamp = nativeEvent.timeStamp || Date.now();
	}
	
	var EventBaseObjectProto = _EventBaseObject2['default'].prototype;
	
	(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
	  constructor: DomEventObject,
	
	  preventDefault: function preventDefault() {
	    var e = this.nativeEvent;
	
	    // if preventDefault exists run it on the original event
	    if (e.preventDefault) {
	      e.preventDefault();
	    } else {
	      // otherwise set the returnValue property of the original event to FALSE (IE)
	      e.returnValue = FALSE;
	    }
	
	    EventBaseObjectProto.preventDefault.call(this);
	  },
	
	  stopPropagation: function stopPropagation() {
	    var e = this.nativeEvent;
	
	    // if stopPropagation exists run it on the original event
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    } else {
	      // otherwise set the cancelBubble property of the original event to TRUE (IE)
	      e.cancelBubble = TRUE;
	    }
	
	    EventBaseObjectProto.stopPropagation.call(this);
	  }
	});
	
	exports['default'] = DomEventObject;
	module.exports = exports['default'];

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = addEventListener;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventObject = __webpack_require__(435);
	
	var _EventObject2 = _interopRequireDefault(_EventObject);
	
	function addEventListener(target, eventType, callback) {
	  function wrapCallback(e) {
	    var ne = new _EventObject2['default'](e);
	    callback.call(target, ne);
	  }
	
	  if (target.addEventListener) {
	    target.addEventListener(eventType, wrapCallback, false);
	    return {
	      remove: function remove() {
	        target.removeEventListener(eventType, wrapCallback, false);
	      }
	    };
	  } else if (target.attachEvent) {
	    target.attachEvent('on' + eventType, wrapCallback);
	    return {
	      remove: function remove() {
	        target.detachEvent('on' + eventType, wrapCallback);
	      }
	    };
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(461), __esModule: true };

/***/ },
/* 455 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */
	;(function(root) {
	
		// Detect free variables `exports`.
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`.
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code, and use
		// it as `root`.
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var InvalidCharacterError = function(message) {
			this.message = message;
		};
		InvalidCharacterError.prototype = new Error;
		InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
		var error = function(message) {
			// Note: the error messages used throughout this file match those used by
			// the native `atob`/`btoa` implementation in Chromium.
			throw new InvalidCharacterError(message);
		};
	
		var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
		// http://whatwg.org/html/common-microsyntaxes.html#space-character
		var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;
	
		// `decode` is designed to be fully compatible with `atob` as described in the
		// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
		// The optimized base64-decoding algorithm used is based on @atk’s excellent
		// implementation. https://gist.github.com/atk/1020396
		var decode = function(input) {
			input = String(input)
				.replace(REGEX_SPACE_CHARACTERS, '');
			var length = input.length;
			if (length % 4 == 0) {
				input = input.replace(/==?$/, '');
				length = input.length;
			}
			if (
				length % 4 == 1 ||
				// http://whatwg.org/C#alphanumeric-ascii-characters
				/[^+a-zA-Z0-9/]/.test(input)
			) {
				error(
					'Invalid character: the string to be decoded is not correctly encoded.'
				);
			}
			var bitCounter = 0;
			var bitStorage;
			var buffer;
			var output = '';
			var position = -1;
			while (++position < length) {
				buffer = TABLE.indexOf(input.charAt(position));
				bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
				// Unless this is the first of a group of 4 characters…
				if (bitCounter++ % 4) {
					// …convert the first 8 bits to a single ASCII character.
					output += String.fromCharCode(
						0xFF & bitStorage >> (-2 * bitCounter & 6)
					);
				}
			}
			return output;
		};
	
		// `encode` is designed to be fully compatible with `btoa` as described in the
		// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
		var encode = function(input) {
			input = String(input);
			if (/[^\0-\xFF]/.test(input)) {
				// Note: no need to special-case astral symbols here, as surrogates are
				// matched, and the input is supposed to only contain ASCII anyway.
				error(
					'The string to be encoded contains characters outside of the ' +
					'Latin1 range.'
				);
			}
			var padding = input.length % 3;
			var output = '';
			var position = -1;
			var a;
			var b;
			var c;
			var d;
			var buffer;
			// Make sure any padding is handled outside of the loop.
			var length = input.length - padding;
	
			while (++position < length) {
				// Read three bytes, i.e. 24 bits.
				a = input.charCodeAt(position) << 16;
				b = input.charCodeAt(++position) << 8;
				c = input.charCodeAt(++position);
				buffer = a + b + c;
				// Turn the 24 bits into four chunks of 6 bits each, and append the
				// matching character for each of them to the output.
				output += (
					TABLE.charAt(buffer >> 18 & 0x3F) +
					TABLE.charAt(buffer >> 12 & 0x3F) +
					TABLE.charAt(buffer >> 6 & 0x3F) +
					TABLE.charAt(buffer & 0x3F)
				);
			}
	
			if (padding == 2) {
				a = input.charCodeAt(position) << 8;
				b = input.charCodeAt(++position);
				buffer = a + b;
				output += (
					TABLE.charAt(buffer >> 10) +
					TABLE.charAt((buffer >> 4) & 0x3F) +
					TABLE.charAt((buffer << 2) & 0x3F) +
					'='
				);
			} else if (padding == 1) {
				buffer = input.charCodeAt(position);
				output += (
					TABLE.charAt(buffer >> 2) +
					TABLE.charAt((buffer << 4) & 0x3F) +
					'=='
				);
			}
	
			return output;
		};
	
		var base64 = {
			'encode': encode,
			'decode': decode,
			'version': '0.1.0'
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return base64;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = base64;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (var key in base64) {
					base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.base64 = base64;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(94)(module), (function() { return this; }())))

/***/ },
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	try {
	  var index = __webpack_require__(176);
	} catch (err) {
	  var index = __webpack_require__(176);
	}
	
	/**
	 * Whitespace regexp.
	 */
	
	var re = /\s+/;
	
	/**
	 * toString reference.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Wrap `el` in a `ClassList`.
	 *
	 * @param {Element} el
	 * @return {ClassList}
	 * @api public
	 */
	
	module.exports = function(el){
	  return new ClassList(el);
	};
	
	/**
	 * Initialize a new ClassList for `el`.
	 *
	 * @param {Element} el
	 * @api private
	 */
	
	function ClassList(el) {
	  if (!el || !el.nodeType) {
	    throw new Error('A DOM element reference is required');
	  }
	  this.el = el;
	  this.list = el.classList;
	}
	
	/**
	 * Add class `name` if not already present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.add = function(name){
	  // classList
	  if (this.list) {
	    this.list.add(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (!~i) arr.push(name);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove class `name` when present, or
	 * pass a regular expression to remove
	 * any which match.
	 *
	 * @param {String|RegExp} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.remove = function(name){
	  if ('[object RegExp]' == toString.call(name)) {
	    return this.removeMatching(name);
	  }
	
	  // classList
	  if (this.list) {
	    this.list.remove(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (~i) arr.splice(i, 1);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove all classes matching `re`.
	 *
	 * @param {RegExp} re
	 * @return {ClassList}
	 * @api private
	 */
	
	ClassList.prototype.removeMatching = function(re){
	  var arr = this.array();
	  for (var i = 0; i < arr.length; i++) {
	    if (re.test(arr[i])) {
	      this.remove(arr[i]);
	    }
	  }
	  return this;
	};
	
	/**
	 * Toggle class `name`, can force state via `force`.
	 *
	 * For browsers that support classList, but do not support `force` yet,
	 * the mistake will be detected and corrected.
	 *
	 * @param {String} name
	 * @param {Boolean} force
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.toggle = function(name, force){
	  // classList
	  if (this.list) {
	    if ("undefined" !== typeof force) {
	      if (force !== this.list.toggle(name, force)) {
	        this.list.toggle(name); // toggle again to correct
	      }
	    } else {
	      this.list.toggle(name);
	    }
	    return this;
	  }
	
	  // fallback
	  if ("undefined" !== typeof force) {
	    if (!force) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  } else {
	    if (this.has(name)) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return an array of classes.
	 *
	 * @return {Array}
	 * @api public
	 */
	
	ClassList.prototype.array = function(){
	  var className = this.el.getAttribute('class') || '';
	  var str = className.replace(/^\s+|\s+$/g, '');
	  var arr = str.split(re);
	  if ('' === arr[0]) arr.shift();
	  return arr;
	};
	
	/**
	 * Check if class `name` is present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.has =
	ClassList.prototype.contains = function(name){
	  return this.list
	    ? this.list.contains(name)
	    : !! ~index(this.array(), name);
	};


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(487);
	module.exports = __webpack_require__(177).Object.assign;

/***/ },
/* 462 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(120);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(181)
	  , toLength  = __webpack_require__(483)
	  , toIndex   = __webpack_require__(482);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 465 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(462);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(120)
	  , document = __webpack_require__(119).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 468 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(119)
	  , core      = __webpack_require__(177)
	  , ctx       = __webpack_require__(466)
	  , hide      = __webpack_require__(471)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 470 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(474)
	  , createDesc = __webpack_require__(479);
	module.exports = __webpack_require__(117) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(117) && !__webpack_require__(118)(function(){
	  return Object.defineProperty(__webpack_require__(467)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(477)
	  , gOPS     = __webpack_require__(475)
	  , pIE      = __webpack_require__(478)
	  , toObject = __webpack_require__(484)
	  , IObject  = __webpack_require__(179)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(118)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(463)
	  , IE8_DOM_DEFINE = __webpack_require__(472)
	  , toPrimitive    = __webpack_require__(485)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(117) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 475 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(470)
	  , toIObject    = __webpack_require__(181)
	  , arrayIndexOf = __webpack_require__(464)(false)
	  , IE_PROTO     = __webpack_require__(480)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(476)
	  , enumBugKeys = __webpack_require__(468);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 478 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 479 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(481)('keys')
	  , uid    = __webpack_require__(486);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(119)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(180)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(180)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(178);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(120);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 486 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(469);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(473)});

/***/ },
/* 488 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
	      var baseEvents = EVENT_NAME_MAP[baseEventName];
	      for (var styleName in baseEvents) {
	        if (styleName in style) {
	          endEvents.push(baseEvents[styleName]);
	          break;
	        }
	      }
	    }
	  }
	}
	
	if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	  detectEvents();
	}
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var TransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	
	  endEvents: endEvents,
	
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports["default"] = TransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _Event = __webpack_require__(488);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	var _componentClasses = __webpack_require__(460);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var isCssAnimationSupported = _Event2["default"].endEvents.length !== 0;
	
	
	var capitalPrefixes = ['Webkit', 'Moz', 'O',
	// ms is special .... !
	'ms'];
	var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
	
	function getStyleProperty(node, name) {
	  var style = window.getComputedStyle(node);
	
	  var ret = '';
	  for (var i = 0; i < prefixes.length; i++) {
	    ret = style.getPropertyValue(prefixes[i] + name);
	    if (ret) {
	      break;
	    }
	  }
	  return ret;
	}
	
	function fixBrowserByTimeout(node) {
	  if (isCssAnimationSupported) {
	    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
	    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
	    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
	    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
	    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
	    // sometimes, browser bug
	    node.rcEndAnimTimeout = setTimeout(function () {
	      node.rcEndAnimTimeout = null;
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }, time * 1000 + 200);
	  }
	}
	
	function clearBrowserBugTimeout(node) {
	  if (node.rcEndAnimTimeout) {
	    clearTimeout(node.rcEndAnimTimeout);
	    node.rcEndAnimTimeout = null;
	  }
	}
	
	var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
	  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : _typeof(transitionName)) === 'object';
	  var className = nameIsObj ? transitionName.name : transitionName;
	  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
	  var end = endCallback;
	  var start = void 0;
	  var active = void 0;
	  var nodeClasses = (0, _componentClasses2["default"])(node);
	
	  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
	    end = endCallback.end;
	    start = endCallback.start;
	    active = endCallback.active;
	  }
	
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    nodeClasses.remove(className);
	    nodeClasses.remove(activeClassName);
	
	    _Event2["default"].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional end is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (end) {
	      end();
	    }
	  };
	
	  _Event2["default"].addEndEventListener(node, node.rcEndListener);
	
	  if (start) {
	    start();
	  }
	  nodeClasses.add(className);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    node.rcAnimTimeout = null;
	    nodeClasses.add(activeClassName);
	    if (active) {
	      setTimeout(active, 0);
	    }
	    fixBrowserByTimeout(node);
	    // 30ms for firefox
	  }, 30);
	
	  return {
	    stop: function stop() {
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }
	  };
	};
	
	cssAnimation.style = function (node, style, callback) {
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    _Event2["default"].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional callback is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (callback) {
	      callback();
	    }
	  };
	
	  _Event2["default"].addEndEventListener(node, node.rcEndListener);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    for (var s in style) {
	      if (style.hasOwnProperty(s)) {
	        node.style[s] = style[s];
	      }
	    }
	    node.rcAnimTimeout = null;
	    fixBrowserByTimeout(node);
	  }, 0);
	};
	
	cssAnimation.setTransition = function (node, p, value) {
	  var property = p;
	  var v = value;
	  if (value === undefined) {
	    v = property;
	    property = '';
	  }
	  property = property || '';
	  capitalPrefixes.forEach(function (prefix) {
	    node.style[prefix + 'Transition' + property] = v;
	  });
	};
	
	cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
	
	exports["default"] = cssAnimation;
	module.exports = exports['default'];

/***/ },
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(68);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
	  var pos = _utils2["default"].clone(elFuturePos);
	  var size = {
	    width: elRegion.width,
	    height: elRegion.height
	  };
	
	  if (overflow.adjustX && pos.left < visibleRect.left) {
	    pos.left = visibleRect.left;
	  }
	
	  // Left edge inside and right edge outside viewport, try to resize it.
	  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
	    size.width -= pos.left + size.width - visibleRect.right;
	  }
	
	  // Right edge outside viewport, try to move it.
	  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
	    // 保证左边界和可视区域左边界对齐
	    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
	  }
	
	  // Top edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top < visibleRect.top) {
	    pos.top = visibleRect.top;
	  }
	
	  // Top edge inside and bottom edge outside viewport, try to resize it.
	  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
	    size.height -= pos.top + size.height - visibleRect.bottom;
	  }
	
	  // Bottom edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
	    // 保证上边界和可视区域上边界对齐
	    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
	  }
	
	  return _utils2["default"].mix(pos, size);
	}
	
	exports["default"] = adjustForViewport;
	module.exports = exports['default'];

/***/ },
/* 501 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * 获取 node 上的 align 对齐点 相对于页面的坐标
	 */
	
	function getAlignOffset(region, align) {
	  var V = align.charAt(0);
	  var H = align.charAt(1);
	  var w = region.width;
	  var h = region.height;
	  var x = void 0;
	  var y = void 0;
	
	  x = region.left;
	  y = region.top;
	
	  if (V === 'c') {
	    y += h / 2;
	  } else if (V === 'b') {
	    y += h;
	  }
	
	  if (H === 'c') {
	    x += w / 2;
	  } else if (H === 'r') {
	    x += w;
	  }
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	exports["default"] = getAlignOffset;
	module.exports = exports['default'];

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getAlignOffset = __webpack_require__(501);
	
	var _getAlignOffset2 = _interopRequireDefault(_getAlignOffset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
	  var xy = void 0;
	  var diff = void 0;
	  var p1 = void 0;
	  var p2 = void 0;
	
	  xy = {
	    left: elRegion.left,
	    top: elRegion.top
	  };
	
	  p1 = (0, _getAlignOffset2["default"])(refNodeRegion, points[1]);
	  p2 = (0, _getAlignOffset2["default"])(elRegion, points[0]);
	
	  diff = [p2.left - p1.left, p2.top - p1.top];
	
	  return {
	    left: xy.left - diff[0] + offset[0] - targetOffset[0],
	    top: xy.top - diff[1] + offset[1] - targetOffset[1]
	  };
	}
	
	exports["default"] = getElFuturePos;
	module.exports = exports['default'];

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(68);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getRegion(node) {
	  var offset = void 0;
	  var w = void 0;
	  var h = void 0;
	  if (!_utils2["default"].isWindow(node) && node.nodeType !== 9) {
	    offset = _utils2["default"].offset(node);
	    w = _utils2["default"].outerWidth(node);
	    h = _utils2["default"].outerHeight(node);
	  } else {
	    var win = _utils2["default"].getWindow(node);
	    offset = {
	      left: _utils2["default"].getWindowScrollLeft(win),
	      top: _utils2["default"].getWindowScrollTop(win)
	    };
	    w = _utils2["default"].viewportWidth(win);
	    h = _utils2["default"].viewportHeight(win);
	  }
	  offset.width = w;
	  offset.height = h;
	  return offset;
	}
	
	exports["default"] = getRegion;
	module.exports = exports['default'];

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(68);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _getOffsetParent = __webpack_require__(185);
	
	var _getOffsetParent2 = _interopRequireDefault(_getOffsetParent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * 获得元素的显示部分的区域
	 */
	function getVisibleRectForElement(element) {
	  var visibleRect = {
	    left: 0,
	    right: Infinity,
	    top: 0,
	    bottom: Infinity
	  };
	  var el = (0, _getOffsetParent2["default"])(element);
	  var scrollX = void 0;
	  var scrollY = void 0;
	  var winSize = void 0;
	  var doc = element.ownerDocument;
	  var win = doc.defaultView || doc.parentWindow;
	  var body = doc.body;
	  var documentElement = doc.documentElement;
	
	  // Determine the size of the visible rect by climbing the dom accounting for
	  // all scrollable containers.
	  while (el) {
	    // clientWidth is zero for inline block elements in ie.
	    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
	    // body may have overflow set on it, yet we still get the entire
	    // viewport. In some browsers, el.offsetParent may be
	    // document.documentElement, so check for that too.
	    el !== body && el !== documentElement && _utils2["default"].css(el, 'overflow') !== 'visible') {
	      var pos = _utils2["default"].offset(el);
	      // add border
	      pos.left += el.clientLeft;
	      pos.top += el.clientTop;
	      visibleRect.top = Math.max(visibleRect.top, pos.top);
	      visibleRect.right = Math.min(visibleRect.right,
	      // consider area without scrollBar
	      pos.left + el.clientWidth);
	      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
	      visibleRect.left = Math.max(visibleRect.left, pos.left);
	    } else if (el === body || el === documentElement) {
	      break;
	    }
	    el = (0, _getOffsetParent2["default"])(el);
	  }
	
	  // Clip by window's viewport.
	  scrollX = _utils2["default"].getWindowScrollLeft(win);
	  scrollY = _utils2["default"].getWindowScrollTop(win);
	  visibleRect.left = Math.max(visibleRect.left, scrollX);
	  visibleRect.top = Math.max(visibleRect.top, scrollY);
	  winSize = {
	    width: _utils2["default"].viewportWidth(win),
	    height: _utils2["default"].viewportHeight(win)
	  };
	  visibleRect.right = Math.min(visibleRect.right, scrollX + winSize.width);
	  visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + winSize.height);
	  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
	}
	
	exports["default"] = getVisibleRectForElement;
	module.exports = exports['default'];

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(68);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _getOffsetParent = __webpack_require__(185);
	
	var _getOffsetParent2 = _interopRequireDefault(_getOffsetParent);
	
	var _getVisibleRectForElement = __webpack_require__(504);
	
	var _getVisibleRectForElement2 = _interopRequireDefault(_getVisibleRectForElement);
	
	var _adjustForViewport = __webpack_require__(500);
	
	var _adjustForViewport2 = _interopRequireDefault(_adjustForViewport);
	
	var _getRegion = __webpack_require__(503);
	
	var _getRegion2 = _interopRequireDefault(_getRegion);
	
	var _getElFuturePos = __webpack_require__(502);
	
	var _getElFuturePos2 = _interopRequireDefault(_getElFuturePos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// http://yiminghe.iteye.com/blog/1124720
	
	/**
	 * align dom node flexibly
	 * @author yiminghe@gmail.com
	 */
	
	function isFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
	}
	
	function isFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
	}
	
	function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
	}
	
	function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
	}
	
	function flip(points, reg, map) {
	  var ret = [];
	  _utils2["default"].each(points, function (p) {
	    ret.push(p.replace(reg, function (m) {
	      return map[m];
	    }));
	  });
	  return ret;
	}
	
	function flipOffset(offset, index) {
	  offset[index] = -offset[index];
	  return offset;
	}
	
	function convertOffset(str, offsetLen) {
	  var n = void 0;
	  if (/%$/.test(str)) {
	    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
	  } else {
	    n = parseInt(str, 10);
	  }
	  return n || 0;
	}
	
	function normalizeOffset(offset, el) {
	  offset[0] = convertOffset(offset[0], el.width);
	  offset[1] = convertOffset(offset[1], el.height);
	}
	
	function domAlign(el, refNode, align) {
	  var points = align.points;
	  var offset = align.offset || [0, 0];
	  var targetOffset = align.targetOffset || [0, 0];
	  var overflow = align.overflow;
	  var target = align.target || refNode;
	  var source = align.source || el;
	  offset = [].concat(offset);
	  targetOffset = [].concat(targetOffset);
	  overflow = overflow || {};
	  var newOverflowCfg = {};
	
	  var fail = 0;
	  // 当前节点可以被放置的显示区域
	  var visibleRect = (0, _getVisibleRectForElement2["default"])(source);
	  // 当前节点所占的区域, left/top/width/height
	  var elRegion = (0, _getRegion2["default"])(source);
	  // 参照节点所占的区域, left/top/width/height
	  var refNodeRegion = (0, _getRegion2["default"])(target);
	  // 将 offset 转换成数值，支持百分比
	  normalizeOffset(offset, elRegion);
	  normalizeOffset(targetOffset, refNodeRegion);
	  // 当前节点将要被放置的位置
	  var elFuturePos = (0, _getElFuturePos2["default"])(elRegion, refNodeRegion, points, offset, targetOffset);
	  // 当前节点将要所处的区域
	  var newElRegion = _utils2["default"].merge(elRegion, elFuturePos);
	
	  // 如果可视区域不能完全放置当前节点时允许调整
	  if (visibleRect && (overflow.adjustX || overflow.adjustY)) {
	    if (overflow.adjustX) {
	      // 如果横向不能放下
	      if (isFailX(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var newPoints = flip(points, /[lr]/ig, {
	          l: 'r',
	          r: 'l'
	        });
	        // 偏移量也反下
	        var newOffset = flipOffset(offset, 0);
	        var newTargetOffset = flipOffset(targetOffset, 0);
	        var newElFuturePos = (0, _getElFuturePos2["default"])(elRegion, refNodeRegion, newPoints, newOffset, newTargetOffset);
	        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = newPoints;
	          offset = newOffset;
	          targetOffset = newTargetOffset;
	        }
	      }
	    }
	
	    if (overflow.adjustY) {
	      // 如果纵向不能放下
	      if (isFailY(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var _newPoints = flip(points, /[tb]/ig, {
	          t: 'b',
	          b: 't'
	        });
	        // 偏移量也反下
	        var _newOffset = flipOffset(offset, 1);
	        var _newTargetOffset = flipOffset(targetOffset, 1);
	        var _newElFuturePos = (0, _getElFuturePos2["default"])(elRegion, refNodeRegion, _newPoints, _newOffset, _newTargetOffset);
	        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = _newPoints;
	          offset = _newOffset;
	          targetOffset = _newTargetOffset;
	        }
	      }
	    }
	
	    // 如果失败，重新计算当前节点将要被放置的位置
	    if (fail) {
	      elFuturePos = (0, _getElFuturePos2["default"])(elRegion, refNodeRegion, points, offset, targetOffset);
	      _utils2["default"].mix(newElRegion, elFuturePos);
	    }
	
	    // 检查反下后的位置是否可以放下了
	    // 如果仍然放不下只有指定了可以调整当前方向才调整
	    newOverflowCfg.adjustX = overflow.adjustX && isFailX(elFuturePos, elRegion, visibleRect);
	
	    newOverflowCfg.adjustY = overflow.adjustY && isFailY(elFuturePos, elRegion, visibleRect);
	
	    // 确实要调整，甚至可能会调整高度宽度
	    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
	      newElRegion = (0, _adjustForViewport2["default"])(elFuturePos, elRegion, visibleRect, newOverflowCfg);
	    }
	  }
	
	  // need judge to in case set fixed with in css on height auto element
	  if (newElRegion.width !== elRegion.width) {
	    _utils2["default"].css(source, 'width', _utils2["default"].width(source) + newElRegion.width - elRegion.width);
	  }
	
	  if (newElRegion.height !== elRegion.height) {
	    _utils2["default"].css(source, 'height', _utils2["default"].height(source) + newElRegion.height - elRegion.height);
	  }
	
	  // https://github.com/kissyteam/kissy/issues/190
	  // 相对于屏幕位置没变，而 left/top 变了
	  // 例如 <div 'relative'><el absolute></div>
	  _utils2["default"].offset(source, {
	    left: newElRegion.left,
	    top: newElRegion.top
	  }, {
	    useCssRight: align.useCssRight,
	    useCssBottom: align.useCssBottom,
	    useCssTransform: align.useCssTransform
	  });
	
	  return {
	    points: points,
	    offset: offset,
	    targetOffset: targetOffset,
	    overflow: newOverflowCfg
	  };
	}
	
	domAlign.__getOffsetParent = _getOffsetParent2["default"];
	
	domAlign.__getVisibleRectForElement = _getVisibleRectForElement2["default"];
	
	exports["default"] = domAlign;
	/**
	 *  2012-04-26 yiminghe@gmail.com
	 *   - 优化智能对齐算法
	 *   - 慎用 resizeXX
	 *
	 *  2011-07-13 yiminghe@gmail.com note:
	 *   - 增加智能对齐，以及大小调整选项
	 **/
	
	module.exports = exports['default'];

/***/ },
/* 506 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransformName = getTransformName;
	exports.setTransitionProperty = setTransitionProperty;
	exports.getTransitionProperty = getTransitionProperty;
	exports.getTransformXY = getTransformXY;
	exports.setTransformXY = setTransformXY;
	var vendorPrefix = void 0;
	
	var jsCssMap = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  // IE did it wrong again ...
	  ms: '-ms-',
	  O: '-o-'
	};
	
	function getVendorPrefix() {
	  if (vendorPrefix !== undefined) {
	    return vendorPrefix;
	  }
	  vendorPrefix = '';
	  var style = document.createElement('p').style;
	  var testProp = 'Transform';
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      vendorPrefix = key;
	    }
	  }
	  return vendorPrefix;
	}
	
	function getTransitionName() {
	  return getVendorPrefix() ? getVendorPrefix() + 'TransitionProperty' : 'transitionProperty';
	}
	
	function getTransformName() {
	  return getVendorPrefix() ? getVendorPrefix() + 'Transform' : 'transform';
	}
	
	function setTransitionProperty(node, value) {
	  var name = getTransitionName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transitionProperty') {
	      node.style.transitionProperty = value;
	    }
	  }
	}
	
	function setTransform(node, value) {
	  var name = getTransformName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transform') {
	      node.style.transform = value;
	    }
	  }
	}
	
	function getTransitionProperty(node) {
	  return node.style.transitionProperty || node.style[getTransitionName()];
	}
	
	function getTransformXY(node) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
	    return { x: parseFloat(matrix[12] || matrix[4], 0), y: parseFloat(matrix[13] || matrix[5], 0) };
	  }
	  return {
	    x: 0,
	    y: 0
	  };
	}
	
	var matrix2d = /matrix\((.*)\)/;
	var matrix3d = /matrix3d\((.*)\)/;
	
	function setTransformXY(node, xy) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var arr = void 0;
	    var match2d = transform.match(matrix2d);
	    if (match2d) {
	      match2d = match2d[1];
	      arr = match2d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[4] = xy.x;
	      arr[5] = xy.y;
	      setTransform(node, 'matrix(' + arr.join(',') + ')');
	    } else {
	      var match3d = transform.match(matrix3d)[1];
	      arr = match3d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[12] = xy.x;
	      arr[13] = xy.y;
	      setTransform(node, 'matrix3d(' + arr.join(',') + ')');
	    }
	  } else {
	    setTransform(node, 'translateX(' + xy.x + 'px) translateY(' + xy.y + 'px) translateZ(0)');
	  }
	}

/***/ },
/* 507 */,
/* 508 */
/***/ function(module, exports) {

	var exports = function exports(element, fn) {
	  var window = this
	  var document = window.document
	  var isIE
	  var requestFrame
	
	  var attachEvent = document.attachEvent
	  if (typeof navigator !== 'undefined') {
	    isIE = navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/Edge/)
	  }
	
	  requestFrame = (function () {
	    var raf = window.requestAnimationFrame ||
	      window.mozRequestAnimationFrame ||
	        window.webkitRequestAnimationFrame ||
	          function fallbackRAF(func) {
	            return window.setTimeout(func, 20)
	          }
	    return function requestFrameFunction(func) {
	      return raf(func)
	    }
	  })()
	
	  var cancelFrame = (function () {
	    var cancel = window.cancelAnimationFrame ||
	      window.mozCancelAnimationFrame ||
	        window.webkitCancelAnimationFrame ||
	          window.clearTimeout
	    return function cancelFrameFunction(id) {
	      return cancel(id)
	    }
	  })()
	
	  function resizeListener(e) {
	    var win = e.target || e.srcElement
	    if (win.__resizeRAF__) {
	      cancelFrame(win.__resizeRAF__)
	    }
	    win.__resizeRAF__ = requestFrame(function () {
	      var trigger = win.__resizeTrigger__
	      if(trigger !== undefined) {
	        trigger.__resizeListeners__.forEach(function (fn) {
	          fn.call(trigger, e)
	        })
	      }
	    })
	  }
	
	  function objectLoad() {
	    this.contentDocument.defaultView.__resizeTrigger__ = this.__resizeElement__
	    this.contentDocument.defaultView.addEventListener('resize', resizeListener)
	  }
	
	  if (!element.__resizeListeners__) {
	    element.__resizeListeners__ = []
	    if (attachEvent) {
	      element.__resizeTrigger__ = element
	      element.attachEvent('onresize', resizeListener)
	    } else {
	      if (getComputedStyle(element).position === 'static') {
	        element.style.position = 'relative'
	      }
	      var obj = element.__resizeTrigger__ = document.createElement('object')
	      obj.setAttribute('style', 'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1; opacity: 0;')
	      obj.setAttribute('class', 'resize-sensor')
	      obj.__resizeElement__ = element
	      obj.onload = objectLoad
	      obj.type = 'text/html'
	      if (isIE) {
	        element.appendChild(obj)
	      }
	      obj.data = 'about:blank'
	      if (!isIE) {
	        element.appendChild(obj)
	      }
	    }
	  }
	  element.__resizeListeners__.push(fn)
	}
	
	exports.unbind = function(element, fn){
	  var attachEvent = document.attachEvent;
	  element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	  if (!element.__resizeListeners__.length) {
	    if (attachEvent) {
	      element.detachEvent('onresize', resizeListener);
	    } else {
	      element.__resizeTrigger__.contentDocument.defaultView.removeEventListener('resize', resizeListener);
	      element.__resizeTrigger__ = !element.removeChild(element.__resizeTrigger__);
	    }
	  }
	}
	
	module.exports = (typeof window === 'undefined') ? exports : exports.bind(window)


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';
	
	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */
	function Events() {}
	
	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);
	
	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}
	
	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */
	function addListener(emitter, event, fn, context, once) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('The listener must be a function');
	  }
	
	  var listener = new EE(fn, context || emitter, once)
	    , evt = prefix ? prefix + event : event;
	
	  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
	  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
	  else emitter._events[evt] = [emitter._events[evt], listener];
	
	  return emitter;
	}
	
	/**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */
	function clearEvent(emitter, evt) {
	  if (--emitter._eventsCount === 0) emitter._events = new Events();
	  else delete emitter._events[evt];
	}
	
	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;
	
	  if (this._eventsCount === 0) return names;
	
	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  var evt = prefix ? prefix + event : event
	    , handlers = this._events[evt];
	
	  if (!handlers) return [];
	  if (handlers.fn) return [handlers.fn];
	
	  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
	    ee[i] = handlers[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */
	EventEmitter.prototype.listenerCount = function listenerCount(event) {
	  var evt = prefix ? prefix + event : event
	    , listeners = this._events[evt];
	
	  if (!listeners) return 0;
	  if (listeners.fn) return 1;
	  return listeners.length;
	};
	
	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  return addListener(this, event, fn, context, false);
	};
	
	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  return addListener(this, event, fn, context, true);
	};
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return this;
	  if (!fn) {
	    clearEvent(this, evt);
	    return this;
	  }
	
	  var listeners = this._events[evt];
	
	  if (listeners.fn) {
	    if (
	      listeners.fn === fn &&
	      (!once || listeners.once) &&
	      (!context || listeners.context === context)
	    ) {
	      clearEvent(this, evt);
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	        listeners[i].fn !== fn ||
	        (once && !listeners[i].once) ||
	        (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }
	
	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else clearEvent(this, evt);
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;
	
	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) clearEvent(this, evt);
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ },
/* 510 */
186,
/* 511 */
186,
/* 512 */
186,
/* 513 */
186,
/* 514 */
186,
/* 515 */
186,
/* 516 */
186,
/* 517 */
186,
/* 518 */
186,
/* 519 */
186,
/* 520 */
186,
/* 521 */
186,
/* 522 */
186,
/* 523 */
186,
/* 524 */
186,
/* 525 */
186,
/* 526 */
186,
/* 527 */
186,
/* 528 */
186,
/* 529 */
186,
/* 530 */
186,
/* 531 */
186,
/* 532 */
186,
/* 533 */
186,
/* 534 */
186,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "config.json";

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.3.2
	 * 2016-06-16 18:25:19
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */
	
	/*global self */
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */
	
	/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
	
	var saveAs = saveAs || (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
			, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, force = type === force_saveable_type
					, object_url
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
								var popup = view.open(url, '_blank');
								if(!popup) view.location.href = url;
								url=undefined; // release reference before dispatching
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (!object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (force) {
							view.location.href = object_url;
						} else {
							var opened = view.open(object_url, "_blank");
							if (!opened) {
								// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
								view.location.href = object_url;
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
				;
				filesaver.readyState = filesaver.INIT;
	
				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}
	
				fs_error();
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				name = name || blob.name || "download";
	
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}
	
		FS_proto.abort = function(){};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;
	
		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;
	
		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window
	
	if (typeof module !== "undefined" && module.exports) {
	  module.exports.saveAs = saveAs;
	} else if (("function" !== "undefined" && __webpack_require__(417) !== null) && (__webpack_require__(886) !== null)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return saveAs;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}


/***/ },
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(21);
	
	var _config = __webpack_require__(32);
	
	var _config2 = _interopRequireDefault(_config);
	
	__webpack_require__(511);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoPath = __webpack_require__(875);
	
	var _ref2 = _jsx(_reactRouter.Link, {
	  className: 'nav-item',
	  to: '/'
	}, void 0, _jsx('img', {
	  src: logoPath,
	  alt: 'Grab Logo'
	}));
	
	var _ref3 = _jsx('span', {
	  className: 'nav-toggle'
	}, void 0, _jsx('span', {}), _jsx('span', {}), _jsx('span', {}));
	
	var _ref4 = _jsx(_reactRouter.Link, {
	  className: 'nav-item',
	  to: '/app',
	  title: 'Home',
	  'aria-label': 'Home'
	}, void 0, _jsx('span', {
	  className: 'icon',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-home'
	})));
	
	var _ref5 = _jsx(_reactRouter.Link, {
	  className: 'nav-item',
	  to: '/dashboard',
	  title: 'Dashboards',
	  'aria-label': 'Dashboards'
	}, void 0, _jsx('span', {
	  className: 'icon',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-dashboard'
	})));
	
	var _ref6 = _jsx(_reactRouter.Link, {
	  className: 'nav-item',
	  to: '/token',
	  title: 'User Token',
	  'aria-label': 'User Token'
	}, void 0, _jsx('span', {
	  className: 'icon',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-key'
	})));
	
	var _ref7 = _jsx(_reactRouter.Link, {
	  className: 'nav-item',
	  to: '/library',
	  title: 'Library',
	  'aria-label': 'Library'
	}, void 0, _jsx('span', {
	  className: 'icon',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-users'
	})));
	
	var _ref8 = _jsx(_reactRouter.Link, {
	  className: 'nav-item',
	  to: '/auto',
	  title: 'Automatic Simulation',
	  'aria-label': 'Automatic Simulation'
	}, void 0, _jsx('span', {
	  className: 'icon',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-magic'
	})));
	
	var _ref9 = _jsx(_reactRouter.Link, {
	  className: 'nav-item',
	  to: '/generate-resources',
	  title: 'Generate Resources',
	  'aria-label': 'Generate Resources'
	}, void 0, _jsx('span', {
	  className: 'icon',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-plus-square'
	})));
	
	var _ref10 = _jsx('a', {
	  className: 'nav-item',
	  target: '_blank',
	  href: 'https://wiki.grab.com/display/QUAL/Marionette',
	  rel: 'noopener noreferrer',
	  title: 'Marionette Wiki',
	  'aria-label': 'Marionette Wiki'
	}, void 0, _jsx('span', {
	  className: 'icon',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-question-circle'
	})));
	
	var _ref11 = _jsx('span', {
	  className: 'icon',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-sign-out'
	}));
	
	var NavBar = function NavBar(_ref) {
	  var logoutHandler = _ref.logoutHandler;
	  return _jsx('section', {
	    className: 'hero'
	  }, void 0, _jsx('div', {
	    className: 'hero-head'
	  }, void 0, _jsx('nav', {
	    className: 'nav'
	  }, void 0, _jsx('div', {
	    className: 'nav-left'
	  }, void 0, _ref2, _jsx('span', {
	    className: 'app-version'
	  }, void 0, 'Marionette ', _config2.default.APP_VERSION)), _ref3, _jsx('div', {
	    className: 'nav-right nav-menu'
	  }, void 0, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _jsx(_reactRouter.Link, {
	    className: 'nav-item',
	    to: '/',
	    title: 'Logout',
	    'aria-label': 'Logout',
	    onClick: logoutHandler
	  }, void 0, _ref11)))));
	};
	
	NavBar.defaultProps = {
	  logoutHandler: function logoutHandler() {},
	  jwtHandler: function jwtHandler() {}
	};
	
	exports.default = NavBar;

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	// Workaround for usage with flow: https://github.com/facebook/immutable-js/issues/863
	
	/* eslint-disable new-cap */ // Because of Immutable.List etc.
	
	var _bookings = __webpack_require__(72);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAutobind = __webpack_require__(77);
	
	var _reactAutobind2 = _interopRequireDefault(_reactAutobind);
	
	var _reactDimensions = __webpack_require__(325);
	
	var _reactDimensions2 = _interopRequireDefault(_reactDimensions);
	
	var _reactMapGl = __webpack_require__(135);
	
	var _reactMapGl2 = _interopRequireDefault(_reactMapGl);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _mapUtils = __webpack_require__(74);
	
	var _immutable = __webpack_require__(22);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	__webpack_require__(186);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Defaults to IT.03SS0M9D7XP4B
	var DEFAULT_LATITUDE = 1.28105;
	var DEFAULT_LONGITUDE = 103.84853;
	var DEFAULT_ZOOM = 13;
	var MARKER_RADIUS = 15;
	var pickUpMarkerPath = __webpack_require__(412);
	var dropOffMarkerPath = __webpack_require__(411);
	var driverMarkerPath = __webpack_require__(413);
	
	function isBookingMode(mode) {
	  return !!mode && mode === 'BOOKING';
	}
	
	function isDisplayBookingMode(mode) {
	  return !!mode && mode === 'DISPLAY_BOOKING';
	}
	
	var _ref = _jsx('image', {
	  xlinkHref: driverMarkerPath,
	  width: '45',
	  height: '42',
	  x: '-22.5',
	  y: '-21'
	});
	
	var _ref3 = _jsx('image', {
	  xlinkHref: pickUpMarkerPath,
	  width: '38',
	  height: '75',
	  x: '-19',
	  y: '-37'
	});
	
	var _ref4 = _jsx('circle', {
	  r: MARKER_RADIUS,
	  className: 'pulsing-ring'
	});
	
	var _ref6 = _jsx('image', {
	  xlinkHref: dropOffMarkerPath,
	  width: '38',
	  height: '75',
	  x: '-19',
	  y: '-37'
	});
	
	var _ref7 = _jsx('circle', {
	  r: MARKER_RADIUS,
	  className: 'pulsing-ring'
	});
	
	var _ref9 = _jsx('image', {
	  xlinkHref: dropOffMarkerPath,
	  width: '38',
	  height: '75',
	  x: '-19',
	  y: '-37'
	});
	
	var _ref10 = _jsx('circle', {
	  r: MARKER_RADIUS,
	  className: 'pulsing-ring'
	});
	
	var _ref12 = _jsx('span', {
	  className: 'icon',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-search-minus'
	}));
	
	var Map = (_temp = _class = function (_Component) {
	  _inherits(Map, _Component);
	
	  function Map(props) {
	    _classCallCheck(this, Map);
	
	    var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));
	
	    _this.state = {
	      viewport: {
	        latitude: DEFAULT_LATITUDE,
	        longitude: DEFAULT_LONGITUDE,
	        zoom: DEFAULT_ZOOM
	      }
	    };
	    (0, _reactAutobind2.default)(_this);
	    return _this;
	  }
	
	  _createClass(Map, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('mouseup', this.mapDragEnd, false);
	      document.addEventListener('dragstart', this.preventDrag, false);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((!_lodash2.default.isEqual(this.props.pickUpMarker, nextProps.pickUpMarker) || !_lodash2.default.isEqual(this.props.dropOffMarker, nextProps.dropOffMarker)) && nextProps.pickUpMarker && nextProps.dropOffMarker && isDisplayBookingMode(nextProps.mode)) {
	        // Only change the viewport if it's in DISPLAY_BOOKING mode
	        var bounds = (0, _mapUtils.extendBounds)([nextProps.pickUpMarker, nextProps.dropOffMarker]);
	        var _viewport = _reactMapGl2.default.fitBounds(this.props.containerWidth, this.props.containerHeight, bounds);
	        var _zoom = (0, _mapUtils.getBoundsZoomLevel)(this.props.containerWidth, this.props.containerHeight, bounds);
	        this.setState({
	          viewport: _extends({}, _viewport, {
	            zoom: _zoom
	          })
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('mouseup', this.mapDragEnd, false);
	      document.removeEventListener('dragstart', this.preventDrag, false);
	    }
	  }, {
	    key: 'getMapCenter',
	    value: function getMapCenter() {
	      return {
	        latitude: this.state.viewport.latitude,
	        longitude: this.state.viewport.longitude
	      };
	    }
	  }, {
	    key: 'setMapCenter',
	    value: function setMapCenter(latitude, longitude) {
	      this.setState({
	        viewport: _extends({}, this.state.viewport, {
	          latitude: latitude,
	          longitude: longitude
	        })
	      });
	    }
	  }, {
	    key: 'getDestinationIndex',
	    value: function getDestinationIndex() {
	      var extraDropOffMarkers = this.props.extraDropOffMarkers;
	
	      if (!extraDropOffMarkers || _lodash2.default.isEmpty(extraDropOffMarkers[0])) {
	        return 1;
	      }
	
	      return extraDropOffMarkers.length + 1;
	    }
	  }, {
	    key: 'mapDragEnd',
	    value: function mapDragEnd() {
	      if (this.props.mapDragEnd) {
	        this.props.mapDragEnd();
	      }
	    }
	  }, {
	    key: 'preventDrag',
	    value: function preventDrag(event) {
	      // eslint-disable-line class-methods-use-this
	      event.preventDefault();
	    }
	  }, {
	    key: 'countLoggedInDrivers',
	    value: function countLoggedInDrivers() {
	      var _this2 = this;
	
	      if (this.props.cohort) {
	        var _ret = function () {
	          var drivers = _this2.props.cohort.drivers;
	          var loggedInDrivers = Object.keys(drivers).map(function (driverID) {
	            return drivers[driverID];
	          }).filter(function (driver) {
	            return driver.loggedIn;
	          });
	          return {
	            v: loggedInDrivers.length
	          };
	        }();
	
	        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	      }
	      return 0;
	    }
	  }, {
	    key: 'zoomToFit',
	    value: function zoomToFit() {
	      var _this3 = this;
	
	      if (this.props.cohort) {
	        (function () {
	          // Assume that there are more than one loggedIn drivers present as that is the condition
	          // for the zoom-to-fit button to appear.
	          var drivers = _this3.props.cohort.drivers;
	          var driverLocations = Object.keys(drivers).map(function (driverID) {
	            return drivers[driverID];
	          }).filter(function (driver) {
	            return driver.loggedIn;
	          }).map(function (driver) {
	            return [driver.longitude, driver.latitude];
	          });
	          var bounds = (0, _mapUtils.extendBounds)(driverLocations);
	          var viewport = _reactMapGl2.default.fitBounds(_this3.props.containerWidth, _this3.props.containerHeight, bounds);
	          var zoom = (0, _mapUtils.getBoundsZoomLevel)(_this3.props.containerWidth, _this3.props.containerHeight, bounds);
	          _this3.setState({
	            viewport: _extends({}, viewport, {
	              zoom: zoom
	            })
	          });
	        })();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var viewport = _extends({}, this.state.viewport);
	
	      var _props = this.props,
	          cohort = _props.cohort,
	          onDriverDragStart = _props.onDriverDragStart,
	          onDriverDragEnd = _props.onDriverDragEnd,
	          onDriverDrag = _props.onDriverDrag;
	
	
	      var driverPoints = [];
	      if (cohort && !_lodash2.default.isEmpty(cohort.drivers)) {
	        (function () {
	          var drivers = cohort.drivers;
	          driverPoints = Object.keys(drivers).map(function (driverID) {
	            var driver = drivers[driverID];
	            return {
	              id: driverID,
	              location: [driver.longitude, driver.latitude],
	              loggedIn: driver.loggedIn,
	              bookings: driver.bookings,
	              renderPoint: function renderPoint(point) {
	                return _jsx('g', {
	                  className: 'entity-marker driver-marker',
	                  onMouseDown: function onMouseDown() {
	                    if (onDriverDragStart) {
	                      onDriverDragStart(point.get('id'));
	                    }
	                  },
	                  onMouseUp: function onMouseUp() {
	                    if (onDriverDragEnd) {
	                      onDriverDragEnd(point.get('id'), point.get('location').toArray());
	                    }
	                  }
	                }, void 0, _ref, _jsx('text', {
	                  className: 'entity-label'
	                }, void 0, 'Driver ', point.get('id')));
	              },
	              onUpdatePoint: function onUpdatePoint(_ref2) {
	                var key = _ref2.key,
	                    location = _ref2.location;
	
	                if (onDriverDrag) {
	                  onDriverDrag(key, location);
	                }
	              }
	            };
	          }).filter(function (driver) {
	            return driver.loggedIn;
	          });
	        })();
	      }
	
	      var _props2 = this.props,
	          pickUpMarker = _props2.pickUpMarker,
	          dropOffMarker = _props2.dropOffMarker,
	          onBookingMarkerDragEnd = _props2.onBookingMarkerDragEnd,
	          onBookingMarkerDrag = _props2.onBookingMarkerDrag,
	          extraDropOffMarkers = _props2.extraDropOffMarkers,
	          mode = _props2.mode;
	
	
	      var bookingMarkers = [];
	      if (pickUpMarker) {
	        bookingMarkers.push({
	          id: 'pickUp',
	          type: 'PICK_UP',
	          location: pickUpMarker,
	          renderPoint: function renderPoint(point) {
	            return _jsx('g', {
	              className: (0, _classnames2.default)('entity-marker pick-up-marker', {
	                disabled: isDisplayBookingMode(mode)
	              }),
	              onMouseUp: function onMouseUp() {
	                onBookingMarkerDragEnd(point.get('location').toArray(), _bookings.BOOKING_MARKER_PICKUP);
	              }
	            }, void 0, _ref3, _ref4);
	          },
	          onUpdatePoint: function onUpdatePoint(_ref5) {
	            var key = _ref5.key,
	                location = _ref5.location;
	
	            if (isBookingMode(mode) && onBookingMarkerDrag) {
	              onBookingMarkerDrag(key, location);
	            }
	          }
	        });
	      }
	
	      if (dropOffMarker) {
	        bookingMarkers.push({
	          id: 'dropOff',
	          type: 'DROP_OFF',
	          location: dropOffMarker,
	          renderPoint: function renderPoint(point) {
	            return _jsx('g', {
	              className: (0, _classnames2.default)('entity-marker drop-off-marker', {
	                disabled: isDisplayBookingMode(mode)
	              }),
	              onMouseUp: function onMouseUp() {
	                onBookingMarkerDragEnd(point.get('location').toArray(), _bookings.BOOKING_MARKER_DROPOFF);
	              }
	            }, void 0, _ref6, _ref7, _jsx('text', {
	              style: { fill: 'white', textAnchor: 'middle' },
	              y: '-20'
	            }, void 0, _this4.getDestinationIndex()));
	          },
	          onUpdatePoint: function onUpdatePoint(_ref8) {
	            var key = _ref8.key,
	                location = _ref8.location;
	
	            if (isBookingMode(mode) && onBookingMarkerDrag) {
	              onBookingMarkerDrag(key, location);
	            }
	          }
	        });
	      }
	
	      if (extraDropOffMarkers) {
	        var _loop = function _loop(i) {
	          var marker = extraDropOffMarkers[i];
	          var idx = i + 1;
	          if (!_lodash2.default.isEmpty(marker)) {
	            bookingMarkers.push({
	              id: 'extraDropOff_' + i,
	              type: 'EXTRA_DROP_OFF',
	              location: marker,
	              renderPoint: function renderPoint(point) {
	                return _jsx('g', {
	                  className: (0, _classnames2.default)('entity-marker extra-drop-off-marker', {
	                    disabled: isDisplayBookingMode(mode)
	                  }),
	                  onMouseUp: function onMouseUp() {
	                    onBookingMarkerDragEnd(point.get('location').toArray());
	                  }
	                }, void 0, _ref9, _ref10, _jsx('text', {
	                  style: { fill: 'white', textAnchor: 'middle' },
	                  y: '-20'
	                }, void 0, idx));
	              },
	              onUpdatePoint: function onUpdatePoint(_ref11) {
	                var key = _ref11.key,
	                    location = _ref11.location;
	
	                if (isBookingMode(mode) && onBookingMarkerDrag) {
	                  onBookingMarkerDrag(key, location);
	                }
	              }
	            });
	          }
	        };
	
	        for (var i = 0; i < extraDropOffMarkers.length; i += 1) {
	          _loop(i);
	        }
	      }
	
	      var _props3 = this.props,
	          containerWidth = _props3.containerWidth,
	          containerHeight = _props3.containerHeight,
	          accessToken = _props3.accessToken,
	          mapboxStyle = _props3.mapboxStyle;
	      // Driver points should be the last items in the array so that
	      // they are in front of other markers and will not be obscured by them.
	      // onMouseUp can then trigger correctly on the driver markers without issue.
	
	      var points = [].concat(bookingMarkers, _toConsumableArray(driverPoints));
	      return _jsx('div', {
	        className: 'map'
	      }, void 0, cohort && _lodash2.default.size(cohort.drivers) > 1 && this.countLoggedInDrivers() > 1 && _jsx('button', {
	        className: 'button is-primary zoom-to-fit-button',
	        title: 'Zoom to fit',
	        onClick: this.zoomToFit,
	        'aria-label': 'Zoom map to fit markers'
	      }, void 0, _ref12), _react2.default.createElement(
	        _reactMapGl2.default,
	        _extends({}, viewport, {
	          width: containerWidth,
	          height: containerHeight,
	          onChangeViewport: function onChangeViewport(vp) {
	            _this4.setState({
	              viewport: vp
	            });
	          },
	          mapboxApiAccessToken: accessToken,
	          mapStyle: mapboxStyle
	        }),
	        _react2.default.createElement(_reactMapGl.DraggablePointsOverlay, _extends({}, viewport, {
	          mercator: true,
	          points: Immutable.fromJS(points),
	          width: containerWidth,
	          height: containerHeight,
	          renderPoint: function renderPoint(point) {
	            return point.get('renderPoint')(point);
	          },
	          onUpdatePoint: function onUpdatePoint(_ref13) {
	            var key = _ref13.key,
	                location = _ref13.location;
	
	            var point = points.filter(function (pt) {
	              return pt.id === key;
	            })[0];
	            return point.onUpdatePoint({ key: key, location: location });
	          }
	        }))
	      ));
	    }
	  }]);
	
	  return Map;
	}(_react.Component), _class.defaultProps = {
	  cohort: null,
	  mode: 'BOOKING'
	}, _temp);
	exports.default = (0, _reactDimensions2.default)()(Map);

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	// Workaround for usage with flow: https://github.com/facebook/immutable-js/issues/863
	
	/* eslint-disable new-cap */ // Because of Immutable.List etc.
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAutobind = __webpack_require__(77);
	
	var _reactAutobind2 = _interopRequireDefault(_reactAutobind);
	
	var _reactDimensions = __webpack_require__(325);
	
	var _reactDimensions2 = _interopRequireDefault(_reactDimensions);
	
	var _reactMapGl = __webpack_require__(135);
	
	var _reactMapGl2 = _interopRequireDefault(_reactMapGl);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _mapUtils = __webpack_require__(74);
	
	var _immutable = __webpack_require__(22);
	
	var Immutable = _interopRequireWildcard(_immutable);
	
	__webpack_require__(186);
	
	var _cohortUtils = __webpack_require__(52);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Defaults to IT.03SS0M9D7XP4B
	var DEFAULT_LATITUDE = 1.28105;
	var DEFAULT_LONGITUDE = 103.84853;
	var DEFAULT_ZOOM = 11;
	var MARKER_RADIUS = 15;
	var pickUpMarkerPath = __webpack_require__(412);
	var dropOffMarkerPath = __webpack_require__(411);
	var driverMarkerPath = __webpack_require__(413);
	
	function isDisplayBookingMode(mode) {
	  return !!mode && mode === 'DISPLAY_BOOKING';
	}
	
	var _ref = _jsx('image', {
	  xlinkHref: driverMarkerPath,
	  width: '45',
	  height: '42',
	  x: '-22.5',
	  y: '-21'
	});
	
	var _ref2 = _jsx('image', {
	  xlinkHref: pickUpMarkerPath,
	  width: '38',
	  height: '75',
	  x: '-19',
	  y: '-37'
	});
	
	var _ref3 = _jsx('circle', {
	  r: MARKER_RADIUS,
	  className: 'pulsing-ring'
	});
	
	var _ref4 = _jsx('image', {
	  xlinkHref: dropOffMarkerPath,
	  width: '38',
	  height: '75',
	  x: '-19',
	  y: '-37'
	});
	
	var _ref5 = _jsx('circle', {
	  r: MARKER_RADIUS,
	  className: 'pulsing-ring'
	});
	
	var _ref6 = _jsx('span', {
	  className: 'icon',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-search-minus'
	}));
	
	var SimulationMap = (_temp = _class = function (_Component) {
	  _inherits(SimulationMap, _Component);
	
	  function SimulationMap(props) {
	    _classCallCheck(this, SimulationMap);
	
	    var _this = _possibleConstructorReturn(this, (SimulationMap.__proto__ || Object.getPrototypeOf(SimulationMap)).call(this, props));
	
	    _this.state = {
	      viewport: {
	        latitude: DEFAULT_LATITUDE,
	        longitude: DEFAULT_LONGITUDE,
	        zoom: DEFAULT_ZOOM
	      }
	    };
	    (0, _reactAutobind2.default)(_this);
	    return _this;
	  }
	
	  _createClass(SimulationMap, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('dragstart', this.preventDrag, false);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var newCenterLat = nextProps.mapCenterLatitude,
	          newCenterLng = nextProps.mapCenterLongitude;
	      var _props = this.props,
	          curCenterLat = _props.mapCenterLatitude,
	          curCenterLng = _props.mapCenterLongitude;
	
	
	      if (newCenterLat && newCenterLng && curCenterLat !== newCenterLat && curCenterLng !== newCenterLng) {
	        this.setMapCenter(newCenterLat, newCenterLng);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('dragstart', this.preventDrag, false);
	    }
	  }, {
	    key: 'getMapCenter',
	    value: function getMapCenter() {
	      return {
	        latitude: this.state.viewport.latitude,
	        longitude: this.state.viewport.longitude
	      };
	    }
	  }, {
	    key: 'setMapCenter',
	    value: function setMapCenter(latitude, longitude) {
	      this.setState({
	        viewport: _extends({}, this.state.viewport, {
	          latitude: latitude,
	          longitude: longitude
	        })
	      });
	    }
	  }, {
	    key: 'preventDrag',
	    value: function preventDrag(event) {
	      // eslint-disable-line class-methods-use-this
	      event.preventDefault();
	    }
	  }, {
	    key: 'zoomToFit',
	    value: function zoomToFit() {
	      var _this2 = this;
	
	      if (this.props.cohort) {
	        (function () {
	          // Assume that there are more than one loggedIn drivers present as that is the condition
	          // for the zoom-to-fit button to appear.
	          var drivers = _this2.props.cohort.drivers;
	          var driverLocations = Object.keys(drivers).map(function (driverID) {
	            return drivers[driverID];
	          }).filter(function (driver) {
	            return driver.loggedIn;
	          }).map(function (driver) {
	            return [driver.longitude, driver.latitude];
	          });
	          var bounds = (0, _mapUtils.extendBounds)(driverLocations);
	          var viewport = _reactMapGl2.default.fitBounds(_this2.props.containerWidth, _this2.props.containerHeight, bounds);
	          var zoom = (0, _mapUtils.getBoundsZoomLevel)(_this2.props.containerWidth, _this2.props.containerHeight, bounds);
	          _this2.setState({
	            viewport: _extends({}, viewport, {
	              zoom: zoom
	            })
	          });
	        })();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var viewport = _extends({}, this.state.viewport);
	
	      var _props2 = this.props,
	          cohort = _props2.cohort,
	          mode = _props2.mode;
	
	
	      var driverPoints = [];
	      if (cohort && !_lodash2.default.isEmpty(cohort.drivers)) {
	        (function () {
	          var drivers = cohort.drivers;
	          driverPoints = Object.keys(drivers).map(function (driverID) {
	            var driver = drivers[driverID];
	            return {
	              id: driverID,
	              location: [driver.longitude, driver.latitude],
	              loggedIn: driver.loggedIn,
	              bookings: driver.bookings,
	              renderPoint: function renderPoint(point) {
	                return _jsx('g', {
	                  className: (0, _classnames2.default)('entity-marker driver-marker')
	                }, void 0, _jsx('a', {
	                  href: (0, _cohortUtils.entityURLForCohort)() + '/drivers/' + driver.cohortDriverID,
	                  target: '_blank',
	                  rel: 'noopener noreferrer'
	                }, void 0, _ref), _jsx('text', {
	                  className: 'entity-label',
	                  textAnchor: 'middle'
	                }, void 0, 'Driver ', point.get('id')));
	              }
	            };
	          }).filter(function (driver) {
	            return driver.loggedIn;
	          });
	        })();
	      }
	
	      var bookings = [];
	      if (cohort && !_lodash2.default.isEmpty(cohort.passengers)) {
	        var passengers = cohort.passengers;
	        bookings = _lodash2.default.flatMap(passengers, function (passenger) {
	          if (passenger) {
	            return passenger.bookings;
	          }
	
	          return [];
	        });
	      }
	
	      var bookingMarkers = [];
	      _lodash2.default.each(bookings, function (booking) {
	        var _booking$itinerary = _slicedToArray(booking.itinerary, 2),
	            pickUpMarker = _booking$itinerary[0],
	            dropOffMarker = _booking$itinerary[1];
	
	        if (pickUpMarker) {
	          bookingMarkers.push({
	            id: 'pickUp',
	            type: 'PICK_UP',
	            location: [pickUpMarker.longitude, pickUpMarker.latitude],
	            renderPoint: function renderPoint() {
	              return _jsx('g', {
	                className: (0, _classnames2.default)('entity-marker pick-up-marker', {
	                  disabled: isDisplayBookingMode(mode)
	                })
	              }, void 0, _jsx('a', {
	                href: (0, _cohortUtils.entityURLForCohort)() + '/bookings/' + booking.bookingID,
	                target: '_blank',
	                rel: 'noopener noreferrer'
	              }, void 0, _ref2), _ref3, _jsx('text', {
	                className: 'entity-label'
	              }, void 0, booking.bookingID));
	            }
	          });
	        }
	
	        if (dropOffMarker) {
	          bookingMarkers.push({
	            id: 'dropOff',
	            type: 'DROP_OFF',
	            location: [dropOffMarker.longitude, dropOffMarker.latitude],
	            renderPoint: function renderPoint() {
	              return _jsx('g', {
	                className: (0, _classnames2.default)('entity-marker drop-off-marker', {
	                  disabled: isDisplayBookingMode(mode)
	                })
	              }, void 0, _ref4, _ref5);
	            }
	          });
	        }
	      });
	
	      var _props3 = this.props,
	          containerWidth = _props3.containerWidth,
	          containerHeight = _props3.containerHeight,
	          accessToken = _props3.accessToken,
	          mapboxStyle = _props3.mapboxStyle;
	      // Driver points should be the last items in the array so that
	      // they are in front of other markers and will not be obscured by them.
	      // onMouseUp can then trigger correctly on the driver markers without issue.
	
	      var points = [].concat(bookingMarkers, _toConsumableArray(driverPoints));
	      return _jsx('div', {
	        className: 'map'
	      }, void 0, _lodash2.default.size(driverPoints) > 1 && _jsx('button', {
	        className: 'button is-primary zoom-to-fit-button',
	        title: 'Zoom to fit',
	        onClick: this.zoomToFit,
	        'aria-label': 'Zoom map to fit markers'
	      }, void 0, _ref6), _react2.default.createElement(
	        _reactMapGl2.default,
	        _extends({}, viewport, {
	          height: containerHeight,
	          onChangeViewport: function onChangeViewport(vp) {
	            _this3.setState({
	              viewport: vp
	            });
	          },
	          mapboxApiAccessToken: accessToken,
	          mapStyle: mapboxStyle
	        }),
	        _react2.default.createElement(_reactMapGl.DraggablePointsOverlay, _extends({}, viewport, {
	          mercator: true,
	          points: Immutable.fromJS(points),
	          width: containerWidth,
	          height: containerHeight,
	          renderPoint: function renderPoint(point) {
	            return point.get('renderPoint')(point);
	          }
	        }))
	      ));
	    }
	  }]);
	
	  return SimulationMap;
	}(_react.Component), _class.defaultProps = {
	  cohort: null,
	  mode: 'BOOKING'
	}, _temp);
	exports.default = (0, _reactDimensions2.default)()(SimulationMap);

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	/* eslint-disable import/no-unresolved, import/no-extraneous-dependencies, import/extensions */
	
	// history is imported by react-router.
	
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactGa = __webpack_require__(78);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _ravenJs = __webpack_require__(648);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var _fastclick = __webpack_require__(187);
	
	var _fastclick2 = _interopRequireDefault(_fastclick);
	
	var _grabStorage = __webpack_require__(124);
	
	var _grabStorage2 = _interopRequireDefault(_grabStorage);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactRouterRedux = __webpack_require__(136);
	
	var _reactRouter = __webpack_require__(21);
	
	var _history = __webpack_require__(620);
	
	var _configureStore = __webpack_require__(572);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _config = __webpack_require__(32);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _routes = __webpack_require__(571);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	__webpack_require__(534);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function initApp() {
	  // GA
	  _reactGa2.default.initialize(_config2.default.GA_KEY, {
	    debug: _grabStorage2.default.reactGa === 'true',
	    titleCase: false
	  });
	
	  var reduxStateStorageKey = 'reduxState';
	  var persistedState = JSON.parse(_grabStorage2.default.getItem(reduxStateStorageKey)) || {};
	  var store = (0, _configureStore2.default)(persistedState);
	  store.subscribe(_lodash2.default.throttle(function () {
	    var storeState = store.getState();
	    // TODO: Possibly write our own utility pickNestedKeys function to
	    //       pick out the keys (including nested keys) from the store
	    //       that we want to persist.
	    _grabStorage2.default.setItem(reduxStateStorageKey, JSON.stringify({
	      library: {
	        passengers: storeState.library.passengers,
	        drivers: storeState.library.drivers,
	        merchants: storeState.library.merchants,
	        bookings: storeState.library.bookings
	      },
	      app: {
	        activeCohortID: storeState.app.activeCohortID,
	        user: storeState.app.user
	      }
	    }));
	  }, 1000));
	
	  // Mobile Click Support
	  _fastclick2.default.attach(document.body);
	
	  // Get Sentry
	  if (true) {
	    _ravenJs2.default.config(_config2.default.SENTRY_DSN, {
	      release: _config2.default.APP_VERSION
	    }).install();
	  }
	
	  // Route Settings
	  function routeChange() {
	    document.body.scrollTop = 0;
	    _reactGa2.default.pageview(window.location.pathname);
	  }
	
	  var history = (0, _reactRouterRedux.syncHistoryWithStore)((0, _reactRouter.useRouterHistory)(_history.createHistory)({
	    basename: '/'
	  }), store);
	
	  _reactDom2.default.render(_jsx(_reactRedux.Provider, {
	    store: store
	  }, void 0, _jsx(_reactRouter.Router, {
	    history: history,
	    onUpdate: routeChange
	  }, void 0, (0, _routes2.default)(store))), document.getElementById('app'));
	}
	
	window.fetch(__webpack_require__(547)).then(function (configResponse) {
	  if (configResponse.status !== 200) {
	    return;
	  }
	  configResponse.json().then(function (config) {
	    (0, _config.loadConfig)(config);
	    initApp();
	  });
	}).catch(function (err) {
	  _ravenJs2.default.captureException(err);
	});

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultAppState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _cohorts2 = __webpack_require__(30);
	
	var _passengers = __webpack_require__(71);
	
	var _drivers = __webpack_require__(58);
	
	var _app = __webpack_require__(26);
	
	var _apiMiddleware = __webpack_require__(35);
	
	var RequestResultCases = _interopRequireWildcard(_apiMiddleware);
	
	var _immutable = __webpack_require__(22);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var defaultAppState = exports.defaultAppState = {
	  activeCohortID: null,
	  showPassengersModal: false,
	  passengerBeingEdited: null,
	  showDriversModal: false,
	  driverCompletingBooking: null,
	  driverBeingEdited: null,
	  driverLocationBeingEdited: null,
	  driverBeingDragged: null,
	  newlyCreatedBookingID: null,
	  activeBooking: null,
	  user: null,
	  nearbyTaxiTypes: null,
	  pois: null,
	  errors: null,
	  simulationList: null,
	  resultantCohortIDs: null,
	  cohortStatus: null,
	  cohortYamlFile: null
	};
	
	function app() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultAppState;
	  var action = arguments[1];
	
	  var payload = action.payload;
	  var response = payload ? payload.response : null;
	  if (payload && response && response.status === 401) {
	    return _extends({}, state, {
	      user: null
	    });
	  }
	  switch (action.type) {
	    case '@@router/LOCATION_CHANGE':
	      {
	        var re = /cohorts\/(\d+)/;
	        var matches = action.payload.pathname.match(re);
	        if (matches && matches[1]) {
	          var cohortID = matches[1];
	          return _extends({}, state, {
	            activeCohortID: cohortID,
	            activeBooking: null
	          });
	        }
	        return state;
	      }
	    case _cohorts2.COHORT_CREATE + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        activeCohortID: action.payload.cohortID,
	        activeBooking: null
	      });
	    case _cohorts2.COHORT_GET + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        activeCohortID: action.meta && action.meta.cohortID,
	        activeBooking: null
	      });
	    case _cohorts2.COHORT_DELETE:
	      if (state.activeCohortID === action.payload.cohortID) {
	        return _extends({}, state, {
	          activeCohortID: null,
	          activeBooking: null
	        });
	      }
	      return state;
	    // Directly remove non-existing cohorts to handle the case of fetching cohorts
	    // that existed before a server restart.
	    // TODO: When we persist cohorts data this can be removed.
	    case _cohorts2.COHORT_GET + RequestResultCases.FAILURE:
	    case _cohorts2.COHORT_DELETE + RequestResultCases.SUCCESS:
	      if (action.meta && state.activeCohortID === action.meta.cohortID) {
	        return _extends({}, state, {
	          activeCohortID: null,
	          activeBooking: null
	        });
	      }
	      return state;
	    case _cohorts2.UNSET_COHORT:
	      return _extends({}, state, {
	        activeCohortID: null,
	        activeBooking: null
	      });
	    case _app.SHOW_PASSENGERS_MODAL:
	      return _extends({}, state, {
	        showPassengersModal: action.payload
	      });
	    case _app.SHOW_PASSENGER_EDIT_MODAL:
	      return _extends({}, state, {
	        passengerBeingEdited: action.payload
	      });
	    case _cohorts2.COHORT_PASSENGER_ASSOCIATE + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        showPassengersModal: false
	      });
	    case _app.SHOW_DRIVERS_MODAL:
	      return _extends({}, state, {
	        showDriversModal: action.payload
	      });
	    case _app.SHOW_DRIVER_EDIT_MODAL:
	      return _extends({}, state, {
	        driverBeingEdited: action.payload
	      });
	    case _app.SHOW_DRIVER_LOCATION_MODAL:
	      return _extends({}, state, {
	        driverLocationBeingEdited: action.payload
	      });
	    case _app.SHOW_DRIVER_FARE_MODAL:
	      return _extends({}, state, {
	        driverCompletingBooking: action.payload
	      });
	    case _app.CLOSE_DRIVER_FARE_MODAL:
	      return _extends({}, state, {
	        driverCompletingBooking: null
	      });
	    case _drivers.DRIVER_BOOKING_DROP_OFF + RequestResultCases.SUCCESS:
	      if (!!state.driverCompletingBooking && action.meta && action.meta.driverID === state.driverCompletingBooking.driverID && action.meta && action.meta.bookingID === state.driverCompletingBooking.bookingID) {
	        return _extends({}, state, {
	          driverCompletingBooking: null
	        });
	      }
	      return state;
	    case _app.DRIVER_DRAG:
	      return _extends({}, state, {
	        driverBeingDragged: action.payload
	      });
	    case _cohorts2.COHORT_DRIVER_ASSOCIATE + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        showDriversModal: false
	      });
	    case _passengers.PASSENGER_BOOKING_CREATE + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        newlyCreatedBookingID: action.payload.bookingID
	      });
	    case _passengers.PASSENGER_BOOKING_CREATE + RequestResultCases.FAILURE:
	    case _app.UNSET_NEWLY_CREATED_BOOKING:
	      return _extends({}, state, {
	        newlyCreatedBookingID: null
	      });
	    case _app.SET_ACTIVE_BOOKING:
	      return _extends({}, state, {
	        activeBooking: {
	          passengerID: action.payload.passengerID,
	          driverID: action.payload.driverID,
	          bookingID: action.payload.bookingID
	        }
	      });
	    case _app.UNSET_ACTIVE_BOOKING:
	      return _extends({}, state, {
	        activeBooking: null
	      });
	    case _passengers.PASSENGER_DELETE:
	    case _passengers.PASSENGER_DELETE + RequestResultCases.SUCCESS:
	      // Unset activeBooking if passenger for activeBooking is deleted.
	      if (state.activeBooking && (action.meta && action.meta.passengerID === state.activeBooking.passengerID || action.payload && action.payload.passengerID === state.activeBooking.passengerID)) {
	        return _extends({}, state, {
	          activeBooking: null
	        });
	      }
	      return state;
	    case _drivers.DRIVER_DELETE:
	    case _drivers.DRIVER_DELETE + RequestResultCases.SUCCESS:
	      // Unset activeBooking if driver for activeBooking is deleted.
	      if (state.activeBooking && (action.meta && action.meta.driverID === state.activeBooking.driverID || action.payload && action.payload.driverID === state.activeBooking.driverID)) {
	        return _extends({}, state, {
	          activeBooking: null
	        });
	      }
	      return state;
	    case _passengers.PASSENGER_BOOKING_DELETE:
	      if (state.activeBooking && action.payload.bookingID === state.activeBooking.bookingID) {
	        return _extends({}, state, {
	          activeBooking: null
	        });
	      }
	      return state;
	    case _app.LOGIN + RequestResultCases.SUCCESS:
	    case _app.VALIDATE_TOKEN + RequestResultCases.SUCCESS:
	      return action.payload.jwtToken ? _extends({}, state, {
	        user: {
	          accessToken: action.payload.jwtToken
	        }
	      }) : state;
	    case _app.CONCEDO_LOGIN + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        user: {
	          concedoToken: action.payload.tokens.concedoToken.access_token,
	          accessToken: action.payload.tokens.internalToken
	        }
	      });
	    case _app.CONCEDO_CHECK + RequestResultCases.FAILURE:
	      return action.payload.valid ? state : _extends({}, state, {
	        user: null
	      });
	    case _app.LOGOUT + RequestResultCases.SUCCESS:
	    case _app.LOGIN + RequestResultCases.FAILURE:
	    case _app.VALIDATE_TOKEN + RequestResultCases.FAILURE:
	    case _app.LOCAL_LOGOUT:
	      return _extends({}, state, {
	        user: null
	      });
	    case _passengers.PASSENGER_GET_NEARBY_TAXI_TYPES + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        nearbyTaxiTypes: action.payload.taxiTypes
	      });
	    case _passengers.PASSENGER_GET_NEARBY_TAXI_TYPES + RequestResultCases.FAILURE:
	      return _extends({}, state, {
	        nearbyTaxiTypes: null
	      });
	    case _app.REVERSE_GEO + RequestResultCases.SUCCESS:
	      {
	        var meta = action.meta;
	
	        if (meta && meta.params.query) {
	          return _extends({}, state, {
	            pois: (state.pois || (0, _immutable.Map)()).set((0, _immutable.List)(meta.params.query), payload.body.features[0].place_name)
	          });
	        }
	
	        return state;
	      }
	    case _app.FORWARD_GEO + RequestResultCases.SUCCESS:
	      {
	        var _meta = action.meta;
	
	        if (_meta && _meta.params.query) {
	          return _extends({}, state, {
	            autoComplete: payload.body.features
	          });
	        }
	
	        return state;
	      }
	    case _app.START_SIMULATION + RequestResultCases.SUCCESS:
	      {
	        return _extends({}, state, {
	          activeCohortID: payload.cohortID,
	          simulationCompleted: false,
	          totalBookings: null,
	          successfulRides: null,
	          successRate: null,
	          allocationRate: null,
	          passengerIDs: null,
	          driverIDs: null,
	          errors: null,
	          timeoutEvent: false,
	          bookings: null,
	          resourceCreationError: false
	        });
	      }
	    case _app.START_SIMULATION + RequestResultCases.FAILURE:
	      {
	        return _extends({}, state, {
	          activeCohortID: null,
	          simulationCompleted: false,
	          totalBookings: null,
	          successfulRides: null,
	          successRate: null,
	          allocationRate: null,
	          passengerIDs: null,
	          driverIDs: null,
	          errors: payload.message,
	          timeoutEvent: false,
	          bookings: null,
	          resourceCreationError: false
	        });
	      }
	    case _app.SIMULATION_GET_REPORT:
	      {
	        return _extends({}, state, {
	          totalBookings: payload.totalBookings,
	          successfulRides: payload.successfulRides,
	          successRate: payload.successRate,
	          allocationRate: payload.allocationRate,
	          passengerIDs: payload.passengerIDs,
	          driverIDs: payload.driverIDs,
	          errors: payload.errors,
	          simulationCompleted: true,
	          timeoutEvent: payload.timeoutEvent,
	          bookings: payload.bookings,
	          resourceCreationError: false
	        });
	      }
	    case _app.RESOURCE_CREATION_ERROR:
	      {
	        return _extends({}, state, {
	          resourceCreationError: true
	        });
	      }
	    case _app.SIMULATION_TAXI_TYPES + RequestResultCases.SUCCESS:
	      {
	        return _extends({}, state, {
	          taxiTypes: payload.taxiTypeIDs
	        });
	      }
	    case _app.SIMULATION_TAXI_TYPES + RequestResultCases.FAILURE:
	      {
	        return _extends({}, state, {
	          taxiTypes: []
	        });
	      }
	    case _app.GET_TOKEN_LIST + RequestResultCases.SUCCESS:
	      {
	        return _extends({}, state, {
	          tokenList: payload.tokens,
	          tokenCreationError: false,
	          updateTokenSuccess: false,
	          newToken: null
	        });
	      }
	    case _app.ADD_NEW_TOKEN + RequestResultCases.FAILURE:
	      {
	        return _extends({}, state, {
	          tokenCreationError: true,
	          updateTokenSuccess: false,
	          newToken: null
	        });
	      }
	    case _app.ACTIVATE_TOKEN + RequestResultCases.SUCCESS:
	    case _app.DEACTIVATE_TOKEN + RequestResultCases.SUCCESS:
	    case _app.DELETE_TOKEN + RequestResultCases.SUCCESS:
	      {
	        return _extends({}, state, {
	          tokenCreationError: false,
	          updateTokenSuccess: true,
	          newToken: null
	        });
	      }
	    case _app.ADD_NEW_TOKEN + RequestResultCases.SUCCESS:
	      {
	        return _extends({}, state, {
	          tokenCreationError: false,
	          updateTokenSuccess: true,
	          newToken: payload.jwtToken
	        });
	      }
	    case _app.SIMULATION_DASHBOARD + RequestResultCases.SUCCESS:
	      {
	        var displaySimulations = null;
	        if (state.simulationList == null) {
	          displaySimulations = action.payload.simulationList;
	        } else if (action.payload.simulationList != null) {
	          displaySimulations = state.simulationList.concat(action.payload.simulationList);
	        } else {
	          displaySimulations = state.simulationList;
	        }
	        return _extends({}, state, {
	          simulationList: displaySimulations,
	          lastEvaluatedKey: action.payload.lastEvaluatedKey
	        });
	      }
	    case _app.SIMULATION_DASHBOARD + RequestResultCases.FAILURE:
	      {
	        return _extends({}, state, {
	          simulationList: [],
	          lastEvaluatedKey: null
	        });
	      }
	    case _app.TOGGLE_SIMULATION_STATUS + RequestResultCases.SUCCESS:
	      {
	        return _extends({}, state, {
	          simulationList: action.payload.simulationList,
	          lastEvaluatedKey: action.payload.lastEvaluatedKey
	        });
	      }
	    case _app.TOGGLE_SIMULATION_STATUS + RequestResultCases.FAILURE:
	      {
	        return _extends({}, state, {
	          simulationList: [],
	          lastEvaluatedKey: null
	        });
	      }
	    case _app.RESET_SIMULATION_DASHBOARD:
	      {
	        return _extends({}, state, {
	          simulationList: [],
	          lastEvaluatedKey: null
	        });
	      }
	    case _app.GET_SIMULATION_REPORT + RequestResultCases.SUCCESS:
	      {
	        return _extends({}, state, {
	          simulationDetails: action.payload.simulationDetails
	        });
	      }
	    case _app.GET_SIMULATION_REPORT + RequestResultCases.FAILURE:
	      {
	        return _extends({}, state, {
	          simulationDetails: null
	        });
	      }
	    case _app.GENERATE_RESOURCES + RequestResultCases.SUCCESS:
	      {
	        return _extends({}, state, {
	          resultantCohortIDs: [payload.cohortID]
	        });
	      }
	    case _app.GENERATE_RESOURCES + RequestResultCases.FAILURE:
	    case _app.RESET_RESULTANT_COHORTS:
	      {
	        return _extends({}, state, {
	          resultantCohortIDs: null
	        });
	      }
	    case _cohorts2.GET_COHORTS + RequestResultCases.SUCCESS:
	      return action.meta && action.meta.initial ? _extends({}, state, {
	        user: _extends({}, state.user, {
	          cohorts: action.payload.cohorts,
	          lastOffset: action.payload.lastOffset
	        })
	      }) : _extends({}, state, {
	        user: _extends({}, state.user, {
	          cohorts: _lodash2.default.merge(state.user ? state.user.cohorts || {} : {}, action.payload.cohorts),
	          lastOffset: action.payload.lastOffset
	        })
	      });
	    case _cohorts2.GET_COHORTS + RequestResultCases.FAILURE:
	      return _extends({}, state, {
	        user: _extends({}, state.user, {
	          cohorts: {}
	        })
	      });
	    case _cohorts2.GET_COHORT_STATUS:
	      {
	        var _cohorts = null;
	        if (!state.cohortStatus) {
	          _cohorts = [action.payload];
	        } else {
	          _cohorts = [].concat(_toConsumableArray(state.cohortStatus), [action.payload]);
	        }
	        return _extends({}, state, {
	          cohortStatus: _cohorts
	        });
	      }
	    case _cohorts2.DOWNLOAD_COHORT_YAML + RequestResultCases.SUCCESS:
	      return _extends({}, state, {
	        cohortYamlFile: action.payload
	      });
	    default:
	      {
	        return state;
	      }
	  }
	}
	
	exports.default = app;

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultErrorsState = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = errors;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _helpers = __webpack_require__(51);
	
	var ActionTypes = _interopRequireWildcard(_helpers);
	
	var _apiMiddleware = __webpack_require__(35);
	
	var RequestResultTypes = _interopRequireWildcard(_apiMiddleware);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultErrorsState = exports.defaultErrorsState = {};
	
	function errors() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultErrorsState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload,
	      meta = action.meta;
	
	  // Reset all state
	
	  if (type === ActionTypes.RESET_ALL_STATE) {
	    return defaultErrorsState;
	  }
	
	  // Reset error state
	  if (type === ActionTypes.RESET_ERROR_STATE) {
	    var _ret = function () {
	      var newState = {};
	      _lodash2.default.each(action.payload, function (domain) {
	        newState[domain] = {};
	      });
	
	      return {
	        v: _extends({}, state, newState)
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	
	  if (meta && meta.requestStatus && meta.requestStatus === RequestResultTypes.SUCCESS) {
	    var domain = _lodash2.default.camelCase(type.replace(RequestResultTypes.SUCCESS, ''));
	    return _lodash2.default.omit(state, domain);
	  }
	
	  // Display api request errors
	  if (meta && meta.requestStatus && meta.requestStatus === RequestResultTypes.FAILURE) {
	    var _domain = _lodash2.default.camelCase(type.replace(RequestResultTypes.FAILURE, ''));
	    var _payload$response = payload.response,
	        data = _payload$response.data,
	        status = _payload$response.status,
	        statusText = _payload$response.statusText;
	
	    return _extends({}, state, _defineProperty({}, _domain, _lodash2.default.isEmpty(data) || _lodash2.default.isEmpty(data.errors) ? { errors: [{ code: status, message: statusText }] } : data));
	  }
	
	  return state;
	}

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (state, action) {
	  return {
	    app: (0, _app2.default)(state.app, action),
	    cohorts: (0, _cohorts2.default)(state.cohorts, action, state.app),
	    requests: (0, _requests2.default)(state.requests, action),
	    routing: (0, _reactRouterRedux.routerReducer)(state.routing, action),
	    library: (0, _library2.default)(state.library, action),
	    errors: (0, _errors2.default)(state.errors, action)
	  };
	};
	
	var _reactRouterRedux = __webpack_require__(136);
	
	var _requests = __webpack_require__(570);
	
	var _requests2 = _interopRequireDefault(_requests);
	
	var _app = __webpack_require__(566);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _cohorts = __webpack_require__(201);
	
	var _cohorts2 = _interopRequireDefault(_cohorts);
	
	var _library = __webpack_require__(569);
	
	var _library2 = _interopRequireDefault(_library);
	
	var _errors = __webpack_require__(567);
	
	var _errors2 = _interopRequireDefault(_errors);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultLibraryState = exports.defaultMerchantLibraryState = exports.defaultDriverLibraryState = exports.defaultPassengerLibraryState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.passengers = passengers;
	exports.drivers = drivers;
	exports.merchants = merchants;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _library = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultPassengerLibraryState = exports.defaultPassengerLibraryState = {};
	var defaultDriverLibraryState = exports.defaultDriverLibraryState = {};
	var defaultMerchantLibraryState = exports.defaultMerchantLibraryState = {};
	
	var defaultLibraryState = exports.defaultLibraryState = {
	  passengers: defaultPassengerLibraryState,
	  drivers: defaultDriverLibraryState,
	  merchants: defaultMerchantLibraryState
	};
	
	function passengers() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultPassengerLibraryState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _library.LIBRARY_PASSENGER_ADD:
	      return _extends({}, state, _defineProperty({}, action.payload.cohortPassengerID, action.payload));
	    case _library.LIBRARY_PASSENGER_DELETE:
	      return _lodash2.default.omit(state, action.payload.cohortPassengerID);
	    default:
	      return state;
	  }
	}
	
	function drivers() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultDriverLibraryState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _library.LIBRARY_DRIVER_ADD:
	      return _extends({}, state, _defineProperty({}, action.payload.cohortDriverID, action.payload));
	    case _library.LIBRARY_DRIVER_DELETE:
	      return _lodash2.default.omit(state, action.payload.cohortDriverID);
	    default:
	      return state;
	  }
	}
	
	function merchants() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultMerchantLibraryState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _library.LIBRARY_MERCHANT_ADD:
	      return _extends({}, state, _defineProperty({}, action.payload.cohortMerchantID, action.payload));
	    case _library.LIBRARY_MERCHANT_DELETE:
	      return _lodash2.default.omit(state, action.payload.cohortMerchantID);
	    default:
	      return state;
	  }
	}
	
	function library() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultLibraryState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _library.LIBRARY_PASSENGER_ADD:
	    case _library.LIBRARY_PASSENGER_DELETE:
	      return _extends({}, state, {
	        passengers: passengers(state.passengers, action)
	      });
	    case _library.LIBRARY_DRIVER_ADD:
	    case _library.LIBRARY_DRIVER_DELETE:
	      return _extends({}, state, {
	        drivers: drivers(state.drivers, action)
	      });
	    case _library.LIBRARY_MERCHANT_ADD:
	    case _library.LIBRARY_MERCHANT_DELETE:
	      return _extends({}, state, {
	        merchants: merchants(state.merchants, action)
	      });
	    default:
	      return state;
	  }
	}
	
	exports.default = library;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.requestStateSuffix = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultRequestsState = defaultRequestsState;
	exports.default = requests;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _helpers = __webpack_require__(51);
	
	var _apiMiddleware = __webpack_require__(35);
	
	var RequestResultTypes = _interopRequireWildcard(_apiMiddleware);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var requestStateSuffix = exports.requestStateSuffix = 'Request';
	
	function defaultRequestsState() {
	  return {};
	}
	
	function requests() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRequestsState();
	  var action = arguments[1];
	  var type = action.type,
	      meta = action.meta;
	
	
	  if (type === _helpers.RESET_ALL_STATE) {
	    return defaultRequestsState();
	  }
	
	  // Reset individual request state.
	  if (type === _helpers.RESET_REQUEST_STATE) {
	    var _ret = function () {
	      var newState = {};
	      _lodash2.default.each(action.payload, function (domain) {
	        newState[_lodash2.default.camelCase(domain) + requestStateSuffix] = {
	          isPending: false,
	          isSuccessful: false,
	          isFailure: false
	        };
	      });
	
	      return {
	        v: _extends({}, state, newState)
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	
	  if (!meta) {
	    return state;
	  }
	
	  var requestStatus = meta.requestStatus;
	  // requestStatus is a field specially designed and owned by api request actions.
	  var domain = '';
	  switch (requestStatus) {
	    case RequestResultTypes.REQUEST:
	      domain = _lodash2.default.camelCase(type.replace(RequestResultTypes.REQUEST, ''));
	      return _extends({}, state, _defineProperty({}, domain + requestStateSuffix, {
	        isPending: true,
	        isSuccessful: false,
	        isFailure: false
	      }));
	    case RequestResultTypes.SUCCESS:
	      domain = _lodash2.default.camelCase(type.replace(RequestResultTypes.SUCCESS, ''));
	      return _extends({}, state, _defineProperty({}, domain + requestStateSuffix, {
	        isPending: false,
	        isSuccessful: true,
	        isFailure: false
	      }));
	    case RequestResultTypes.FAILURE:
	      domain = _lodash2.default.camelCase(type.replace(RequestResultTypes.FAILURE, ''));
	      return _extends({}, state, _defineProperty({}, domain + requestStateSuffix, {
	        isPending: false,
	        isSuccessful: false,
	        isFailure: true
	      }));
	    default:
	      return state;
	  }
	}

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint-disable import/no-named-as-default */
	// We expose the non-wrapped components for testing
	// and importing the Redux-wrapped component in routes gives an error
	
	
	exports.default = routes;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(21);
	
	var _AppContainer = __webpack_require__(574);
	
	var _AppContainer2 = _interopRequireDefault(_AppContainer);
	
	var _NotFoundPage = __webpack_require__(575);
	
	var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);
	
	var _DashboardContainer = __webpack_require__(589);
	
	var _DashboardContainer2 = _interopRequireDefault(_DashboardContainer);
	
	var _LibraryPage = __webpack_require__(604);
	
	var _LibraryPage2 = _interopRequireDefault(_LibraryPage);
	
	var _PassengerAddPage = __webpack_require__(608);
	
	var _PassengerAddPage2 = _interopRequireDefault(_PassengerAddPage);
	
	var _PassengerEditPage = __webpack_require__(609);
	
	var _PassengerEditPage2 = _interopRequireDefault(_PassengerEditPage);
	
	var _DriverAddPage = __webpack_require__(605);
	
	var _DriverAddPage2 = _interopRequireDefault(_DriverAddPage);
	
	var _DriverEditPage = __webpack_require__(606);
	
	var _DriverEditPage2 = _interopRequireDefault(_DriverEditPage);
	
	var _ConcedoLoginPage = __webpack_require__(577);
	
	var _ConcedoLoginPage2 = _interopRequireDefault(_ConcedoLoginPage);
	
	var _ConcedoCallbackPage = __webpack_require__(576);
	
	var _ConcedoCallbackPage2 = _interopRequireDefault(_ConcedoCallbackPage);
	
	var _SimulationPage = __webpack_require__(578);
	
	var _SimulationPage2 = _interopRequireDefault(_SimulationPage);
	
	var _ReportContainer = __webpack_require__(129);
	
	var _ReportContainer2 = _interopRequireDefault(_ReportContainer);
	
	var _TokenContainer = __webpack_require__(614);
	
	var _TokenContainer2 = _interopRequireDefault(_TokenContainer);
	
	var _CentralDashboardPage = __webpack_require__(588);
	
	var _CentralDashboardPage2 = _interopRequireDefault(_CentralDashboardPage);
	
	var _ResourceGeneratorContainer = __webpack_require__(611);
	
	var _ResourceGeneratorContainer2 = _interopRequireDefault(_ResourceGeneratorContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _jsx(_reactRouter.IndexRoute, {
	  component: _ConcedoLoginPage2.default
	});
	
	var _ref2 = _jsx(_reactRouter.Route, {
	  path: 'login',
	  component: _ConcedoLoginPage2.default
	});
	
	var _ref3 = _jsx(_reactRouter.Route, {
	  path: 'concedoCB',
	  component: _ConcedoCallbackPage2.default
	});
	
	var _ref4 = _jsx(_reactRouter.IndexRoute, {
	  component: _DashboardContainer2.default
	});
	
	var _ref5 = _jsx(_reactRouter.Route, {
	  path: '/cohorts/:cohortID',
	  component: _DashboardContainer2.default
	});
	
	var _ref6 = _jsx(_reactRouter.Route, {
	  path: '/library'
	}, void 0, _jsx(_reactRouter.IndexRoute, {
	  component: _LibraryPage2.default
	}), _jsx(_reactRouter.Route, {
	  path: '/passengers/new',
	  component: _PassengerAddPage2.default
	}), _jsx(_reactRouter.Route, {
	  path: '/passengers/:cohortPassengerID/edit',
	  component: _PassengerEditPage2.default
	}), _jsx(_reactRouter.Route, {
	  path: '/drivers/new',
	  component: _DriverAddPage2.default
	}), _jsx(_reactRouter.Route, {
	  path: '/drivers/:cohortDriverID/edit',
	  component: _DriverEditPage2.default
	}));
	
	var _ref7 = _jsx(_reactRouter.Route, {
	  path: '/auto',
	  component: _SimulationPage2.default
	});
	
	var _ref8 = _jsx(_reactRouter.Route, {
	  path: '/report',
	  component: _ReportContainer2.default
	});
	
	var _ref9 = _jsx(_reactRouter.Route, {
	  path: '/token',
	  component: _TokenContainer2.default
	});
	
	var _ref10 = _jsx(_reactRouter.Route, {
	  path: '/dashboard',
	  component: _CentralDashboardPage2.default
	});
	
	var _ref11 = _jsx(_reactRouter.Route, {
	  path: '/generate-resources',
	  component: _ResourceGeneratorContainer2.default
	});
	
	var _ref12 = _jsx(_reactRouter.Route, {
	  path: '*',
	  component: _NotFoundPage2.default
	});
	
	function routes(store) {
	  var requireAuth = function requireAuth(nextState, replace, callback) {
	    var state = store.getState();
	    var user = state.app.user || {};
	    if (!user.concedoToken) {
	      replace('/login');
	    }
	    callback();
	  };
	
	  return _jsx(_reactRouter.Route, {
	    path: '/'
	  }, void 0, _ref, _ref2, _ref3, _jsx(_reactRouter.Route, {
	    path: 'app',
	    component: _AppContainer2.default,
	    onEnter: requireAuth
	  }, void 0, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11), _ref12);
	}

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(164);
	
	var _reduxThunk = __webpack_require__(366);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducers = __webpack_require__(568);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _apiMiddleware = __webpack_require__(35);
	
	var _apiMiddleware2 = _interopRequireDefault(_apiMiddleware);
	
	var _mapboxMiddleware = __webpack_require__(200);
	
	var _mapboxMiddleware2 = _interopRequireDefault(_mapboxMiddleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Creates a preconfigured store for this example.
	function configureStore(defaultState) {
	  var middlewares = [_reduxThunk2.default, _apiMiddleware2.default, _mapboxMiddleware2.default];
	  if (false) {
	    /* eslint-disable global-require */
	    // Only want to require it when in development mode.
	    var createLogger = require('redux-logger');
	
	    var logger = createLogger({
	      level: 'info',
	      collapsed: true,
	      duration: true
	    });
	    middlewares.push(logger);
	  }
	
	  return (0, _redux.createStore)(_reducers2.default, defaultState, _redux.applyMiddleware.apply(undefined, middlewares));
	}

/***/ },
/* 573 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = loadGoogleMaps;
	function loadGoogleMaps(apiKey, callback) {
	  // Callback has to be a string which is the function name and attached to the window scope.
	  var gmapsScript = document.createElement('script');
	  gmapsScript.async = true;
	  gmapsScript.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + ('&libraries=places,drawing&callback=' + callback);
	  var scripts = document.getElementsByTagName('script')[0];
	  scripts.parentNode.insertBefore(gmapsScript, scripts);
	}

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppContainer = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(11);
	
	var _app = __webpack_require__(26);
	
	var _NavBar = __webpack_require__(562);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppContainer = exports.AppContainer = function (_Component) {
	  _inherits(AppContainer, _Component);
	
	  function AppContainer() {
	    _classCallCheck(this, AppContainer);
	
	    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
	  }
	
	  _createClass(AppContainer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var user = nextProps.user,
	          checkToken = nextProps.checkToken,
	          location = nextProps.location;
	
	      if (user.concedoToken) {
	        var prevLocationState = this.props.location.state || {};
	        var curlocationState = location.state || {};
	
	        if (!prevLocationState.cohortRedirection && curlocationState.cohortRedirection) {
	          return;
	        }
	
	        checkToken(user.concedoToken);
	      } else {
	        this.context.router.push('/login');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _jsx('div', {
	        className: 'app-container'
	      }, void 0, _jsx(_NavBar2.default, {
	        logoutHandler: this.props.simpleLogout
	      }), _jsx('div', {
	        className: 'app-content'
	      }, void 0, this.props.children));
	    }
	  }]);
	
	  return AppContainer;
	}(_react.Component);
	
	AppContainer.contextTypes = {
	  router: _react.PropTypes.object
	};
	
	function mapStateToProps(state) {
	  return {
	    user: state.app.user || {}
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  simpleLogout: _app.simpleLogout,
	  checkToken: _app.checkConcedoToken
	})(AppContainer);

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	exports.default = NotFoundPage;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _jsx('div', {}, void 0, _jsx('h1', {}, void 0, '404 Not Found'));
	
	function NotFoundPage() {
	  return _ref;
	}

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConcedoCallbackPage = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _app = __webpack_require__(26);
	
	var _reactRedux = __webpack_require__(11);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConcedoCallbackPage = exports.ConcedoCallbackPage = function (_Component) {
	  _inherits(ConcedoCallbackPage, _Component);
	
	  function ConcedoCallbackPage() {
	    _classCallCheck(this, ConcedoCallbackPage);
	
	    return _possibleConstructorReturn(this, (ConcedoCallbackPage.__proto__ || Object.getPrototypeOf(ConcedoCallbackPage)).apply(this, arguments));
	  }
	
	  _createClass(ConcedoCallbackPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          location = _props.location,
	          userLogin = _props.userLogin;
	      var query = location.query;
	
	      if (query && query.code) {
	        userLogin(query.code);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var user = nextProps.user;
	      if (user.concedoToken) {
	        this.context.router.push('/app');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _jsx('div', {
	        style: { height: '100vh', textAlign: 'center', color: '#3e3e3e' }
	      }, void 0, _jsx('div', {
	        style: { fontSize: '50px', fontWeight: 'bold', padding: '300px 0' }
	      }, void 0, 'AUTHENTICATING...'));
	    }
	  }]);
	
	  return ConcedoCallbackPage;
	}(_react.Component);
	
	ConcedoCallbackPage.contextTypes = {
	  router: _react.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    user: state.app.user || {},
	    loginRequest: state.requests.loginWithConcedoRequest || {},
	    loginErrors: _lodash2.default.get(state.errors, 'loginWithConcedo.errors', [])
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  userLogin: _app.loginWithConcedo
	})(ConcedoCallbackPage);

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(32);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _marionetteLogo = __webpack_require__(876);
	
	var _marionetteLogo2 = _interopRequireDefault(_marionetteLogo);
	
	var _logo = __webpack_require__(874);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	__webpack_require__(513);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _jsx('div', {
	  className: 'logoContainer'
	}, void 0, _jsx('img', {
	  src: _marionetteLogo2.default,
	  alt: 'Marionette Logo'
	}));
	
	var _ref2 = _jsx('span', {
	  className: 'welcomeText'
	}, void 0, 'Welcome to Marionette');
	
	var _ref3 = _jsx('div', {
	  className: 'footer'
	}, void 0, _jsx('span', {}, void 0, 'Made with love by '), _jsx('img', {
	  src: _logo2.default,
	  alt: 'Grab Logo'
	}));
	
	var SignInComponent = function SignInComponent() {
	  return _jsx('div', {
	    className: 'mainBody'
	  }, void 0, _jsx('div', {
	    className: 'contentBody'
	  }, void 0, _ref, _ref2, _jsx('a', {
	    href: _config2.default.CONCEDO_URL,
	    className: 'loginButton'
	  }, void 0, 'Login with Concedo')), _ref3);
	};
	
	exports.default = SignInComponent;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SimulationPage = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(27);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _SimulationMap = __webpack_require__(564);
	
	var _SimulationMap2 = _interopRequireDefault(_SimulationMap);
	
	var _config = __webpack_require__(32);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _cohorts = __webpack_require__(30);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(11);
	
	var _helpers = __webpack_require__(51);
	
	var _app = __webpack_require__(26);
	
	var _DisplayForm = __webpack_require__(582);
	
	var _DisplayForm2 = _interopRequireDefault(_DisplayForm);
	
	__webpack_require__(514);
	
	var _BookingStatsPanel = __webpack_require__(579);
	
	var _BookingStatsPanel2 = _interopRequireDefault(_BookingStatsPanel);
	
	var _simulationEventsHandler = __webpack_require__(587);
	
	var _simulationEventsHandler2 = _interopRequireDefault(_simulationEventsHandler);
	
	var _ReportContainer = __webpack_require__(129);
	
	var _ReportContainer2 = _interopRequireDefault(_ReportContainer);
	
	var _SimulationDetailsPanel = __webpack_require__(580);
	
	var _SimulationDetailsPanel2 = _interopRequireDefault(_SimulationDetailsPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// IT.29TV8TPSSTDV4
	var DEFAULT_LATITUDE = 1.347597342;
	var DEFAULT_LONGITUDE = 103.8516846;
	
	var requestErrors = ['cohortGet', 'startSimulation'];
	
	// eslint-disable-next-line react/prefer-stateless-function
	
	var _ref = _jsx('div', {
	  className: 'creation_error'
	}, void 0, 'An error has occurred while creating resources. Please re-run the simulation.');
	
	var _ref2 = _jsx('div', {
	  className: 'modal-background'
	});
	
	var _ref3 = _jsx('p', {
	  className: 'modal-card-title'
	}, void 0, 'Simulation Results Report');
	
	var SimulationPage = exports.SimulationPage = (_temp = _class = function (_Component) {
	  _inherits(SimulationPage, _Component);
	
	  function SimulationPage(props) {
	    _classCallCheck(this, SimulationPage);
	
	    var _this = _possibleConstructorReturn(this, (SimulationPage.__proto__ || Object.getPrototypeOf(SimulationPage)).call(this, props));
	
	    _this.setCohortCreated = function (created) {
	      _this.setState({
	        isCohortCreated: created
	      });
	    };
	
	    _this.setMapCenter = function (latitude, longitude) {
	      _this.setState({
	        mapCenterLatitude: latitude,
	        mapCenterLongitude: longitude
	      });
	    };
	
	    _this.showDialog = function (show) {
	      _this.setState({
	        showReportDialog: show
	      });
	    };
	
	    _this.showSimulationParams = function (show) {
	      _this.setState({
	        showSimulationParams: show
	      });
	    };
	
	    _this.closeDialog = function () {
	      _this.showDialog(false);
	      _this.disconnectActiveCohortSocket();
	    };
	
	    _this.SimulationModal = function (showReport, closeDialog) {
	      var contents = _jsx(_ReportContainer2.default, {
	        details: _this.props
	      });
	      if (!showReport) {
	        return null;
	      }
	      if (_this.props.resourceCreationError) {
	        contents = _ref;
	      }
	      return _jsx('div', {
	        className: 'modal is-active'
	      }, void 0, _ref2, _jsx('div', {
	        className: 'modal-card'
	      }, void 0, _jsx('header', {
	        className: 'modal-card-head'
	      }, void 0, _ref3, _jsx('button', {
	        className: 'delete',
	        'aria-label': 'close',
	        onClick: closeDialog
	      })), _jsx('section', {
	        className: 'modal-card-body'
	      }, void 0, contents), _jsx('footer', {
	        className: 'modal-card-foot'
	      }, void 0, _jsx('button', {
	        className: 'button',
	        onClick: closeDialog
	      }, void 0, 'Cancel'))));
	    };
	
	    _this.state = {
	      showReportDialog: false,
	      mapCenterLatitude: DEFAULT_LATITUDE,
	      mapCenterLongitude: DEFAULT_LONGITUDE,
	      showSimulationParams: false,
	      searchCohortID: '',
	      isCohortCreated: false
	    };
	    _this.cohortRequestInFlight = false;
	    return _this;
	  }
	
	  _createClass(SimulationPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.resetErrorState(requestErrors);
	      var _props = this.props,
	          deactivateCohort = _props.unsetCohort,
	          activeCohortID = _props.activeCohortID;
	
	
	      deactivateCohort(activeCohortID);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var activeCohort = nextProps.activeCohort,
	          activeCohortID = nextProps.activeCohortID;
	
	
	      if (!activeCohort && activeCohortID || activeCohortID && activeCohort.cohortID !== activeCohortID) {
	        if (!this.cohortRequestInFlight) {
	          this.cohortRequestInFlight = true;
	          this.props.cohortGet(activeCohortID);
	        }
	      }
	
	      if (!_lodash2.default.isEmpty(activeCohort) && activeCohort.cohortID) {
	        this.cohortRequestInFlight = false;
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var prevSimulationGetRequest = prevProps.simulationGetRequest,
	          prevSimulationCompleted = prevProps.simulationCompleted,
	          prevCohortGetRequest = prevProps.cohortGetRequest,
	          prevresourceCreationError = prevProps.resourceCreationError;
	      var _props2 = this.props,
	          simulationGetRequest = _props2.simulationGetRequest,
	          simulationCompleted = _props2.simulationCompleted,
	          deactivateCohort = _props2.unsetCohort,
	          activeCohortID = _props2.activeCohortID,
	          cohortGetRequest = _props2.cohortGetRequest,
	          resourceCreationError = _props2.resourceCreationError;
	
	      var successfulSimulationRequest = !prevSimulationGetRequest.isSuccessful && simulationGetRequest.isSuccessful;
	      var successfulSimulationReport = !prevSimulationCompleted && simulationCompleted;
	      var successfulCohortGetRequest = !prevCohortGetRequest.isSuccessful && cohortGetRequest.isSuccessful;
	      var failedSimulationReport = !prevresourceCreationError && resourceCreationError;
	
	      if (successfulSimulationRequest) {
	        this.connectActiveCohortSocket();
	      }
	      if (successfulSimulationReport || failedSimulationReport) {
	        deactivateCohort(activeCohortID);
	        this.disconnectActiveCohortSocket();
	        this.showDialog(true);
	      }
	
	      if (successfulCohortGetRequest) {
	        this.setCohortCreated(true);
	        this.showSimulationParams(true);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.disconnectActiveCohortSocket();
	    }
	  }, {
	    key: 'connectActiveCohortSocket',
	    value: function connectActiveCohortSocket() {
	      var _this2 = this;
	
	      if (this.cohortSocket) {
	        this.cohortSocket.close();
	      }
	      var cohortID = this.props.activeCohortID;
	      var cohortSocket = new WebSocket(_config2.default.WEBSOCKET_BASE_URL + '/cohorts/' + cohortID + '/events');
	
	      cohortSocket.onmessage = function (event) {
	        var action = (0, _simulationEventsHandler2.default)(cohortID, JSON.parse(event.data));
	        if (action && !_lodash2.default.isEmpty(action.type)) {
	          _this2.context.store.dispatch(action);
	        }
	      };
	      cohortSocket.onclose = function () {
	        if (_this2.cohortSocket !== cohortSocket) {
	          return;
	        }
	
	        _this2.disconnectActiveCohortSocket();
	      };
	      this.cohortSocket = cohortSocket;
	    }
	  }, {
	    key: 'disconnectActiveCohortSocket',
	    value: function disconnectActiveCohortSocket() {
	      if (this.cohortSocket) {
	        this.cohortSocket.onclose = null;
	        this.cohortSocket.close();
	        this.cohortSocket = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var activeCohort = this.props.activeCohort;
	
	
	      var showDisplay = _jsx(_DisplayForm2.default, {
	        setMapCenter: this.setMapCenter,
	        setSimulationParams: this.showSimulationParams,
	        disconnectActiveCohortSocket: this.disconnectActiveCohortSocket,
	        isCohortCreated: this.state.isCohortCreated,
	        setCohortCreated: this.setCohortCreated,
	        transitionViewport: this.props.transitionViewport,
	        cohortGetRequest: this.props.cohortGetRequest,
	        cohortGetErrors: this.props.cohortGetErrors,
	        cohortGet: this.props.cohortGet,
	        resetErrorState: this.props.resetErrorState
	      });
	
	      if (this.state.showSimulationParams) {
	        showDisplay = _jsx(_SimulationDetailsPanel2.default, {
	          onStart: function onStart(Simulations) {
	            _this3.props.resetErrorState(requestErrors);
	            _this3.props.startSimulation(Simulations);
	          },
	          simulationCompleted: this.props.simulationCompleted,
	          errors: this.props.startSimulationErrors,
	          resetErrorState: this.props.resetErrorState,
	          transitionViewport: function transitionViewport(latitude, longitude) {
	            _this3.setMapCenter(latitude, longitude);
	          },
	          back: function back() {
	            _this3.showSimulationParams(false);
	            _this3.props.unsetCohort(_this3.props.activeCohortID);
	            _this3.setCohortCreated(false);
	            _this3.setState({
	              searchCohortID: ''
	            });
	            _this3.props.resetErrorState(requestErrors);
	            _this3.disconnectActiveCohortSocket();
	          },
	          activeCohortID: this.props.activeCohortID,
	          isCohortCreated: this.state.isCohortCreated
	        });
	      }
	
	      return _jsx(_reactDocumentTitle2.default, {
	        title: 'Marionette'
	      }, void 0, _jsx('div', {
	        className: 'map-page'
	      }, void 0, _jsx('div', {
	        className: 'map-page-content columns is-gapless'
	      }, void 0, _jsx('div', {
	        className: 'column is-one-quarter map-sidebar-container'
	      }, void 0, _jsx('div', {
	        className: 'map-sidebar'
	      }, void 0, showDisplay)), _jsx('div', {
	        className: 'column'
	      }, void 0, _jsx(_SimulationMap2.default, {
	        accessToken: _config2.default.MAPBOX_TOKEN,
	        mapboxStyle: _config2.default.MAP_STYLE,
	        cohort: activeCohort,
	        mode: 'DISPLAY_BOOKING',
	        mapCenterLatitude: this.state.mapCenterLatitude,
	        mapCenterLongitude: this.state.mapCenterLongitude
	      }), _jsx(_BookingStatsPanel2.default, {
	        cohort: activeCohort
	      }))), this.SimulationModal(this.state.showReportDialog, this.closeDialog)));
	    }
	  }]);
	
	  return SimulationPage;
	}(_react.Component), _class.contextTypes = {
	  store: _react.PropTypes.object
	}, _temp);
	
	
	function mapStateToProps(state) {
	  var activeCohortID = state.app.activeCohortID;
	
	
	  return {
	    activeCohortID: activeCohortID,
	    activeCohort: state.cohorts[activeCohortID] || {},
	    simulationGetRequest: state.requests.startSimulationRequest || {},
	    simulationCompleted: state.app.simulationCompleted || false,
	    totalBookings: state.app.totalBookings || 0,
	    allocationRate: state.app.allocationRate || 0,
	    successfulRides: state.app.successfulRides || 0,
	    successRate: state.app.successRate || 0,
	    driverIDs: state.app.driverIDs || [],
	    passengerIDs: state.app.passengerIDs || [],
	    errors: state.app.errors || {},
	    timeoutEvent: state.app.timeoutEvent || false,
	    bookings: state.app.bookings || {},
	    startSimulationErrors: _lodash2.default.get(state.errors, 'startSimulation.errors', {}),
	    cohortGetRequest: state.requests.cohortGetRequest || {},
	    cohortGetErrors: _lodash2.default.get(state.errors, 'cohortGet.errors', [])
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  startSimulation: _app.startSimulation,
	  cohortGet: _cohorts.cohortGet,
	  unsetCohort: _cohorts.unsetCohort,
	  resetErrorState: _helpers.resetErrorState
	})(SimulationPage);

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	__webpack_require__(515);
	
	var _cohortUtils = __webpack_require__(52);
	
	var _bookingUtils = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('th', {}, void 0, 'No.');
	
	var _ref2 = _jsx('th', {}, void 0, _jsx('abbr', {
	  title: 'Passenger'
	}, void 0, 'Pax'));
	
	var _ref3 = _jsx('th', {}, void 0, _jsx('abbr', {
	  title: 'Driver'
	}, void 0, 'Dax'));
	
	var _ref4 = _jsx('th', {}, void 0, 'Booking No.');
	
	var _ref5 = _jsx('th', {}, void 0, 'Status');
	
	/* eslint-disable react/prefer-stateless-function */
	var BookingStatsPanel = function (_Component) {
	  _inherits(BookingStatsPanel, _Component);
	
	  function BookingStatsPanel(props) {
	    _classCallCheck(this, BookingStatsPanel);
	
	    var _this = _possibleConstructorReturn(this, (BookingStatsPanel.__proto__ || Object.getPrototypeOf(BookingStatsPanel)).call(this, props));
	
	    _this.generateStats = function () {
	      var cohort = _this.props.cohort;
	
	      var driverBookings = {};
	      _lodash2.default.each(cohort.drivers, function (driver) {
	        _lodash2.default.each(driver.bookings, function (booking) {
	          driverBookings[booking.bookingID] = _extends({}, booking, {
	            driverID: driver.cohortDriverID
	          });
	        });
	      });
	
	      var passengerBookings = [];
	      _lodash2.default.each(cohort.passengers, function (passenger) {
	        _lodash2.default.each(passenger.bookings, function (booking) {
	          passengerBookings.push(_extends({}, booking, {
	            passengerID: passenger.cohortPassengerID
	          }));
	        });
	      });
	
	      if (_lodash2.default.isEmpty(passengerBookings)) {
	        return null;
	      }
	
	      return _lodash2.default.map(passengerBookings, function (booking, idx) {
	        var driverBooking = driverBookings[booking.bookingID];
	        return _jsx('tr', {}, booking.bookingID, _jsx('td', {}, void 0, idx + 1), _jsx('td', {}, void 0, _jsx('a', {
	          href: (0, _cohortUtils.entityURLForCohort)() + '/passengers/' + booking.passengerID,
	          target: '_blank',
	          rel: 'noopener noreferrer'
	        }, void 0, booking.passengerID)), _jsx('td', {}, void 0, driverBooking ? _jsx('a', {
	          href: (0, _cohortUtils.entityURLForCohort)() + '/drivers/' + driverBooking.driverID,
	          target: '_blank',
	          rel: 'noopener noreferrer'
	        }, void 0, driverBooking.driverID) : '-'), _jsx('td', {}, void 0, _jsx('a', {
	          href: (0, _cohortUtils.entityURLForCohort)() + '/bookings/' + booking.bookingID,
	          target: '_blank',
	          rel: 'noopener noreferrer'
	        }, void 0, booking.bookingID)), _jsx('td', {}, void 0, (0, _bookingUtils.bookingStateString)(booking.state)));
	      });
	    };
	
	    _this.state = {
	      show: true
	    };
	    return _this;
	  }
	
	  _createClass(BookingStatsPanel, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var stats = this.generateStats();
	      if (!stats) {
	        return null;
	      }
	
	      return _jsx('div', {
	        className: 'stats-panel'
	      }, void 0, _jsx('div', {
	        className: 'panel-content'
	      }, void 0, _jsx('div', {
	        className: 'panel-header'
	      }, void 0, _jsx('div', {
	        className: 'control-btn'
	      }, void 0, _jsx('a', {
	        onClick: function onClick() {
	          var cur = _this2.state.show;
	          _this2.setState({
	            show: !cur
	          });
	        }
	      }, void 0, _jsx('i', {
	        className: (0, _classnames2.default)('fa', {
	          'fa-expand': !this.state.show,
	          'fa-minus-square': this.state.show
	        })
	      })))), _jsx('div', {
	        className: 'panel-body'
	      }, void 0, _jsx('table', {
	        className: (0, _classnames2.default)('table is-striped is-bordered')
	      }, void 0, _jsx('thead', {}, void 0, _jsx('tr', {
	        className: (0, _classnames2.default)('', {
	          'is-hidden': !this.state.show
	        })
	      }, void 0, _ref, _ref2, _ref3, _ref4, _ref5)), _jsx('tbody', {
	        className: (0, _classnames2.default)('', {
	          'is-hidden': !this.state.show
	        })
	      }, void 0, stats)))));
	    }
	  }]);
	
	  return BookingStatsPanel;
	}(_react.Component);
	
	exports.default = BookingStatsPanel;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SimulationDetailsPanel = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(11);
	
	var _ErrorNotification = __webpack_require__(20);
	
	var _ErrorNotification2 = _interopRequireDefault(_ErrorNotification);
	
	var _app = __webpack_require__(26);
	
	var _WithEscapeToDismiss = __webpack_require__(34);
	
	var _WithEscapeToDismiss2 = _interopRequireDefault(_WithEscapeToDismiss);
	
	__webpack_require__(516);
	
	var _CommonSimulationParams = __webpack_require__(581);
	
	var _CommonSimulationParams2 = _interopRequireDefault(_CommonSimulationParams);
	
	var _NewCohortParams = __webpack_require__(584);
	
	var _NewCohortParams2 = _interopRequireDefault(_NewCohortParams);
	
	var _cities = __webpack_require__(203);
	
	var _cities2 = _interopRequireDefault(_cities);
	
	var _CohortLocationModal = __webpack_require__(199);
	
	var _CohortLocationModal2 = _interopRequireDefault(_CohortLocationModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('h3', {
	  className: 'title is-4'
	}, void 0, 'Simulation Settings');
	
	/* eslint-disable react/prefer-stateless-function */
	var SimulationDetailsPanel = exports.SimulationDetailsPanel = (_dec = (0, _WithEscapeToDismiss2.default)(), _dec(_class = function (_Component) {
	  _inherits(SimulationDetailsPanel, _Component);
	
	  function SimulationDetailsPanel(props) {
	    _classCallCheck(this, SimulationDetailsPanel);
	
	    var _this = _possibleConstructorReturn(this, (SimulationDetailsPanel.__proto__ || Object.getPrototypeOf(SimulationDetailsPanel)).call(this, props));
	
	    _this.setCurrentCohort = function (cohortID) {
	      _this.setState({
	        currentCohortID: cohortID
	      });
	    };
	
	    _this.setLatLongParam = function (latLong) {
	      _this.setState({
	        pickupLatLong: latLong
	      });
	    };
	
	    _this.fillOptions = function (type) {
	      var arr = [];
	      for (var i = 5; i <= 100; i += 5) {
	        arr.push(_jsx('option', {
	          value: i
	        }, type + i, i));
	      }
	      return arr;
	    };
	
	    _this.fillCity = function () {
	      var cityArr = [];
	      var cities = _this.state.cities;
	      for (var i = 0; i < cities.length; i += 1) {
	        var cityDetails = {
	          cityCode: cities[i].city_code,
	          latitude: cities[i].latitude,
	          longitude: cities[i].longitude
	        };
	
	        cityArr.push(_jsx('option', {
	          value: JSON.stringify(cityDetails)
	        }, cities[i].name, cities[i].name));
	      }
	      return cityArr;
	    };
	
	    _this.fillProviderTypes = function () {
	      return _lodash2.default.map(['Random', 'Simple', 'Radius'], function (val, idx) {
	        return _jsx('option', {
	          value: idx
	        }, idx, val);
	      });
	    };
	
	    _this.handleNumPaxChange = function (event) {
	      _this.setState({ paxVal: event.target.value });
	    };
	
	    _this.handleNumDaxChange = function (event) {
	      _this.setState({ daxVal: event.target.value });
	    };
	
	    _this.handleCityChange = function (event) {
	      var cityDetails = JSON.parse(event.target.value);
	      _this.setState({
	        city: cityDetails.cityCode,
	        pickupLatLong: cityDetails.latitude.toString().concat(',', cityDetails.longitude.toString())
	      });
	      _this.props.transitionViewport(cityDetails.latitude, cityDetails.longitude);
	      _this.props.getTaxiTypes(cityDetails.cityCode);
	    };
	
	    _this.handleTimeoutChange = function (event) {
	      _this.setState({
	        timeout: event.target.value
	      });
	    };
	
	    _this.handleProviderTypeChange = function (event) {
	      _this.setState({
	        providerType: event.target.value
	      });
	    };
	
	    _this.handlePickupLatLongChange = function (event) {
	      _this.setState({
	        pickupLatLong: event.target.value
	      });
	    };
	
	    _this.handleShowCohortLocation = function (value) {
	      _this.setState({
	        showCohortLocationModal: value
	      });
	    };
	
	    _this.handleTaxiTypeChange = function (taxiTypeRatio, isHundredPercent) {
	      _this.setState({
	        taxiTypeDistribution: taxiTypeRatio,
	        isHundredPercent: isHundredPercent
	      });
	    };
	
	    _this.toggleAdvanceParams = function () {
	      var toggleStatus = _this.state.showAdvanceSimulationParams;
	
	      _this.setState({
	        showAdvanceSimulationParams: !toggleStatus,
	        isHundredPercent: toggleStatus
	      });
	    };
	
	    _this.state = {
	      cities: new _cities2.default().cities,
	      paxVal: 5,
	      daxVal: 5,
	      city: 'CITY_SG_SIN',
	      disableInputs: false,
	      timeout: 5,
	      currentCohortID: '',
	      providerType: 0,
	      pickupLatLong: '1.2807142,103.8487429',
	      showCohortLocationModal: false,
	      taxiTypeDistribution: null,
	      isHundredPercent: true,
	      showAdvanceSimulationParams: false
	    };
	    return _this;
	  }
	
	  _createClass(SimulationDetailsPanel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.getTaxiTypes('CITY_SG_SIN');
	      this.setCurrentCohort(this.props.activeCohortID);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!prevProps.simulationCompleted && this.props.simulationCompleted || !_lodash2.default.isEmpty(this.props.errors)) {
	        this.reenableInputs();
	      }
	
	      if (!prevProps.activeCohortID && this.props.activeCohortID) {
	        this.setCurrentCohort(this.props.activeCohortID);
	      }
	
	      if (prevProps.activeCohortID && !this.props.activeCohortID && !this.props.isCohortCreated) {
	        this.setCurrentCohort('');
	      }
	    }
	  }, {
	    key: 'reenableInputs',
	    value: function reenableInputs() {
	      if (this.state.disableInputs) {
	        this.setState({
	          disableInputs: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var disableInput = this.state.disableInputs;
	      var autoCompleteLocation = this.props.forwardGeo;
	      return _jsx('div', {
	        className: 'visualization-page '
	      }, void 0, !_lodash2.default.isEmpty(this.props.errors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.errors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this2.props.resetErrorState('startSimulation');
	        }
	      }), _jsx('div', {
	        className: 'section-header map-sidebar-section'
	      }, void 0, _ref, _jsx('div', {
	        className: 'columns'
	      }, void 0, _jsx('h3', {
	        className: 'column is-one-third is-6 cohort-id'
	      }, void 0, 'Cohort ID: ', this.state.currentCohortID), _jsx('button', {
	        className: 'button column back-button is-one-quarter',
	        onClick: this.props.back,
	        disabled: disableInput
	      }, void 0, 'Back'))), _jsx('form', {
	        onSubmit: function onSubmit(event) {
	          event.preventDefault();
	          var pLatLong = _this2.state.pickupLatLong.split(',');
	          var simulation = {
	            numPassengers: parseInt(_this2.state.paxVal, 10),
	            numDrivers: parseInt(_this2.state.daxVal, 10),
	            cohortID: _this2.state.currentCohortID,
	            city: _this2.state.city,
	            timeout: parseInt(_this2.state.timeout, 10),
	            locationDistributor: {
	              type: parseInt(_this2.state.providerType, 10),
	              params: {
	                longitude: parseFloat(pLatLong[1]),
	                latitude: parseFloat(pLatLong[0])
	              }
	            },
	            taxiTypeDistribution: _this2.state.taxiTypeDistribution
	          };
	          _this2.setState({
	            disableInputs: true
	          });
	          _this2.props.onStart(simulation);
	        },
	        className: 'simulation-form'
	      }, void 0, _jsx(_NewCohortParams2.default, {
	        disableInput: disableInput,
	        handleNumPaxChange: this.handleNumPaxChange,
	        handleNumDaxChange: this.handleNumDaxChange,
	        isCohortCreated: this.props.isCohortCreated,
	        fillOptions: this.fillOptions
	      }), _jsx(_CommonSimulationParams2.default, {
	        disableInput: disableInput,
	        handleCityChange: this.handleCityChange,
	        handleTimeoutChange: this.handleTimeoutChange,
	        handleProviderTypeChange: this.handleProviderTypeChange,
	        handlePickupLatLongChange: this.handlePickupLatLongChange,
	        fillCity: this.fillCity,
	        fillProviderTypes: this.fillProviderTypes,
	        showCohortLocationModal: function showCohortLocationModal() {
	          _this2.handleShowCohortLocation(true);
	        },
	        latlongParams: this.state.pickupLatLong,
	        providerType: this.state.providerType,
	        taxiTypes: this.props.taxiTypes,
	        handleTaxiTypeChange: this.handleTaxiTypeChange,
	        toggleAdvanceParams: this.toggleAdvanceParams,
	        showAdvanceSimulationParams: this.state.showAdvanceSimulationParams
	      }), _jsx('button', {
	        disabled: !this.state.isHundredPercent || disableInput,
	        className: 'button startSimulationBtn',
	        type: 'submit'
	      }, void 0, 'Start Simulation')), this.state.showCohortLocationModal && _jsx(_CohortLocationModal2.default, {
	        showModal: this.state.showCohortLocationModal,
	        cohortID: this.state.currentCohortID,
	        cohortSetLocation: function cohortSetLocation(locationLatLong) {
	          _this2.setLatLongParam(locationLatLong);
	        },
	        onAutoCompleteLocation: function onAutoCompleteLocation(locationQuery) {
	          var countryID = _this2.state.city.split('_');
	          autoCompleteLocation(locationQuery, countryID[1]);
	        },
	        handleClose: function handleClose() {
	          _this2.handleShowCohortLocation(false);
	        },
	        autoCompleteLocations: this.props.autoComplete
	      }));
	    }
	  }]);
	
	  return SimulationDetailsPanel;
	}(_react.Component)) || _class);
	
	
	function MapStateToProps(state) {
	  return {
	    autoComplete: state.app.autoComplete,
	    taxiTypes: state.app.taxiTypes || []
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(MapStateToProps, {
	  forwardGeo: _app.forwardGeo,
	  getTaxiTypes: _app.getTaxiTypes
	})(SimulationDetailsPanel);

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	exports.default = CommonSimulationParams;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LatLongParamContainer = __webpack_require__(583);
	
	var _TaxiTypesContainer = __webpack_require__(586);
	
	var _TaxiTypesContainer2 = _interopRequireDefault(_TaxiTypesContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _jsx('div', {
	  className: 'label column is-half',
	  htmlFor: 'timeout'
	}, void 0, 'Set Duration ', _jsx('br', {}), ' (in minutes)');
	
	var _ref2 = _jsx('div', {
	  className: 'label column is-half',
	  htmlFor: 'city'
	}, void 0, 'City');
	
	var _ref3 = _jsx('div', {
	  className: 'label column is-half',
	  htmlFor: 'providerType'
	}, void 0, 'Location Behavior');
	
	function CommonSimulationParams(props) {
	  return _jsx('div', {
	    className: 'common-params'
	  }, void 0, _jsx('div', {
	    className: 'field columns'
	  }, void 0, _ref, _jsx('div', {
	    className: 'field column is-half'
	  }, void 0, _jsx('input', {
	    name: 'timeout',
	    type: 'number',
	    className: 'input',
	    onChange: props.handleTimeoutChange,
	    disabled: props.disableInput,
	    defaultValue: 5
	  }))), _jsx('div', {
	    className: 'field columns'
	  }, void 0, _ref2, _jsx('div', {
	    className: 'select column is-half'
	  }, void 0, _jsx('select', {
	    name: 'city',
	    onChange: props.handleCityChange,
	    disabled: props.disableInput
	  }, void 0, props.fillCity()))), _jsx('div', {
	    className: 'field columns'
	  }, void 0, _ref3, _jsx('div', {
	    className: 'select column is-half'
	  }, void 0, _jsx('select', {
	    name: 'providerType',
	    onChange: props.handleProviderTypeChange,
	    disabled: props.disableInput
	  }, void 0, props.fillProviderTypes()))), _jsx(_LatLongParamContainer.LatLongParamContainer, {
	    disableInput: props.disableInput,
	    latlongParams: props.latlongParams,
	    showCohortLocationModal: props.showCohortLocationModal,
	    handlePickupLatLongChange: props.handlePickupLatLongChange,
	    providerType: props.providerType
	  }), _jsx('button', {
	    className: 'button',
	    onClick: props.toggleAdvanceParams,
	    type: 'button',
	    disabled: props.disableInput
	  }, void 0, props.showAdvanceSimulationParams ? 'Hide Advanced Simulation Behaviors' : 'Show Advanced Simulation Behaviors'), _jsx(_TaxiTypesContainer2.default, {
	    taxiTypes: props.taxiTypes,
	    handleTaxiTypeChange: props.handleTaxiTypeChange,
	    showAdvanceSimulationParams: props.showAdvanceSimulationParams
	  }));
	}

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rcTooltip = __webpack_require__(134);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRedux = __webpack_require__(11);
	
	var _ErrorNotification = __webpack_require__(20);
	
	var _ErrorNotification2 = _interopRequireDefault(_ErrorNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var requestErrors = ['cohortGet'];
	
	var _ref = _jsx('h3', {
	  className: 'title section-title is-6'
	}, void 0, 'Cohort', ' ', _jsx(_rcTooltip2.default, {
	  placement: 'right',
	  trigger: 'hover',
	  overlay: _jsx('span', {}, void 0, 'Cohort drivers will only be able to receive', _jsx('br', {}), 'jobs created within the same cohort.')
	}, void 0, _jsx('i', {
	  className: 'fa fa-question-circle'
	})));
	
	var _ref2 = _jsx('span', {
	  className: 'icon',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-arrow-right'
	}));
	
	var DisplayForm = (_temp = _class = function (_Component) {
	  _inherits(DisplayForm, _Component);
	
	  function DisplayForm(props) {
	    _classCallCheck(this, DisplayForm);
	
	    var _this = _possibleConstructorReturn(this, (DisplayForm.__proto__ || Object.getPrototypeOf(DisplayForm)).call(this, props));
	
	    _this.openCohortParams = function () {
	      _this.props.setSimulationParams(true);
	    };
	
	    _this.state = {
	      searchCohortID: ''
	    };
	    return _this;
	  }
	
	  _createClass(DisplayForm, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _jsx('div', {
	        className: 'cohort-selection-panel map-sidebar-section'
	      }, void 0, _ref, _jsx('div', {
	        className: 'columns'
	      }, void 0, _jsx('div', {
	        className: 'column is-half'
	      }, void 0, _jsx('form', {
	        className: 'field has-addons',
	        onSubmit: function onSubmit(event) {
	          event.preventDefault();
	          _this2.props.cohortGet(_this2.state.searchCohortID);
	          _this2.props.resetErrorState(requestErrors);
	        }
	      }, void 0, _jsx('input', {
	        className: 'input control',
	        type: 'text',
	        placeholder: 'Enter a cohort ID',
	        value: this.state.searchCohortID,
	        'aria-label': 'Cohort ID',
	        onChange: function onChange(event) {
	          _this2.setState({
	            searchCohortID: event.target.value
	          });
	        }
	      }), _jsx('button', {
	        className: (0, _classnames2.default)('button is-info control', {
	          'is-loading': this.props.cohortGetRequest.isPending,
	          'is-disabled': !this.state.searchCohortID
	        }),
	        title: 'Select cohort',
	        'aria-label': 'Select cohort',
	        type: 'submit'
	      }, void 0, _ref2))), _jsx('div', {
	        className: 'column is-half has-text-right'
	      }, void 0, _jsx('button', {
	        className: 'button',
	        onClick: this.openCohortParams
	      }, void 0, 'Run New Simulation'))), !_lodash2.default.isEmpty(this.props.cohortGetErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.cohortGetErrors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this2.props.resetErrorState('cohortGet');
	        }
	      }));
	    }
	  }]);
	
	  return DisplayForm;
	}(_react.Component), _class.contextTypes = {
	  store: _react.PropTypes.object
	}, _temp);
	exports.default = (0, _reactRedux.connect)()(DisplayForm);

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LatLongParamContainer = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(517);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('div', {
	  className: 'label column is-half',
	  htmlFor: 'pickup_location'
	}, void 0, 'Pickup Location');
	
	var _ref2 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-map-marker'
	}));
	
	var _ref3 = _jsx('div', {
	  className: 'field columns'
	});
	
	var LatLongParamContainer = exports.LatLongParamContainer = function (_Component) {
	  _inherits(LatLongParamContainer, _Component);
	
	  function LatLongParamContainer(props) {
	    _classCallCheck(this, LatLongParamContainer);
	
	    var _this = _possibleConstructorReturn(this, (LatLongParamContainer.__proto__ || Object.getPrototypeOf(LatLongParamContainer)).call(this, props));
	
	    _this.state = {
	      LatLong: props.latlongParams
	    };
	    return _this;
	  }
	
	  _createClass(LatLongParamContainer, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (this.props.latlongParams !== nextProps.latlongParams) {
	        this.setState({
	          LatLong: nextProps.latlongParams
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.props.providerType === '1') {
	        return _jsx('div', {
	          className: 'field columns'
	        }, void 0, _ref, _jsx('div', {
	          className: 'field column is-half locationParam'
	        }, void 0, _jsx('input', {
	          name: 'pickup_latitude',
	          type: 'text',
	          className: 'input column is-three-quarters',
	          onChange: this.props.handlePickupLatLongChange,
	          disabled: this.props.disableInput,
	          value: this.state.LatLong
	        }), _jsx('p', {
	          className: 'control locationPinContainer'
	        }, void 0, _jsx('button', {
	          type: 'button',
	          className: (0, _classnames2.default)('button is-success is-outlined', {
	            'is-disabled': this.props.disableInput
	          }),
	          title: 'Set driver to location via address',
	          'aria-label': 'Set driver to location via address',
	          onClick: function onClick() {
	            _this2.props.showCohortLocationModal();
	          }
	        }, void 0, _ref2))));
	      }
	      return _ref3;
	    }
	  }]);

	  return LatLongParamContainer;
	}(_react.Component);

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	exports.default = NewCohortParams;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _jsx("div", {});
	
	var _ref2 = _jsx("div", {
	  className: "label",
	  htmlFor: "num-passengers"
	}, void 0, "Passengers Required");
	
	var _ref3 = _jsx("div", {
	  className: "label",
	  htmlFor: "num-drivers"
	}, void 0, "Drivers Required");
	
	function NewCohortParams(props) {
	  if (props.isCohortCreated) {
	    return _ref;
	  }
	  return _jsx("div", {
	    className: "field is-horizontal"
	  }, void 0, _jsx("div", {
	    className: "field-body"
	  }, void 0, _jsx("div", {
	    className: "field"
	  }, void 0, _ref2, _jsx("div", {
	    className: "select"
	  }, void 0, _jsx("select", {
	    name: "num-passengers",
	    onChange: props.handleNumPaxChange,
	    disabled: props.disableInput
	  }, void 0, props.fillOptions('pax')))), _jsx("div", {
	    className: "field"
	  }, void 0, _ref3, _jsx("div", {
	    className: "select"
	  }, void 0, _jsx("select", {
	    name: "num-drivers",
	    onChange: props.handleNumDaxChange,
	    disabled: props.disableInput
	  }, void 0, props.fillOptions('dax'))))));
	}

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	exports.default = TaxiTypeInput;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TaxiTypeInput(props) {
	  return _jsx("tr", {}, props.taxiType, _jsx("td", {
	    className: "centralize"
	  }, void 0, props.taxiType), _jsx("td", {
	    className: "alignment"
	  }, void 0, _jsx("input", {
	    className: "input is-small",
	    type: "number",
	    placeholder: "0",
	    onChange: function onChange(event) {
	      props.handlePercentageChange(props.taxiType, event);
	    },
	    onKeyPress: function onKeyPress(e) {
	      if (e.key === 'Enter') {
	        e.preventDefault();
	      }
	    }
	  })));
	}

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	__webpack_require__(518);
	
	var _TaxiTypeInput = __webpack_require__(585);
	
	var _TaxiTypeInput2 = _interopRequireDefault(_TaxiTypeInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('div', {});
	
	var _ref2 = _jsx('thead', {}, void 0, _jsx('tr', {}, void 0, _jsx('th', {
	  className: 'centralize'
	}, void 0, 'Taxi Type'), _jsx('th', {
	  className: 'centralize alignment'
	}, void 0, 'Percentage in Cohort')));
	
	var _ref3 = _jsx('th', {
	  className: 'centralize'
	}, void 0, 'Total Percentage:');
	
	var TaxiTypeContainer = function (_Component) {
	  _inherits(TaxiTypeContainer, _Component);
	
	  function TaxiTypeContainer(props) {
	    _classCallCheck(this, TaxiTypeContainer);
	
	    var _this = _possibleConstructorReturn(this, (TaxiTypeContainer.__proto__ || Object.getPrototypeOf(TaxiTypeContainer)).call(this, props));
	
	    _this.handlePercentageChange = function (taxiType, event) {
	      var updatedValue = _lodash2.default.ceil(event.target.value / 100, 2) || 0.0;
	      var updatedRatio = _this.state.taxiTypeRatio;
	      var oldValue = updatedRatio[taxiType.toString()] || 0;
	      var newPercentage = parseInt(_this.state.percentage, 10) / 100 - oldValue + updatedValue;
	      updatedRatio[taxiType.toString()] = updatedValue;
	      _this.setState({
	        taxiTypeRatio: updatedRatio,
	        percentage: (newPercentage * 100).toFixed(0)
	      });
	
	      _this.props.handleTaxiTypeChange(updatedRatio, _lodash2.default.round(newPercentage, 2) === 1);
	    };
	
	    _this.state = {
	      taxiTypeRatio: {},
	      renderTaxiTypes: false,
	      percentage: 0
	    };
	    return _this;
	  }
	
	  _createClass(TaxiTypeContainer, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (nextProps.taxiTypes !== this.props.taxiTypes) {
	        this.setState({
	          renderTaxiTypes: true
	        });
	      }
	      if (nextProps.showAdvanceSimulationParams !== this.props.showAdvanceSimulationParams) {
	        this.setState({
	          percentage: 0
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var contents = [];
	      if (this.props.taxiTypes.length === 0 || !this.props.showAdvanceSimulationParams) {
	        return _ref;
	      }
	
	      if (this.state.renderTaxiTypes) {
	        this.props.taxiTypes.forEach(function (taxiType) {
	          contents.push(_jsx(_TaxiTypeInput2.default, {
	            taxiType: taxiType,
	            handlePercentageChange: _this2.handlePercentageChange
	          }, taxiType));
	        });
	      }
	      return _jsx('div', {
	        className: 'taxiTypeContainer table-container'
	      }, void 0, _jsx('table', {
	        className: 'table taxiTypeTable'
	      }, void 0, _ref2, _jsx('tbody', {}, void 0, contents), _jsx('tfoot', {}, void 0, _jsx('tr', {}, void 0, _ref3, _jsx('th', {
	        className: (0, _classnames2.default)('centralize', {
	          'over-limit': this.state.percentage > 100
	        })
	      }, void 0, this.state.percentage, '%')))));
	    }
	  }]);
	
	  return TaxiTypeContainer;
	}(_react.Component);
	
	exports.default = TaxiTypeContainer;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.emptyEvent = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = handleSimulationEvent;
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _events = __webpack_require__(202);
	
	var _app = __webpack_require__(26);
	
	var _drivers = __webpack_require__(58);
	
	var _cohortEventsHandler = __webpack_require__(128);
	
	var _cohortEventsHandler2 = _interopRequireDefault(_cohortEventsHandler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyEvent = exports.emptyEvent = {
	  type: '',
	  payload: null
	};
	
	function EventAccumulator() {
	  var queue = {};
	  var last = new Date();
	
	  this.add = function add(cohortID, driverID, location) {
	    queue[driverID] = location;
	    if ((0, _moment2.default)().diff(last, 'seconds') > 2) {
	      var fsa = (0, _drivers.batchDriverSetLocation)(cohortID, _extends({}, queue));
	
	      queue = {};
	      last = new Date();
	      return fsa;
	    }
	
	    return emptyEvent;
	  };
	}
	
	var evtAcct = new EventAccumulator();
	
	function handleSimulationEvent(cohortID, eventData) {
	  var type = eventData.type,
	      params = eventData.params;
	
	  switch (type) {
	    case _events.SIMULATION_BOOKINGS_TIMEOUT_EVENT:
	    case _events.SIMULATION_BOOKINGS_COMPLETE_EVENT:
	      {
	        var timeout = false;
	        if (type === _events.SIMULATION_BOOKINGS_TIMEOUT_EVENT) {
	          timeout = true;
	        }
	        var event = params;
	        var successfulRides = event.successfulRides,
	            totalBookings = event.totalBookings,
	            successRate = event.successRate,
	            allocationRate = event.allocationRate,
	            passengerIDs = event.passengerIDs,
	            driverIDs = event.driverIDs,
	            errors = event.errors,
	            bookings = event.bookings;
	
	        return (0, _app.simulationReportLoad)(successfulRides, totalBookings, successRate, allocationRate, passengerIDs, driverIDs, errors, timeout, bookings);
	      }
	    case _events.DRIVER_LOCATION_UPDATE_EVENT:
	      {
	        var _event = params;
	        var driverID = _event.driverID,
	            latitude = _event.latitude,
	            longitude = _event.longitude;
	
	        var location = [longitude, latitude];
	        return evtAcct.add(cohortID, driverID, location);
	      }
	    case _events.SIMULATION_RESOURCE_CREATION_ERROR:
	      {
	        return (0, _app.resourceCreationError)();
	      }
	    default:
	      break;
	  }
	  return (0, _cohortEventsHandler2.default)(cohortID, eventData);
	}

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CentralDashboardPage = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(11);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDocumentTitle = __webpack_require__(27);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cohorts = __webpack_require__(30);
	
	var _app = __webpack_require__(26);
	
	var _CohortDashboard = __webpack_require__(592);
	
	var _CohortDashboard2 = _interopRequireDefault(_CohortDashboard);
	
	var _SimulationDashboardPage = __webpack_require__(602);
	
	var _SimulationDashboardPage2 = _interopRequireDefault(_SimulationDashboardPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('h1', {
	  className: 'title is-2'
	}, void 0, 'Dashboards');
	
	var _ref2 = _jsx('span', {
	  className: 'icon is-small'
	}, void 0, _jsx('i', {
	  className: 'fa fa-group',
	  'aria-hidden': 'true'
	}));
	
	var _ref3 = _jsx('span', {}, void 0, 'Cohorts');
	
	var _ref4 = _jsx('span', {
	  className: 'icon is-small'
	}, void 0, _jsx('i', {
	  className: 'fa fa-gears',
	  'aria-hidden': 'true'
	}));
	
	var _ref5 = _jsx('span', {}, void 0, 'Simulations');
	
	var CentralDashboardPage = exports.CentralDashboardPage = function (_Component) {
	  _inherits(CentralDashboardPage, _Component);
	
	  function CentralDashboardPage(props) {
	    _classCallCheck(this, CentralDashboardPage);
	
	    var _this = _possibleConstructorReturn(this, (CentralDashboardPage.__proto__ || Object.getPrototypeOf(CentralDashboardPage)).call(this, props));
	
	    _this.switchTab = function (tabIdx) {
	      _this.setState({
	        tabStatus: 1 << tabIdx });
	    };
	
	    _this.isActive = function (tabIdx) {
	      return (_this.state.tabStatus & 1 << tabIdx) !== 0;
	    };
	
	    _this.state = {
	      tabStatus: 1
	    };
	    return _this;
	  }
	
	  _createClass(CentralDashboardPage, [{
	    key: 'render',
	    // eslint-disable-line no-bitwise
	
	    value: function render() {
	      var _this2 = this;
	
	      return _jsx(_reactDocumentTitle2.default, {
	        title: 'Marionette'
	      }, void 0, _jsx('section', {
	        className: 'section'
	      }, void 0, _jsx('div', {
	        className: 'container'
	      }, void 0, _ref, _jsx('div', {
	        className: 'tabs is-centered is-boxed is-medium'
	      }, void 0, _jsx('ul', {}, void 0, _jsx('li', {
	        className: (0, _classnames2.default)({
	          'is-active': this.isActive(0)
	        })
	      }, void 0, _jsx('a', {
	        onClick: function onClick() {
	          return _this2.switchTab(0);
	        }
	      }, void 0, _ref2, _ref3)), _jsx('li', {
	        className: (0, _classnames2.default)({
	          'is-active': this.isActive(1)
	        })
	      }, void 0, _jsx('a', {
	        onClick: function onClick() {
	          return _this2.switchTab(1);
	        }
	      }, void 0, _ref4, _ref5)))), _jsx('div', {}, void 0, this.isActive(0) && _jsx(_CohortDashboard2.default, {
	        cohorts: this.props.cohorts,
	        getCohorts: this.props.getCohorts,
	        lastOffset: this.props.lastOffset
	      }), this.isActive(1) && _react2.default.createElement(_SimulationDashboardPage2.default, this.props)))));
	    }
	  }]);
	
	  return CentralDashboardPage;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  var _state$app$user = state.app.user,
	      cohorts = _state$app$user.cohorts,
	      lastOffset = _state$app$user.lastOffset;
	
	  return {
	    // cohort dashboard
	    cohorts: _lodash2.default.flatMap(cohorts || {}, function (cohort, cohortID) {
	      return _extends({}, cohort, {
	        cohortID: cohortID
	      });
	    }),
	    lastOffset: lastOffset,
	    // simulation dashboard
	    simulationList: state.app.simulationList || [],
	    simulationDetails: state.app.simulationDetails || null,
	    lastEvaluatedKey: state.app.lastEvaluatedKey || null
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  // cohort dashboard
	  getCohorts: _cohorts.getCohorts,
	  // simulation dashboard
	  getSimulations: _app.getSimulations,
	  getSimulationReport: _app.getSimulationReport,
	  toggleSimulationStatus: _app.toggleSimulationStatus,
	  resetSimulationDashboard: _app.resetSimulationDashboard
	})(CentralDashboardPage);

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DashboardContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	/* eslint-disable import/no-named-as-default-member */
	
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(27);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _reactRedux = __webpack_require__(11);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(21);
	
	var _grabStorage = __webpack_require__(124);
	
	var _grabStorage2 = _interopRequireDefault(_grabStorage);
	
	var _rcTooltip = __webpack_require__(134);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _immutable = __webpack_require__(22);
	
	var _reactAutobind = __webpack_require__(77);
	
	var _reactAutobind2 = _interopRequireDefault(_reactAutobind);
	
	var _config = __webpack_require__(32);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _cohorts = __webpack_require__(30);
	
	var _drivers = __webpack_require__(58);
	
	var _passengers = __webpack_require__(71);
	
	var _helpers = __webpack_require__(51);
	
	var _app = __webpack_require__(26);
	
	var _mapUtils = __webpack_require__(74);
	
	var _libraryUtils = __webpack_require__(36);
	
	var _bookings = __webpack_require__(72);
	
	var _Map = __webpack_require__(563);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _ErrorNotification = __webpack_require__(20);
	
	var _ErrorNotification2 = _interopRequireDefault(_ErrorNotification);
	
	var _PassengersPanel = __webpack_require__(600);
	
	var _PassengersPanel2 = _interopRequireDefault(_PassengersPanel);
	
	var _DriversPanel = __webpack_require__(597);
	
	var _DriversPanel2 = _interopRequireDefault(_DriversPanel);
	
	var _CreateBookingPanel = __webpack_require__(591);
	
	var _CreateBookingPanel2 = _interopRequireDefault(_CreateBookingPanel);
	
	var _BookingDetailsPanel = __webpack_require__(590);
	
	var _BookingDetailsPanel2 = _interopRequireDefault(_BookingDetailsPanel);
	
	var _cohortEventsHandler = __webpack_require__(128);
	
	var _cohortEventsHandler2 = _interopRequireDefault(_cohortEventsHandler);
	
	__webpack_require__(519);
	
	__webpack_require__(520);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var taxiTypeIDKey = 'taxiTypeID';
	var paymentTypeKey = 'paymentType';
	var requestErrors = ['cohortCreate', 'cohortGet', 'cohortDelete'];
	
	var _ref = _jsx('h3', {
	  className: 'title section-title is-6'
	}, void 0, 'Cohort', ' ', _jsx(_rcTooltip2.default, {
	  placement: 'right',
	  trigger: 'hover',
	  overlay: _jsx('span', {}, void 0, 'Cohort drivers will only be able to receive', _jsx('br', {}), 'jobs created within the same cohort.')
	}, void 0, _jsx('i', {
	  className: 'fa fa-question-circle'
	})));
	
	var _ref2 = _jsx('span', {
	  className: 'tag'
	}, void 0, 'Passenger Type');
	
	var _ref3 = _jsx('span', {
	  className: 'icon',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-trash'
	}));
	
	var _ref4 = _jsx('span', {
	  className: 'icon',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-search'
	}));
	
	var _ref5 = _jsx('span', {
	  className: 'icon',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-times'
	}));
	
	var _ref6 = _jsx(_reactRouter.Link, {
	  className: 'generate-resource-link',
	  to: '/generate-resources',
	  title: 'Generate Resources',
	  'aria-label': 'Generate Resources'
	}, void 0, _jsx('h3', {}, void 0, 'Generate new cohort'));
	
	var _ref7 = _jsx('div', {
	  className: 'map-sidebar-section'
	}, void 0, _jsx('div', {
	  className: 'notification is-warning',
	  role: 'alert'
	}, void 0, 'No cohort selected for viewing. Please enter a cohort ID above.'));
	
	var DashboardContainer = exports.DashboardContainer = (_temp = _class = function (_Component) {
	  _inherits(DashboardContainer, _Component);
	
	  function DashboardContainer(props) {
	    _classCallCheck(this, DashboardContainer);
	
	    var _this = _possibleConstructorReturn(this, (DashboardContainer.__proto__ || Object.getPrototypeOf(DashboardContainer)).call(this, props));
	
	    _this.state = {
	      searchCohortID: '',
	      newCohortName: '',
	      activePassengerBooking: null,
	      cohortDisconnectionCode: null,
	      cohortPaxType: 0
	    };
	    _this.cohortSocket = null;
	    (0, _reactAutobind2.default)(_this, 'renderBookingPanel');
	    return _this;
	  }
	  // Can't get context to work with Flow. Fallback to es7 approach.
	
	
	  _createClass(DashboardContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.resetErrorState(requestErrors);
	      if (this.props.activeCohortID) {
	        this.props.cohortGet(this.props.activeCohortID);
	        this.context.router.push({
	          pathname: '/cohorts/' + this.props.activeCohortID,
	          state: {
	            cohortRedirection: true
	          }
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      var appActiveBookingChanged = !_lodash2.default.isEqual(this.props.appActiveBooking, nextProps.appActiveBooking) && !!nextProps.appActiveBooking;
	      var activeCohortIDChanged = this.props.activeCohortID !== nextProps.activeCohortID;
	      var successfulCohortGetRequest = !this.props.cohortGetRequest.isSuccessful && nextProps.cohortGetRequest.isSuccessful;
	      var successfulCohortCreateRequest = !this.props.cohortCreateRequest.isSuccessful && nextProps.cohortCreateRequest.isSuccessful;
	      var successfulCohortDeleteRequest = !this.props.cohortDeleteRequest.isSuccessful && nextProps.cohortDeleteRequest.isSuccessful;
	      var activePassengerRemoved = !!this.state.activePassengerBooking && !_lodash2.default.has(nextProps, 'passengers.' + this.state.activePassengerBooking.passengerID);
	      var activePassengerLoggedOut = !!this.state.activePassengerBooking && _lodash2.default.has(nextProps, 'passengers.' + this.state.activePassengerBooking.passengerID) && !nextProps.passengers[this.state.activePassengerBooking.passengerID].loggedIn;
	
	      if (activeCohortIDChanged) {
	        if (nextProps.activeCohortID) {
	          this.context.router.push('/cohorts/' + nextProps.activeCohortID);
	        } else {
	          this.context.router.push('/app');
	        }
	      }
	
	      if (appActiveBookingChanged || activeCohortIDChanged || successfulCohortGetRequest || successfulCohortCreateRequest || successfulCohortDeleteRequest || activePassengerRemoved || activePassengerLoggedOut) {
	        this.setState({
	          activePassengerBooking: null
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var successfulCohortGetRequest = !prevProps.cohortGetRequest.isSuccessful && this.props.cohortGetRequest.isSuccessful;
	      var successfulCohortCreateRequest = !prevProps.cohortCreateRequest.isSuccessful && this.props.cohortCreateRequest.isSuccessful;
	      var successfulCohortDeleteRequest = !prevProps.cohortDeleteRequest.isSuccessful && this.props.cohortDeleteRequest.isSuccessful;
	      if (successfulCohortGetRequest || successfulCohortCreateRequest) {
	        this.connectActiveCohortSocket();
	      }
	      if (successfulCohortDeleteRequest) {
	        this.disconnectActiveCohortSocket();
	      }
	
	      if (prevProps.passengerBookingCreateErrors.isFailure && !this.props.passengerBookingCreateErrors.isFailure) {
	        this.props.resetErrorState('passengerBookingCreate');
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.disconnectActiveCohortSocket();
	    }
	  }, {
	    key: 'connectActiveCohortSocket',
	    value: function connectActiveCohortSocket() {
	      var _this2 = this;
	
	      if (this.cohortSocket) {
	        this.cohortSocket.close();
	      }
	      var cohortID = this.props.activeCohortID;
	      var cohortSocket = new WebSocket(_config2.default.WEBSOCKET_BASE_URL + '/cohorts/' + cohortID + '/events');
	
	      cohortSocket.onmessage = function (event) {
	        var action = (0, _cohortEventsHandler2.default)(cohortID, JSON.parse(event.data));
	        _this2.context.store.dispatch(action);
	      };
	      cohortSocket.onclose = function (event) {
	        if (_this2.cohortSocket !== cohortSocket) {
	          return;
	        }
	        _this2.setState({
	          cohortDisconnectionCode: event.code
	        });
	        _this2.disconnectActiveCohortSocket();
	      };
	      this.cohortSocket = cohortSocket;
	    }
	  }, {
	    key: 'disconnectActiveCohortSocket',
	    value: function disconnectActiveCohortSocket() {
	      if (this.cohortSocket) {
	        this.cohortSocket.onclose = null;
	        this.cohortSocket.close();
	        this.cohortSocket = null;
	      }
	    }
	  }, {
	    key: 'renderBookingPanel',
	    value: function renderBookingPanel(activePassengerBooking) {
	      var _this3 = this;
	
	      if (this.props.activeCohortID && activePassengerBooking.passengerID) {
	        var _ret = function () {
	          var _props = _this3.props,
	              createBooking = _props.passengerBookingCreate,
	              passengerBookingCreateRequest = _props.passengerBookingCreateRequest,
	              resetError = _props.resetErrorState,
	              newlyCreatedBookingID = _props.newlyCreatedBookingID,
	              resetBookingState = _props.unsetNewlyCreatedBooking,
	              activeCohortID = _props.activeCohortID,
	              passengerBookingCreateErrors = _props.passengerBookingCreateErrors,
	              nearbyTaxiTypes = _props.nearbyTaxiTypes,
	              passengerGetNearbyTaxiTypesRequest = _props.passengerGetNearbyTaxiTypesRequest,
	              passengerGetNearbyTaxiTypesErrors = _props.passengerGetNearbyTaxiTypesErrors,
	              pois = _props.pois,
	              _getPOI = _props.reverseGeo;
	
	
	          return {
	            v: _jsx(_CreateBookingPanel2.default, {
	              activePassengerBooking: activePassengerBooking,
	              onUpdate: function onUpdate(booking) {
	                _this3.setState({
	                  activePassengerBooking: booking
	                });
	              },
	              onCreate: function onCreate(bookingRequest) {
	                var cohortID = activeCohortID;
	                var passengerID = activePassengerBooking.passengerID;
	                // TODO: Potentially reset the cached TaxiTypeID if cohort changes.
	                _grabStorage2.default.setItem(taxiTypeIDKey, activePassengerBooking.taxiTypeID);
	                _grabStorage2.default.setItem(paymentTypeKey, activePassengerBooking.paymentType);
	                createBooking(cohortID, passengerID, bookingRequest, pois);
	              },
	              onShow: function onShow() {
	                resetError('passengerBookingCreate');
	              },
	              onHide: function onHide() {
	                resetBookingState();
	              },
	              isLoading: passengerBookingCreateRequest.isPending,
	              successBookingID: newlyCreatedBookingID,
	              errors: passengerBookingCreateErrors,
	              handleClose: function handleClose() {
	                _this3.setState({
	                  activePassengerBooking: null
	                });
	              },
	              nearbyTaxiTypes: nearbyTaxiTypes,
	              isGetTaxiTypesPending: passengerGetNearbyTaxiTypesRequest.isPending,
	              taxiTypesErrors: passengerGetNearbyTaxiTypesErrors,
	              pointOfInterests: pois,
	              getPOI: function getPOI(location) {
	                _getPOI(location);
	              },
	              clearError: function clearError() {
	                resetError('passengerBookingCreate');
	              }
	            })
	          };
	        }();
	
	        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderMap',
	    value: function renderMap(pickUpLocation, dropOffLocation, extraDropOffLocations, activePassengerBooking, bookingMode) {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          activeCohort = _props2.activeCohort,
	          activeCohortID = _props2.activeCohortID,
	          localSetDriverLocation = _props2.driverSetLocationInstant,
	          remoteSetDriverLocation = _props2.driverSetLocation,
	          handleDriverDrag = _props2.driverDrag,
	          driverBeingDragged = _props2.driverBeingDragged,
	          handleReverseGeo = _props2.reverseGeo,
	          handleGetNearbyTaxiTypes = _props2.passengerGetNearbyTaxiTypes;
	
	      return _react2.default.createElement(_Map2.default, {
	        accessToken: _config2.default.MAPBOX_TOKEN,
	        mapboxStyle: _config2.default.MAP_STYLE,
	        cohort: activeCohort,
	        pickUpMarker: pickUpLocation,
	        dropOffMarker: dropOffLocation,
	        extraDropOffMarkers: extraDropOffLocations,
	        ref: function ref(map) {
	          _this4.map = map;
	        },
	        onDriverDrag: function onDriverDrag(driverID, location) {
	          localSetDriverLocation(activeCohortID, driverID, location, true);
	        },
	        onDriverDragStart: function onDriverDragStart(driverID) {
	          handleDriverDrag(driverID);
	        },
	        onDriverDragEnd: function onDriverDragEnd(driverID, location) {
	          handleDriverDrag(null);
	          remoteSetDriverLocation(activeCohortID, driverID, location);
	        },
	        mapDragEnd: function mapDragEnd() {
	          if (driverBeingDragged) {
	            // Reset if there's a driver being dragged.
	            handleDriverDrag(null);
	          }
	        },
	        onBookingMarkerDrag: function onBookingMarkerDrag(type, location) {
	          var locationType = {
	            pickUp: 'pickUpLocation',
	            dropOff: 'dropOffLocation',
	            extraDropOff_0: 0
	          }[type];
	
	          if (typeof locationType === 'number') {
	            _this4.setState(function (curState) {
	              var paxBkg = curState.activePassengerBooking;
	              var updatedLocations = _lodash2.default.slice(paxBkg.extraDropOffLocations);
	              updatedLocations[locationType] = location.map(function (value) {
	                return (0, _mapUtils.roundCoordinate)(value);
	              });
	
	              return {
	                activePassengerBooking: _extends({}, paxBkg, {
	                  extraDropOffLocations: updatedLocations
	                })
	              };
	            });
	          } else {
	            _this4.setState({
	              activePassengerBooking: _extends({}, activePassengerBooking, _defineProperty({}, locationType, location.map(function (value) {
	                return (0, _mapUtils.roundCoordinate)(value);
	              })))
	            });
	          }
	        },
	        onBookingMarkerDragEnd: function onBookingMarkerDragEnd(location, bookingMarkerType) {
	          handleReverseGeo(location.map(function (value) {
	            return (0, _mapUtils.roundCoordinate)(value);
	          }));
	          if (bookingMarkerType === _bookings.BOOKING_MARKER_PICKUP) {
	            handleGetNearbyTaxiTypes(activePassengerBooking.passengerID, location);
	          }
	        },
	        mode: bookingMode
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var activePassengerBooking = this.state.activePassengerBooking || {};
	      var bookingMode = null;
	      var pickUpLocation = null;
	      var dropOffLocation = null;
	      var itinerary = null;
	      var extraDropOffLocations = [];
	
	      if (!_lodash2.default.isEmpty(activePassengerBooking)) {
	        bookingMode = 'BOOKING';
	        pickUpLocation = activePassengerBooking.pickUpLocation;
	        dropOffLocation = activePassengerBooking.dropOffLocation;
	        extraDropOffLocations = activePassengerBooking.extraDropOffLocations;
	      } else if (this.props.appActiveBooking) {
	        var _appActiveBooking = this.props.appActiveBooking;
	        itinerary = _appActiveBooking.itinerary;
	        bookingMode = 'DISPLAY_BOOKING';
	
	        var pickUpPoint = _lodash2.default.first(itinerary);
	        var dropOffPoint = _lodash2.default.last(itinerary);
	        if (pickUpPoint.longitude && pickUpPoint.latitude) {
	          pickUpLocation = [pickUpPoint.longitude, pickUpPoint.latitude];
	        }
	        if (dropOffPoint.longitude && dropOffPoint.latitude) {
	          dropOffLocation = [dropOffPoint.longitude, dropOffPoint.latitude];
	        }
	        if (_lodash2.default.size(itinerary) > 2) {
	          var _itinerary = itinerary,
	              _itinerary2 = _toArray(_itinerary),
	              rest = _itinerary2.slice(1);
	
	          extraDropOffLocations = _lodash2.default.take(rest, rest.length - 1).map(function (point) {
	            return [point.longitude, point.latitude];
	          });
	        }
	      }
	
	      return _jsx(_reactDocumentTitle2.default, {
	        title: 'Marionette'
	      }, void 0, _jsx('div', {
	        className: 'map-page'
	      }, void 0, _jsx('div', {
	        className: 'map-page-content columns is-gapless'
	      }, void 0, _jsx('div', {
	        className: 'column is-one-third map-sidebar-container'
	      }, void 0, _jsx('div', {
	        className: 'map-sidebar'
	      }, void 0, _jsx('div', {
	        className: 'cohort-selection-panel map-sidebar-section'
	      }, void 0, _ref, _jsx('div', {
	        className: 'columns'
	      }, void 0, _jsx('div', {
	        className: 'column is-full'
	      }, void 0, this.props.activeCohortID && _jsx('div', {
	        className: 'cohort-tags'
	      }, void 0, _jsx('div', {
	        className: 'tags has-addons'
	      }, void 0, _ref2, _jsx('span', {
	        className: 'tag is-primary is-small'
	      }, void 0, this.props.activeCohort.paxType === 0 ? 'PASSENGER' : 'CHARICE'))), _jsx('div', {
	        className: 'active-cohort columns'
	      }, void 0, _jsx('form', {
	        className: 'field has-addons column is-three-quarters',
	        onSubmit: function onSubmit(event) {
	          event.preventDefault();
	          _this5.props.cohortGet(_this5.state.searchCohortID);
	          _this5.props.resetErrorState(requestErrors);
	        }
	      }, void 0, _jsx('p', {
	        className: 'control is-full-width'
	      }, void 0, this.props.activeCohortID ? _jsx('input', {
	        className: 'input',
	        type: 'text',
	        disabled: true,
	        value: this.props.activeCohortID,
	        'aria-label': 'Cohort ID'
	      }) : _jsx('input', {
	        className: 'input',
	        type: 'text',
	        placeholder: 'Cohort Search: Enter cohort ID',
	        value: this.state.searchCohortID,
	        'aria-label': 'Cohort ID',
	        onChange: function onChange(event) {
	          _this5.setState({
	            searchCohortID: event.target.value
	          });
	        }
	      })), _jsx('p', {
	        className: 'control'
	      }, void 0, this.props.activeCohortID ? _jsx('button', {
	        className: (0, _classnames2.default)('button is-danger', {
	          'is-loading': this.props.cohortDeleteRequest.isPending
	        }),
	        title: 'Delete cohort',
	        'aria-label': 'Delete cohort',
	        type: 'button',
	        onClick: function onClick() {
	          /* eslint-disable no-alert */
	          if (confirm('Are you sure you want to delete Cohort ' + _this5.props.activeCohortID + '?')) {
	            _this5.props.cohortDelete(_this5.props.activeCohortID);
	            _this5.props.resetErrorState(requestErrors);
	            _this5.setState({
	              searchCohortID: ''
	            });
	          }
	        }
	      }, void 0, _ref3) : _jsx('button', {
	        className: (0, _classnames2.default)('button is-info', {
	          'is-loading': this.props.cohortGetRequest.isPending,
	          'is-disabled': !this.state.searchCohortID
	        }),
	        title: 'Select cohort',
	        'aria-label': 'Select cohort',
	        type: 'submit'
	      }, void 0, _ref4)), this.props.activeCohortID && _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx('button', {
	        className: 'button is-warning',
	        title: 'Unselect cohort',
	        'aria-label': 'Unselect cohort',
	        onClick: function onClick() {
	          _this5.props.unsetCohort(_this5.props.activeCohortID);
	          _this5.setState({
	            searchCohortID: '',
	            newCohortName: '',
	            cohortDisconnectionCode: null
	          });
	          _this5.props.resetErrorState(requestErrors);
	          _this5.disconnectActiveCohortSocket();
	        }
	      }, void 0, _ref5)))))), _ref6, this.state.cohortDisconnectionCode && _jsx('div', {
	        className: 'notification is-danger',
	        role: 'alert'
	      }, void 0, 'Cohort socket disconnected. Error code: ', this.state.cohortDisconnectionCode, _jsx('button', {
	        className: 'button is-small is-pulled-right',
	        onClick: function onClick() {
	          _this5.props.cohortGet(_this5.props.activeCohortID);
	        }
	      }, void 0, 'Reconnect')), !_lodash2.default.isEmpty(this.props.cohortCreateErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.cohortCreateErrors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this5.props.resetErrorState('cohortCreate');
	        }
	      }), !_lodash2.default.isEmpty(this.props.cohortGetErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.cohortGetErrors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this5.props.resetErrorState('cohortGet');
	        }
	      }), !_lodash2.default.isEmpty(this.props.cohortDeleteErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.cohortDeleteErrors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this5.props.resetErrorState('cohortDelete');
	        }
	      })), !this.props.activeCohortID && _ref7, this.props.activeCohortID && _jsx('div', {
	        className: 'cohort-passengers map-sidebar-section'
	      }, void 0, _jsx(_PassengersPanel2.default, {
	        bookingInProgress: activePassengerBooking.passengerID,
	        onPassengerBookingClick: function onPassengerBookingClick(passengerID) {
	          // For some reason DimensionsHOC.getWrappedInstance does not work.
	          var mapCenter = _this5.map.refs.wrappedInstance.getMapCenter();
	          var lat = (0, _mapUtils.roundCoordinate)(mapCenter.latitude);
	          var lng = (0, _mapUtils.roundCoordinate)(mapCenter.longitude);
	
	          var _props3 = _this5.props,
	              deactivateBooking = _props3.unsetActiveBooking,
	              getPOI = _props3.reverseGeo,
	              handleGetNearbyTaxiTypes = _props3.passengerGetNearbyTaxiTypes;
	
	
	          deactivateBooking();
	
	          var curBooking = {
	            passengerID: passengerID,
	            // Just to place the markers on the map.
	            pickUpLocation: [lng - 0.02, lat + 0.01],
	            dropOffLocation: [lng + 0.02, lat + 0.01],
	            extraDropOffLocations: [[]],
	            taxiTypeID: _grabStorage2.default.getItem(taxiTypeIDKey) || '',
	            paymentType: _grabStorage2.default.getItem(paymentTypeKey) || _libraryUtils.DEFAULT_PAYMENT_TYPE,
	            rewardType: _libraryUtils.DEFAULT_REWARD_TYPE,
	            rewardValue: ''
	          };
	          _this5.setState({
	            activePassengerBooking: curBooking
	          });
	
	          getPOI(curBooking.pickUpLocation);
	          getPOI(curBooking.dropOffLocation);
	          handleGetNearbyTaxiTypes(passengerID, curBooking.pickUpLocation);
	        }
	      })), this.props.activeCohortID && _jsx('div', {
	        className: 'cohort-drivers map-sidebar-section'
	      }, void 0, _jsx(_DriversPanel2.default, {
	        onDriverClick: function onDriverClick(driver) {
	          _this5.map.refs.wrappedInstance.setMapCenter(driver.latitude, driver.longitude);
	        },
	        getMapCenter: function getMapCenter() {
	          return _this5.map.refs.wrappedInstance.getMapCenter();
	        }
	      })))), _jsx('div', {
	        className: 'column is-two-third map-section'
	      }, void 0, this.renderMap(pickUpLocation, dropOffLocation, extraDropOffLocations, activePassengerBooking, bookingMode), this.renderBookingPanel(activePassengerBooking), this.props.appActiveBooking && _jsx(_BookingDetailsPanel2.default, {
	        booking: this.props.appActiveBooking,
	        handleClose: function handleClose() {
	          _this5.props.unsetActiveBooking();
	        }
	      })))));
	    }
	  }]);
	
	  return DashboardContainer;
	}(_react.Component), _class.contextTypes = {
	  store: _react.PropTypes.object,
	  router: _react.PropTypes.object
	}, _temp);
	
	
	function mapStateToProps(state) {
	  var activeCohortID = state.app.activeCohortID;
	  var activeBooking = state.app.activeBooking;
	  var appActiveBooking = null;
	
	  if (activeBooking) {
	    var bookings = [];
	    if (activeBooking.passengerID) {
	      var passengerID = activeBooking.passengerID;
	      bookings = _lodash2.default.get(state.cohorts[activeCohortID], 'passengers.' + passengerID + '.bookings', []);
	    }
	    if (activeBooking.driverID) {
	      var driverID = activeBooking.driverID;
	      bookings = _lodash2.default.get(state.cohorts[activeCohortID], 'drivers.' + driverID + '.bookings', []);
	    }
	    appActiveBooking = _lodash2.default.find(bookings, function (bkg) {
	      return bkg.bookingID === activeBooking.bookingID;
	    }) || null;
	  }
	
	  return {
	    activeCohortID: activeCohortID,
	    activeCohort: state.cohorts[activeCohortID] || {},
	    driverBeingDragged: state.app.driverBeingDragged,
	    passengers: _lodash2.default.get(state.cohorts[activeCohortID], 'passengers', {}),
	
	    cohortCreateRequest: state.requests.cohortCreateRequest || {},
	    cohortCreateErrors: _lodash2.default.get(state.errors, 'cohortCreate.errors', []),
	
	    cohortGetRequest: state.requests.cohortGetRequest || {},
	    cohortGetErrors: _lodash2.default.get(state.errors, 'cohortGet.errors', []),
	
	    cohortDeleteRequest: state.requests.cohortDeleteRequest || {},
	    cohortDeleteErrors: _lodash2.default.get(state.errors, 'cohortDelete.errors', []),
	
	    passengerBookingCreateRequest: state.requests.passengerBookingCreateRequest || {},
	    passengerBookingCreateErrors: _lodash2.default.get(state.errors, 'passengerBookingCreate.errors', []),
	
	    newlyCreatedBookingID: state.app.newlyCreatedBookingID,
	    appActiveBooking: appActiveBooking,
	
	    nearbyTaxiTypes: state.app.nearbyTaxiTypes,
	    passengerGetNearbyTaxiTypesRequest: state.requests.passengerGetNearbyTaxiTypesRequest || {},
	    passengerGetNearbyTaxiTypesErrors: _lodash2.default.get(state.errors, 'passengerGetNearbyTaxiTypes.errors', []),
	
	    pois: state.app.pois
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  cohortCreate: _cohorts.cohortCreate,
	  cohortGet: _cohorts.cohortGet,
	  cohortDelete: _cohorts.cohortDelete,
	
	  unsetCohort: _cohorts.unsetCohort,
	
	  passengerBookingCreate: _passengers.passengerBookingCreate,
	
	  driverSetLocation: _drivers.driverSetLocation,
	  driverSetLocationInstant: _drivers.driverSetLocationInstant,
	
	  driverDrag: _app.driverDrag,
	
	  unsetActiveBooking: _app.unsetActiveBooking,
	  unsetNewlyCreatedBooking: _app.unsetNewlyCreatedBooking,
	  resetErrorState: _helpers.resetErrorState,
	
	  passengerGetNearbyTaxiTypes: _passengers.passengerGetNearbyTaxiTypes,
	  reverseGeo: _app.reverseGeo
	})(DashboardContainer);

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cohortUtils = __webpack_require__(52);
	
	var _bookingUtils = __webpack_require__(73);
	
	var _WithEscapeToDismiss = __webpack_require__(34);
	
	var _WithEscapeToDismiss2 = _interopRequireDefault(_WithEscapeToDismiss);
	
	__webpack_require__(521);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('span', {
	  className: 'icon is-small'
	}, void 0, _jsx('i', {
	  className: 'fa fa-external-link'
	}));
	
	var _ref2 = _jsx('td', {}, void 0, 'State');
	
	var _ref3 = _jsx('td', {}, void 0, 'Passenger ID');
	
	var _ref4 = _jsx('td', {}, void 0, 'Driver ID');
	
	var _ref5 = _jsx('td', {}, void 0, 'Taxi Type');
	
	/* eslint-disable react/prefer-stateless-function */
	var BookingDetailsPanel = (_dec = (0, _WithEscapeToDismiss2.default)(), _dec(_class = function (_Component) {
	  _inherits(BookingDetailsPanel, _Component);
	
	  function BookingDetailsPanel() {
	    _classCallCheck(this, BookingDetailsPanel);
	
	    return _possibleConstructorReturn(this, (BookingDetailsPanel.__proto__ || Object.getPrototypeOf(BookingDetailsPanel)).apply(this, arguments));
	  }
	
	  _createClass(BookingDetailsPanel, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var booking = this.props.booking;
	      return _jsx('div', {
	        className: 'booking-details-panel'
	      }, void 0, _jsx('button', {
	        'aria-label': 'Close',
	        className: 'is-pulled-right delete close-icon',
	        onClick: function onClick() {
	          _this2.props.handleClose();
	        }
	      }), _jsx('h3', {
	        className: 'title is-6'
	      }, void 0, _jsx('strong', {}, void 0, booking.bookingID, ' ', _jsx('a', {
	        href: (0, _cohortUtils.entityURLForCohort)() + '/bookings/' + booking.bookingID,
	        target: '_blank',
	        rel: 'noopener noreferrer'
	      }, void 0, _ref))), _jsx('table', {
	        className: 'table is-narrow'
	      }, void 0, _jsx('tbody', {}, void 0, booking.state != null && _jsx('tr', {}, void 0, _ref2, _jsx('td', {}, void 0, _jsx('span', {
	        className: 'tag is-small'
	      }, void 0, (0, _bookingUtils.bookingStateString)(booking.state)))), booking.passengerID && _jsx('tr', {}, void 0, _ref3, _jsx('td', {}, void 0, booking.passengerID)), booking.driverID && _jsx('tr', {}, void 0, _ref4, _jsx('td', {}, void 0, booking.driverID)), booking.taxiTypeName && _jsx('tr', {}, void 0, _ref5, _jsx('td', {}, void 0, booking.taxiTypeName)))));
	    }
	  }]);
	
	  return BookingDetailsPanel;
	}(_react.Component)) || _class);
	exports.default = BookingDetailsPanel;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAutobind = __webpack_require__(77);
	
	var _reactAutobind2 = _interopRequireDefault(_reactAutobind);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _immutable = __webpack_require__(22);
	
	var _mapUtils = __webpack_require__(74);
	
	var _cohortUtils = __webpack_require__(52);
	
	var _libraryUtils = __webpack_require__(36);
	
	var _WithEscapeToDismiss = __webpack_require__(34);
	
	var _WithEscapeToDismiss2 = _interopRequireDefault(_WithEscapeToDismiss);
	
	var _InputLocation = __webpack_require__(198);
	
	var _InputLocation2 = _interopRequireDefault(_InputLocation);
	
	var _ErrorNotification = __webpack_require__(20);
	
	var _ErrorNotification2 = _interopRequireDefault(_ErrorNotification);
	
	__webpack_require__(522);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('label', {
	  className: 'label',
	  htmlFor: 'pick-up-location'
	}, void 0, 'Pick Up');
	
	var _ref2 = _jsx('span', {}, void 0, 'Drop Off');
	
	var _ref3 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-plus'
	}));
	
	var _ref4 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-minus'
	}));
	
	var _ref5 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'taxi-type-id'
	}, void 0, 'Taxi Type ID');
	
	var _ref6 = _jsx('option', {
	  value: ''
	}, void 0, 'Select a Taxi Type');
	
	var _ref7 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'remarks'
	}, void 0, 'Remarks');
	
	var _ref8 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'promo-or-reward'
	}, void 0, 'Promo/Reward');
	
	var _ref9 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'paymentType'
	}, void 0, 'Pay By');
	
	var _ref10 = _jsx('label', {
	  className: 'label',
	  htmlFor: true
	}, void 0, '\xA0');
	
	var _ref11 = _jsx('br', {});
	
	var CreateBookingPanel = (_dec = (0, _WithEscapeToDismiss2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(CreateBookingPanel, _Component);
	
	  function CreateBookingPanel(props) {
	    _classCallCheck(this, CreateBookingPanel);
	
	    var _this = _possibleConstructorReturn(this, (CreateBookingPanel.__proto__ || Object.getPrototypeOf(CreateBookingPanel)).call(this, props));
	
	    _this.state = { pickUpValid: true, dropOffValid: true, extraDropOffValids: [], remarks: '' };
	    (0, _reactAutobind2.default)(_this);
	    return _this;
	  }
	
	  _createClass(CreateBookingPanel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.onShow();
	      this.taxiTypeID.focus();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextState) {
	      // Set the pick up/drop off location as valid if the location was changed.
	      if (this.props.activePassengerBooking != null && nextState.activePassengerBooking != null) {
	        var currentBooking = this.props.activePassengerBooking;
	        var nextBooking = nextState.activePassengerBooking;
	
	        if (!_lodash2.default.isEqual(currentBooking.pickUpLocation, nextBooking.pickUpLocation)) {
	          this.setState({ pickUpValid: true });
	        }
	
	        if (!_lodash2.default.isEqual(currentBooking.dropOffLocation, nextBooking.dropOffLocation)) {
	          this.setState({ dropOffValid: true });
	        }
	
	        // when the first element of extraDropOffLocations is empty,
	        // it is a brand new booking
	        if (_lodash2.default.isEmpty(nextBooking.extraDropOffLocations[0])) {
	          this.setState({ extraDropOffValids: [] });
	          this.pushDropOffBtn.removeAttribute('disabled');
	          this.popDropOffBtn.setAttribute('disabled', true);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onHide();
	    }
	  }, {
	    key: 'pushDropOff',
	    value: function pushDropOff(paxBkg) {
	      var _this2 = this;
	
	      return function () {
	        if (_this2.state.extraDropOffValids.length === 1) {
	          return;
	        }
	
	        _this2.setState(function (curState) {
	          return {
	            extraDropOffValids: _lodash2.default.concat(curState.extraDropOffValids, true)
	          };
	        });
	
	        var location = [(0, _mapUtils.roundCoordinate)(paxBkg.pickUpLocation[0] + 0.01), (0, _mapUtils.roundCoordinate)(paxBkg.pickUpLocation[1] + 0.01)];
	
	        var _props = _this2.props,
	            onUpdate = _props.onUpdate,
	            getPOI = _props.getPOI;
	
	
	        onUpdate(_extends({}, paxBkg, {
	          extraDropOffLocations: [location]
	        }));
	        getPOI(location);
	
	        _this2.pushDropOffBtn.setAttribute('disabled', true);
	        _this2.popDropOffBtn.removeAttribute('disabled');
	      };
	    }
	  }, {
	    key: 'popDropOff',
	    value: function popDropOff(paxBkg) {
	      var _this3 = this;
	
	      return function () {
	        if (_this3.state.extraDropOffValids.length === 0) {
	          return;
	        }
	
	        _this3.setState(function (curState) {
	          return {
	            extraDropOffValids: _lodash2.default.dropRight(curState.extraDropOffValids)
	          };
	        });
	
	        _this3.props.onUpdate(_extends({}, paxBkg, {
	          extraDropOffLocations: [[]]
	        }));
	
	        _this3.pushDropOffBtn.removeAttribute('disabled');
	        _this3.popDropOffBtn.setAttribute('disabled', true);
	      };
	    }
	  }, {
	    key: 'createTaxiTypeOptions',
	    value: function createTaxiTypeOptions() {
	      return _lodash2.default.map(this.props.nearbyTaxiTypes || [], function (category) {
	        return _jsx('optgroup', {
	          label: category.group
	        }, category.group, _lodash2.default.map(category.nearbyTaxiTypes, function (taxiType) {
	          return _jsx('option', {
	            value: taxiType.id
	          }, taxiType.id, taxiType.name);
	        }));
	      });
	    }
	  }, {
	    key: 'renderPOI',
	    value: function renderPOI(location, extraDrop) {
	      var pointOfInterests = this.props.pointOfInterests;
	
	      var key = (0, _immutable.List)(location);
	      if (pointOfInterests && pointOfInterests.has(key)) {
	        return _jsx('p', {
	          className: (0, _classnames2.default)('help', 'is-success', {
	            'extra-drop-off': extraDrop
	          })
	        }, void 0, pointOfInterests.get(key));
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var activePassengerBooking = this.props.activePassengerBooking || {};
	      return _jsx('div', {
	        className: 'create-booking-panel'
	      }, void 0, _jsx('button', {
	        'aria-label': 'Close',
	        className: 'is-pulled-right delete',
	        onClick: function onClick() {
	          _this4.props.handleClose();
	        }
	      }), _jsx('h3', {
	        className: 'title is-5'
	      }, void 0, 'Create booking - Passenger ID: ', activePassengerBooking.passengerID), _jsx('form', {
	        onSubmit: function onSubmit(event) {
	          event.preventDefault();
	          var bookingRequest = {
	            taxiTypeID: activePassengerBooking.taxiTypeID,
	            paymentType: activePassengerBooking.paymentType,
	            remarks: _this4.state.remarks,
	            pickUpLongitude: activePassengerBooking.pickUpLocation[0],
	            pickUpLatitude: activePassengerBooking.pickUpLocation[1],
	            dropOffLongitude: activePassengerBooking.dropOffLocation[0],
	            dropOffLatitude: activePassengerBooking.dropOffLocation[1],
	            extraDropOffs: activePassengerBooking.extraDropOffLocations
	          };
	          if (activePassengerBooking.rewardValue) {
	            bookingRequest[activePassengerBooking.rewardType] = activePassengerBooking.rewardValue;
	          }
	          _this4.props.onCreate(bookingRequest);
	        }
	      }, void 0, _jsx('div', {
	        className: 'columns is-multiline is-mobile'
	      }, void 0, _jsx('div', {
	        className: 'column is-one-third'
	      }, void 0, _ref, _react2.default.createElement(_InputLocation2.default, {
	        name: 'pick-up-location',
	        className: (0, _classnames2.default)({
	          'is-danger': !this.state.pickUpValid
	        }),
	        value: activePassengerBooking.pickUpLocation,
	        ref: function ref(value) {
	          _this4.pickUp = value;
	        },
	        onBeforeChange: function onBeforeChange() {
	          _this4.setState({ pickUpValid: _this4.pickUp.isValid() });
	        },
	        onChange: function onChange(value) {
	          _this4.props.onUpdate(_extends({}, activePassengerBooking, {
	            pickUpLocation: value
	          }));
	        }
	      }), this.renderPOI(activePassengerBooking.pickUpLocation, false)), _jsx('div', {
	        className: 'column is-one-third'
	      }, void 0, _jsx('label', {
	        className: 'label',
	        htmlFor: 'drop-off-location'
	      }, void 0, _ref2, _jsx('div', {
	        className: 'is-pulled-right'
	      }, void 0, _react2.default.createElement(
	        'a',
	        {
	          className: 'button is-primary is-small gap',
	          title: 'Add Extra Dropoff', 'aria-label': 'Add Extra Dropoff',
	          ref: function ref(value) {
	            _this4.pushDropOffBtn = value;
	          },
	          onClick: this.pushDropOff(activePassengerBooking)
	        },
	        _ref3
	      ), _react2.default.createElement(
	        'a',
	        {
	          className: 'button is-primary is-small',
	          title: 'Remove Extra Dropoff', 'aria-label': 'Remove Extra Dropoff',
	          ref: function ref(value) {
	            _this4.popDropOffBtn = value;
	          },
	          onClick: this.popDropOff(activePassengerBooking),
	          disabled: true
	        },
	        _ref4
	      ))), _react2.default.createElement(_InputLocation2.default, {
	        name: 'extra-drop-off-location-1',
	        className: (0, _classnames2.default)({
	          'is-danger': !this.state.extraDropOffValids[0],
	          'is-hidden': this.state.extraDropOffValids.length === 0
	        }),
	        value: activePassengerBooking.extraDropOffLocations[0],
	        ref: function ref(value) {
	          _this4.xdropOff = value;
	        },
	        onBeforeChange: function onBeforeChange() {
	          _this4.setState(function (curState) {
	            var extraDropOffValids = _lodash2.default.slice(curState.extraDropOffValids);
	            extraDropOffValids[0] = _this4.xdropOff.isValid();
	
	            return {
	              extraDropOffValids: extraDropOffValids
	            };
	          });
	        },
	        onChange: function onChange(value) {
	          var extraDropOffLocations = _lodash2.default.slice(activePassengerBooking.extraDropOffLocations);
	          extraDropOffLocations[0] = value;
	          _this4.props.onUpdate(_extends({}, activePassengerBooking, {
	            extraDropOffLocations: extraDropOffLocations
	          }));
	        }
	      }), this.state.extraDropOffValids.length > 0 && this.renderPOI(activePassengerBooking.extraDropOffLocations[0], true), _react2.default.createElement(_InputLocation2.default, {
	        name: 'drop-off-location',
	        className: (0, _classnames2.default)({
	          'is-danger': !this.state.dropOffValid
	        }),
	        value: activePassengerBooking.dropOffLocation,
	        ref: function ref(value) {
	          _this4.dropOff = value;
	        },
	        onBeforeChange: function onBeforeChange() {
	          _this4.setState({ dropOffValid: _this4.dropOff.isValid() });
	        },
	        onChange: function onChange(value) {
	          _this4.props.onUpdate(_extends({}, activePassengerBooking, {
	            dropOffLocation: value
	          }));
	        }
	      }), this.renderPOI(activePassengerBooking.dropOffLocation, false)), _jsx('div', {
	        className: 'column is-one-third'
	      }, void 0, _ref5, _jsx('div', {
	        className: 'control'
	      }, void 0, _jsx('div', {
	        className: (0, _classnames2.default)('select', {
	          'is-loading': this.props.isGetTaxiTypesPending
	        })
	      }, void 0, _react2.default.createElement(
	        'select',
	        {
	          className: 'is-focused',
	          name: 'taxi-type-id',
	          onChange: function onChange(event) {
	            _this4.props.onUpdate(_extends({}, activePassengerBooking, {
	              taxiTypeID: event.target.value
	            }));
	          },
	          value: activePassengerBooking.taxiTypeID,
	          ref: function ref(input) {
	            _this4.taxiTypeID = input;
	          }
	        },
	        _ref6,
	        this.createTaxiTypeOptions()
	      )))), _jsx('div', {
	        className: 'column is-one-third'
	      }, void 0, _ref7, _jsx('div', {
	        className: 'field'
	      }, void 0, _jsx('div', {
	        className: 'control'
	      }, void 0, _jsx('textarea', {
	        name: 'remarks',
	        className: 'textarea',
	        rows: '3',
	        value: this.state.remarks,
	        onChange: function onChange(event) {
	          _this4.setState({
	            remarks: event.target.value
	          });
	        }
	      })))), _jsx('div', {
	        className: 'column is-one-third'
	      }, void 0, _ref8, _jsx('div', {
	        className: 'field has-addons'
	      }, void 0, _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx('span', {
	        className: 'select'
	      }, void 0, _react2.default.createElement(
	        'select',
	        {
	          name: 'promo-or-reward',
	          onChange: function onChange(event) {
	            _this4.props.onUpdate(_extends({}, activePassengerBooking, {
	              rewardType: event.target.value,
	              rewardValue: ''
	            }));
	          },
	          value: activePassengerBooking.rewardType,
	          ref: function ref(value) {
	            _this4.rewardType = value;
	          }
	        },
	        _libraryUtils.REWARD_TYPES.map(function (reward) {
	          return _jsx('option', {
	            value: reward.name
	          }, reward.name, reward.display);
	        })
	      ))), _jsx('p', {
	        className: 'control'
	      }, void 0, _react2.default.createElement('input', {
	        className: 'input',
	        onChange: function onChange(event) {
	          _this4.props.onUpdate(_extends({}, activePassengerBooking, {
	            rewardValue: event.target.value
	          }));
	        },
	        value: activePassengerBooking.rewardValue,
	        ref: function ref(input) {
	          _this4.rewardValue = input;
	        }
	      })))), _jsx('div', {
	        className: 'column is-one-third'
	      }, void 0, _jsx('div', {
	        className: 'columns'
	      }, void 0, _jsx('div', {
	        className: 'column is-half'
	      }, void 0, _ref9, _jsx('span', {
	        className: 'select'
	      }, void 0, _react2.default.createElement(
	        'select',
	        {
	          name: 'paymentType',
	          onChange: function onChange(event) {
	            _this4.props.onUpdate(_extends({}, activePassengerBooking, {
	              paymentType: event.target.value
	            }));
	          },
	          value: activePassengerBooking.paymentType,
	          ref: function ref(value) {
	            _this4.paymentType = value;
	          }
	        },
	        _libraryUtils.PAYMENT_TYPES.map(function (payment) {
	          return _jsx('option', {
	            value: payment.name
	          }, payment.name, payment.display);
	        })
	      ))), _jsx('div', {
	        className: 'column is-half'
	      }, void 0, _ref10, _jsx('div', {
	        className: 'control is-grouped'
	      }, void 0, _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx('button', {
	        type: 'submit',
	        className: (0, _classnames2.default)('button is-info', {
	          'is-loading': this.props.isLoading,
	          'is-disabled': this.props.isLoading
	        })
	      }, void 0, 'Book')))))))), _ref11, !_lodash2.default.isEmpty(this.props.errors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.errors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this4.props.clearError();
	        }
	      }), this.props.successBookingID && _jsx('div', {
	        className: 'notification is-success',
	        role: 'alert'
	      }, void 0, _jsx('p', {}, void 0, 'Booking', ' ', _jsx('a', {
	        href: (0, _cohortUtils.entityURLForCohort)() + '/bookings/' + String(this.props.successBookingID),
	        target: '_blank',
	        rel: 'noopener noreferrer'
	      }, void 0, this.props.successBookingID), ' has been created.')));
	    }
	  }]);
	
	  return CreateBookingPanel;
	}(_react.Component), _class2.defaultProps = {
	  activePassengerBooking: null
	}, _temp)) || _class);
	exports.default = CreateBookingPanel;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(21);
	
	var _reactDocumentTitle = __webpack_require__(27);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CohortTable = function CohortTable(_ref) {
	  var headers = _ref.headers,
	      cohorts = _ref.cohorts;
	  return _jsx('table', {
	    className: 'table is-striped'
	  }, void 0, _jsx(TableHeader, {
	    columnNames: headers
	  }), _jsx(TableBody, {
	    data: cohorts
	  }));
	};
	
	var TableHeader = function TableHeader(_ref2) {
	  var columnNames = _ref2.columnNames;
	  return _jsx('thead', {}, void 0, _jsx('tr', {}, void 0, _lodash2.default.map(columnNames, function (name) {
	    return _jsx('th', {}, name, name);
	  })));
	};
	
	var TableBody = function TableBody(_ref3) {
	  var data = _ref3.data;
	  return _jsx('tbody', {}, void 0, _lodash2.default.map(data, function (cohort, idx) {
	    return _jsx('tr', {}, idx, _jsx('th', {}, void 0, idx + 1), _jsx('td', {}, void 0, _jsx(_reactRouter.Link, {
	      to: '/cohorts/' + cohort.cohortID
	    }, void 0, cohort.cohortID)), _jsx('td', {}, void 0, cohort.name || cohort.cohortID), _jsx('td', {}, void 0, cohort.ownerID), _jsx('td', {}, void 0, new Date(cohort.createdAt).toLocaleString()));
	  }));
	};
	
	var CohortDashboard = function (_Component) {
	  _inherits(CohortDashboard, _Component);
	
	  function CohortDashboard(props) {
	    _classCallCheck(this, CohortDashboard);
	
	    var _this = _possibleConstructorReturn(this, (CohortDashboard.__proto__ || Object.getPrototypeOf(CohortDashboard)).call(this, props));
	
	    _this.fetchCohorts = function (lastOffset, initial) {
	      _this.props.getCohorts(10, lastOffset, initial);
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CohortDashboard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchCohorts('', true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _jsx(_reactDocumentTitle2.default, {
	        title: 'Marionette'
	      }, void 0, _jsx('section', {
	        className: 'section'
	      }, void 0, _jsx('div', {
	        className: 'container'
	      }, void 0, _jsx(CohortTable, {
	        headers: ['No.', 'ID', 'NAME', 'OWNER ID', 'Creation Time'],
	        cohorts: this.props.cohorts
	      }), _jsx('a', {
	        onClick: function onClick() {
	          return _this2.fetchCohorts(_this2.props.lastOffset, false);
	        },
	        className: (0, _classnames2.default)('button is-primary', {
	          'is-hidden': !this.props.lastOffset
	        })
	      }, void 0, 'Load more'))));
	    }
	  }]);
	
	  return CohortDashboard;
	}(_react.Component);
	
	exports.default = CohortDashboard;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DriverEditModal = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(11);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _cohorts = __webpack_require__(30);
	
	var _WithEscapeToDismiss = __webpack_require__(34);
	
	var _WithEscapeToDismiss2 = _interopRequireDefault(_WithEscapeToDismiss);
	
	var _DriverForm = __webpack_require__(125);
	
	var _DriverForm2 = _interopRequireDefault(_DriverForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('h1', {
	  className: 'title'
	}, void 0, 'Edit Driver');
	
	var _ref2 = _jsx('hr', {});
	
	var _ref3 = _jsx('hr', {});
	
	var DriverEditModal = exports.DriverEditModal = (_dec = (0, _WithEscapeToDismiss2.default)(), _dec(_class = function (_Component) {
	  _inherits(DriverEditModal, _Component);
	
	  function DriverEditModal() {
	    _classCallCheck(this, DriverEditModal);
	
	    return _possibleConstructorReturn(this, (DriverEditModal.__proto__ || Object.getPrototypeOf(DriverEditModal)).apply(this, arguments));
	  }
	
	  _createClass(DriverEditModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _jsx('div', {
	        className: (0, _classnames2.default)('modal', {
	          'is-active': this.props.showModal
	        }),
	        role: 'dialog'
	      }, void 0, _jsx('div', {
	        className: 'modal-background',
	        onClick: function onClick() {
	          _this2.props.handleClose();
	        }
	      }), _jsx('div', {
	        className: 'modal-content'
	      }, void 0, _jsx('div', {
	        className: 'modal-box'
	      }, void 0, _jsx('button', {
	        'aria-label': 'Close modal',
	        className: 'is-pulled-right delete',
	        onClick: function onClick() {
	          _this2.props.handleClose();
	        }
	      }), _ref, _ref2, _react2.default.createElement(_DriverForm2.default, {
	        defaultValue: this.props.driver,
	        disableLoginFields: true,
	        ref: function ref(input) {
	          _this2.form = input;
	        }
	      }), _ref3, _jsx('div', {
	        className: 'field is-grouped has-text-right'
	      }, void 0, _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx('button', {
	        className: 'button is-outlined',
	        onClick: function onClick() {
	          _this2.props.handleClose();
	        }
	      }, void 0, 'Cancel')), _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx('button', {
	        className: 'button is-primary',
	        onClick: function onClick() {
	          var driver = _this2.form.getValue();
	          _this2.props.cohortDriverUpdate(_this2.props.cohortID, _this2.props.driverID, driver);
	          _this2.props.handleClose();
	        }
	      }, void 0, 'Update'))))));
	    }
	  }]);
	
	  return DriverEditModal;
	}(_react.Component)) || _class);
	
	
	DriverEditModal.contextTypes = {
	  router: _react.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state, ownProps) {
	  return {
	    driver: state.cohorts[ownProps.cohortID].drivers[ownProps.driverID]
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  cohortDriverUpdate: _cohorts.cohortDriverUpdate
	})(DriverEditModal);

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _WithEscapeToDismiss = __webpack_require__(34);
	
	var _WithEscapeToDismiss2 = _interopRequireDefault(_WithEscapeToDismiss);
	
	var _ErrorNotification = __webpack_require__(20);
	
	var _ErrorNotification2 = _interopRequireDefault(_ErrorNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('hr', {});
	
	var _ref2 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'taxi-type-id'
	}, void 0, 'Fare');
	
	var _ref3 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'taxi-type-id'
	}, void 0, 'Booking Fee');
	
	var _ref4 = _jsx('label', {
	  className: 'label',
	  htmlFor: 'taxi-type-id'
	}, void 0, 'Other Fees');
	
	var _ref5 = _jsx('label', {
	  className: 'label',
	  htmlFor: true
	}, void 0, '\xA0');
	
	var _ref6 = _jsx('br', {});
	
	var DriverFareModal = (_dec = (0, _WithEscapeToDismiss2.default)(), _dec(_class = function (_Component) {
	  _inherits(DriverFareModal, _Component);
	
	  function DriverFareModal(props) {
	    _classCallCheck(this, DriverFareModal);
	
	    var _this = _possibleConstructorReturn(this, (DriverFareModal.__proto__ || Object.getPrototypeOf(DriverFareModal)).call(this, props));
	
	    _this.state = {
	      fare: 10,
	      bookingFee: 5,
	      otherFees: 0
	    };
	    return _this;
	  }
	
	  _createClass(DriverFareModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.resetErrorState('driverBookingDropOff');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _jsx('div', {
	        className: (0, _classnames2.default)('modal', {
	          'is-active': this.props.showModal
	        }),
	        role: 'dialog'
	      }, void 0, _jsx('div', {
	        className: 'modal-background',
	        onClick: function onClick() {
	          _this2.props.handleClose();
	        }
	      }), _jsx('div', {
	        className: 'modal-content'
	      }, void 0, _jsx('div', {
	        className: 'modal-box'
	      }, void 0, _jsx('button', {
	        'aria-label': 'Close modal',
	        className: 'is-pulled-right delete',
	        onClick: function onClick() {
	          _this2.props.handleClose();
	        }
	      }), _jsx('h3', {
	        className: 'title is-5'
	      }, void 0, this.props.bookingID), _ref, _jsx('form', {
	        onSubmit: function onSubmit(event) {
	          event.preventDefault();
	          _this2.props.driverBookingDropOff(_this2.props.driverID, _this2.props.bookingID, parseFloat(_this2.state.fare), parseFloat(_this2.state.bookingFee), parseFloat(_this2.state.otherFees));
	        }
	      }, void 0, _jsx('div', {
	        className: 'columns'
	      }, void 0, _jsx('div', {
	        className: 'column is-3'
	      }, void 0, _ref2, _jsx('input', {
	        className: 'input',
	        name: 'fare',
	        value: this.state.fare,
	        onChange: function onChange(event) {
	          _this2.setState({
	            fare: event.target.value
	          });
	        }
	      })), _jsx('div', {
	        className: 'column is-3'
	      }, void 0, _ref3, _jsx('input', {
	        className: 'input',
	        name: 'booking-fee',
	        value: this.state.bookingFee,
	        onChange: function onChange(event) {
	          _this2.setState({
	            bookingFee: event.target.value
	          });
	        }
	      })), _jsx('div', {
	        className: 'column is-3'
	      }, void 0, _ref4, _jsx('input', {
	        className: 'input',
	        name: 'other-fees',
	        value: this.state.otherFees,
	        onChange: function onChange(event) {
	          _this2.setState({
	            otherFees: event.target.value
	          });
	        }
	      })), _jsx('div', {
	        className: 'column is-3'
	      }, void 0, _ref5, _jsx('div', {
	        className: 'control is-grouped'
	      }, void 0, _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx('button', {
	        type: 'submit',
	        className: (0, _classnames2.default)('button is-info', {
	          'is-loading': this.props.driverBookingDropOffRequest.isPending,
	          'is-disabled': this.props.driverBookingDropOffRequest.isPending
	        })
	      }, void 0, 'Submit')))))), _ref6, !_lodash2.default.isEmpty(this.props.driverBookingDropOffErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.driverBookingDropOffErrors
	      }))));
	    }
	  }]);
	
	  return DriverFareModal;
	}(_react.Component)) || _class);
	exports.default = DriverFareModal;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _WithEscapeToDismiss = __webpack_require__(34);
	
	var _WithEscapeToDismiss2 = _interopRequireDefault(_WithEscapeToDismiss);
	
	var _googleMaps = __webpack_require__(573);
	
	var _googleMaps2 = _interopRequireDefault(_googleMaps);
	
	var _config = __webpack_require__(32);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('hr', {});
	
	var _ref2 = _jsx('label', {
	  className: 'label sr-only',
	  htmlFor: 'address'
	}, void 0, 'Search address in Google');
	
	var _ref3 = _jsx('hr', {});
	
	var DriverLocationModal = (_dec = (0, _WithEscapeToDismiss2.default)(), _dec(_class = function (_Component) {
	  _inherits(DriverLocationModal, _Component);
	
	  function DriverLocationModal(props) {
	    _classCallCheck(this, DriverLocationModal);
	
	    var _this = _possibleConstructorReturn(this, (DriverLocationModal.__proto__ || Object.getPrototypeOf(DriverLocationModal)).call(this, props));
	
	    _this.state = {
	      googleMapInitialized: false,
	      location: null
	    };
	    return _this;
	  }
	
	  _createClass(DriverLocationModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (window.google && window.google.maps) {
	        // Google maps has been included before; Initialize straightaway.
	        this.initializeMap();
	      } else {
	        window.initializeMap = this.initializeMap.bind(this);
	        (0, _googleMaps2.default)(_config2.default.GOOGLE_API_BROWSER_KEY, 'initializeMap');
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.initializeMap = null;
	    }
	  }, {
	    key: 'initializeMap',
	    value: function initializeMap() {
	      var _this2 = this;
	
	      this.geocoder = new window.google.maps.Geocoder();
	      this.setState({
	        googleMapInitialized: true
	      });
	
	      var locationInput = this.locationInput;
	      var searchBox = new window.google.maps.places.SearchBox(locationInput);
	      searchBox.addListener('places_changed', function () {
	        var places = searchBox.getPlaces();
	        if (places.length === 0) {
	          return;
	        }
	
	        var location = places[0].geometry.location;
	        _this2.setState({
	          location: [location.lng(), location.lat()]
	        });
	      });
	
	      locationInput.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var address = this.locationInput ? this.locationInput.value : '';
	      return _jsx('div', {
	        className: (0, _classnames2.default)('modal', {
	          'is-active': this.props.showModal
	        }),
	        role: 'dialog'
	      }, void 0, _jsx('div', {
	        className: 'modal-background',
	        onClick: function onClick() {
	          _this3.props.handleClose();
	        }
	      }), _jsx('div', {
	        className: 'modal-content'
	      }, void 0, _jsx('div', {
	        className: 'modal-box'
	      }, void 0, _jsx('button', {
	        'aria-label': 'Close modal',
	        className: 'is-pulled-right delete',
	        onClick: function onClick() {
	          _this3.props.handleClose();
	        }
	      }), _jsx('h3', {
	        className: 'title is-5'
	      }, void 0, 'Set location for Driver ', this.props.driverID), _ref, _jsx('div', {
	        className: 'field'
	      }, void 0, _jsx('p', {
	        className: 'control'
	      }, void 0, _ref2, _react2.default.createElement('input', {
	        id: 'address',
	        className: 'input',
	        type: 'text',
	        placeholder: 'Search address in Google',
	        ref: function ref(locationInput) {
	          _this3.locationInput = locationInput;
	        }
	      }))), _ref3, _jsx('div', {
	        className: 'field is-grouped has-text-right'
	      }, void 0, _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx('button', {
	        className: 'button is-outlined',
	        onClick: function onClick() {
	          _this3.props.handleClose();
	        }
	      }, void 0, 'Cancel')), _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx('button', {
	        className: 'button is-primary',
	        'aria-label': 'Set driver to address: ' + address,
	        onClick: function onClick() {
	          _this3.props.driverSetLocation(_this3.props.cohortID, _this3.props.driverID, _this3.state.location);
	          _this3.props.handleClose();
	        }
	      }, void 0, 'Set Driver Location'))))));
	    }
	  }]);
	
	  return DriverLocationModal;
	}(_react.Component)) || _class);
	exports.default = DriverLocationModal;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _libraryUtils = __webpack_require__(36);
	
	var _WithEscapeToDismiss = __webpack_require__(34);
	
	var _WithEscapeToDismiss2 = _interopRequireDefault(_WithEscapeToDismiss);
	
	var _ErrorNotification = __webpack_require__(20);
	
	var _ErrorNotification2 = _interopRequireDefault(_ErrorNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('h3', {
	  className: 'title is-5'
	}, void 0, 'Associate Drivers');
	
	var _ref2 = _jsx('thead', {}, void 0, _jsx('tr', {}, void 0, _jsx('th', {}, void 0, 'Gamma ID'), _jsx('th', {}, void 0, 'Name'), _jsx('th', {}, void 0, 'Behaviour'), _jsx('th', {}, void 0, 'Actions')));
	
	var _ref3 = _jsx('tr', {}, void 0, _jsx('td', {
	  colSpan: 999,
	  className: 'has-text-centered'
	}, void 0, 'No drivers added.'));
	
	var DriversModal = (_dec = (0, _WithEscapeToDismiss2.default)(), _dec(_class = function (_Component) {
	  _inherits(DriversModal, _Component);
	
	  function DriversModal() {
	    _classCallCheck(this, DriversModal);
	
	    return _possibleConstructorReturn(this, (DriversModal.__proto__ || Object.getPrototypeOf(DriversModal)).apply(this, arguments));
	  }
	
	  _createClass(DriversModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.resetErrorState('cohortDriverAssociate');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _jsx('div', {
	        className: (0, _classnames2.default)('modal', {
	          'is-active': this.props.isDriversModalActive
	        }),
	        role: 'dialog'
	      }, void 0, _jsx('div', {
	        className: 'modal-background',
	        onClick: function onClick() {
	          _this2.props.handleClose();
	        }
	      }), _jsx('div', {
	        className: 'modal-content'
	      }, void 0, _jsx('div', {
	        className: 'modal-box'
	      }, void 0, _jsx('button', {
	        'aria-label': 'Close modal',
	        className: 'is-pulled-right delete',
	        onClick: function onClick() {
	          _this2.props.handleClose();
	        }
	      }), _ref, _jsx('table', {
	        className: 'table is-bordered is-striped'
	      }, void 0, _ref2, _jsx('tbody', {}, void 0, Object.keys(this.props.drivers).map(function (cohortDriverID) {
	        var driver = _this2.props.drivers[cohortDriverID];
	        return _jsx('tr', {}, cohortDriverID, _jsx('td', {}, void 0, cohortDriverID), _jsx('td', {}, void 0, driver.name || '-'), _jsx('td', {}, void 0, _libraryUtils.DRIVER_BEHAVIOURS_NAMES[_lodash2.default.get(driver, 'behaviour.type')]), _jsx('td', {}, void 0, _jsx('div', {
	          className: 'control is-grouped'
	        }, void 0, _jsx('p', {
	          className: 'control'
	        }, void 0, _jsx('button', {
	          className: (0, _classnames2.default)('button is-small is-outlined is-info', {
	            'is-disabled': _this2.props.cohortDriverAssociateRequest.isPending
	          }),
	          onClick: function onClick() {
	            _this2.props.cohortDriverAssociate(_this2.props.activeCohortID, _lodash2.default.cloneDeep(driver));
	          }
	        }, void 0, 'Associate')))));
	      }), _lodash2.default.isEmpty(this.props.drivers) && _ref3)), !_lodash2.default.isEmpty(this.props.cohortDriverAssociateErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.cohortDriverAssociateErrors
	      }))));
	    }
	  }]);
	
	  return DriversModal;
	}(_react.Component)) || _class);
	exports.default = DriversModal;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DriversPanel = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(11);
	
	var _cohorts = __webpack_require__(30);
	
	var _drivers = __webpack_require__(58);
	
	var _app = __webpack_require__(26);
	
	var _helpers = __webpack_require__(51);
	
	var _libraryUtils = __webpack_require__(36);
	
	var _cohortUtils = __webpack_require__(52);
	
	var _bookingUtils = __webpack_require__(73);
	
	var _cohorts2 = __webpack_require__(201);
	
	var _reactToggle = __webpack_require__(140);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _reactMultiToggle = __webpack_require__(686);
	
	var _reactMultiToggle2 = _interopRequireDefault(_reactMultiToggle);
	
	var _ErrorNotification = __webpack_require__(20);
	
	var _ErrorNotification2 = _interopRequireDefault(_ErrorNotification);
	
	var _PowerButton = __webpack_require__(197);
	
	var _PowerButton2 = _interopRequireDefault(_PowerButton);
	
	var _DriversModal = __webpack_require__(596);
	
	var _DriversModal2 = _interopRequireDefault(_DriversModal);
	
	var _DriverEditModal = __webpack_require__(593);
	
	var _DriverEditModal2 = _interopRequireDefault(_DriverEditModal);
	
	var _DriverFareModal = __webpack_require__(594);
	
	var _DriverFareModal2 = _interopRequireDefault(_DriverFareModal);
	
	var _DriverLocationModal = __webpack_require__(595);
	
	var _DriverLocationModal2 = _interopRequireDefault(_DriverLocationModal);
	
	__webpack_require__(523);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var requestErrors = ['cohortDriverAssociate', 'driverLogin', 'driverLogout', 'driverDelete', 'driverSetAvailability', 'driverSetAutoAccept', 'driverBookingBid', 'driverBookingCancel', 'driverBookingPickUp', 'driverBookingAdditionalDropOff', 'driverBookingDropOff'];
	
	var autoAcceptValues = [{
	  displayName: 'On',
	  value: 1
	}, {
	  displayName: 'NA',
	  value: -1
	}, {
	  displayName: 'Off',
	  value: 0
	}];
	
	var _ref = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-plus'
	}));
	
	var _ref2 = _jsx('span', {
	  className: 'sr-only'
	}, void 0, 'Driver availability');
	
	var _ref3 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-crosshairs'
	}));
	
	var _ref4 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-map-marker'
	}));
	
	var _ref5 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-pencil'
	}));
	
	var _ref6 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-trash'
	}));
	
	var _ref7 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-external-link'
	}));
	
	var _ref8 = _jsx('span', {
	  className: 'sr-only'
	}, void 0, 'Driver auto-accept');
	
	var _ref9 = _jsx('span', {
	  className: 'icon is-small'
	}, void 0, _jsx('i', {
	  className: 'fa fa-trash',
	  title: 'Remove booking'
	}));
	
	var _ref10 = _jsx('li', {
	  className: 'entity-row'
	}, void 0, 'No drivers associated to this cohort.');
	
	var DriversPanel = exports.DriversPanel = function (_Component) {
	  _inherits(DriversPanel, _Component);
	
	  function DriversPanel(props) {
	    _classCallCheck(this, DriversPanel);
	
	    var _this = _possibleConstructorReturn(this, (DriversPanel.__proto__ || Object.getPrototypeOf(DriversPanel)).call(this, props));
	
	    _this.state = {
	      isCollapsed: false
	    };
	    return _this;
	  }
	
	  _createClass(DriversPanel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.resetErrorState(requestErrors);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var numDrivers = Object.keys(this.props.drivers).length;
	      return _jsx('div', {
	        className: 'entity-panel'
	      }, void 0, _jsx('button', {
	        className: 'button is-primary is-small is-pulled-right entity-add-button',
	        title: 'Associate driver to cohort',
	        'aria-label': 'Associate driver to cohort',
	        onClick: function onClick(event) {
	          event.stopPropagation();
	          _this2.props.showDriversModal(true);
	        }
	      }, void 0, _ref), _jsx('h3', {
	        className: 'title section-title is-6 entity-panel-title'
	      }, void 0, _jsx('button', {
	        onClick: function onClick() {
	          _this2.setState({
	            isCollapsed: !_this2.state.isCollapsed
	          });
	        }
	      }, void 0, _jsx('span', {
	        className: 'icon is-small'
	      }, void 0, _jsx('i', {
	        className: (0, _classnames2.default)('fa fa-fw', {
	          'fa-chevron-down': !this.state.isCollapsed,
	          'fa-chevron-right': this.state.isCollapsed
	        })
	      })), ' ', 'Drivers ', !!numDrivers && '(' + numDrivers + ')')), this.props.isDriversModalActive && _react2.default.createElement(_DriversModal2.default, _extends({}, this.props, {
	        handleClose: function handleClose() {
	          _this2.props.showDriversModal(false);
	        },
	        drivers: this.props.libraryDrivers
	      })), !!this.props.driverBeingEdited && _jsx(_DriverEditModal2.default, {
	        cohortID: this.props.activeCohortID,
	        driverID: this.props.driverBeingEdited,
	        handleClose: function handleClose() {
	          _this2.props.showDriverEditModal(null);
	        },
	        showModal: !!this.props.driverBeingEdited
	      }), !!this.props.driverLocationBeingEdited && _jsx(_DriverLocationModal2.default, {
	        cohortID: this.props.activeCohortID,
	        driverID: this.props.driverLocationBeingEdited,
	        driverSetLocation: this.props.driverSetLocation,
	        handleClose: function handleClose() {
	          _this2.props.showDriverLocationModal(null);
	        },
	        showModal: !!this.props.driverLocationBeingEdited
	      }), !!this.props.driverCompletingBooking && _jsx(_DriverFareModal2.default, {
	        driverID: this.props.driverCompletingBooking.driverID,
	        bookingID: this.props.driverCompletingBooking.bookingID,
	        handleClose: function handleClose() {
	          _this2.props.closeDriverFareModal();
	        },
	        showModal: !!this.props.driverCompletingBooking,
	        resetErrorState: this.props.resetErrorState,
	        driverBookingDropOff: this.props.driverBookingDropOff,
	        driverBookingDropOffErrors: this.props.driverBookingDropOffErrors,
	        driverBookingDropOffRequest: this.props.driverBookingDropOffRequest
	      }), !this.state.isCollapsed && _jsx('div', {}, void 0, !_lodash2.default.isEmpty(this.props.driverLoginErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.driverLoginErrors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this2.props.resetErrorState('driverLogin');
	        }
	      }), !_lodash2.default.isEmpty(this.props.driverLogoutErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.driverLogoutErrors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this2.props.resetErrorState('driverLogout');
	        }
	      }), !_lodash2.default.isEmpty(this.props.driverDeleteErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.driverDeleteErrors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this2.props.resetErrorState('driverDelete');
	        }
	      }), !_lodash2.default.isEmpty(this.props.driverSetAvailabilityErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.driverSetAvailabilityErrors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this2.props.resetErrorState('driverSetAvailability');
	        }
	      }), !_lodash2.default.isEmpty(this.props.driverSetAutoAcceptErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.driverSetAutoAcceptErrors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this2.props.resetErrorState('driverSetAutoAccept');
	        }
	      }), !_lodash2.default.isEmpty(this.props.driverBookingBidErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.driverBookingBidErrors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this2.props.resetErrorState('driverBookingBid');
	        }
	      }), !_lodash2.default.isEmpty(this.props.driverBookingCancelErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.driverBookingCancelErrors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this2.props.resetErrorState('driverBookingCancel');
	        }
	      }), !_lodash2.default.isEmpty(this.props.driverBookingPickUpErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.driverBookingPickUpErrors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this2.props.resetErrorState('driverBookingPickUp');
	        }
	      }), !_lodash2.default.isEmpty(this.props.driverBookingAdditionalDropOffErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.driverBookingAdditionalDropOffErrors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this2.props.resetErrorState('driverBookingAdditionalDropOff');
	        }
	      }), _jsx('ul', {}, void 0, numDrivers ? Object.keys(this.props.drivers).map(function (driverID) {
	        var driver = _this2.props.drivers[driverID];
	        var disableButtons = _this2.props.driverLoginRequest.isPending || _this2.props.driverLogoutRequest.isPending || _this2.props.driverDeleteRequest.isPending || _this2.props.driverSetAvailabilityRequest.isPending || _this2.props.driverSetAutoAcceptRequest.isPending || _this2.props.driverBookingBidRequest.isPending || _this2.props.driverBookingCancelRequest.isPending || _this2.props.driverBookingPickUpRequest.isPending || _this2.props.driverBookingAdditionalDropOffRequest.isPending || _this2.props.driverBookingDropOffRequest.isPending;
	        return _jsx('li', {
	          className: 'entity-row'
	        }, driverID, _jsx('div', {
	          className: 'field is-grouped is-pulled-right'
	        }, void 0, driver.loggedIn && _jsx('div', {
	          className: 'control'
	        }, void 0, _jsx('span', {
	          title: 'Driver availability'
	        }, void 0, _ref2, _jsx(_reactToggle2.default, {
	          disabled: disableButtons,
	          checked: driver.available,
	          icons: false,
	          onChange: function onChange() {
	            _this2.props.driverSetAvailability(_this2.props.activeCohortID, driverID, !driver.available);
	            _this2.props.resetErrorState(requestErrors);
	          }
	        }))), _jsx('div', {
	          className: 'control'
	        }, void 0, _jsx('span', {
	          title: 'Driver is logged in'
	        }, void 0, _jsx(_PowerButton2.default, {
	          disabled: disableButtons,
	          active: driver.loggedIn,
	          onClick: function onClick() {
	            if (driver.loggedIn) {
	              _this2.props.driverLogout(_this2.props.activeCohortID, driverID);
	            } else {
	              var mapCenter = _this2.props.getMapCenter();
	              var location = [mapCenter.longitude, mapCenter.latitude];
	              if (driver.latitude && driver.longitude) {
	                // Use driver's location if he has lat/lng.
	                location = [driver.longitude, driver.latitude];
	              }
	              _this2.props.driverLogin(_this2.props.activeCohortID, driverID, driver, location);
	            }
	            _this2.props.resetErrorState(requestErrors);
	          },
	          label: driver.loggedIn ? 'Logout driver' : 'Login driver'
	        }))), driver.loggedIn && _jsx('p', {
	          className: 'control'
	        }, void 0, _jsx('button', {
	          className: (0, _classnames2.default)('button is-small is-warning is-outlined', {
	            'is-disabled': disableButtons
	          }),
	          title: 'Pan map to driver',
	          'aria-label': 'Pan map to driver',
	          onClick: function onClick() {
	            _this2.props.onDriverClick(driver);
	          }
	        }, void 0, _ref3)), driver.loggedIn && _jsx('p', {
	          className: 'control'
	        }, void 0, _jsx('button', {
	          className: (0, _classnames2.default)('button is-small is-success is-outlined', {
	            'is-disabled': disableButtons
	          }),
	          title: 'Set driver to location via address',
	          'aria-label': 'Set driver to location via address',
	          onClick: function onClick() {
	            _this2.props.showDriverLocationModal(driverID);
	          }
	        }, void 0, _ref4)), !driver.loggedIn && _jsx('p', {
	          className: 'control'
	        }, void 0, _jsx('button', {
	          className: (0, _classnames2.default)('button is-small is-info is-outlined', {
	            'is-disabled': disableButtons
	          }),
	          title: 'Edit driver',
	          'aria-label': 'Edit driver',
	          onClick: function onClick() {
	            _this2.props.showDriverEditModal(driverID);
	          }
	        }, void 0, _ref5)), _jsx('p', {
	          className: 'control'
	        }, void 0, _jsx('button', {
	          className: (0, _classnames2.default)('button is-small is-danger is-outlined', {
	            'is-disabled': disableButtons,
	            'is-loading': _this2.props.driverDeleteRequest.isPending
	          }),
	          onClick: function onClick() {
	            /* eslint-disable no-alert */
	            if (confirm('Are you sure you want to remove Driver ' + driverID + ' from the cohort?')) {
	              _this2.props.driverDelete(_this2.props.activeCohortID, driverID);
	              _this2.props.resetErrorState(requestErrors);
	            }
	          },
	          title: 'Unassociate driver',
	          'aria-label': 'Unassociate driver'
	        }, void 0, _ref6))), _jsx('p', {
	          className: 'entity-title'
	        }, void 0, 'Driver ID: ', driverID), _jsx('div', {
	          className: 'entity-details-section'
	        }, void 0, _jsx('div', {}, void 0, 'Gamma ID: ', driver.cohortDriverID, ' ', _jsx('a', {
	          href: (0, _cohortUtils.entityURLForCohort)() + '/drivers/' + driver.cohortDriverID,
	          target: '_blank',
	          title: 'View driver in Gamma',
	          'aria-label': 'View driver in Gamma',
	          rel: 'noopener noreferrer'
	        }, void 0, _ref7), ' ', '\xB7', ' ', _libraryUtils.DRIVER_BEHAVIOURS_NAMES[_lodash2.default.get(driver, 'behaviour.type')]), _jsx('div', {
	          className: 'field is-grouped'
	        }, void 0, _jsx('div', {
	          className: 'control'
	        }, void 0, _jsx('span', {
	          title: 'Driver auto-accept status toggle'
	        }, void 0, _ref8, _jsx(_reactMultiToggle2.default, {
	          options: autoAcceptValues,
	          selectedOption: driver.autoAccept,
	          onSelectOption: function onSelectOption(value) {
	            var flag = void 0;
	            driver.autoAccept = value;
	            if (value === _cohorts2.autoAcceptValueNA) {
	              return;
	            }
	            if (value > _cohorts2.autoAcceptValueOff) {
	              flag = true;
	            } else {
	              flag = false;
	            }
	            _this2.props.driverSetAutoAccept(_this2.props.activeCohortID, driverID, flag);
	          },
	          label: 'Auto Accept:'
	        })))), !!driver.bookings && !!driver.bookings.length && _jsx('div', {}, void 0, _jsx('ul', {
	          className: 'entity-bookings'
	        }, void 0, driver.bookings.map(function (booking) {
	          var bookingID = booking.bookingID;
	          return _jsx('li', {
	            className: (0, _classnames2.default)('entity-booking-row', {
	              active: _this2.props.activeBookingID === bookingID
	            }),
	            onClick: function onClick() {
	              if (_this2.props.activeBookingID === bookingID) {
	                _this2.props.unsetActiveBooking();
	              } else {
	                _this2.props.setActiveBooking({
	                  driverID: driverID,
	                  bookingID: bookingID
	                });
	              }
	            }
	          }, bookingID, _jsx('div', {
	            className: 'field is-grouped is-pulled-right',
	            onClick: function onClick(event) {
	              event.stopPropagation();
	            }
	          }, void 0, (0, _bookingUtils.canBookingBeBid)(booking.state) && _jsx('p', {
	            className: 'control'
	          }, void 0, _jsx('button', {
	            className: (0, _classnames2.default)('button is-small is-primary is-outlined', {
	              'is-disabled': disableButtons
	            }),
	            onClick: function onClick() {
	              _this2.props.driverBookingBid(driverID, bookingID);
	            }
	          }, void 0, 'BID')), (0, _bookingUtils.canBookingBePickedUp)(booking.state) && _jsx('p', {
	            className: 'control'
	          }, void 0, _jsx('button', {
	            className: (0, _classnames2.default)('button is-small is-primary is-outlined', {
	              'is-disabled': disableButtons
	            }),
	            onClick: function onClick() {
	              _this2.props.driverBookingPickUp(driverID, bookingID);
	            }
	          }, void 0, 'PICK UP')), (0, _bookingUtils.canBookingBeDroppedOff)(booking.state) && (0, _bookingUtils.containsAdditionalDropOff)(booking) && !_this2.props.driverBookingAdditionalDropOffRequest.isSuccessful && _jsx('p', {
	            className: 'control'
	          }, void 0, _jsx('button', {
	            className: (0, _classnames2.default)('button is-small is-primary is-outlined', {
	              'is-disabled': disableButtons
	            }),
	            onClick: function onClick() {
	              _this2.props.driverBookingAdditionalDropOff(driverID, bookingID, 0, 0, 0, 1);
	            }
	          }, void 0, '1ST DROP OFF')), (0, _bookingUtils.canBookingBeDroppedOff)(booking.state) && (0, _bookingUtils.containsAdditionalDropOff)(booking) && _jsx('p', {
	            className: 'control'
	          }, void 0, _jsx('button', {
	            className: (0, _classnames2.default)('button is-small is-primary is-outlined', {
	              'is-disabled': disableButtons
	            }),
	            onClick: function onClick() {
	              _this2.props.showDriverFareModal(driverID, bookingID);
	            }
	          }, void 0, '2ND DROP OFF')), (0, _bookingUtils.canBookingBeDroppedOff)(booking.state) && !(0, _bookingUtils.containsAdditionalDropOff)(booking) && _jsx('p', {
	            className: 'control'
	          }, void 0, _jsx('button', {
	            className: (0, _classnames2.default)('button is-small is primary is-outlined', {
	              'is-disabled': disableButtons
	            }),
	            onClick: function onClick() {
	              _this2.props.showDriverFareModal(driverID, bookingID);
	            }
	          }, void 0, 'DROP OFF')), !(0, _libraryUtils.hasDriverBehaviour)(_lodash2.default.get(driver, 'behaviour.type')) && (0, _bookingUtils.canBookingBeCancelledByDriver)(booking.state) && _jsx('p', {
	            className: 'control'
	          }, void 0, _jsx('button', {
	            className: (0, _classnames2.default)('button is-small is-warning is-outlined', {
	              'is-disabled': disableButtons
	            }),
	            onClick: function onClick() {
	              _this2.props.driverBookingCancel(driverID, bookingID);
	            }
	          }, void 0, 'CANCEL')), _jsx('p', {
	            className: 'control'
	          }, void 0, _jsx('button', {
	            className: 'button is-small is-outlined is-danger',
	            onClick: function onClick() {
	              _this2.props.driverBookingDelete(_this2.props.activeCohortID, driverID, bookingID);
	            }
	          }, void 0, _ref9))), _jsx('p', {
	            className: 'entity-title'
	          }, void 0, bookingID), _jsx('p', {}, void 0, _jsx('span', {
	            className: 'tag is-small'
	          }, void 0, (0, _bookingUtils.bookingStateString)(booking.state)), booking.passengerID && _jsx('span', {}, void 0, ' ', '\xB7', ' ', 'Passenger ', booking.passengerID)));
	        })))));
	      }) : _ref10)));
	    }
	  }]);
	
	  return DriversPanel;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  var activeCohortID = state.app.activeCohortID;
	  var activeBookingID = _lodash2.default.get(state.app, 'activeBooking.bookingID');
	  var libraryDrivers = state.library.drivers || {};
	  var drivers = _lodash2.default.get(state.cohorts[activeCohortID], 'drivers', {});
	  var cohortDriverIDs = _lodash2.default.map(drivers, function (pax) {
	    return pax.cohortDriverID;
	  });
	  // Remove the already associated drivers.
	  var filteredLibraryDrivers = _lodash2.default.omit(libraryDrivers, cohortDriverIDs);
	
	  return {
	    activeCohortID: activeCohortID,
	    activeBookingID: activeBookingID,
	    isDriversModalActive: state.app.showDriversModal,
	    driverBeingEdited: state.app.driverBeingEdited,
	    driverLocationBeingEdited: state.app.driverLocationBeingEdited,
	    driverCompletingBooking: state.app.driverCompletingBooking,
	
	    libraryDrivers: filteredLibraryDrivers,
	    drivers: drivers,
	
	    cohortDriverAssociateRequest: state.requests.cohortDriverAssociateRequest || {},
	    cohortDriverAssociateErrors: _lodash2.default.get(state.errors, 'cohortDriverAssociate.errors', []),
	
	    driverLoginRequest: state.requests.driverLoginRequest || {},
	    driverLoginErrors: _lodash2.default.get(state.errors, 'driverLogin.errors', []),
	
	    driverLogoutRequest: state.requests.driverLogoutRequest || {},
	    driverLogoutErrors: _lodash2.default.get(state.errors, 'driverLogout.errors', []),
	
	    driverDeleteRequest: state.requests.driverDeleteRequest || {},
	    driverDeleteErrors: _lodash2.default.get(state.errors, 'driverDelete.errors', []),
	
	    driverSetAvailabilityRequest: state.requests.driverSetAvailabilityRequest || {},
	    driverSetAvailabilityErrors: _lodash2.default.get(state.errors, 'driverSetAvailability.errors', []),
	
	    driverSetAutoAcceptRequest: state.requests.driverSetAutoAcceptRequest || {},
	    driverSetAutoAcceptErrors: _lodash2.default.get(state.errors, 'driverSetAutoAccept.errors', []),
	
	    driverBookingBidRequest: state.requests.driverBookingBidRequest || {},
	    driverBookingBidErrors: _lodash2.default.get(state.errors, 'driverBookingBid.errors', []),
	
	    driverBookingCancelRequest: state.requests.driverBookingCancelRequest || {},
	    driverBookingCancelErrors: _lodash2.default.get(state.errors, 'driverBookingCancel.errors', []),
	
	    driverBookingPickUpRequest: state.requests.driverBookingPickUpRequest || {},
	    driverBookingPickUpErrors: _lodash2.default.get(state.errors, 'driverBookingPickUp.errors', []),
	
	    driverBookingAdditionalDropOffRequest: state.requests.driverBookingAdditionalDropOffRequest || {},
	    driverBookingAdditionalDropOffErrors: _lodash2.default.get(state.errors, 'driverBookingAdditionalDropOff.errors', []),
	
	    driverBookingDropOffRequest: state.requests.driverBookingDropOffRequest || {},
	    driverBookingDropOffErrors: _lodash2.default.get(state.errors, 'driverBookingDropOff.errors', [])
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  cohortDriverAssociate: _cohorts.cohortDriverAssociate,
	  driverLogin: _drivers.driverLogin,
	  driverLogout: _drivers.driverLogout,
	  driverDelete: _drivers.driverDelete,
	  driverSetAvailability: _drivers.driverSetAvailability,
	  driverSetAutoAccept: _drivers.driverSetAutoAccept,
	  driverSetLocation: _drivers.driverSetLocation,
	
	  driverBookingBid: _drivers.driverBookingBid,
	  driverBookingCancel: _drivers.driverBookingCancel,
	  driverBookingPickUp: _drivers.driverBookingPickUp,
	  driverBookingAdditionalDropOff: _drivers.driverBookingAdditionalDropOff,
	  driverBookingDropOff: _drivers.driverBookingDropOff,
	  driverBookingDelete: _drivers.driverBookingDelete,
	
	  showDriversModal: _app.showDriversModal,
	  showDriverEditModal: _app.showDriverEditModal,
	  showDriverLocationModal: _app.showDriverLocationModal,
	  showDriverFareModal: _app.showDriverFareModal,
	  closeDriverFareModal: _app.closeDriverFareModal,
	
	  setActiveBooking: _app.setActiveBooking,
	  unsetActiveBooking: _app.unsetActiveBooking,
	
	  resetErrorState: _helpers.resetErrorState
	})(DriversPanel);

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PassengerEditModal = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(11);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _cohorts = __webpack_require__(30);
	
	var _WithEscapeToDismiss = __webpack_require__(34);
	
	var _WithEscapeToDismiss2 = _interopRequireDefault(_WithEscapeToDismiss);
	
	var _PassengerForm = __webpack_require__(126);
	
	var _PassengerForm2 = _interopRequireDefault(_PassengerForm);
	
	var _ErrorNotification = __webpack_require__(20);
	
	var _ErrorNotification2 = _interopRequireDefault(_ErrorNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('h1', {
	  className: 'title'
	}, void 0, 'Edit Passenger');
	
	var _ref2 = _jsx('hr', {});
	
	var _ref3 = _jsx('hr', {});
	
	var PassengerEditModal = exports.PassengerEditModal = (_dec = (0, _WithEscapeToDismiss2.default)(), _dec(_class = function (_Component) {
	  _inherits(PassengerEditModal, _Component);
	
	  function PassengerEditModal(props) {
	    _classCallCheck(this, PassengerEditModal);
	
	    var _this = _possibleConstructorReturn(this, (PassengerEditModal.__proto__ || Object.getPrototypeOf(PassengerEditModal)).call(this, props));
	
	    _this.state = {
	      showFormError: false,
	      errors: []
	    };
	    return _this;
	  }
	
	  _createClass(PassengerEditModal, [{
	    key: 'hideErrors',
	    value: function hideErrors() {
	      this.setState({
	        showFormError: false,
	        errors: []
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _jsx('div', {
	        className: (0, _classnames2.default)('modal', {
	          'is-active': this.props.showModal
	        }),
	        role: 'dialog'
	      }, void 0, _jsx('div', {
	        className: 'modal-background',
	        onClick: function onClick() {
	          _this2.props.handleClose();
	        }
	      }), _jsx('div', {
	        className: 'modal-content'
	      }, void 0, _jsx('div', {
	        className: 'modal-box'
	      }, void 0, _jsx('button', {
	        'aria-label': 'Close',
	        className: 'is-pulled-right delete',
	        onClick: function onClick() {
	          _this2.props.handleClose();
	        }
	      }), _ref, _ref2, _react2.default.createElement(_PassengerForm2.default, {
	        defaultValue: this.props.passenger,
	        disableLoginFields: true,
	        ref: function ref(input) {
	          _this2.form = input;
	        }
	      }), _ref3, this.state.showFormError && _jsx(_ErrorNotification2.default, {
	        errors: this.state.errors,
	        dismissible: true,
	        onClose: function onClose() {
	          return _this2.hideErrors();
	        }
	      }), _jsx('div', {
	        className: 'field is-grouped has-text-right'
	      }, void 0, _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx('button', {
	        className: 'button is-outlined',
	        onClick: function onClick() {
	          _this2.props.handleClose();
	        }
	      }, void 0, 'Cancel')), _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx('button', {
	        className: 'button is-primary',
	        onClick: function onClick() {
	          if (!_this2.form.isValid()) {
	            _this2.setState({
	              showFormError: true,
	              errors: _this2.form.errors()
	            });
	            return;
	          }
	          var passenger = _this2.form.getValue();
	          _this2.props.cohortPassengerUpdate(_this2.props.cohortID, _this2.props.passengerID, passenger);
	          _this2.props.handleClose();
	        }
	      }, void 0, 'Update'))))));
	    }
	  }]);
	
	  return PassengerEditModal;
	}(_react.Component)) || _class);
	
	
	PassengerEditModal.contextTypes = {
	  router: _react.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state, ownProps) {
	  return {
	    passenger: state.cohorts[ownProps.cohortID].passengers[ownProps.passengerID]
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  cohortPassengerUpdate: _cohorts.cohortPassengerUpdate
	})(PassengerEditModal);

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _libraryUtils = __webpack_require__(36);
	
	var _WithEscapeToDismiss = __webpack_require__(34);
	
	var _WithEscapeToDismiss2 = _interopRequireDefault(_WithEscapeToDismiss);
	
	var _ErrorNotification = __webpack_require__(20);
	
	var _ErrorNotification2 = _interopRequireDefault(_ErrorNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('h3', {
	  className: 'title is-5'
	}, void 0, 'Associate Passengers');
	
	var _ref2 = _jsx('thead', {}, void 0, _jsx('tr', {}, void 0, _jsx('th', {}, void 0, 'Gamma ID'), _jsx('th', {}, void 0, 'Name'), _jsx('th', {}, void 0, 'Behaviour'), _jsx('th', {}, void 0, 'Actions')));
	
	var _ref3 = _jsx('tr', {}, void 0, _jsx('td', {
	  colSpan: 999,
	  className: 'has-text-centered'
	}, void 0, 'No passengers added.'));
	
	var PassengersModal = (_dec = (0, _WithEscapeToDismiss2.default)(), _dec(_class = function (_Component) {
	  _inherits(PassengersModal, _Component);
	
	  function PassengersModal() {
	    _classCallCheck(this, PassengersModal);
	
	    return _possibleConstructorReturn(this, (PassengersModal.__proto__ || Object.getPrototypeOf(PassengersModal)).apply(this, arguments));
	  }
	
	  _createClass(PassengersModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.resetErrorState('cohortPassengerAssociate');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _jsx('div', {
	        className: (0, _classnames2.default)('modal', {
	          'is-active': this.props.isPassengersModalActive
	        }),
	        role: 'dialog'
	      }, void 0, _jsx('div', {
	        className: 'modal-background',
	        onClick: function onClick() {
	          _this2.props.handleClose();
	        }
	      }), _jsx('div', {
	        className: 'modal-content'
	      }, void 0, _jsx('div', {
	        className: 'modal-box'
	      }, void 0, _jsx('button', {
	        'aria-label': 'Close',
	        className: 'is-pulled-right delete',
	        onClick: function onClick() {
	          _this2.props.handleClose();
	        }
	      }), _ref, _jsx('table', {
	        className: 'table is-bordered is-striped'
	      }, void 0, _ref2, _jsx('tbody', {}, void 0, Object.keys(this.props.passengers).map(function (cohortPassengerID) {
	        var passenger = _this2.props.passengers[cohortPassengerID];
	        return _jsx('tr', {}, cohortPassengerID, _jsx('td', {}, void 0, cohortPassengerID), _jsx('td', {}, void 0, passenger.name || '-'), _jsx('td', {}, void 0, _libraryUtils.PASSENGER_BEHAVIOURS_NAMES[_lodash2.default.get(passenger, 'behaviour.type')]), _jsx('td', {}, void 0, _jsx('div', {
	          className: 'control is-grouped'
	        }, void 0, _jsx('p', {
	          className: 'control'
	        }, void 0, _jsx('button', {
	          className: (0, _classnames2.default)('button is-small is-outlined is-info', {
	            'is-disabled': _this2.props.cohortPassengerAssociateRequest.isPending
	          }),
	          onClick: function onClick() {
	            _this2.props.cohortPassengerAssociate(_this2.props.activeCohortID, _lodash2.default.cloneDeep(passenger));
	          }
	        }, void 0, 'Associate')))));
	      }), _lodash2.default.isEmpty(this.props.passengers) && _ref3)), !_lodash2.default.isEmpty(this.props.cohortPassengerAssociateErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.cohortPassengerAssociateErrors
	      }))));
	    }
	  }]);
	
	  return PassengersModal;
	}(_react.Component)) || _class);
	exports.default = PassengersModal;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PassengersPanel = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(11);
	
	var _cohorts = __webpack_require__(30);
	
	var _passengers = __webpack_require__(71);
	
	var _app = __webpack_require__(26);
	
	var _helpers = __webpack_require__(51);
	
	var _libraryUtils = __webpack_require__(36);
	
	var _cohortUtils = __webpack_require__(52);
	
	var _bookingUtils = __webpack_require__(73);
	
	var _ErrorNotification = __webpack_require__(20);
	
	var _ErrorNotification2 = _interopRequireDefault(_ErrorNotification);
	
	var _PowerButton = __webpack_require__(197);
	
	var _PowerButton2 = _interopRequireDefault(_PowerButton);
	
	var _PassengersModal = __webpack_require__(599);
	
	var _PassengersModal2 = _interopRequireDefault(_PassengersModal);
	
	var _PassengerEditModal = __webpack_require__(598);
	
	var _PassengerEditModal2 = _interopRequireDefault(_PassengerEditModal);
	
	var _CohortLocationModal = __webpack_require__(199);
	
	var _CohortLocationModal2 = _interopRequireDefault(_CohortLocationModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var requestErrors = ['cohortPassengerAssociate', 'passengerLogin', 'passengerLogout', 'passengerDelete'];
	
	var _ref = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-plus'
	}));
	
	var _ref2 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-pencil'
	}));
	
	var _ref3 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-book'
	}));
	
	var _ref4 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-trash'
	}));
	
	var _ref5 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-external-link'
	}));
	
	var _ref6 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-trash'
	}));
	
	var _ref7 = _jsx('li', {
	  className: 'entity-row'
	}, void 0, 'No passengers associated to this cohort.');
	
	var PassengersPanel = exports.PassengersPanel = function (_Component) {
	  _inherits(PassengersPanel, _Component);
	
	  function PassengersPanel(props) {
	    _classCallCheck(this, PassengersPanel);
	
	    var _this = _possibleConstructorReturn(this, (PassengersPanel.__proto__ || Object.getPrototypeOf(PassengersPanel)).call(this, props));
	
	    _this.state = {
	      isCollapsed: false,
	      changeDestination: false,
	      pickupPoint: null
	    };
	    return _this;
	  }
	
	  _createClass(PassengersPanel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.resetErrorState(requestErrors);
	    }
	  }, {
	    key: 'toggleLocationSelection',
	    value: function toggleLocationSelection(point) {
	      this.setState({
	        changeDestination: !this.state.changeDestination,
	        pickupPoint: point
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var numPassengers = Object.keys(this.props.passengers).length;
	      return _jsx('div', {
	        className: 'entity-panel'
	      }, void 0, _jsx('button', {
	        className: 'button is-primary is-small is-pulled-right entity-add-button',
	        title: 'Associate passenger to cohort',
	        'aria-label': 'Associate passenger to cohort',
	        onClick: function onClick(event) {
	          event.stopPropagation();
	          _this2.props.showPassengersModal(true);
	        }
	      }, void 0, _ref), _jsx('h3', {
	        className: 'title section-title is-6 entity-panel-title'
	      }, void 0, _jsx('button', {
	        'aria-label': 'Toggle panel',
	        onClick: function onClick() {
	          _this2.setState({
	            isCollapsed: !_this2.state.isCollapsed
	          });
	        }
	      }, void 0, _jsx('span', {
	        className: 'icon is-small'
	      }, void 0, _jsx('i', {
	        className: (0, _classnames2.default)('fa fa-fw', {
	          'fa-chevron-down': !this.state.isCollapsed,
	          'fa-chevron-right': this.state.isCollapsed
	        })
	      })), ' ', 'Passengers ', !!numPassengers && '(' + numPassengers + ')')), this.props.isPassengersModalActive && _react2.default.createElement(_PassengersModal2.default, _extends({}, this.props, {
	        handleClose: function handleClose() {
	          _this2.props.showPassengersModal(false);
	        },
	        passengers: this.props.libraryPassengers
	      })), !!this.props.passengerBeingEdited && _jsx(_PassengerEditModal2.default, {
	        cohortID: this.props.activeCohortID,
	        passengerID: this.props.passengerBeingEdited,
	        handleClose: function handleClose() {
	          _this2.props.showPassengerEditModal(null);
	        },
	        showModal: !!this.props.passengerBeingEdited
	      }), this.state.changeDestination && _jsx(_CohortLocationModal2.default, {
	        showModal: 'true',
	        cohortSetLocation: function cohortSetLocation(latlng) {
	          var _props = _this2.props,
	              activeCohortID = _props.activeCohortID,
	              activePassengerID = _props.activePassengerID,
	              activeBookingID = _props.activeBookingID,
	              changeDestination = _props.passengerChangeDestination;
	
	          changeDestination(activeCohortID, activePassengerID, activeBookingID, _lodash2.default.map(latlng.split(','), Number));
	        },
	        onAutoCompleteLocation: function onAutoCompleteLocation(locationQuery) {
	          if (!_this2.state.pickupPoint) {
	            _this2.props.forwardGeo(locationQuery, '');
	            return;
	          }
	
	          var _state$pickupPoint = _this2.state.pickupPoint,
	              lng = _state$pickupPoint.longitude,
	              lat = _state$pickupPoint.latitude;
	
	          _this2.props.forwardGeo(locationQuery, '', [lng, lat]);
	        },
	        handleClose: function handleClose() {
	          _this2.toggleLocationSelection(null);
	        },
	        autoCompleteLocations: this.props.locations
	      }), !this.state.isCollapsed && _jsx('div', {}, void 0, !_lodash2.default.isEmpty(this.props.passengerLoginErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.passengerLoginErrors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this2.props.resetErrorState('passengerLogin');
	        }
	      }), !_lodash2.default.isEmpty(this.props.passengerLogoutErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.passengerLogoutErrors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this2.props.resetErrorState('passengerLogout');
	        }
	      }), !_lodash2.default.isEmpty(this.props.passengerDeleteErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.passengerDeleteErrors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this2.props.resetErrorState('passengerDelete');
	        }
	      }), !_lodash2.default.isEmpty(this.props.passengerBookingCancelErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.passengerBookingCancelErrors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this2.props.resetErrorState('passengerBookingCancel');
	        }
	      }), !_lodash2.default.isEmpty(this.props.passengerChangeDestinationErrors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.passengerChangeDestinationErrors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this2.props.resetErrorState('passengerChangeDestination');
	        }
	      }), _jsx('ul', {}, void 0, numPassengers ? Object.keys(this.props.passengers).map(function (passengerID) {
	        var passenger = _this2.props.passengers[passengerID];
	        var disableButtons = _this2.props.passengerLoginRequest.isPending || _this2.props.passengerLogoutRequest.isPending || _this2.props.passengerDeleteRequest.isPending;
	        var canMakeBooking = passenger.loggedIn && !_lodash2.default.get(passenger.behaviour, 'type');
	        return _jsx('li', {
	          className: 'entity-row'
	        }, passengerID, _jsx('div', {
	          className: 'field is-grouped is-pulled-right'
	        }, void 0, _jsx('div', {
	          className: 'control'
	        }, void 0, _jsx('span', {
	          title: 'Passenger is logged in'
	        }, void 0, _jsx(_PowerButton2.default, {
	          disabled: disableButtons,
	          active: passenger.loggedIn,
	          onClick: function onClick() {
	            if (passenger.loggedIn) {
	              _this2.props.passengerLogout(_this2.props.activeCohortID, passengerID);
	            } else {
	              _this2.props.passengerLogin(_this2.props.activeCohortID, passengerID, passenger);
	            }
	            _this2.props.resetErrorState(requestErrors);
	          },
	          label: passenger.loggedIn ? 'Logout passenger' : 'Login passenger'
	        }))), !passenger.loggedIn && _jsx('p', {
	          className: 'control'
	        }, void 0, _jsx('button', {
	          className: 'button is-small is-outlined is-info',
	          title: 'Edit passenger',
	          'aria-label': 'Edit passenger',
	          onClick: function onClick() {
	            _this2.props.showPassengerEditModal(passengerID);
	          }
	        }, void 0, _ref2)), canMakeBooking && _jsx('p', {
	          className: 'control'
	        }, void 0, _jsx('button', {
	          className: (0, _classnames2.default)('button is-small is-outlined is-info', {
	            'is-disabled': _this2.props.bookingInProgress
	          }),
	          title: 'Create booking',
	          'aria-label': 'Create booking',
	          onClick: function onClick() {
	            _this2.props.onPassengerBookingClick(passengerID);
	          }
	        }, void 0, _ref3)), _jsx('p', {
	          className: 'control'
	        }, void 0, _jsx('button', {
	          className: (0, _classnames2.default)('button is-small is-danger is-outlined', {
	            'is-disabled': disableButtons,
	            'is-loading': _this2.props.passengerDeleteRequest.isPending
	          }),
	          title: 'Unassociate passenger',
	          'aria-label': 'Unassociate passenger',
	          onClick: function onClick() {
	            /* eslint-disable no-alert */
	            if (confirm('Are you sure you want to remove Passenger ' + (passengerID + ' from the cohort?'))) {
	              _this2.props.passengerDelete(_this2.props.activeCohortID, passengerID);
	              _this2.props.resetErrorState(requestErrors);
	            }
	          }
	        }, void 0, _ref4))), _jsx('p', {
	          className: 'entity-title'
	        }, void 0, 'Passenger ID: ', passengerID), _jsx('div', {
	          className: 'entity-details-section'
	        }, void 0, _jsx('div', {}, void 0, 'Gamma ID: ', passenger.cohortPassengerID, ' ', _jsx('a', {
	          href: (0, _cohortUtils.entityURLForCohort)() + '/passengers/' + passenger.cohortPassengerID,
	          target: '_blank',
	          title: 'View passenger in Gamma',
	          'aria-label': 'View passenger in Gamma',
	          rel: 'noopener noreferrer'
	        }, void 0, _ref5), ' ', '\xB7', ' ', _libraryUtils.PASSENGER_BEHAVIOURS_NAMES[_lodash2.default.get(passenger, 'behaviour.type')]), !!passenger.bookings && !!passenger.bookings.length && _jsx('div', {}, void 0, _jsx('ul', {
	          className: 'entity-bookings'
	        }, void 0, passenger.bookings.map(function (booking) {
	          var bookingID = booking.bookingID;
	          return _jsx('li', {
	            className: (0, _classnames2.default)('entity-booking-row', {
	              active: _this2.props.activeBookingID === bookingID
	            }),
	            onClick: function onClick() {
	              if (_this2.props.activeBookingID === bookingID) {
	                _this2.props.unsetActiveBooking();
	              } else {
	                _this2.props.passengerBookingGet(_this2.props.activeCohortID, passengerID, bookingID);
	                _this2.props.setActiveBooking({
	                  passengerID: passengerID,
	                  bookingID: bookingID
	                });
	              }
	            }
	          }, bookingID, _jsx('div', {
	            className: 'field is-grouped is-pulled-right',
	            onClick: function onClick(event) {
	              event.stopPropagation();
	            }
	          }, void 0, _jsx('p', {
	            className: 'control'
	          }, void 0, (0, _bookingUtils.canBookingBeCancelledByPassenger)(booking.state) && _jsx('button', {
	            className: (0, _classnames2.default)('button is-small is-outlined is-warning', {
	              'is-loading': _this2.props.passengerBookingCancelRequest.isPending,
	              'is-disabled': _this2.props.passengerBookingCancelRequest.isPending
	            }),
	            title: 'Cancel booking',
	            onClick: function onClick() {
	              _this2.props.passengerBookingCancel(_this2.props.activeCohortID, passengerID, bookingID);
	            }
	          }, void 0, 'CANCEL')), _jsx('p', {
	            className: 'control'
	          }, void 0, (0, _bookingUtils.canDestinationBeChanged)(booking.state) && _jsx('button', {
	            className: (0, _classnames2.default)('button is-small is-outlined is-warning', {
	              'is-loading': _this2.props.passengerChangeDestinationRequest.isPending,
	              'is-disabled': _this2.props.passengerChangeDestinationRequest.isPending
	            }),
	            title: 'Change Destination',
	            onClick: function onClick() {
	              _this2.toggleLocationSelection(booking.itinerary[0]);
	              _this2.props.setActiveBooking({ bookingID: bookingID, passengerID: passengerID });
	            }
	          }, void 0, 'CHANGE DESTINATION')), _jsx('p', {
	            className: 'control'
	          }, void 0, _jsx('button', {
	            className: 'button is-small is-outlined is-danger',
	            title: 'Remove booking',
	            'aria-label': 'Remove booking',
	            onClick: function onClick() {
	              _this2.props.passengerBookingDelete(_this2.props.activeCohortID, passengerID, bookingID);
	            }
	          }, void 0, _ref6))), _jsx('p', {
	            className: 'entity-title'
	          }, void 0, bookingID), _jsx('p', {}, void 0, _jsx('span', {
	            className: 'tag is-small'
	          }, void 0, (0, _bookingUtils.bookingStateString)(booking.state)), booking.driverID && _jsx('span', {}, void 0, ' ', '\xB7', ' ', 'Driver ', booking.driverID)));
	        })))));
	      }) : _ref7)));
	    }
	  }]);
	
	  return PassengersPanel;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  var activeCohortID = state.app.activeCohortID;
	  var activeBookingID = _lodash2.default.get(state.app, 'activeBooking.bookingID');
	  var activePassengerID = _lodash2.default.get(state.app, 'activeBooking.passengerID');
	  var libraryPassengers = state.library.passengers || {};
	  var passengers = _lodash2.default.get(state.cohorts[activeCohortID], 'passengers', {});
	  var cohortPassengerIDs = _lodash2.default.map(passengers, function (pax) {
	    return pax.cohortPassengerID;
	  });
	  // Remove the already associated passengers.
	  var filteredLibraryPassengers = _lodash2.default.omit(libraryPassengers, cohortPassengerIDs);
	
	  return {
	    activeCohortID: activeCohortID,
	    activeBookingID: activeBookingID,
	    activePassengerID: activePassengerID,
	    isPassengersModalActive: state.app.showPassengersModal,
	    passengerBeingEdited: state.app.passengerBeingEdited,
	
	    libraryPassengers: filteredLibraryPassengers,
	    passengers: passengers,
	
	    cohortPassengerAssociateRequest: state.requests.cohortPassengerAssociateRequest || {},
	    cohortPassengerAssociateErrors: _lodash2.default.get(state.errors, 'cohortPassengerAssociate.errors', []),
	
	    passengerLoginRequest: state.requests.passengerLoginRequest || {},
	    passengerLoginErrors: _lodash2.default.get(state.errors, 'passengerLogin.errors', []),
	
	    passengerLogoutRequest: state.requests.passengerLogoutRequest || {},
	    passengerLogoutErrors: _lodash2.default.get(state.errors, 'passengerLogout.errors', []),
	
	    passengerDeleteRequest: state.requests.passengerDeleteRequest || {},
	    passengerDeleteErrors: _lodash2.default.get(state.errors, 'passengerDelete.errors', []),
	
	    passengerBookingGetRequest: state.requests.passengerBookingGetRequest || {},
	    passengerBookingGetErrors: _lodash2.default.get(state.errors, 'passengerBookingGet.errors', []),
	
	    passengerBookingCancelRequest: state.requests.passengerBookingCancelRequest || {},
	    passengerBookingCancelErrors: _lodash2.default.get(state.errors, 'passengerBookingCancel.errors', []),
	
	    locations: state.app.autoComplete,
	
	    passengerChangeDestinationRequest: state.requests.passengerChangeDestinationRequest || {},
	    passengerChangeDestinationErrors: _lodash2.default.get(state.errors, 'passengerChangeDestination.errors', [])
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  cohortPassengerAssociate: _cohorts.cohortPassengerAssociate,
	  passengerLogin: _passengers.passengerLogin,
	  passengerLogout: _passengers.passengerLogout,
	  passengerDelete: _passengers.passengerDelete,
	
	  passengerBookingGet: _passengers.passengerBookingGet,
	  passengerBookingCancel: _passengers.passengerBookingCancel,
	  passengerBookingDelete: _passengers.passengerBookingDelete,
	  passengerChangeDestination: _passengers.passengerChangeDestination,
	
	  showPassengersModal: _app.showPassengersModal,
	  showPassengerEditModal: _app.showPassengerEditModal,
	
	  setActiveBooking: _app.setActiveBooking,
	  unsetActiveBooking: _app.unsetActiveBooking,
	
	  resetErrorState: _helpers.resetErrorState,
	  forwardGeo: _app.forwardGeo
	})(PassengersPanel);

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DashboardContentContainer = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _SimulationPreviewPanel = __webpack_require__(603);
	
	var _SimulationPreviewPanel2 = _interopRequireDefault(_SimulationPreviewPanel);
	
	__webpack_require__(524);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('div', {
	  className: 'no-simulations'
	}, void 0, _jsx('span', {
	  className: 'head'
	}, void 0, 'No Simulations Found'), _jsx('p', {}, void 0, 'You have not run any simulations or you do not have any active simulations'));
	
	var _ref2 = _jsx('td', {}, void 0, 'SIMULATION ID');
	
	var _ref3 = _jsx('td', {}, void 0, 'COHORT ID');
	
	var _ref4 = _jsx('td', {}, void 0, 'START TIME');
	
	var _ref5 = _jsx('td', {}, void 0, 'DURATION');
	
	var _ref6 = _jsx('td', {}, void 0, 'STATUS');
	
	var _ref7 = _jsx('td', {}, void 0, 'OPTIONS');
	
	var DashboardContentContainer = exports.DashboardContentContainer = function (_Component) {
	  _inherits(DashboardContentContainer, _Component);
	
	  function DashboardContentContainer(props) {
	    _classCallCheck(this, DashboardContentContainer);
	
	    var _this = _possibleConstructorReturn(this, (DashboardContentContainer.__proto__ || Object.getPrototypeOf(DashboardContentContainer)).call(this, props));
	
	    _this.generateContent = function () {
	      var content = [];
	      for (var i = 0; i < _this.state.simulations.length; i += 1) {
	        var startTime = new Date(_this.state.simulations[i].triggeredTime);
	        content.push(_jsx(_SimulationPreviewPanel2.default, {
	          CohortID: _this.state.simulations[i].cohortID,
	          SimulationID: _this.state.simulations[i].simulationID,
	          StartTime: startTime.toString(),
	          Status: _this.state.simulations[i].status,
	          Duration: _this.state.simulations[i].duration,
	          onClickHandler: _this.props.loadDetails
	        }, i));
	      }
	      var showSimulations = content.length === 0 ? 'hide' : '';
	      if (showSimulations !== '') {
	        return _ref;
	      }
	      return _jsx('table', {
	        className: 'center-table table is-striped is-fullwidth'
	      }, void 0, _jsx('thead', {}, void 0, _jsx('tr', {
	        className: showSimulations
	      }, void 0, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7)), _jsx('tbody', {}, void 0, content));
	    };
	
	    _this.state = {
	      simulations: _this.props.simulations
	    };
	    return _this;
	  }
	
	  _createClass(DashboardContentContainer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!_lodash2.default.isEqual(this.props.simulations, nextProps.simulations)) {
	        this.setState({
	          simulations: nextProps.simulations
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _jsx('div', {
	        className: 'SimulationContentContainer'
	      }, void 0, this.generateContent());
	    }
	  }]);

	  return DashboardContentContainer;
	}(_react.Component);

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(27);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _reactToggle = __webpack_require__(140);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(525);
	
	var _DashboardContentContainer = __webpack_require__(601);
	
	var _ReportContainer = __webpack_require__(129);
	
	var _ReportContainer2 = _interopRequireDefault(_ReportContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var scanLimit = 10;
	
	var _ref = _jsx('div', {
	  className: 'modal-background'
	});
	
	var _ref2 = _jsx('p', {
	  className: 'modal-card-title'
	}, void 0, 'Simulation Results Report');
	
	var SimulationDashboardPage = function (_Component) {
	  _inherits(SimulationDashboardPage, _Component);
	
	  function SimulationDashboardPage(props) {
	    _classCallCheck(this, SimulationDashboardPage);
	
	    var _this = _possibleConstructorReturn(this, (SimulationDashboardPage.__proto__ || Object.getPrototypeOf(SimulationDashboardPage)).call(this, props));
	
	    _this.getNextSimulations = function () {
	      var status = _this.state.active ? 1 : 0;
	      _this.props.getSimulations(status, scanLimit, _this.props.lastEvaluatedKey);
	    };
	
	    _this.closeDialog = function () {
	      _this.showDialog(false);
	    };
	
	    _this.showDialog = function (show) {
	      _this.setState({
	        showReportDialog: show
	      });
	    };
	
	    _this.loadDetailsHandler = function (simulationID) {
	      _this.props.getSimulationReport(simulationID);
	      _this.showDialog(true);
	    };
	
	    _this.toggleActiveStatus = function () {
	      var status = _this.state.active ? 0 : 1;
	      _this.setState(function (state) {
	        var isActive = !state.active;
	        return {
	          active: isActive
	        };
	      });
	      _this.props.toggleSimulationStatus(status, scanLimit);
	    };
	
	    _this.SimulationReportModal = function (showReport, closeDialog) {
	      var contents = _jsx(_ReportContainer2.default, {
	        details: _this.props.simulationDetails
	      });
	      if (!showReport) {
	        return null;
	      }
	      return _jsx('div', {
	        className: 'modal is-active'
	      }, void 0, _ref, _jsx('div', {
	        className: 'modal-card'
	      }, void 0, _jsx('header', {
	        className: 'modal-card-head'
	      }, void 0, _ref2, _jsx('button', {
	        className: 'delete',
	        'aria-label': 'close',
	        onClick: closeDialog
	      })), _jsx('section', {
	        className: 'modal-card-body'
	      }, void 0, contents), _jsx('footer', {
	        className: 'modal-card-foot'
	      }, void 0, _jsx('button', {
	        className: 'button',
	        onClick: closeDialog
	      }, void 0, 'Cancel'))));
	    };
	
	    _this.state = {
	      showReportDialog: false,
	      active: false
	    };
	    return _this;
	  }
	
	  _createClass(SimulationDashboardPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.getSimulations(0, scanLimit, null);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.resetSimulationDashboard();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _jsx(_reactDocumentTitle2.default, {
	        title: 'Marionette'
	      }, void 0, _jsx('section', {
	        className: 'section'
	      }, void 0, _jsx('div', {
	        className: 'container'
	      }, void 0, _jsx('div', {
	        className: 'is-horizontal'
	      }, void 0, _jsx('div', {
	        className: 'is-pulled-left field-label is-normal'
	      }, void 0, _jsx('label', {
	        className: 'label',
	        htmlFor: 'toggle'
	      }, void 0, this.state.active ? 'Active simulations' : 'All simulations')), _jsx('div', {
	        className: 'field-body'
	      }, void 0, _jsx('div', {
	        className: 'field is-narrow'
	      }, void 0, _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx(_reactToggle2.default, {
	        checked: this.state.active,
	        icons: false,
	        onChange: function onChange() {
	          _this2.toggleActiveStatus();
	        }
	      }))))), _jsx(_DashboardContentContainer.DashboardContentContainer, {
	        simulations: this.props.simulationList,
	        loadDetails: this.loadDetailsHandler
	      }), _jsx('a', {
	        className: (0, _classnames2.default)('button is-primary', {
	          'is-hidden': !this.props.lastEvaluatedKey
	        }),
	        onClick: function onClick() {
	          return _this2.getNextSimulations();
	        }
	      }, void 0, 'Load more'), this.SimulationReportModal(this.state.showReportDialog, this.closeDialog))));
	    }
	  }]);
	
	  return SimulationDashboardPage;
	}(_react.Component);
	
	exports.default = SimulationDashboardPage;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	exports.default = SimulationPreviewPanel;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(21);
	
	__webpack_require__(526);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var completeIcon = 'complete-icon fa fa-check-circle';
	var terminatedIcon = 'terminated-icon fa fa-ban';
	var runningIcon = 'running-icon fa fa-cog fa-spin';
	
	var simulationStatus = {
	  RUNNING: 1,
	  COMPLETE: 2,
	  TERMINATED: 3
	};
	
	var _ref = _jsx('a', {}, void 0, 'View Details');
	
	function SimulationPreviewPanel(props) {
	  var statusIcon = completeIcon;
	  if (props.Status === simulationStatus.RUNNING) {
	    statusIcon = runningIcon;
	  } else if (props.Status === simulationStatus.TERMINATED) {
	    statusIcon = terminatedIcon;
	  }
	
	  return _jsx('tr', {}, void 0, _jsx('td', {}, void 0, props.SimulationID, ' '), _jsx('td', {}, void 0, _jsx(_reactRouter.Link, {
	    to: '/cohorts/' + props.CohortID + ' '
	  }, void 0, props.CohortID)), _jsx('td', {}, void 0, props.StartTime, ' '), _jsx('td', {}, void 0, props.Duration, ' minutes'), _jsx('td', {}, void 0, _jsx('span', {
	    className: 'icon'
	  }, void 0, _jsx('i', {
	    className: statusIcon
	  }))), _jsx('td', {
	    onClick: function onClick() {
	      return props.onClickHandler(props.SimulationID);
	    }
	  }, void 0, _ref));
	}

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LibraryPage = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(27);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _reactRedux = __webpack_require__(11);
	
	var _PassengersTable = __webpack_require__(610);
	
	var _PassengersTable2 = _interopRequireDefault(_PassengersTable);
	
	var _DriversTable = __webpack_require__(607);
	
	var _DriversTable2 = _interopRequireDefault(_DriversTable);
	
	var _library = __webpack_require__(59);
	
	__webpack_require__(527);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('div', {
	  className: 'columns'
	}, void 0, _jsx('div', {
	  className: 'column'
	}, void 0, _jsx('h1', {
	  className: 'title is-2'
	}, void 0, 'Library'), _jsx('hr', {}), _jsx('div', {
	  className: 'notification is-warning',
	  role: 'alert'
	}, void 0, 'These entities are templates used when associating a passenger/driver with a cohort. Changes made to these templates will not be reflected in the respective entity in the cohort.')));
	
	/* eslint-disable react/prefer-stateless-function */
	var LibraryPage = exports.LibraryPage = function (_Component) {
	  _inherits(LibraryPage, _Component);
	
	  function LibraryPage() {
	    _classCallCheck(this, LibraryPage);
	
	    return _possibleConstructorReturn(this, (LibraryPage.__proto__ || Object.getPrototypeOf(LibraryPage)).apply(this, arguments));
	  }
	
	  _createClass(LibraryPage, [{
	    key: 'render',
	    value: function render() {
	      return _jsx(_reactDocumentTitle2.default, {
	        title: 'Library'
	      }, void 0, _jsx('div', {
	        className: 'section'
	      }, void 0, _jsx('div', {
	        className: 'container'
	      }, void 0, _ref, _jsx('div', {
	        className: 'columns'
	      }, void 0, _jsx('div', {
	        className: 'column is-half'
	      }, void 0, _jsx(_PassengersTable2.default, {
	        passengers: this.props.passengers,
	        deletePassenger: this.props.libraryPassengerDelete
	      })), _jsx('div', {
	        className: 'column is-half'
	      }, void 0, _jsx(_DriversTable2.default, {
	        drivers: this.props.drivers,
	        deleteDriver: this.props.libraryDriverDelete
	      }))))));
	    }
	  }]);
	
	  return LibraryPage;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    passengers: state.library.passengers,
	    drivers: state.library.drivers,
	    merchants: state.library.merchants
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  libraryPassengerDelete: _library.libraryPassengerDelete,
	  libraryDriverDelete: _library.libraryDriverDelete,
	  libraryMerchantDelete: _library.libraryMerchantDelete
	})(LibraryPage);

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DriverAddPage = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(27);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(21);
	
	var _library = __webpack_require__(59);
	
	var _DriverForm = __webpack_require__(125);
	
	var _DriverForm2 = _interopRequireDefault(_DriverForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('h3', {
	  className: 'title is-3'
	}, void 0, 'Add Library Driver');
	
	var _ref2 = _jsx('hr', {});
	
	var _ref3 = _jsx('hr', {});
	
	var _ref4 = _jsx('p', {
	  className: 'control'
	}, void 0, _jsx(_reactRouter.Link, {
	  to: '/library',
	  className: 'button is-outlined',
	  title: 'Back to library',
	  'aria-label': 'Back to library'
	}, void 0, 'Back'));
	
	var DriverAddPage = exports.DriverAddPage = function (_Component) {
	  _inherits(DriverAddPage, _Component);
	
	  function DriverAddPage(props) {
	    _classCallCheck(this, DriverAddPage);
	
	    var _this = _possibleConstructorReturn(this, (DriverAddPage.__proto__ || Object.getPrototypeOf(DriverAddPage)).call(this, props));
	
	    _this.state = {
	      showFormError: false
	    };
	    return _this;
	  }
	
	  _createClass(DriverAddPage, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _jsx(_reactDocumentTitle2.default, {
	        title: 'Add Driver'
	      }, void 0, _jsx('div', {
	        className: 'section'
	      }, void 0, _jsx('div', {
	        className: 'container'
	      }, void 0, _jsx('div', {
	        className: 'columns'
	      }, void 0, _jsx('div', {
	        className: 'column is-half is-offset-one-quarter'
	      }, void 0, _ref, _ref2, _react2.default.createElement(_DriverForm2.default, { ref: function ref(input) {
	          _this2.form = input;
	        } }), _ref3, this.state.showFormError && _jsx('div', {
	        className: 'notification is-danger',
	        role: 'alert'
	      }, void 0, _jsx('button', {
	        title: 'Close notification',
	        'aria-label': 'Close notification',
	        className: 'delete',
	        onClick: function onClick() {
	          _this2.setState({
	            showFormError: false
	          });
	        }
	      }), 'Invalid entries. Please check your form again.'), _jsx('div', {
	        className: 'field is-grouped is-pulled-right'
	      }, void 0, _ref4, _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx('button', {
	        className: 'button is-primary',
	        onClick: function onClick() {
	          if (!_this2.form.isValid()) {
	            _this2.setState({
	              showFormError: true
	            });
	            return;
	          }
	          var driver = _this2.form.getValue();
	          _this2.props.libraryDriverAdd(driver);
	          _this2.context.router.push('/library');
	        }
	      }, void 0, 'Add'))))))));
	    }
	  }]);
	
	  return DriverAddPage;
	}(_react.Component);
	
	DriverAddPage.contextTypes = {
	  router: _react.PropTypes.object.isRequired
	};
	
	function mapStateToProps() {
	  return {};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  libraryDriverAdd: _library.libraryDriverAdd
	})(DriverAddPage);

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DriverEditPage = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(27);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(21);
	
	var _library = __webpack_require__(59);
	
	var _DriverForm = __webpack_require__(125);
	
	var _DriverForm2 = _interopRequireDefault(_DriverForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('h1', {
	  className: 'title'
	}, void 0, 'Edit Library Driver');
	
	var _ref2 = _jsx('hr', {});
	
	var _ref3 = _jsx('hr', {});
	
	var _ref4 = _jsx('p', {
	  className: 'control'
	}, void 0, _jsx(_reactRouter.Link, {
	  to: '/library',
	  className: 'button is-outlined',
	  title: 'Back to library',
	  'aria-label': 'Back to library'
	}, void 0, 'Back'));
	
	var DriverEditPage = exports.DriverEditPage = function (_Component) {
	  _inherits(DriverEditPage, _Component);
	
	  function DriverEditPage(props) {
	    _classCallCheck(this, DriverEditPage);
	
	    var _this = _possibleConstructorReturn(this, (DriverEditPage.__proto__ || Object.getPrototypeOf(DriverEditPage)).call(this, props));
	
	    _this.state = {
	      showFormError: false
	    };
	    return _this;
	  }
	
	  _createClass(DriverEditPage, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var cohortDriverID = this.props.driver.cohortDriverID;
	      return _jsx(_reactDocumentTitle2.default, {
	        title: 'Edit Driver'
	      }, void 0, _jsx('div', {
	        className: 'section'
	      }, void 0, _jsx('div', {
	        className: 'container'
	      }, void 0, _jsx('div', {
	        className: 'columns'
	      }, void 0, _jsx('div', {
	        className: 'column is-half is-offset-one-quarter'
	      }, void 0, _ref, _ref2, _react2.default.createElement(_DriverForm2.default, {
	        defaultValue: this.props.driver,
	        ref: function ref(input) {
	          _this2.form = input;
	        }
	      }), _ref3, this.state.showFormError && _jsx('div', {
	        className: 'notification is-danger',
	        role: 'alert'
	      }, void 0, _jsx('button', {
	        title: 'Close notification',
	        'aria-label': 'Close notification',
	        className: 'delete',
	        onClick: function onClick() {
	          _this2.setState({
	            showFormError: false
	          });
	        }
	      }), 'Invalid entries. Please check your form again.'), _jsx('div', {
	        className: 'field is-grouped is-pulled-right'
	      }, void 0, _ref4, _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx('button', {
	        className: 'button is-danger is-outlined',
	        onClick: function onClick() {
	          /* eslint-disable no-alert */
	          if (confirm('Are you sure you want to remove Driver ' + cohortDriverID + '?')) {
	            _this2.props.libraryDriverDelete(cohortDriverID);
	            _this2.context.router.push('/library');
	          }
	        }
	      }, void 0, 'Delete')), _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx('button', {
	        className: 'button is-primary',
	        onClick: function onClick() {
	          if (!_this2.form.isValid()) {
	            _this2.setState({
	              showFormError: true
	            });
	            return;
	          }
	          var driver = _this2.form.getValue();
	          // Edit is a delete and add again.
	          _this2.props.libraryDriverDelete(cohortDriverID);
	          _this2.props.libraryDriverAdd(driver);
	          _this2.context.router.push('/library');
	        }
	      }, void 0, 'Update'))))))));
	    }
	  }]);
	
	  return DriverEditPage;
	}(_react.Component);
	
	DriverEditPage.contextTypes = {
	  router: _react.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state, ownProps) {
	  return {
	    driver: state.library.drivers[ownProps.params.cohortDriverID]
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  libraryDriverAdd: _library.libraryDriverAdd,
	  libraryDriverDelete: _library.libraryDriverDelete
	})(DriverEditPage);

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	exports.default = DriversTable;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRouter = __webpack_require__(21);
	
	var _libraryUtils = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _jsx('h2', {
	  className: 'title is-4'
	}, void 0, 'Library Drivers', _jsx(_reactRouter.Link, {
	  to: '/drivers/new',
	  className: 'button is-primary is-small is-pulled-right',
	  title: 'Add driver to library',
	  'aria-label': 'Add driver to library'
	}, void 0, _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-plus'
	}))));
	
	var _ref2 = _jsx('thead', {}, void 0, _jsx('tr', {}, void 0, _jsx('th', {}, void 0, 'Gamma ID'), _jsx('th', {}, void 0, 'Name'), _jsx('th', {}, void 0, 'Device ID'), _jsx('th', {}, void 0, 'IMEI'), _jsx('th', {}, void 0, 'Behaviour'), _jsx('th', {}, void 0, 'Actions')));
	
	var _ref3 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-pencil'
	}));
	
	var _ref4 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-trash'
	}));
	
	var _ref5 = _jsx('tr', {}, void 0, _jsx('td', {
	  colSpan: 999,
	  className: 'has-text-centered'
	}, void 0, 'No drivers added.'));
	
	function DriversTable(props) {
	  return _jsx('div', {}, void 0, _ref, _jsx('table', {
	    className: 'table is-bordered is-striped'
	  }, void 0, _ref2, _jsx('tbody', {}, void 0, Object.keys(props.drivers).map(function (cohortDriverID) {
	    var driver = props.drivers[cohortDriverID];
	    var editDriverButtonTitle = 'Edit driver ' + cohortDriverID;
	    var deleteDriverButtonTitle = 'Delete driver ' + cohortDriverID + ' from cohort';
	    return _jsx('tr', {}, cohortDriverID, _jsx('td', {}, void 0, cohortDriverID), _jsx('td', {}, void 0, driver.name || '-'), _jsx('td', {
	      className: 'word-wrap'
	    }, void 0, driver.deviceID || '-'), _jsx('td', {
	      className: 'word-wrap'
	    }, void 0, driver.imei || '-'), _jsx('td', {}, void 0, _libraryUtils.DRIVER_BEHAVIOURS_NAMES[_lodash2.default.get(driver, 'behaviour.type')]), _jsx('td', {}, void 0, _jsx('div', {
	      className: 'field is-grouped'
	    }, void 0, _jsx('p', {
	      className: 'control'
	    }, void 0, _jsx(_reactRouter.Link, {
	      to: '/drivers/' + cohortDriverID + '/edit',
	      className: 'button is-info is-small is-outlined',
	      title: editDriverButtonTitle,
	      'aria-label': editDriverButtonTitle
	    }, void 0, _ref3)), _jsx('p', {
	      className: 'control'
	    }, void 0, _jsx('button', {
	      className: 'button is-small is-outlined is-danger',
	      title: deleteDriverButtonTitle,
	      'aria-label': deleteDriverButtonTitle,
	      onClick: function onClick() {
	        /* eslint-disable no-alert */
	        if (confirm('Are you sure you want to remove Driver ' + cohortDriverID + '?')) {
	          props.deleteDriver(cohortDriverID);
	        }
	      }
	    }, void 0, _ref4)))));
	  }), _lodash2.default.isEmpty(props.drivers) && _ref5)));
	}

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PassengerAddPage = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(27);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(21);
	
	var _library = __webpack_require__(59);
	
	var _PassengerForm = __webpack_require__(126);
	
	var _PassengerForm2 = _interopRequireDefault(_PassengerForm);
	
	var _ErrorNotification = __webpack_require__(20);
	
	var _ErrorNotification2 = _interopRequireDefault(_ErrorNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('h1', {
	  className: 'title'
	}, void 0, 'Add Library Passenger');
	
	var _ref2 = _jsx('hr', {});
	
	var _ref3 = _jsx('hr', {});
	
	var _ref4 = _jsx('p', {
	  className: 'control'
	}, void 0, _jsx(_reactRouter.Link, {
	  to: '/library',
	  className: 'button is-outlined',
	  title: 'Back to library',
	  'aria-label': 'Back to library'
	}, void 0, 'Back'));
	
	var PassengerAddPage = exports.PassengerAddPage = function (_Component) {
	  _inherits(PassengerAddPage, _Component);
	
	  function PassengerAddPage(props) {
	    _classCallCheck(this, PassengerAddPage);
	
	    var _this = _possibleConstructorReturn(this, (PassengerAddPage.__proto__ || Object.getPrototypeOf(PassengerAddPage)).call(this, props));
	
	    _this.state = {
	      showFormError: false,
	      errors: []
	    };
	    return _this;
	  }
	
	  _createClass(PassengerAddPage, [{
	    key: 'hideErrors',
	    value: function hideErrors() {
	      this.setState({
	        showFormError: false,
	        errors: []
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _jsx(_reactDocumentTitle2.default, {
	        title: 'Add Passenger'
	      }, void 0, _jsx('div', {
	        className: 'section'
	      }, void 0, _jsx('div', {
	        className: 'container'
	      }, void 0, _jsx('div', {
	        className: 'columns'
	      }, void 0, _jsx('div', {
	        className: 'column is-half is-offset-one-quarter'
	      }, void 0, _ref, _ref2, _react2.default.createElement(_PassengerForm2.default, { ref: function ref(input) {
	          _this2.form = input;
	        } }), _ref3, this.state.showFormError && _jsx(_ErrorNotification2.default, {
	        errors: this.state.errors,
	        dismissible: true,
	        onClose: function onClose() {
	          return _this2.hideErrors();
	        }
	      }), _jsx('div', {
	        className: 'field is-grouped is-pulled-right'
	      }, void 0, _ref4, _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx('button', {
	        className: 'button is-primary',
	        onClick: function onClick() {
	          if (!_this2.form.isValid()) {
	            _this2.setState({
	              showFormError: true,
	              errors: _this2.form.errors()
	            });
	            return;
	          }
	          var passenger = _this2.form.getValue();
	          _this2.props.libraryPassengerAdd(passenger);
	          _this2.context.router.push('/library');
	        }
	      }, void 0, 'Add'))))))));
	    }
	  }]);
	
	  return PassengerAddPage;
	}(_react.Component);
	
	PassengerAddPage.contextTypes = {
	  router: _react.PropTypes.object.isRequired
	};
	
	function mapStateToProps() {
	  return {};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  libraryPassengerAdd: _library.libraryPassengerAdd
	})(PassengerAddPage);

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PassengerEditPage = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(27);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _reactRedux = __webpack_require__(11);
	
	var _reactRouter = __webpack_require__(21);
	
	var _library = __webpack_require__(59);
	
	var _PassengerForm = __webpack_require__(126);
	
	var _PassengerForm2 = _interopRequireDefault(_PassengerForm);
	
	var _ErrorNotification = __webpack_require__(20);
	
	var _ErrorNotification2 = _interopRequireDefault(_ErrorNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('h1', {
	  className: 'title'
	}, void 0, 'Edit Library Passenger');
	
	var _ref2 = _jsx('hr', {});
	
	var _ref3 = _jsx('hr', {});
	
	var _ref4 = _jsx('p', {
	  className: 'control'
	}, void 0, _jsx(_reactRouter.Link, {
	  to: '/library',
	  className: 'button is-outlined',
	  title: 'Back to library',
	  'aria-label': 'Back to library'
	}, void 0, 'Back'));
	
	var PassengerEditPage = exports.PassengerEditPage = function (_Component) {
	  _inherits(PassengerEditPage, _Component);
	
	  function PassengerEditPage(props) {
	    _classCallCheck(this, PassengerEditPage);
	
	    var _this = _possibleConstructorReturn(this, (PassengerEditPage.__proto__ || Object.getPrototypeOf(PassengerEditPage)).call(this, props));
	
	    _this.state = {
	      showFormError: false,
	      errors: []
	    };
	    return _this;
	  }
	
	  _createClass(PassengerEditPage, [{
	    key: 'hideErrors',
	    value: function hideErrors() {
	      this.setState({
	        showFormError: false,
	        errors: []
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var cohortPassengerID = this.props.passenger.cohortPassengerID;
	      return _jsx(_reactDocumentTitle2.default, {
	        title: 'Edit Passenger'
	      }, void 0, _jsx('div', {
	        className: 'section'
	      }, void 0, _jsx('div', {
	        className: 'container'
	      }, void 0, _jsx('div', {
	        className: 'columns'
	      }, void 0, _jsx('div', {
	        className: 'column is-half is-offset-one-quarter'
	      }, void 0, _ref, _ref2, _react2.default.createElement(_PassengerForm2.default, {
	        defaultValue: this.props.passenger,
	        ref: function ref(input) {
	          _this2.form = input;
	        }
	      }), _ref3, this.state.showFormError && _jsx(_ErrorNotification2.default, {
	        errors: this.state.errors,
	        dismissible: true,
	        onClose: function onClose() {
	          return _this2.hideErrors();
	        }
	      }), _jsx('div', {
	        className: 'field is-grouped is-pulled-right'
	      }, void 0, _ref4, _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx('button', {
	        className: 'button is-danger is-outlined',
	        onClick: function onClick() {
	          /* eslint-disable no-alert */
	          if (confirm('Are you sure you want to remove Passenger ' + cohortPassengerID + '?')) {
	            _this2.props.libraryPassengerDelete(cohortPassengerID);
	            _this2.context.router.push('/library');
	          }
	        }
	      }, void 0, 'Delete')), _jsx('p', {
	        className: 'control'
	      }, void 0, _jsx('button', {
	        className: 'button is-primary',
	        onClick: function onClick() {
	          if (!_this2.form.isValid()) {
	            _this2.setState({
	              showFormError: true,
	              errors: _this2.form.errors()
	            });
	            return;
	          }
	          var passenger = _this2.form.getValue();
	          // Edit is a delete and add again.
	          _this2.props.libraryPassengerDelete(cohortPassengerID);
	          _this2.props.libraryPassengerAdd(passenger);
	          _this2.context.router.push('/library');
	        }
	      }, void 0, 'Update'))))))));
	    }
	  }]);
	
	  return PassengerEditPage;
	}(_react.Component);
	
	PassengerEditPage.contextTypes = {
	  router: _react.PropTypes.object.isRequired
	};
	
	function mapStateToProps(state, ownProps) {
	  return {
	    passenger: state.library.passengers[ownProps.params.cohortPassengerID]
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  libraryPassengerAdd: _library.libraryPassengerAdd,
	  libraryPassengerDelete: _library.libraryPassengerDelete
	})(PassengerEditPage);

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	exports.default = PassengersTable;
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(21);
	
	var _libraryUtils = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _jsx('h2', {
	  className: 'title is-4'
	}, void 0, 'Library Passengers', _jsx(_reactRouter.Link, {
	  to: '/passengers/new',
	  className: 'button is-primary is-small is-pulled-right',
	  title: 'Add passenger to library',
	  'aria-label': 'Add passenger to library'
	}, void 0, _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-plus'
	}))));
	
	var _ref2 = _jsx('thead', {}, void 0, _jsx('tr', {}, void 0, _jsx('th', {}, void 0, 'Gamma ID'), _jsx('th', {}, void 0, 'Name'), _jsx('th', {}, void 0, 'Behaviour'), _jsx('th', {}, void 0, 'Actions')));
	
	var _ref3 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-pencil'
	}));
	
	var _ref4 = _jsx('span', {
	  className: 'icon is-small',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-trash'
	}));
	
	var _ref5 = _jsx('tr', {}, void 0, _jsx('td', {
	  colSpan: 999,
	  className: 'has-text-centered'
	}, void 0, 'No passengers added.'));
	
	function PassengersTable(props) {
	  return _jsx('div', {}, void 0, _ref, _jsx('table', {
	    className: 'table is-bordered is-striped entities-table'
	  }, void 0, _ref2, _jsx('tbody', {}, void 0, Object.keys(props.passengers).map(function (cohortPassengerID) {
	    var passenger = props.passengers[cohortPassengerID];
	    var editPassengerButtonTitle = 'Edit passenger ' + cohortPassengerID;
	    var deletePassengerButtonTitle = 'Delete passenger ' + cohortPassengerID + ' from cohort';
	    return _jsx('tr', {}, cohortPassengerID, _jsx('td', {}, void 0, cohortPassengerID), _jsx('td', {}, void 0, passenger.name || '-'), _jsx('td', {}, void 0, _libraryUtils.PASSENGER_BEHAVIOURS_NAMES[_lodash2.default.get(passenger, 'behaviour.type')]), _jsx('td', {}, void 0, _jsx('div', {
	      className: 'field is-grouped'
	    }, void 0, _jsx('p', {
	      className: 'control'
	    }, void 0, _jsx(_reactRouter.Link, {
	      to: '/passengers/' + cohortPassengerID + '/edit',
	      className: 'button is-info is-small is-outlined',
	      title: editPassengerButtonTitle,
	      'aria-label': editPassengerButtonTitle
	    }, void 0, _ref3)), _jsx('p', {
	      className: 'control'
	    }, void 0, _jsx('button', {
	      className: 'button is-small is-outlined is-danger',
	      title: deletePassengerButtonTitle,
	      'aria-label': deletePassengerButtonTitle,
	      onClick: function onClick() {
	        /* eslint-disable no-alert */
	        if (confirm('Are you sure you want to remove passenger ' + cohortPassengerID + '?')) {
	          props.deletePassenger(cohortPassengerID);
	        }
	      }
	    }, void 0, _ref4)))));
	  }), _lodash2.default.isEmpty(props.passengers) && _ref5)));
	}

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ResourceGeneratorContainer = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(11);
	
	var _fileSaver = __webpack_require__(548);
	
	var _fileSaver2 = _interopRequireDefault(_fileSaver);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _config = __webpack_require__(32);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _ResourceGeneratorParams = __webpack_require__(613);
	
	var _app = __webpack_require__(26);
	
	var _cohorts = __webpack_require__(30);
	
	var _helpers = __webpack_require__(51);
	
	var _cities = __webpack_require__(203);
	
	var _cities2 = _interopRequireDefault(_cities);
	
	var _ResourceGeneratorOutput = __webpack_require__(612);
	
	var _cohortEventsHandler = __webpack_require__(128);
	
	var _cohortEventsHandler2 = _interopRequireDefault(_cohortEventsHandler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourceGeneratorContainer = exports.ResourceGeneratorContainer = (_temp = _class = function (_Component) {
	  _inherits(ResourceGeneratorContainer, _Component);
	
	  function ResourceGeneratorContainer(props) {
	    _classCallCheck(this, ResourceGeneratorContainer);
	
	    var _this = _possibleConstructorReturn(this, (ResourceGeneratorContainer.__proto__ || Object.getPrototypeOf(ResourceGeneratorContainer)).call(this, props));
	
	    _this.fillCity = function () {
	      var cityArr = [];
	      var cities = _this.state.cities;
	      for (var i = 0; i < cities.length; i += 1) {
	        var cityCode = cities[i].city_code;
	
	        cityArr.push(_jsx('option', {
	          value: cityCode
	        }, cities[i].name, cities[i].name));
	      }
	      return cityArr;
	    };
	
	    _this.handleCohortNameChange = function (event) {
	      var cohortName = event.target.value;
	      _this.setState({
	        cohortName: cohortName
	      });
	    };
	
	    _this.handleCityChange = function (event) {
	      var city = event.target.value;
	      _this.setState({
	        cityCode: city
	      });
	    };
	
	    _this.handleNumPaxChange = function (paxVal) {
	      _this.setState({ paxVal: paxVal });
	    };
	
	    _this.handleNumDaxChange = function (daxVal) {
	      _this.setState({ daxVal: daxVal });
	    };
	
	    _this.handleCohortTypeChange = function (event) {
	      _this.setState({ cohortType: event.target.value });
	    };
	
	    _this.startGenerateResources = function () {
	      var request = {
	        name: _this.state.cohortName,
	        numPassengers: parseInt(_this.state.paxVal, 10),
	        numDrivers: parseInt(_this.state.daxVal, 10),
	        cityCode: _this.state.cityCode,
	        shortLived: _this.state.cohortType
	      };
	      _this.props.generateResources(request);
	    };
	
	    _this.downloadCohortYaml = function (cohortID) {
	      _this.setState({
	        downloadCohortID: cohortID
	      });
	      _this.props.downloadCohortYaml(cohortID);
	    };
	
	    _this.state = {
	      cohortName: null,
	      paxVal: 0,
	      daxVal: 0,
	      cityCode: 'CITY_SG_SIN',
	      cohortType: '0',
	      disabledInputs: false,
	      cities: new _cities2.default().cities,
	
	      downloadCohortID: null
	    };
	    _this.cohortSocket = null;
	    return _this;
	  }
	
	  _createClass(ResourceGeneratorContainer, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var successCohortID = !_lodash2.default.isEqual(prevProps.resultantCohortIDs, this.props.resultantCohortIDs) && this.props.resultantCohortIDs.length > 0;
	      if (successCohortID) {
	        this.connectActiveCohortSocket();
	      }
	      var successCohortYamlFile = !_lodash2.default.isEqual(prevProps.cohortYamlFile, this.props.cohortYamlFile) && this.props.cohortYamlFile;
	      if (successCohortYamlFile) {
	        var blob = new Blob([this.props.cohortYamlFile], { type: 'text/plain;charset=utf-8' });
	        _fileSaver2.default.saveAs(blob, this.state.downloadCohortID + '-cohort-yaml.txt');
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.resetResultantCohorts();
	    }
	  }, {
	    key: 'connectActiveCohortSocket',
	    value: function connectActiveCohortSocket() {
	      var _this2 = this;
	
	      if (this.cohortSocket) {
	        this.cohortSocket.close();
	      }
	      var cohortID = this.props.resultantCohortIDs;
	      var cohortSocket = new WebSocket(_config2.default.WEBSOCKET_BASE_URL + '/cohorts/' + cohortID + '/events');
	
	      cohortSocket.onmessage = function (event) {
	        var action = (0, _cohortEventsHandler2.default)(cohortID, JSON.parse(event.data));
	        _this2.context.store.dispatch(action);
	      };
	      cohortSocket.onclose = function (event) {
	        if (_this2.cohortSocket !== cohortSocket) {
	          return;
	        }
	        _this2.setState({
	          cohortDisconnectionCode: event.code
	        });
	        _this2.disconnectActiveCohortSocket();
	      };
	      this.cohortSocket = cohortSocket;
	    }
	  }, {
	    key: 'disconnectActiveCohortSocket',
	    value: function disconnectActiveCohortSocket() {
	      if (this.cohortSocket) {
	        this.cohortSocket.onclose = null;
	        this.cohortSocket.close();
	        this.cohortSocket = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _jsx('div', {}, void 0, _jsx(_ResourceGeneratorParams.ResourceGeneratorParams, {
	        startGenerateResources: this.startGenerateResources,
	        handleCohortNameChange: this.handleCohortNameChange,
	        handleNumPaxChange: this.handleNumPaxChange,
	        handleNumDaxChange: this.handleNumDaxChange,
	        handleCityChange: this.handleCityChange,
	        handleCohortTypeChange: this.handleCohortTypeChange,
	        cohortType: this.state.cohortType,
	        fillCities: this.fillCity,
	        errors: this.props.generateResourcesErrors,
	        resetErrorState: this.props.resetErrorState
	      }), _jsx(_ResourceGeneratorOutput.ResourceGeneratorOutput, {
	        cohortStatus: this.props.cohortStatus,
	        downloadCohortYaml: function downloadCohortYaml(cohortID) {
	          return _this3.downloadCohortYaml(cohortID);
	        }
	      }));
	    }
	  }]);
	
	  return ResourceGeneratorContainer;
	}(_react.Component), _class.contextTypes = {
	  store: _react.PropTypes.object
	}, _temp);
	
	
	function mapStateToProps(state) {
	  return {
	    resultantCohortIDs: state.app.resultantCohortIDs,
	    generateResourcesErrors: _lodash2.default.get(state.errors, 'generateResources.errors', {}),
	    cohortStatus: state.app.cohortStatus,
	    cohortYamlFile: state.app.cohortYamlFile
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  generateResources: _app.generateResources,
	  resetErrorState: _helpers.resetErrorState,
	  resetResultantCohorts: _app.resetResultantCohorts,
	  downloadCohortYaml: _cohorts.downloadCohortYaml
	})(ResourceGeneratorContainer);

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ResourceGeneratorOutput = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactRouter = __webpack_require__(21);
	
	__webpack_require__(529);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('div', {});
	
	var _ref2 = _jsx('thead', {}, void 0, _jsx('tr', {}, void 0, _jsx('td', {}, void 0, 'COHORT ID'), _jsx('td', {}, void 0, 'STATUS'), _jsx('td', {})));
	
	var _ref3 = _jsx('td', {});
	
	var ResourceGeneratorOutput = exports.ResourceGeneratorOutput = function (_Component) {
	  _inherits(ResourceGeneratorOutput, _Component);
	
	  function ResourceGeneratorOutput(props) {
	    _classCallCheck(this, ResourceGeneratorOutput);
	
	    var _this = _possibleConstructorReturn(this, (ResourceGeneratorOutput.__proto__ || Object.getPrototypeOf(ResourceGeneratorOutput)).call(this, props));
	
	    _this.generateCohortStatus = function () {
	      var cohortStatus = _this.state.cohortStatus;
	
	      if (!cohortStatus) {
	        return _ref;
	      }
	
	      var cohortStatusContainer = [];
	
	      var _loop = function _loop(index) {
	        cohortStatusContainer.push(_jsx('tr', {}, cohortStatus[index].cohortID[0], _jsx('td', {}, void 0, _jsx(_reactRouter.Link, {
	          to: '/cohorts/' + cohortStatus[index].cohortID[0]
	        }, void 0, cohortStatus[index].cohortID[0])), _jsx('td', {}, void 0, _this.renderStatus(cohortStatus[index].status)), cohortStatus[index].status === 2 ? _jsx('td', {
	          className: 'download-button',
	          onClick: function onClick() {
	            return _this.props.downloadCohortYaml(cohortStatus[index].cohortID[0]);
	          }
	        }, void 0, 'Download') : _ref3));
	      };
	
	      for (var index = 0; index < cohortStatus.length; index += 1) {
	        _loop(index);
	      }
	
	      return _jsx('table', {
	        className: 'center-table table is-striped is-fullwidth'
	      }, void 0, _ref2, _jsx('tbody', {}, void 0, cohortStatusContainer));
	    };
	
	    _this.renderStatus = function (status) {
	      switch (status) {
	        case 1:
	          return 'Pending';
	        case 2:
	          return 'Completed';
	        default:
	          return 'Failed';
	      }
	    };
	
	    _this.state = {
	      cohortStatus: _this.props.cohortStatus
	    };
	    return _this;
	  }
	
	  _createClass(ResourceGeneratorOutput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!_lodash2.default.isEqual(this.props.cohortStatus, nextProps.cohortStatus)) {
	        this.setState({
	          cohortStatus: nextProps.cohortStatus
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _jsx('div', {}, void 0, this.generateCohortStatus());
	    }
	  }]);

	  return ResourceGeneratorOutput;
	}(_react.Component);

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ResourceGeneratorParams = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _rcTooltip = __webpack_require__(134);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _ErrorNotification = __webpack_require__(20);
	
	var _ErrorNotification2 = _interopRequireDefault(_ErrorNotification);
	
	__webpack_require__(530);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var entityLowerBound = 0;
	var entityUpperBound = 5000;
	var paxEntity = 'pax';
	var daxEntity = 'dax';
	var outOfBoundsErrorMessage = 'Range should be between 0 to 5000, inclusive';
	
	var _ref = _jsx('div', {
	  className: 'label column is-half'
	}, void 0, ' Name of Cohort ');
	
	var _ref2 = _jsx('div', {
	  className: 'label column is-half'
	}, void 0, ' Number of Passengers ');
	
	var _ref3 = _jsx('p', {
	  className: 'help is-danger'
	}, void 0, outOfBoundsErrorMessage);
	
	var _ref4 = _jsx('div', {
	  className: 'label column is-half'
	}, void 0, ' Number of Drivers ');
	
	var _ref5 = _jsx('p', {
	  className: 'help is-danger'
	}, void 0, outOfBoundsErrorMessage);
	
	var _ref6 = _jsx('div', {
	  className: 'label column is-half',
	  htmlFor: 'city'
	}, void 0, 'City');
	
	var _ref7 = _jsx('div', {
	  className: 'label column is-half',
	  htmlFor: 'city'
	}, void 0, 'Cohort Type', _jsx(_rcTooltip2.default, {
	  placement: 'right',
	  trigger: 'hover',
	  overlay: _jsx('span', {}, void 0, 'Select Persistent if you want to keep the cohort for a long term.', _jsx('br', {}), 'Else, short-lived cohorts will be created with a duration of 1 hour from the time of creation.')
	}, void 0, _jsx('i', {
	  className: 'fa fa-question-circle'
	})));
	
	var _ref8 = _jsx('article', {
	  className: 'message is-danger'
	}, void 0, _jsx('div', {
	  className: 'message-body'
	}, void 0, 'Select persistent if you want to keep the cohort for a long term'));
	
	var _ref9 = _jsx('noscript', {});
	
	var ResourceGeneratorParams = exports.ResourceGeneratorParams = function (_Component) {
	  _inherits(ResourceGeneratorParams, _Component);
	
	  function ResourceGeneratorParams(props) {
	    _classCallCheck(this, ResourceGeneratorParams);
	
	    var _this = _possibleConstructorReturn(this, (ResourceGeneratorParams.__proto__ || Object.getPrototypeOf(ResourceGeneratorParams)).call(this, props));
	
	    _this.setEntityOutOfBounds = function (entityType, trigger) {
	      if (entityType === paxEntity) {
	        _this.setState({
	          paxValOutOfBounds: trigger
	        });
	      } else if (entityType === daxEntity) {
	        _this.setState({
	          daxValOutOfBounds: trigger
	        });
	      }
	    };
	
	    _this.checkPaxRange = function (event) {
	      event.persist();
	      var paxVal = event.target.value;
	      if (paxVal >= entityLowerBound && paxVal <= entityUpperBound) {
	        _this.setEntityOutOfBounds(paxEntity, false);
	        _this.props.handleNumPaxChange(paxVal);
	      } else {
	        _this.setEntityOutOfBounds(paxEntity, true);
	      }
	    };
	
	    _this.checkDaxRange = function (event) {
	      event.persist();
	      var daxVal = event.target.value;
	      if (daxVal >= entityLowerBound && daxVal <= entityUpperBound) {
	        _this.setEntityOutOfBounds(daxEntity, false);
	        _this.props.handleNumDaxChange(daxVal);
	      } else {
	        _this.setEntityOutOfBounds(daxEntity, true);
	      }
	    };
	
	    _this.entityInput = function (handler) {
	      return _jsx('input', {
	        className: 'input',
	        type: 'number',
	        onChange: handler,
	        defaultValue: entityLowerBound,
	        min: entityLowerBound,
	        max: entityUpperBound
	      });
	    };
	
	    _this.state = {
	      disabledInputs: false,
	      paxValOutOfBounds: false,
	      daxValOutOfBounds: false
	    };
	    return _this;
	  }
	
	  _createClass(ResourceGeneratorParams, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          paxValOutOfBounds = _state.paxValOutOfBounds,
	          daxValOutOfBounds = _state.daxValOutOfBounds;
	
	      return _jsx('div', {
	        className: 'resourceGeneratorParams'
	      }, void 0, !_lodash2.default.isEmpty(this.props.errors) && _jsx(_ErrorNotification2.default, {
	        errors: this.props.errors,
	        dismissible: true,
	        onClose: function onClose() {
	          _this2.props.resetErrorState('generateResources');
	        }
	      }), _jsx('div', {
	        className: 'field columns'
	      }, void 0, _ref, _jsx('div', {
	        className: 'column is-fullwidth'
	      }, void 0, _jsx('input', {
	        className: 'input',
	        type: 'text',
	        placeholder: '[optional]',
	        onChange: this.props.handleCohortNameChange
	      }))), _jsx('div', {
	        className: 'field columns'
	      }, void 0, _ref2, _jsx('div', {
	        className: 'column is-fullwidth'
	      }, void 0, this.entityInput(this.checkPaxRange), paxValOutOfBounds && _ref3)), _jsx('div', {
	        className: 'field columns'
	      }, void 0, _ref4, _jsx('div', {
	        className: 'column is-fullwidth'
	      }, void 0, this.entityInput(this.checkDaxRange), daxValOutOfBounds && _ref5)), _jsx('div', {
	        className: 'field columns'
	      }, void 0, _ref6, _jsx('div', {
	        className: 'select column is-fullwidth'
	      }, void 0, _jsx('select', {
	        name: 'city',
	        onChange: this.props.handleCityChange
	      }, void 0, this.props.fillCities()))), _jsx('div', {
	        className: 'field columns'
	      }, void 0, _ref7, _jsx('div', {
	        className: 'column is-fullwidth'
	      }, void 0, _jsx('label', {
	        className: 'radio',
	        htmlFor: 'cohortType'
	      }, void 0, _jsx('input', {
	        type: 'radio',
	        name: 'cohortType',
	        value: 0,
	        checked: this.props.cohortType === '0',
	        onChange: this.props.handleCohortTypeChange
	      }), 'Short-lived'), _jsx('label', {
	        className: 'radio right-radio',
	        htmlFor: 'cohortType'
	      }, void 0, _jsx('input', {
	        type: 'radio',
	        name: 'cohortType',
	        value: 1,
	        checked: this.props.cohortType === '1',
	        onChange: this.props.handleCohortTypeChange
	      }), 'Persistent'), this.props.cohortType === '1' ? _ref8 : _ref9)), _jsx('button', {
	        className: 'button is-primary is-pulled-left',
	        type: 'submit',
	        onClick: this.props.startGenerateResources,
	        disabled: paxValOutOfBounds || daxValOutOfBounds
	      }, void 0, 'Generate'));
	    }
	  }]);

	  return ResourceGeneratorParams;
	}(_react.Component);

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TokenContainer = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(27);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _reactRedux = __webpack_require__(11);
	
	var _app = __webpack_require__(26);
	
	var _ErrorNotification = __webpack_require__(20);
	
	var _ErrorNotification2 = _interopRequireDefault(_ErrorNotification);
	
	__webpack_require__(531);
	
	var _TokenGenerator = __webpack_require__(615);
	
	var _TokenGenerator2 = _interopRequireDefault(_TokenGenerator);
	
	var _TokenModal = __webpack_require__(616);
	
	var _TokenModal2 = _interopRequireDefault(_TokenModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('span', {
	  className: 'icon',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-plus'
	}));
	
	var TokenContainer = exports.TokenContainer = function (_Component) {
	  _inherits(TokenContainer, _Component);
	
	  function TokenContainer(props) {
	    _classCallCheck(this, TokenContainer);
	
	    var _this = _possibleConstructorReturn(this, (TokenContainer.__proto__ || Object.getPrototypeOf(TokenContainer)).call(this, props));
	
	    _this.state = {
	      status: [],
	      tokens: null,
	      maxTokensCreated: false,
	      newTokenCreated: false
	    };
	    return _this;
	  }
	
	  _createClass(TokenContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.getTokenList();
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      var tokenListChanged = this.props.userTokens !== nextProps.userTokens;
	      var maxTokensCreated = this.props.tokenCreationError !== nextProps.tokenCreationError && nextProps.tokenCreationError;
	
	      var updateTokenSuccessful = this.props.updateTokenSuccess !== nextProps.updateTokenSuccess && nextProps.updateTokenSuccess;
	
	      var newTokenCreated = !!nextProps.newToken && !this.state.newTokenCreated;
	
	      if (tokenListChanged) {
	        this.setState({
	          tokens: nextProps.userTokens
	        });
	      }
	
	      if (newTokenCreated) {
	        this.setState({
	          newTokenCreated: true
	        });
	      }
	      if (maxTokensCreated) {
	        this.setState({
	          maxTokensCreated: true
	        });
	      }
	      if (updateTokenSuccessful) {
	        this.props.getTokenList();
	      }
	    }
	  }, {
	    key: 'handleCloseModal',
	    value: function handleCloseModal() {
	      this.setState({
	        newTokenCreated: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var tokens = this.state.tokens;
	      var generatedTokens = [];
	      if (tokens) {
	        generatedTokens = tokens.map(function (token) {
	          return _jsx(_TokenGenerator2.default, {
	            jwtTokenID: token.tokenId,
	            tokenDeleteRequest: function tokenDeleteRequest(jwt) {
	              _this2.props.deleteToken(jwt);
	            },
	            active: token.status,
	            expiry: token.expiredAt,
	            tokenActivateRequest: function tokenActivateRequest(jwt) {
	              _this2.props.activateToken(jwt);
	            },
	            tokenDeactivateRequest: function tokenDeactivateRequest(jwt) {
	              _this2.props.deactivateToken(jwt);
	            }
	          }, token.tokenId);
	        });
	      }
	      var alert = [{ message: 'Token Creation Limit Reached.' }];
	      return _jsx(_reactDocumentTitle2.default, {
	        title: 'Marionette'
	      }, void 0, _jsx('div', {
	        className: 'token-page has-text-centered'
	      }, void 0, _jsx('div', {
	        className: 'token-control'
	      }, void 0, this.state.maxTokensCreated && _jsx(_ErrorNotification2.default, {
	        errors: alert,
	        dismissible: true,
	        onClose: function onClose() {
	          _this2.setState({
	            maxTokensCreated: false
	          });
	          _this2.props.getTokenList();
	        }
	      }), _jsx('button', {
	        className: 'button is-primary',
	        title: 'Create New Token',
	        'aria-label': 'Create New Token',
	        onClick: function onClick() {
	          _this2.props.addNewToken();
	        }
	      }, void 0, 'Create New Token', _ref)), generatedTokens, this.state.newTokenCreated && _jsx(_TokenModal2.default, {
	        jwtToken: this.props.newToken,
	        showModal: 'true',
	        handleClose: function handleClose() {
	          return _this2.handleCloseModal();
	        }
	      })));
	    }
	  }]);
	
	  return TokenContainer;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    userTokens: state.app.tokenList || [],
	    tokenCreationError: state.app.tokenCreationError || false,
	    updateTokenSuccess: state.app.updateTokenSuccess || false,
	    newToken: state.app.newToken || null
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, {
	  getTokenList: _app.getTokenList,
	  activateToken: _app.activateToken,
	  deactivateToken: _app.deactivateToken,
	  deleteToken: _app.deleteToken,
	  addNewToken: _app.addNewToken
	})(TokenContainer);

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToggle = __webpack_require__(140);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	__webpack_require__(532);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('span', {
	  className: 'icon',
	  'aria-hidden': 'true'
	}, void 0, _jsx('i', {
	  className: 'fa fa-trash'
	}));
	
	var TokenGenerator = function (_Component) {
	  _inherits(TokenGenerator, _Component);
	
	  function TokenGenerator(props) {
	    _classCallCheck(this, TokenGenerator);
	
	    var _this = _possibleConstructorReturn(this, (TokenGenerator.__proto__ || Object.getPrototypeOf(TokenGenerator)).call(this, props));
	
	    _this.convertActive = function (activeStatus) {
	      return activeStatus === 1;
	    };
	
	    _this.handleToggleChange = function () {
	      var currentStatus = !_this.state.active;
	      var jwt = _this.props.jwtTokenID;
	      if (currentStatus) {
	        _this.props.tokenActivateRequest(jwt);
	      } else {
	        _this.props.tokenDeactivateRequest(jwt);
	      }
	    };
	
	    _this.state = {
	      active: _this.convertActive(_this.props.active)
	    };
	    return _this;
	  }
	
	  _createClass(TokenGenerator, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      var changeStatus = nextProps.active !== this.props.active;
	
	      if (changeStatus) {
	        this.setState({
	          active: this.convertActive(nextProps.active)
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _jsx('div', {
	        className: 'tokenComponent'
	      }, void 0, _jsx('div', {
	        className: 'card columns'
	      }, void 0, _jsx('div', {
	        className: 'content-wrapper column is-three-quarters'
	      }, void 0, _jsx('div', {
	        className: 'card-contents'
	      }, void 0, _jsx('p', {}, void 0, 'Token Id: ', this.props.jwtTokenID)), _jsx('footer', {
	        className: 'card-footer'
	      }, void 0, _jsx('div', {
	        className: 'column '
	      }, void 0, _jsx('div', {
	        className: 'card-footer-item tokenFooter'
	      }, void 0, _jsx('div', {
	        className: 'tokenStatus'
	      }, void 0, 'Status: ', this.state.active ? 'Activated' : 'Deactivated'), _jsx(_reactToggle2.default, {
	        checked: this.state.active,
	        icons: false,
	        onChange: this.handleToggleChange
	      })), _jsx('p', {
	        className: 'card-footer-item tokenFooter'
	      }, void 0, 'Expiry Date: ', this.props.expiry)))), _jsx('div', {
	        className: 'column is-one-quarter'
	      }, void 0, _jsx('button', {
	        className: 'button is-danger tokenDelBtn',
	        title: 'Delete token',
	        'aria-label': 'Delete token',
	        type: 'button',
	        onClick: function onClick() {
	          /* eslint-disable no-alert */
	          if (confirm('Are you sure you want to delete Token ' + _this2.props.jwtTokenID + '?')) {
	            _this2.props.tokenDeleteRequest(_this2.props.jwtTokenID);
	          }
	        }
	      }, void 0, _ref))));
	    }
	  }]);
	
	  return TokenGenerator;
	}(_react.Component);
	
	exports.default = TokenGenerator;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(533);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('p', {
	  className: 'modal-card-title'
	}, void 0, 'New JWT Token');
	
	var _ref2 = _jsx('p', {
	  className: 'notification is-warning'
	}, void 0, 'Please note that you will not be able to see your token again after closing.');
	
	var TokenModal = function (_Component) {
	  _inherits(TokenModal, _Component);
	
	  function TokenModal(props) {
	    _classCallCheck(this, TokenModal);
	
	    var _this = _possibleConstructorReturn(this, (TokenModal.__proto__ || Object.getPrototypeOf(TokenModal)).call(this, props));
	
	    _this.copyToClipboard = function (event) {
	      _this.textArea.select();
	      document.execCommand('copy');
	      event.target.focus();
	    };
	
	    _this.textArea = null;
	    return _this;
	  }
	
	  _createClass(TokenModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _jsx('div', {
	        className: (0, _classnames2.default)('modal TokenModal', {
	          'is-active': this.props.showModal
	        }),
	        role: 'dialog'
	      }, void 0, _jsx('div', {
	        className: 'modal-background',
	        onClick: function onClick() {
	          _this2.props.handleClose();
	        }
	      }), _jsx('div', {
	        className: 'modal-card'
	      }, void 0, _jsx('header', {
	        className: 'modal-card-head'
	      }, void 0, _ref, _jsx('button', {
	        className: 'delete',
	        'aria-label': 'close',
	        onClick: this.props.handleClose
	      })), _jsx('section', {
	        className: 'modal-card-body'
	      }, void 0, _ref2, _react2.default.createElement('textarea', {
	        readOnly: true,
	        value: this.props.jwtToken,
	        ref: function ref(textarea) {
	          _this2.textArea = textarea;
	        },
	        className: 'tokenTextArea'
	      })), _jsx('footer', {
	        className: 'modal-card-foot'
	      }, void 0, _jsx('button', {
	        className: 'button',
	        onClick: this.copyToClipboard
	      }, void 0, 'Copy Token'), _jsx('button', {
	        className: 'button',
	        onClick: this.props.handleClose
	      }, void 0, 'Close'))));
	    }
	  }]);
	
	  return TokenModal;
	}(_react.Component);
	
	exports.default = TokenModal;

/***/ },
/* 617 */,
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(55);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _useBeforeUnload = __webpack_require__(210);
	
	var _useBeforeUnload2 = _interopRequireDefault(_useBeforeUnload);
	
	exports['default'] = _deprecate2['default'](_useBeforeUnload2['default'], 'enableBeforeUnload is deprecated, use useBeforeUnload instead');
	module.exports = exports['default'];

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(55);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _useQueries = __webpack_require__(60);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	exports['default'] = _deprecate2['default'](_useQueries2['default'], 'enableQueries is deprecated, use useQueries instead');
	module.exports = exports['default'];

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(55);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _createLocation2 = __webpack_require__(208);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _createBrowserHistory = __webpack_require__(205);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	exports.createHistory = _createBrowserHistory2['default'];
	
	var _createHashHistory2 = __webpack_require__(130);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	exports.createHashHistory = _createHashHistory3['default'];
	
	var _createMemoryHistory2 = __webpack_require__(209);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	exports.createMemoryHistory = _createMemoryHistory3['default'];
	
	var _useBasename2 = __webpack_require__(132);
	
	var _useBasename3 = _interopRequireDefault(_useBasename2);
	
	exports.useBasename = _useBasename3['default'];
	
	var _useBeforeUnload2 = __webpack_require__(210);
	
	var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);
	
	exports.useBeforeUnload = _useBeforeUnload3['default'];
	
	var _useQueries2 = __webpack_require__(60);
	
	var _useQueries3 = _interopRequireDefault(_useQueries2);
	
	exports.useQueries = _useQueries3['default'];
	
	var _Actions2 = __webpack_require__(53);
	
	var _Actions3 = _interopRequireDefault(_Actions2);
	
	exports.Actions = _Actions3['default'];
	
	// deprecated
	
	var _enableBeforeUnload2 = __webpack_require__(618);
	
	var _enableBeforeUnload3 = _interopRequireDefault(_enableBeforeUnload2);
	
	exports.enableBeforeUnload = _enableBeforeUnload3['default'];
	
	var _enableQueries2 = __webpack_require__(619);
	
	var _enableQueries3 = _interopRequireDefault(_enableQueries2);
	
	exports.enableQueries = _enableQueries3['default'];
	var createLocation = _deprecate2['default'](_createLocation3['default'], 'Using createLocation without a history instance is deprecated; please use history.createLocation instead');
	exports.createLocation = createLocation;

/***/ },
/* 621 */,
/* 622 */
/***/ function(module, exports) {

	'use strict';
	var toString = Object.prototype.toString;
	
	module.exports = function (x) {
		var prototype;
		return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
	};


/***/ },
/* 623 */,
/* 624 */
/***/ function(module, exports) {

	exports = module.exports = stringify
	exports.getSerialize = serializer
	
	function stringify(obj, replacer, spaces, cycleReplacer) {
	  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
	}
	
	function serializer(replacer, cycleReplacer) {
	  var stack = [], keys = []
	
	  if (cycleReplacer == null) cycleReplacer = function(key, value) {
	    if (stack[0] === value) return "[Circular ~]"
	    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
	  }
	
	  return function(key, value) {
	    if (stack.length > 0) {
	      var thisPos = stack.indexOf(this)
	      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
	      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
	      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
	    }
	    else stack.push(value)
	
	    return replacer == null ? value : replacer.call(this, key, value)
	  }
	}


/***/ },
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(638);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(636)();
	}


/***/ },
/* 638 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */
/***/ function(module, exports) {

	'use strict';
	
	function RavenConfigError(message) {
	    this.name = 'RavenConfigError';
	    this.message = message;
	}
	RavenConfigError.prototype = new Error();
	RavenConfigError.prototype.constructor = RavenConfigError;
	
	module.exports = RavenConfigError;


/***/ },
/* 646 */
/***/ function(module, exports) {

	'use strict';
	
	var wrapMethod = function(console, level, callback) {
	    var originalConsoleLevel = console[level];
	    var originalConsole = console;
	
	    if (!(level in console)) {
	        return;
	    }
	
	    var sentryLevel = level === 'warn'
	        ? 'warning'
	        : level;
	
	    console[level] = function () {
	        var args = [].slice.call(arguments);
	
	        var msg = '' + args.join(' ');
	        var data = {level: sentryLevel, logger: 'console', extra: {'arguments': args}};
	        callback && callback(msg, data);
	
	        // this fails for some browsers. :(
	        if (originalConsoleLevel) {
	            // IE9 doesn't allow calling apply on console functions directly
	            // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
	            Function.prototype.apply.call(
	                originalConsoleLevel,
	                originalConsole,
	                args
	            );
	        }
	    };
	};
	
	module.exports = {
	    wrapMethod: wrapMethod
	};


/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false, __DEV__:false*/
	'use strict';
	
	var TraceKit = __webpack_require__(649);
	var RavenConfigError = __webpack_require__(645);
	var stringify = __webpack_require__(624);
	
	var wrapConsoleMethod = __webpack_require__(646).wrapMethod;
	
	var dsnKeys = 'source protocol user pass host port path'.split(' '),
	    dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;
	
	function now() {
	    return +new Date();
	}
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window = typeof window !== 'undefined' ? window
	            : typeof global !== 'undefined' ? global
	            : typeof self !== 'undefined' ? self
	            : {};
	var _document = _window.document;
	
	// First, check for JSON support
	// If there is no JSON, we no-op the core features of Raven
	// since JSON is required to encode the payload
	function Raven() {
	    this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
	    // Raven can run in contexts where there's no document (react-native)
	    this._hasDocument = !isUndefined(_document);
	    this._lastCapturedException = null;
	    this._lastEventId = null;
	    this._globalServer = null;
	    this._globalKey = null;
	    this._globalProject = null;
	    this._globalContext = {};
	    this._globalOptions = {
	        logger: 'javascript',
	        ignoreErrors: [],
	        ignoreUrls: [],
	        whitelistUrls: [],
	        includePaths: [],
	        crossOrigin: 'anonymous',
	        collectWindowErrors: true,
	        maxMessageLength: 0,
	        stackTraceLimit: 50,
	        autoBreadcrumbs: true
	    };
	    this._ignoreOnError = 0;
	    this._isRavenInstalled = false;
	    this._originalErrorStackTraceLimit = Error.stackTraceLimit;
	    // capture references to window.console *and* all its methods first
	    // before the console plugin has a chance to monkey patch
	    this._originalConsole = _window.console || {};
	    this._originalConsoleMethods = {};
	    this._plugins = [];
	    this._startTime = now();
	    this._wrappedBuiltIns = [];
	    this._breadcrumbs = [];
	    this._lastCapturedEvent = null;
	    this._keypressTimeout;
	    this._location = _window.location;
	    this._lastHref = this._location && this._location.href;
	
	    for (var method in this._originalConsole) {  // eslint-disable-line guard-for-in
	      this._originalConsoleMethods[method] = this._originalConsole[method];
	    }
	}
	
	/*
	 * The core Raven singleton
	 *
	 * @this {Raven}
	 */
	
	Raven.prototype = {
	    // Hardcode version string so that raven source can be loaded directly via
	    // webpack (using a build step causes webpack #1617). Grunt verifies that
	    // this value matches package.json during build.
	    //   See: https://github.com/getsentry/raven-js/issues/465
	    VERSION: '3.9.2',
	
	    debug: false,
	
	    TraceKit: TraceKit, // alias to TraceKit
	
	    /*
	     * Configure Raven with a DSN and extra options
	     *
	     * @param {string} dsn The public Sentry DSN
	     * @param {object} options Optional set of of global options [optional]
	     * @return {Raven}
	     */
	    config: function(dsn, options) {
	        var self = this;
	
	        if (self._globalServer) {
	                this._logDebug('error', 'Error: Raven has already been configured');
	            return self;
	        }
	        if (!dsn) return self;
	
	        var globalOptions = self._globalOptions;
	
	        // merge in options
	        if (options) {
	            each(options, function(key, value){
	                // tags and extra are special and need to be put into context
	                if (key === 'tags' || key === 'extra' || key === 'user') {
	                    self._globalContext[key] = value;
	                } else {
	                    globalOptions[key] = value;
	                }
	            });
	        }
	
	        self.setDSN(dsn);
	
	        // "Script error." is hard coded into browsers for errors that it can't read.
	        // this is the result of a script being pulled in from an external domain and CORS.
	        globalOptions.ignoreErrors.push(/^Script error\.?$/);
	        globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);
	
	        // join regexp rules into one big rule
	        globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
	        globalOptions.ignoreUrls = globalOptions.ignoreUrls.length ? joinRegExp(globalOptions.ignoreUrls) : false;
	        globalOptions.whitelistUrls = globalOptions.whitelistUrls.length ? joinRegExp(globalOptions.whitelistUrls) : false;
	        globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
	        globalOptions.maxBreadcrumbs = Math.max(0, Math.min(globalOptions.maxBreadcrumbs || 100, 100)); // default and hard limit is 100
	
	        var autoBreadcrumbDefaults = {
	            xhr: true,
	            console: true,
	            dom: true,
	            location: true
	        };
	
	        var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
	        if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
	            autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
	        } else if (autoBreadcrumbs !== false) {
	            autoBreadcrumbs = autoBreadcrumbDefaults;
	        }
	        globalOptions.autoBreadcrumbs = autoBreadcrumbs;
	
	        TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;
	
	        // return for chaining
	        return self;
	    },
	
	    /*
	     * Installs a global window.onerror error handler
	     * to capture and report uncaught exceptions.
	     * At this point, install() is required to be called due
	     * to the way TraceKit is set up.
	     *
	     * @return {Raven}
	     */
	    install: function() {
	        var self = this;
	        if (self.isSetup() && !self._isRavenInstalled) {
	            TraceKit.report.subscribe(function () {
	                self._handleOnErrorStackInfo.apply(self, arguments);
	            });
	            self._instrumentTryCatch();
	            if (self._globalOptions.autoBreadcrumbs)
	                self._instrumentBreadcrumbs();
	
	            // Install all of the plugins
	            self._drainPlugins();
	
	            self._isRavenInstalled = true;
	        }
	
	        Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
	        return this;
	    },
	
	    /*
	     * Set the DSN (can be called multiple time unlike config)
	     *
	     * @param {string} dsn The public Sentry DSN
	     */
	    setDSN: function(dsn) {
	        var self = this,
	            uri = self._parseDSN(dsn),
	          lastSlash = uri.path.lastIndexOf('/'),
	          path = uri.path.substr(1, lastSlash);
	
	        self._dsn = dsn;
	        self._globalKey = uri.user;
	        self._globalSecret = uri.pass && uri.pass.substr(1);
	        self._globalProject = uri.path.substr(lastSlash + 1);
	
	        self._globalServer = self._getGlobalServer(uri);
	
	        self._globalEndpoint = self._globalServer +
	            '/' + path + 'api/' + self._globalProject + '/store/';
	    },
	
	    /*
	     * Wrap code within a context so Raven can capture errors
	     * reliably across domains that is executed immediately.
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The callback to be immediately executed within the context
	     * @param {array} args An array of arguments to be called with the callback [optional]
	     */
	    context: function(options, func, args) {
	        if (isFunction(options)) {
	            args = func || [];
	            func = options;
	            options = undefined;
	        }
	
	        return this.wrap(options, func).apply(this, args);
	    },
	
	    /*
	     * Wrap code within a context and returns back a new function to be executed
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The function to be wrapped in a new context
	     * @param {function} func A function to call before the try/catch wrapper [optional, private]
	     * @return {function} The newly wrapped functions with a context
	     */
	    wrap: function(options, func, _before) {
	        var self = this;
	        // 1 argument has been passed, and it's not a function
	        // so just return it
	        if (isUndefined(func) && !isFunction(options)) {
	            return options;
	        }
	
	        // options is optional
	        if (isFunction(options)) {
	            func = options;
	            options = undefined;
	        }
	
	        // At this point, we've passed along 2 arguments, and the second one
	        // is not a function either, so we'll just return the second argument.
	        if (!isFunction(func)) {
	            return func;
	        }
	
	        // We don't wanna wrap it twice!
	        try {
	            if (func.__raven__) {
	                return func;
	            }
	
	            // If this has already been wrapped in the past, return that
	            if (func.__raven_wrapper__ ){
	                return func.__raven_wrapper__ ;
	            }
	        } catch (e) {
	            // Just accessing custom props in some Selenium environments
	            // can cause a "Permission denied" exception (see raven-js#495).
	            // Bail on wrapping and return the function as-is (defers to window.onerror).
	            return func;
	        }
	
	        function wrapped() {
	            var args = [], i = arguments.length,
	                deep = !options || options && options.deep !== false;
	
	            if (_before && isFunction(_before)) {
	                _before.apply(this, arguments);
	            }
	
	            // Recursively wrap all of a function's arguments that are
	            // functions themselves.
	            while(i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];
	
	            try {
	                return func.apply(this, args);
	            } catch(e) {
	                self._ignoreNextOnError();
	                self.captureException(e, options);
	                throw e;
	            }
	        }
	
	        // copy over properties of the old function
	        for (var property in func) {
	            if (hasKey(func, property)) {
	                wrapped[property] = func[property];
	            }
	        }
	        wrapped.prototype = func.prototype;
	
	        func.__raven_wrapper__ = wrapped;
	        // Signal that this function has been wrapped already
	        // for both debugging and to prevent it to being wrapped twice
	        wrapped.__raven__ = true;
	        wrapped.__inner__ = func;
	
	        return wrapped;
	    },
	
	    /*
	     * Uninstalls the global error handler.
	     *
	     * @return {Raven}
	     */
	    uninstall: function() {
	        TraceKit.report.uninstall();
	
	        this._restoreBuiltIns();
	
	        Error.stackTraceLimit = this._originalErrorStackTraceLimit;
	        this._isRavenInstalled = false;
	
	        return this;
	    },
	
	    /*
	     * Manually capture an exception and send it over to Sentry
	     *
	     * @param {error} ex An exception to be logged
	     * @param {object} options A specific set of options for this error [optional]
	     * @return {Raven}
	     */
	    captureException: function(ex, options) {
	        // If not an Error is passed through, recall as a message instead
	        if (!isError(ex)) {
	            return this.captureMessage(ex, objectMerge({
	                trimHeadFrames: 1,
	                stacktrace: true // if we fall back to captureMessage, default to attempting a new trace
	            }, options));
	        }
	
	        // Store the raw exception object for potential debugging and introspection
	        this._lastCapturedException = ex;
	
	        // TraceKit.report will re-raise any exception passed to it,
	        // which means you have to wrap it in try/catch. Instead, we
	        // can wrap it here and only re-raise if TraceKit.report
	        // raises an exception different from the one we asked to
	        // report on.
	        try {
	            var stack = TraceKit.computeStackTrace(ex);
	            this._handleStackInfo(stack, options);
	        } catch(ex1) {
	            if(ex !== ex1) {
	                throw ex1;
	            }
	        }
	
	        return this;
	    },
	
	    /*
	     * Manually send a message to Sentry
	     *
	     * @param {string} msg A plain message to be captured in Sentry
	     * @param {object} options A specific set of options for this message [optional]
	     * @return {Raven}
	     */
	    captureMessage: function(msg, options) {
	        // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
	        // early call; we'll error on the side of logging anything called before configuration since it's
	        // probably something you should see:
	        if (!!this._globalOptions.ignoreErrors.test && this._globalOptions.ignoreErrors.test(msg)) {
	            return;
	        }
	
	        options = options || {};
	
	        var data = objectMerge({
	            message: msg + ''  // Make sure it's actually a string
	        }, options);
	
	        if (this._globalOptions.stacktrace || (options && options.stacktrace)) {
	            var ex;
	            // create a stack trace from this point; just trim
	            // off extra frames so they don't include this function call (or
	            // earlier Raven.js library fn calls)
	            try {
	                throw new Error(msg);
	            } catch (ex1) {
	                ex = ex1;
	            }
	
	            // null exception name so `Error` isn't prefixed to msg
	            ex.name = null;
	
	            options = objectMerge({
	                // fingerprint on msg, not stack trace (legacy behavior, could be
	                // revisited)
	                fingerprint: msg,
	                trimHeadFrames: (options.trimHeadFrames || 0) + 1
	            }, options);
	
	            var stack = TraceKit.computeStackTrace(ex);
	            var frames = this._prepareFrames(stack, options);
	            data.stacktrace = {
	                // Sentry expects frames oldest to newest
	                frames: frames.reverse()
	            }
	        }
	
	        // Fire away!
	        this._send(data);
	
	        return this;
	    },
	
	    captureBreadcrumb: function (obj) {
	        var crumb = objectMerge({
	            timestamp: now() / 1000
	        }, obj);
	
	        if (isFunction(this._globalOptions.breadcrumbCallback)) {
	            var result = this._globalOptions.breadcrumbCallback(crumb);
	
	            if (isObject(result) && !isEmptyObject(result)) {
	                crumb = result;
	            } else if (result === false) {
	                return this;
	            }
	        }
	
	        this._breadcrumbs.push(crumb);
	        if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
	            this._breadcrumbs.shift();
	        }
	        return this;
	    },
	
	    addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
	        var pluginArgs = [].slice.call(arguments, 1);
	
	        this._plugins.push([plugin, pluginArgs]);
	        if (this._isRavenInstalled) {
	            this._drainPlugins();
	        }
	
	        return this;
	    },
	
	    /*
	     * Set/clear a user to be sent along with the payload.
	     *
	     * @param {object} user An object representing user data [optional]
	     * @return {Raven}
	     */
	    setUserContext: function(user) {
	        // Intentionally do not merge here since that's an unexpected behavior.
	        this._globalContext.user = user;
	
	        return this;
	    },
	
	    /*
	     * Merge extra attributes to be sent along with the payload.
	     *
	     * @param {object} extra An object representing extra data [optional]
	     * @return {Raven}
	     */
	    setExtraContext: function(extra) {
	        this._mergeContext('extra', extra);
	
	        return this;
	    },
	
	    /*
	     * Merge tags to be sent along with the payload.
	     *
	     * @param {object} tags An object representing tags [optional]
	     * @return {Raven}
	     */
	    setTagsContext: function(tags) {
	        this._mergeContext('tags', tags);
	
	        return this;
	    },
	
	    /*
	     * Clear all of the context.
	     *
	     * @return {Raven}
	     */
	    clearContext: function() {
	        this._globalContext = {};
	
	        return this;
	    },
	
	    /*
	     * Get a copy of the current context. This cannot be mutated.
	     *
	     * @return {object} copy of context
	     */
	    getContext: function() {
	        // lol javascript
	        return JSON.parse(stringify(this._globalContext));
	    },
	
	
	    /*
	     * Set environment of application
	     *
	     * @param {string} environment Typically something like 'production'.
	     * @return {Raven}
	     */
	    setEnvironment: function(environment) {
	        this._globalOptions.environment = environment;
	
	        return this;
	    },
	
	    /*
	     * Set release version of application
	     *
	     * @param {string} release Typically something like a git SHA to identify version
	     * @return {Raven}
	     */
	    setRelease: function(release) {
	        this._globalOptions.release = release;
	
	        return this;
	    },
	
	    /*
	     * Set the dataCallback option
	     *
	     * @param {function} callback The callback to run which allows the
	     *                            data blob to be mutated before sending
	     * @return {Raven}
	     */
	    setDataCallback: function(callback) {
	        var original = this._globalOptions.dataCallback;
	        this._globalOptions.dataCallback = isFunction(callback)
	          ? function (data) { return callback(data, original); }
	          : callback;
	
	        return this;
	    },
	
	    /*
	     * Set the breadcrumbCallback option
	     *
	     * @param {function} callback The callback to run which allows filtering
	     *                            or mutating breadcrumbs
	     * @return {Raven}
	     */
	    setBreadcrumbCallback: function(callback) {
	        var original = this._globalOptions.breadcrumbCallback;
	        this._globalOptions.breadcrumbCallback = isFunction(callback)
	          ? function (data) { return callback(data, original); }
	          : callback;
	
	        return this;
	    },
	
	    /*
	     * Set the shouldSendCallback option
	     *
	     * @param {function} callback The callback to run which allows
	     *                            introspecting the blob before sending
	     * @return {Raven}
	     */
	    setShouldSendCallback: function(callback) {
	        var original = this._globalOptions.shouldSendCallback;
	        this._globalOptions.shouldSendCallback = isFunction(callback)
	            ? function (data) { return callback(data, original); }
	            : callback;
	
	        return this;
	    },
	
	    /**
	     * Override the default HTTP transport mechanism that transmits data
	     * to the Sentry server.
	     *
	     * @param {function} transport Function invoked instead of the default
	     *                             `makeRequest` handler.
	     *
	     * @return {Raven}
	     */
	    setTransport: function(transport) {
	        this._globalOptions.transport = transport;
	
	        return this;
	    },
	
	    /*
	     * Get the latest raw exception that was captured by Raven.
	     *
	     * @return {error}
	     */
	    lastException: function() {
	        return this._lastCapturedException;
	    },
	
	    /*
	     * Get the last event id
	     *
	     * @return {string}
	     */
	    lastEventId: function() {
	        return this._lastEventId;
	    },
	
	    /*
	     * Determine if Raven is setup and ready to go.
	     *
	     * @return {boolean}
	     */
	    isSetup: function() {
	        if (!this._hasJSON) return false;  // needs JSON support
	        if (!this._globalServer) {
	            if (!this.ravenNotConfiguredError) {
	              this.ravenNotConfiguredError = true;
	              this._logDebug('error', 'Error: Raven has not been configured.');
	            }
	            return false;
	        }
	        return true;
	    },
	
	    afterLoad: function () {
	        // TODO: remove window dependence?
	
	        // Attempt to initialize Raven on load
	        var RavenConfig = _window.RavenConfig;
	        if (RavenConfig) {
	            this.config(RavenConfig.dsn, RavenConfig.config).install();
	        }
	    },
	
	    showReportDialog: function (options) {
	        if (!_document) // doesn't work without a document (React native)
	            return;
	
	        options = options || {};
	
	        var lastEventId = options.eventId || this.lastEventId();
	        if (!lastEventId) {
	            throw new RavenConfigError('Missing eventId');
	        }
	
	        var dsn = options.dsn || this._dsn;
	        if (!dsn) {
	            throw new RavenConfigError('Missing DSN');
	        }
	
	        var encode = encodeURIComponent;
	        var qs = '';
	        qs += '?eventId=' + encode(lastEventId);
	        qs += '&dsn=' + encode(dsn);
	
	        var user = options.user || this._globalContext.user;
	        if (user) {
	            if (user.name)  qs += '&name=' + encode(user.name);
	            if (user.email) qs += '&email=' + encode(user.email);
	        }
	
	        var globalServer = this._getGlobalServer(this._parseDSN(dsn));
	
	        var script = _document.createElement('script');
	        script.async = true;
	        script.src = globalServer + '/api/embed/error-page/' + qs;
	        (_document.head || _document.body).appendChild(script);
	    },
	
	    /**** Private functions ****/
	    _ignoreNextOnError: function () {
	        var self = this;
	        this._ignoreOnError += 1;
	        setTimeout(function () {
	            // onerror should trigger before setTimeout
	            self._ignoreOnError -= 1;
	        });
	    },
	
	    _triggerEvent: function(eventType, options) {
	        // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
	        var evt, key;
	
	        if (!this._hasDocument)
	            return;
	
	        options = options || {};
	
	        eventType = 'raven' + eventType.substr(0,1).toUpperCase() + eventType.substr(1);
	
	        if (_document.createEvent) {
	            evt = _document.createEvent('HTMLEvents');
	            evt.initEvent(eventType, true, true);
	        } else {
	            evt = _document.createEventObject();
	            evt.eventType = eventType;
	        }
	
	        for (key in options) if (hasKey(options, key)) {
	            evt[key] = options[key];
	        }
	
	        if (_document.createEvent) {
	            // IE9 if standards
	            _document.dispatchEvent(evt);
	        } else {
	            // IE8 regardless of Quirks or Standards
	            // IE9 if quirks
	            try {
	                _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
	            } catch(e) {
	                // Do nothing
	            }
	        }
	    },
	
	    /**
	     * Wraps addEventListener to capture UI breadcrumbs
	     * @param evtName the event name (e.g. "click")
	     * @returns {Function}
	     * @private
	     */
	    _breadcrumbEventHandler: function(evtName) {
	        var self = this;
	        return function (evt) {
	            // reset keypress timeout; e.g. triggering a 'click' after
	            // a 'keypress' will reset the keypress debounce so that a new
	            // set of keypresses can be recorded
	            self._keypressTimeout = null;
	
	            // It's possible this handler might trigger multiple times for the same
	            // event (e.g. event propagation through node ancestors). Ignore if we've
	            // already captured the event.
	            if (self._lastCapturedEvent === evt)
	                return;
	
	            self._lastCapturedEvent = evt;
	            var elem = evt.target;
	
	            var target;
	
	            // try/catch htmlTreeAsString because it's particularly complicated, and
	            // just accessing the DOM incorrectly can throw an exception in some circumstances.
	            try {
	                target = htmlTreeAsString(elem);
	            } catch (e) {
	                target = '<unknown>';
	            }
	
	            self.captureBreadcrumb({
	                category: 'ui.' + evtName, // e.g. ui.click, ui.input
	                message: target
	            });
	        };
	    },
	
	    /**
	     * Wraps addEventListener to capture keypress UI events
	     * @returns {Function}
	     * @private
	     */
	    _keypressEventHandler: function() {
	        var self = this,
	            debounceDuration = 1000; // milliseconds
	
	        // TODO: if somehow user switches keypress target before
	        //       debounce timeout is triggered, we will only capture
	        //       a single breadcrumb from the FIRST target (acceptable?)
	        return function (evt) {
	            var target = evt.target,
	                tagName = target && target.tagName;
	
	            // only consider keypress events on actual input elements
	            // this will disregard keypresses targeting body (e.g. tabbing
	            // through elements, hotkeys, etc)
	            if (!tagName || tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
	                return;
	
	            // record first keypress in a series, but ignore subsequent
	            // keypresses until debounce clears
	            var timeout = self._keypressTimeout;
	            if (!timeout) {
	                self._breadcrumbEventHandler('input')(evt);
	            }
	            clearTimeout(timeout);
	            self._keypressTimeout = setTimeout(function () {
	                self._keypressTimeout = null;
	            }, debounceDuration);
	        };
	    },
	
	    /**
	     * Captures a breadcrumb of type "navigation", normalizing input URLs
	     * @param to the originating URL
	     * @param from the target URL
	     * @private
	     */
	    _captureUrlChange: function(from, to) {
	        var parsedLoc = parseUrl(this._location.href);
	        var parsedTo = parseUrl(to);
	        var parsedFrom = parseUrl(from);
	
	        // because onpopstate only tells you the "new" (to) value of location.href, and
	        // not the previous (from) value, we need to track the value of the current URL
	        // state ourselves
	        this._lastHref = to;
	
	        // Use only the path component of the URL if the URL matches the current
	        // document (almost all the time when using pushState)
	        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
	            to = parsedTo.relative;
	        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
	            from = parsedFrom.relative;
	
	        this.captureBreadcrumb({
	            category: 'navigation',
	            data: {
	                to: to,
	                from: from
	            }
	        });
	    },
	
	    /**
	     * Install any queued plugins
	     */
	    _instrumentTryCatch: function() {
	        var self = this;
	
	        var wrappedBuiltIns = self._wrappedBuiltIns;
	
	        function wrapTimeFn(orig) {
	            return function (fn, t) { // preserve arity
	                // Make a copy of the arguments to prevent deoptimization
	                // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	                var args = new Array(arguments.length);
	                for(var i = 0; i < args.length; ++i) {
	                    args[i] = arguments[i];
	                }
	                var originalCallback = args[0];
	                if (isFunction(originalCallback)) {
	                    args[0] = self.wrap(originalCallback);
	                }
	
	                // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
	                // also supports only two arguments and doesn't care what this is, so we
	                // can just call the original function directly.
	                if (orig.apply) {
	                    return orig.apply(this, args);
	                } else {
	                    return orig(args[0], args[1]);
	                }
	            };
	        }
	
	        var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	
	        function wrapEventTarget(global) {
	            var proto = _window[global] && _window[global].prototype;
	            if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
	                fill(proto, 'addEventListener', function(orig) {
	                    return function (evtName, fn, capture, secure) { // preserve arity
	                        try {
	                            if (fn && fn.handleEvent) {
	                                fn.handleEvent = self.wrap(fn.handleEvent);
	                            }
	                        } catch (err) {
	                            // can sometimes get 'Permission denied to access property "handle Event'
	                        }
	
	                        // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
	                        // so that we don't have more than one wrapper function
	                        var before,
	                            clickHandler,
	                            keypressHandler;
	
	                        if (autoBreadcrumbs && autoBreadcrumbs.dom && (global === 'EventTarget' || global === 'Node')) {
	                            // NOTE: generating multiple handlers per addEventListener invocation, should
	                            //       revisit and verify we can just use one (almost certainly)
	                            clickHandler = self._breadcrumbEventHandler('click');
	                            keypressHandler = self._keypressEventHandler();
	                            before = function (evt) {
	                                // need to intercept every DOM event in `before` argument, in case that
	                                // same wrapped method is re-used for different events (e.g. mousemove THEN click)
	                                // see #724
	                                if (!evt) return;
	
	                                if (evt.type === 'click')
	                                    return clickHandler(evt);
	                                else if (evt.type === 'keypress')
	                                    return keypressHandler(evt);
	                            };
	                        }
	                        return orig.call(this, evtName, self.wrap(fn, undefined, before), capture, secure);
	                    };
	                }, wrappedBuiltIns);
	                fill(proto, 'removeEventListener', function (orig) {
	                    return function (evt, fn, capture, secure) {
	                        try {
	                            fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__  : fn);
	                        } catch (e) {
	                            // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
	                        }
	                        return orig.call(this, evt, fn, capture, secure);
	                    };
	                }, wrappedBuiltIns);
	            }
	        }
	
	        fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
	        fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
	        if (_window.requestAnimationFrame) {
	            fill(_window, 'requestAnimationFrame', function (orig) {
	                return function (cb) {
	                    return orig(self.wrap(cb));
	                };
	            }, wrappedBuiltIns);
	        }
	
	        // event targets borrowed from bugsnag-js:
	        // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
	        var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
	        for (var i = 0; i < eventTargets.length; i++) {
	            wrapEventTarget(eventTargets[i]);
	        }
	
	        var $ = _window.jQuery || _window.$;
	        if ($ && $.fn && $.fn.ready) {
	            fill($.fn, 'ready', function (orig) {
	                return function (fn) {
	                    return orig.call(this, self.wrap(fn));
	                };
	            }, wrappedBuiltIns);
	        }
	    },
	
	
	    /**
	     * Instrument browser built-ins w/ breadcrumb capturing
	     *  - XMLHttpRequests
	     *  - DOM interactions (click/typing)
	     *  - window.location changes
	     *  - console
	     *
	     * Can be disabled or individually configured via the `autoBreadcrumbs` config option
	     */
	    _instrumentBreadcrumbs: function () {
	        var self = this;
	        var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	
	        var wrappedBuiltIns = self._wrappedBuiltIns;
	
	        function wrapProp(prop, xhr) {
	            if (prop in xhr && isFunction(xhr[prop])) {
	                fill(xhr, prop, function (orig) {
	                    return self.wrap(orig);
	                }); // intentionally don't track filled methods on XHR instances
	            }
	        }
	
	        if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
	            var xhrproto = XMLHttpRequest.prototype;
	            fill(xhrproto, 'open', function(origOpen) {
	                return function (method, url) { // preserve arity
	
	                    // if Sentry key appears in URL, don't capture
	                    if (isString(url) && url.indexOf(self._globalKey) === -1) {
	                        this.__raven_xhr = {
	                            method: method,
	                            url: url,
	                            status_code: null
	                        };
	                    }
	
	                    return origOpen.apply(this, arguments);
	                };
	            }, wrappedBuiltIns);
	
	            fill(xhrproto, 'send', function(origSend) {
	                return function (data) { // preserve arity
	                    var xhr = this;
	
	                    function onreadystatechangeHandler() {
	                        if (xhr.__raven_xhr && (xhr.readyState === 1 || xhr.readyState === 4)) {
	                            try {
	                                // touching statusCode in some platforms throws
	                                // an exception
	                                xhr.__raven_xhr.status_code = xhr.status;
	                            } catch (e) { /* do nothing */ }
	                            self.captureBreadcrumb({
	                                type: 'http',
	                                category: 'xhr',
	                                data: xhr.__raven_xhr
	                            });
	                        }
	                    }
	
	                    var props = ['onload', 'onerror', 'onprogress'];
	                    for (var j = 0; j < props.length; j++) {
	                        wrapProp(props[j], xhr);
	                    }
	
	                    if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
	                        fill(xhr, 'onreadystatechange', function (orig) {
	                            return self.wrap(orig, undefined, onreadystatechangeHandler);
	                        } /* intentionally don't track this instrumentation */);
	                    } else {
	                        // if onreadystatechange wasn't actually set by the page on this xhr, we
	                        // are free to set our own and capture the breadcrumb
	                        xhr.onreadystatechange = onreadystatechangeHandler;
	                    }
	
	                    return origSend.apply(this, arguments);
	                };
	            }, wrappedBuiltIns);
	        }
	
	        if (autoBreadcrumbs.xhr && 'fetch' in _window) {
	            fill(_window, 'fetch', function(origFetch) {
	                return function (fn, t) { // preserve arity
	                    // Make a copy of the arguments to prevent deoptimization
	                    // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	                    var args = new Array(arguments.length);
	                    for(var i = 0; i < args.length; ++i) {
	                        args[i] = arguments[i];
	                    }
	
	                    var method = 'GET';
	
	                    if (args[1] && args[1].method) {
	                        method = args[1].method;
	                    }
	
	                    var fetchData = {
	                        method: method,
	                        url: args[0],
	                        status_code: null
	                    };
	
	                    self.captureBreadcrumb({
	                        type: 'http',
	                        category: 'fetch',
	                        data: fetchData
	                    });
	
	                    return origFetch.apply(this, args).then(function (response) {
	                        fetchData.status_code = response.status;
	
	                        return response;
	                    });
	                };
	            }, wrappedBuiltIns);
	        }
	
	        // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
	        // to the document. Do this before we instrument addEventListener.
	        if (autoBreadcrumbs.dom && this._hasDocument) {
	            if (_document.addEventListener) {
	                _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
	                _document.addEventListener('keypress', self._keypressEventHandler(), false);
	            }
	            else {
	                // IE8 Compatibility
	                _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
	                _document.attachEvent('onkeypress', self._keypressEventHandler());
	            }
	        }
	
	        // record navigation (URL) changes
	        // NOTE: in Chrome App environment, touching history.pushState, *even inside
	        //       a try/catch block*, will cause Chrome to output an error to console.error
	        // borrowed from: https://github.com/angular/angular.js/pull/13945/files
	        var chrome = _window.chrome;
	        var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
	        var hasPushState = !isChromePackagedApp && _window.history && history.pushState;
	        if (autoBreadcrumbs.location && hasPushState) {
	            // TODO: remove onpopstate handler on uninstall()
	            var oldOnPopState = _window.onpopstate;
	            _window.onpopstate = function () {
	                var currentHref = self._location.href;
	                self._captureUrlChange(self._lastHref, currentHref);
	
	                if (oldOnPopState) {
	                    return oldOnPopState.apply(this, arguments);
	                }
	            };
	
	            fill(history, 'pushState', function (origPushState) {
	                // note history.pushState.length is 0; intentionally not declaring
	                // params to preserve 0 arity
	                return function (/* state, title, url */) {
	                    var url = arguments.length > 2 ? arguments[2] : undefined;
	
	                    // url argument is optional
	                    if (url) {
	                        // coerce to string (this is what pushState does)
	                        self._captureUrlChange(self._lastHref, url + '');
	                    }
	
	                    return origPushState.apply(this, arguments);
	                };
	            }, wrappedBuiltIns);
	        }
	
	        if (autoBreadcrumbs.console && 'console' in _window && console.log) {
	            // console
	            var consoleMethodCallback = function (msg, data) {
	                self.captureBreadcrumb({
	                    message: msg,
	                    level: data.level,
	                    category: 'console'
	                });
	            };
	
	            each(['debug', 'info', 'warn', 'error', 'log'], function (_, level) {
	                wrapConsoleMethod(console, level, consoleMethodCallback);
	            });
	        }
	
	    },
	
	    _restoreBuiltIns: function () {
	        // restore any wrapped builtins
	        var builtin;
	        while (this._wrappedBuiltIns.length) {
	            builtin = this._wrappedBuiltIns.shift();
	
	            var obj = builtin[0],
	              name = builtin[1],
	              orig = builtin[2];
	
	            obj[name] = orig;
	        }
	    },
	
	    _drainPlugins: function() {
	        var self = this;
	
	        // FIX ME TODO
	        each(this._plugins, function(_, plugin) {
	            var installer = plugin[0];
	            var args = plugin[1];
	            installer.apply(self, [self].concat(args));
	        });
	    },
	
	    _parseDSN: function(str) {
	        var m = dsnPattern.exec(str),
	            dsn = {},
	            i = 7;
	
	        try {
	            while (i--) dsn[dsnKeys[i]] = m[i] || '';
	        } catch(e) {
	            throw new RavenConfigError('Invalid DSN: ' + str);
	        }
	
	        if (dsn.pass && !this._globalOptions.allowSecretKey) {
	            throw new RavenConfigError('Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key');
	        }
	
	        return dsn;
	    },
	
	    _getGlobalServer: function(uri) {
	        // assemble the endpoint from the uri pieces
	        var globalServer = '//' + uri.host +
	            (uri.port ? ':' + uri.port : '');
	
	        if (uri.protocol) {
	            globalServer = uri.protocol + ':' + globalServer;
	        }
	        return globalServer;
	    },
	
	    _handleOnErrorStackInfo: function() {
	        // if we are intentionally ignoring errors via onerror, bail out
	        if (!this._ignoreOnError) {
	            this._handleStackInfo.apply(this, arguments);
	        }
	    },
	
	    _handleStackInfo: function(stackInfo, options) {
	        var frames = this._prepareFrames(stackInfo, options);
	
	        this._triggerEvent('handle', {
	            stackInfo: stackInfo,
	            options: options
	        });
	
	        this._processException(
	            stackInfo.name,
	            stackInfo.message,
	            stackInfo.url,
	            stackInfo.lineno,
	            frames,
	            options
	        );
	    },
	
	    _prepareFrames: function(stackInfo, options) {
	        var self = this;
	        var frames = [];
	        if (stackInfo.stack && stackInfo.stack.length) {
	            each(stackInfo.stack, function(i, stack) {
	                var frame = self._normalizeFrame(stack);
	                if (frame) {
	                    frames.push(frame);
	                }
	            });
	
	            // e.g. frames captured via captureMessage throw
	            if (options && options.trimHeadFrames) {
	                for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
	                    frames[j].in_app = false;
	                }
	            }
	        }
	        frames = frames.slice(0, this._globalOptions.stackTraceLimit);
	        return frames;
	    },
	
	
	    _normalizeFrame: function(frame) {
	        if (!frame.url) return;
	
	        // normalize the frames data
	        var normalized = {
	            filename:   frame.url,
	            lineno:     frame.line,
	            colno:      frame.column,
	            'function': frame.func || '?'
	        };
	
	        normalized.in_app = !( // determine if an exception came from outside of our app
	            // first we check the global includePaths list.
	            !!this._globalOptions.includePaths.test && !this._globalOptions.includePaths.test(normalized.filename) ||
	            // Now we check for fun, if the function name is Raven or TraceKit
	            /(Raven|TraceKit)\./.test(normalized['function']) ||
	            // finally, we do a last ditch effort and check for raven.min.js
	            /raven\.(min\.)?js$/.test(normalized.filename)
	        );
	
	        return normalized;
	    },
	
	    _processException: function(type, message, fileurl, lineno, frames, options) {
	        var stacktrace;
	        if (!!this._globalOptions.ignoreErrors.test && this._globalOptions.ignoreErrors.test(message)) return;
	
	        message += '';
	
	        if (frames && frames.length) {
	            fileurl = frames[0].filename || fileurl;
	            // Sentry expects frames oldest to newest
	            // and JS sends them as newest to oldest
	            frames.reverse();
	            stacktrace = {frames: frames};
	        } else if (fileurl) {
	            stacktrace = {
	                frames: [{
	                    filename: fileurl,
	                    lineno: lineno,
	                    in_app: true
	                }]
	            };
	        }
	
	        if (!!this._globalOptions.ignoreUrls.test && this._globalOptions.ignoreUrls.test(fileurl)) return;
	        if (!!this._globalOptions.whitelistUrls.test && !this._globalOptions.whitelistUrls.test(fileurl)) return;
	
	        var data = objectMerge({
	            // sentry.interfaces.Exception
	            exception: {
	                values: [{
	                    type: type,
	                    value: message,
	                    stacktrace: stacktrace
	                }]
	            },
	            culprit: fileurl
	        }, options);
	
	        // Fire away!
	        this._send(data);
	    },
	
	    _trimPacket: function(data) {
	        // For now, we only want to truncate the two different messages
	        // but this could/should be expanded to just trim everything
	        var max = this._globalOptions.maxMessageLength;
	        if (data.message) {
	            data.message = truncate(data.message, max);
	        }
	        if (data.exception) {
	            var exception = data.exception.values[0];
	            exception.value = truncate(exception.value, max);
	        }
	
	        return data;
	    },
	
	    _getHttpData: function() {
	        if (!this._hasDocument || !_document.location || !_document.location.href) {
	            return;
	        }
	
	        var httpData = {
	            headers: {
	                'User-Agent': navigator.userAgent
	            }
	        };
	
	        httpData.url = _document.location.href;
	
	        if (_document.referrer) {
	            httpData.headers.Referer = _document.referrer;
	        }
	
	        return httpData;
	    },
	
	
	    _send: function(data) {
	        var globalOptions = this._globalOptions;
	
	        var baseData = {
	            project: this._globalProject,
	            logger: globalOptions.logger,
	            platform: 'javascript'
	        }, httpData = this._getHttpData();
	
	        if (httpData) {
	            baseData.request = httpData;
	        }
	
	        // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
	        if (data.trimHeadFrames) delete data.trimHeadFrames;
	
	        data = objectMerge(baseData, data);
	
	        // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
	        data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
	        data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);
	
	        // Send along our own collected metadata with extra
	        data.extra['session:duration'] = now() - this._startTime;
	
	        if (this._breadcrumbs && this._breadcrumbs.length > 0) {
	            // intentionally make shallow copy so that additions
	            // to breadcrumbs aren't accidentally sent in this request
	            data.breadcrumbs = {
	                values: [].slice.call(this._breadcrumbs, 0)
	            };
	        }
	
	        // If there are no tags/extra, strip the key from the payload alltogther.
	        if (isEmptyObject(data.tags)) delete data.tags;
	
	        if (this._globalContext.user) {
	            // sentry.interfaces.User
	            data.user = this._globalContext.user;
	        }
	
	        // Include the environment if it's defined in globalOptions
	        if (globalOptions.environment) data.environment = globalOptions.environment;
	
	        // Include the release if it's defined in globalOptions
	        if (globalOptions.release) data.release = globalOptions.release;
	
	        // Include server_name if it's defined in globalOptions
	        if (globalOptions.serverName) data.server_name = globalOptions.serverName;
	
	        if (isFunction(globalOptions.dataCallback)) {
	            data = globalOptions.dataCallback(data) || data;
	        }
	
	        // Why??????????
	        if (!data || isEmptyObject(data)) {
	            return;
	        }
	
	        // Check if the request should be filtered or not
	        if (isFunction(globalOptions.shouldSendCallback) && !globalOptions.shouldSendCallback(data)) {
	            return;
	        }
	
	        this._sendProcessedPayload(data);
	    },
	
	    _getUuid: function () {
	      return uuid4();
	    },
	
	    _sendProcessedPayload: function(data, callback) {
	        var self = this;
	        var globalOptions = this._globalOptions;
	
	        // Send along an event_id if not explicitly passed.
	        // This event_id can be used to reference the error within Sentry itself.
	        // Set lastEventId after we know the error should actually be sent
	        this._lastEventId = data.event_id || (data.event_id = this._getUuid());
	
	        // Try and clean up the packet before sending by truncating long values
	        data = this._trimPacket(data);
	
	        this._logDebug('debug', 'Raven about to send:', data);
	
	        if (!this.isSetup()) return;
	
	        var auth = {
	            sentry_version: '7',
	            sentry_client: 'raven-js/' + this.VERSION,
	            sentry_key: this._globalKey
	        };
	        if (this._globalSecret) {
	            auth.sentry_secret = this._globalSecret;
	        }
	
	        var exception = data.exception && data.exception.values[0];
	        this.captureBreadcrumb({
	            category: 'sentry',
	            message: exception
	                ? (exception.type ? exception.type + ': ' : '') + exception.value
	                : data.message,
	            event_id: data.event_id,
	            level: data.level || 'error' // presume error unless specified
	        });
	
	        var url = this._globalEndpoint;
	        (globalOptions.transport || this._makeRequest).call(this, {
	            url: url,
	            auth: auth,
	            data: data,
	            options: globalOptions,
	            onSuccess: function success() {
	                self._triggerEvent('success', {
	                    data: data,
	                    src: url
	                });
	                callback && callback();
	            },
	            onError: function failure(error) {
	                self._triggerEvent('failure', {
	                    data: data,
	                    src: url
	                });
	                error = error || new Error('Raven send failed (no additional details provided)');
	                callback && callback(error);
	            }
	        });
	    },
	
	    _makeRequest: function(opts) {
	        var request = new XMLHttpRequest();
	
	        // if browser doesn't support CORS (e.g. IE7), we are out of luck
	        var hasCORS =
	            'withCredentials' in request ||
	            typeof XDomainRequest !== 'undefined';
	
	        if (!hasCORS) return;
	
	        var url = opts.url;
	        function handler() {
	            if (request.status === 200) {
	                if (opts.onSuccess) {
	                    opts.onSuccess();
	                }
	            } else if (opts.onError) {
	                opts.onError(new Error('Sentry error code: ' + request.status));
	            }
	        }
	
	        if ('withCredentials' in request) {
	            request.onreadystatechange = function () {
	                if (request.readyState !== 4) {
	                    return;
	                }
	                handler();
	            };
	        } else {
	            request = new XDomainRequest();
	            // xdomainrequest cannot go http -> https (or vice versa),
	            // so always use protocol relative
	            url = url.replace(/^https?:/, '');
	
	            // onreadystatechange not supported by XDomainRequest
	            request.onload = handler;
	        }
	
	        // NOTE: auth is intentionally sent as part of query string (NOT as custom
	        //       HTTP header) so as to avoid preflight CORS requests
	        request.open('POST', url + '?' + urlencode(opts.auth));
	        request.send(stringify(opts.data));
	    },
	
	    _logDebug: function(level) {
	        if (this._originalConsoleMethods[level] && this.debug) {
	            // In IE<10 console methods do not have their own 'apply' method
	            Function.prototype.apply.call(
	                this._originalConsoleMethods[level],
	                this._originalConsole,
	                [].slice.call(arguments, 1)
	            );
	        }
	    },
	
	    _mergeContext: function(key, context) {
	        if (isUndefined(context)) {
	            delete this._globalContext[key];
	        } else {
	            this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
	        }
	    }
	};
	
	/*------------------------------------------------
	 * utils
	 *
	 * conditionally exported for test via Raven.utils
	 =================================================
	 */
	var objectPrototype = Object.prototype;
	
	function isUndefined(what) {
	    return what === void 0;
	}
	
	function isFunction(what) {
	    return typeof what === 'function';
	}
	
	function isString(what) {
	    return objectPrototype.toString.call(what) === '[object String]';
	}
	
	function isObject(what) {
	    return typeof what === 'object' && what !== null;
	}
	
	function isEmptyObject(what) {
	    for (var _ in what) return false;  // eslint-disable-line guard-for-in, no-unused-vars
	    return true;
	}
	
	// Sorta yanked from https://github.com/joyent/node/blob/aa3b4b4/lib/util.js#L560
	// with some tiny modifications
	function isError(what) {
	    var toString = objectPrototype.toString.call(what);
	    return isObject(what) &&
	        toString === '[object Error]' ||
	        toString === '[object Exception]' || // Firefox NS_ERROR_FAILURE Exceptions
	        what instanceof Error;
	}
	
	function each(obj, callback) {
	    var i, j;
	
	    if (isUndefined(obj.length)) {
	        for (i in obj) {
	            if (hasKey(obj, i)) {
	                callback.call(null, i, obj[i]);
	            }
	        }
	    } else {
	        j = obj.length;
	        if (j) {
	            for (i = 0; i < j; i++) {
	                callback.call(null, i, obj[i]);
	            }
	        }
	    }
	}
	
	function objectMerge(obj1, obj2) {
	    if (!obj2) {
	        return obj1;
	    }
	    each(obj2, function(key, value){
	        obj1[key] = value;
	    });
	    return obj1;
	}
	
	function truncate(str, max) {
	    return !max || str.length <= max ? str : str.substr(0, max) + '\u2026';
	}
	
	/**
	 * hasKey, a better form of hasOwnProperty
	 * Example: hasKey(MainHostObject, property) === true/false
	 *
	 * @param {Object} host object to check property
	 * @param {string} key to check
	 */
	function hasKey(object, key) {
	    return objectPrototype.hasOwnProperty.call(object, key);
	}
	
	function joinRegExp(patterns) {
	    // Combine an array of regular expressions and strings into one large regexp
	    // Be mad.
	    var sources = [],
	        i = 0, len = patterns.length,
	        pattern;
	
	    for (; i < len; i++) {
	        pattern = patterns[i];
	        if (isString(pattern)) {
	            // If it's a string, we need to escape it
	            // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
	            sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
	        } else if (pattern && pattern.source) {
	            // If it's a regexp already, we want to extract the source
	            sources.push(pattern.source);
	        }
	        // Intentionally skip other cases
	    }
	    return new RegExp(sources.join('|'), 'i');
	}
	
	function urlencode(o) {
	    var pairs = [];
	    each(o, function(key, value) {
	        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	    });
	    return pairs.join('&');
	}
	
	// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
	// intentionally using regex and not <a/> href parsing trick because React Native and other
	// environments where DOM might not be available
	function parseUrl(url) {
	    var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
	    if (!match) return {};
	
	    // coerce to undefined values to empty string so we don't get 'undefined'
	    var query = match[6] || '';
	    var fragment = match[8] || '';
	    return {
	        protocol: match[2],
	        host: match[4],
	        path: match[5],
	        relative: match[5] + query + fragment // everything minus origin
	    };
	}
	function uuid4() {
	    var crypto = _window.crypto || _window.msCrypto;
	
	    if (!isUndefined(crypto) && crypto.getRandomValues) {
	        // Use window.crypto API if available
	        var arr = new Uint16Array(8);
	        crypto.getRandomValues(arr);
	
	        // set 4 in byte 7
	        arr[3] = arr[3] & 0xFFF | 0x4000;
	        // set 2 most significant bits of byte 9 to '10'
	        arr[4] = arr[4] & 0x3FFF | 0x8000;
	
	        var pad = function(num) {
	            var v = num.toString(16);
	            while (v.length < 4) {
	                v = '0' + v;
	            }
	            return v;
	        };
	
	        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) +
	        pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
	    } else {
	        // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
	        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	            var r = Math.random()*16|0,
	                v = c === 'x' ? r : r&0x3|0x8;
	            return v.toString(16);
	        });
	    }
	}
	
	/**
	 * Given a child DOM element, returns a query-selector statement describing that
	 * and its ancestors
	 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
	 * @param elem
	 * @returns {string}
	 */
	function htmlTreeAsString(elem) {
	    /* eslint no-extra-parens:0*/
	    var MAX_TRAVERSE_HEIGHT = 5,
	        MAX_OUTPUT_LEN = 80,
	        out = [],
	        height = 0,
	        len = 0,
	        separator = ' > ',
	        sepLength = separator.length,
	        nextStr;
	
	    while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
	
	        nextStr = htmlElementAsString(elem);
	        // bail out if
	        // - nextStr is the 'html' element
	        // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
	        //   (ignore this limit if we are on the first iteration)
	        if (nextStr === 'html' || height > 1 && len + (out.length * sepLength) + nextStr.length >= MAX_OUTPUT_LEN) {
	            break;
	        }
	
	        out.push(nextStr);
	
	        len += nextStr.length;
	        elem = elem.parentNode;
	    }
	
	    return out.reverse().join(separator);
	}
	
	/**
	 * Returns a simple, query-selector representation of a DOM element
	 * e.g. [HTMLElement] => input#foo.btn[name=baz]
	 * @param HTMLElement
	 * @returns {string}
	 */
	function htmlElementAsString(elem) {
	    var out = [],
	        className,
	        classes,
	        key,
	        attr,
	        i;
	
	    if (!elem || !elem.tagName) {
	        return '';
	    }
	
	    out.push(elem.tagName.toLowerCase());
	    if (elem.id) {
	        out.push('#' + elem.id);
	    }
	
	    className = elem.className;
	    if (className && isString(className)) {
	        classes = className.split(' ');
	        for (i = 0; i < classes.length; i++) {
	            out.push('.' + classes[i]);
	        }
	    }
	    var attrWhitelist = ['type', 'name', 'title', 'alt'];
	    for (i = 0; i < attrWhitelist.length; i++) {
	        key = attrWhitelist[i];
	        attr = elem.getAttribute(key);
	        if (attr) {
	            out.push('[' + key + '="' + attr + '"]');
	        }
	    }
	    return out.join('');
	}
	
	/**
	 * Polyfill a method
	 * @param obj object e.g. `document`
	 * @param name method name present on object e.g. `addEventListener`
	 * @param replacement replacement function
	 * @param track {optional} record instrumentation to an array
	 */
	function fill(obj, name, replacement, track) {
	    var orig = obj[name];
	    obj[name] = replacement(orig);
	    if (track) {
	        track.push([obj, name, orig]);
	    }
	}
	
	if (typeof __DEV__ !== 'undefined' && __DEV__) {
	    Raven.utils = {
	        isUndefined: isUndefined,
	        isFunction: isFunction,
	        isString: isString,
	        isObject: isObject,
	        isEmptyObject: isEmptyObject,
	        isError: isError,
	        each: each,
	        objectMerge: objectMerge,
	        truncate: truncate,
	        hasKey: hasKey,
	        joinRegExp: joinRegExp,
	        urlencode: urlencode,
	        uuid4: uuid4,
	        htmlTreeAsString: htmlTreeAsString,
	        htmlElementAsString: htmlElementAsString,
	        parseUrl: parseUrl,
	        fill: fill
	    };
	};
	
	// Deprecations
	Raven.prototype.setUser = Raven.prototype.setUserContext;
	Raven.prototype.setReleaseContext = Raven.prototype.setRelease;
	
	module.exports = Raven;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Enforces a single instance of the Raven client, and the
	 * main entry point for Raven. If you are a consumer of the
	 * Raven library, you SHOULD load this file (vs raven.js).
	 **/
	
	'use strict';
	
	var RavenConstructor = __webpack_require__(647);
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window = typeof window !== 'undefined' ? window
	            : typeof global !== 'undefined' ? global
	            : typeof self !== 'undefined' ? self
	            : {};
	var _Raven = _window.Raven;
	
	var Raven = new RavenConstructor();
	
	/*
	 * Allow multiple versions of Raven to be installed.
	 * Strip Raven from the global context and returns the instance.
	 *
	 * @return {Raven}
	 */
	Raven.noConflict = function () {
		_window.Raven = _Raven;
		return Raven;
	};
	
	Raven.afterLoad();
	
	module.exports = Raven;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 649 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	/*
	 TraceKit - Cross brower stack traces - github.com/occ/TraceKit
	 MIT license
	*/
	
	var TraceKit = {
	    collectWindowErrors: true,
	    debug: false
	};
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window = typeof window !== 'undefined' ? window
	            : typeof global !== 'undefined' ? global
	            : typeof self !== 'undefined' ? self
	            : {};
	
	// global reference to slice
	var _slice = [].slice;
	var UNKNOWN_FUNCTION = '?';
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
	var ERROR_TYPES_RE = /^(?:Uncaught (?:exception: )?)?((?:Eval|Internal|Range|Reference|Syntax|Type|URI)Error): ?(.*)$/;
	
	function getLocationHref() {
	    if (typeof document === 'undefined' || typeof document.location === 'undefined')
	        return '';
	
	    return document.location.href;
	}
	
	/**
	 * TraceKit.report: cross-browser processing of unhandled exceptions
	 *
	 * Syntax:
	 *   TraceKit.report.subscribe(function(stackInfo) { ... })
	 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
	 *   TraceKit.report(exception)
	 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
	 *
	 * Supports:
	 *   - Firefox: full stack trace with line numbers, plus column number
	 *              on top frame; column number is not guaranteed
	 *   - Opera:   full stack trace with line and column numbers
	 *   - Chrome:  full stack trace with line and column numbers
	 *   - Safari:  line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *   - IE:      line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *
	 * In theory, TraceKit should work on all of the following versions:
	 *   - IE5.5+ (only 8.0 tested)
	 *   - Firefox 0.9+ (only 3.5+ tested)
	 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
	 *     Exceptions Have Stacktrace to be enabled in opera:config)
	 *   - Safari 3+ (only 4+ tested)
	 *   - Chrome 1+ (only 5+ tested)
	 *   - Konqueror 3.5+ (untested)
	 *
	 * Requires TraceKit.computeStackTrace.
	 *
	 * Tries to catch all unhandled exceptions and report them to the
	 * subscribed handlers. Please note that TraceKit.report will rethrow the
	 * exception. This is REQUIRED in order to get a useful stack trace in IE.
	 * If the exception does not reach the top of the browser, you will only
	 * get a stack trace from the point where TraceKit.report was called.
	 *
	 * Handlers receive a stackInfo object as described in the
	 * TraceKit.computeStackTrace docs.
	 */
	TraceKit.report = (function reportModuleWrapper() {
	    var handlers = [],
	        lastArgs = null,
	        lastException = null,
	        lastExceptionStack = null;
	
	    /**
	     * Add a crash handler.
	     * @param {Function} handler
	     */
	    function subscribe(handler) {
	        installGlobalHandler();
	        handlers.push(handler);
	    }
	
	    /**
	     * Remove a crash handler.
	     * @param {Function} handler
	     */
	    function unsubscribe(handler) {
	        for (var i = handlers.length - 1; i >= 0; --i) {
	            if (handlers[i] === handler) {
	                handlers.splice(i, 1);
	            }
	        }
	    }
	
	    /**
	     * Remove all crash handlers.
	     */
	    function unsubscribeAll() {
	        uninstallGlobalHandler();
	        handlers = [];
	    }
	
	    /**
	     * Dispatch stack information to all handlers.
	     * @param {Object.<string, *>} stack
	     */
	    function notifyHandlers(stack, isWindowError) {
	        var exception = null;
	        if (isWindowError && !TraceKit.collectWindowErrors) {
	          return;
	        }
	        for (var i in handlers) {
	            if (handlers.hasOwnProperty(i)) {
	                try {
	                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
	                } catch (inner) {
	                    exception = inner;
	                }
	            }
	        }
	
	        if (exception) {
	            throw exception;
	        }
	    }
	
	    var _oldOnerrorHandler, _onErrorHandlerInstalled;
	
	    /**
	     * Ensures all global unhandled exceptions are recorded.
	     * Supported by Gecko and IE.
	     * @param {string} message Error message.
	     * @param {string} url URL of script that generated the exception.
	     * @param {(number|string)} lineNo The line number at which the error
	     * occurred.
	     * @param {?(number|string)} colNo The column number at which the error
	     * occurred.
	     * @param {?Error} ex The actual Error object.
	     */
	    function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
	        var stack = null;
	
	        if (lastExceptionStack) {
	            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
	            processLastException();
	        } else if (ex) {
	            // New chrome and blink send along a real error object
	            // Let's just report that like a normal error.
	            // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
	            stack = TraceKit.computeStackTrace(ex);
	            notifyHandlers(stack, true);
	        } else {
	            var location = {
	                'url': url,
	                'line': lineNo,
	                'column': colNo
	            };
	
	            var name = undefined;
	            var msg = message; // must be new var or will modify original `arguments`
	            var groups;
	            if ({}.toString.call(message) === '[object String]') {
	                var groups = message.match(ERROR_TYPES_RE);
	                if (groups) {
	                    name = groups[1];
	                    msg = groups[2];
	                }
	            }
	
	            location.func = UNKNOWN_FUNCTION;
	
	            stack = {
	                'name': name,
	                'message': msg,
	                'url': getLocationHref(),
	                'stack': [location]
	            };
	            notifyHandlers(stack, true);
	        }
	
	        if (_oldOnerrorHandler) {
	            return _oldOnerrorHandler.apply(this, arguments);
	        }
	
	        return false;
	    }
	
	    function installGlobalHandler ()
	    {
	        if (_onErrorHandlerInstalled) {
	            return;
	        }
	        _oldOnerrorHandler = _window.onerror;
	        _window.onerror = traceKitWindowOnError;
	        _onErrorHandlerInstalled = true;
	    }
	
	    function uninstallGlobalHandler ()
	    {
	        if (!_onErrorHandlerInstalled) {
	            return;
	        }
	        _window.onerror = _oldOnerrorHandler;
	        _onErrorHandlerInstalled = false;
	        _oldOnerrorHandler = undefined;
	    }
	
	    function processLastException() {
	        var _lastExceptionStack = lastExceptionStack,
	            _lastArgs = lastArgs;
	        lastArgs = null;
	        lastExceptionStack = null;
	        lastException = null;
	        notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
	    }
	
	    /**
	     * Reports an unhandled Error to TraceKit.
	     * @param {Error} ex
	     * @param {?boolean} rethrow If false, do not re-throw the exception.
	     * Only used for window.onerror to not cause an infinite loop of
	     * rethrowing.
	     */
	    function report(ex, rethrow) {
	        var args = _slice.call(arguments, 1);
	        if (lastExceptionStack) {
	            if (lastException === ex) {
	                return; // already caught by an inner catch block, ignore
	            } else {
	              processLastException();
	            }
	        }
	
	        var stack = TraceKit.computeStackTrace(ex);
	        lastExceptionStack = stack;
	        lastException = ex;
	        lastArgs = args;
	
	        // If the stack trace is incomplete, wait for 2 seconds for
	        // slow slow IE to see if onerror occurs or not before reporting
	        // this exception; otherwise, we will end up with an incomplete
	        // stack trace
	        setTimeout(function () {
	            if (lastException === ex) {
	                processLastException();
	            }
	        }, (stack.incomplete ? 2000 : 0));
	
	        if (rethrow !== false) {
	            throw ex; // re-throw to propagate to the top level (and cause window.onerror)
	        }
	    }
	
	    report.subscribe = subscribe;
	    report.unsubscribe = unsubscribe;
	    report.uninstall = unsubscribeAll;
	    return report;
	}());
	
	/**
	 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
	 *
	 * Syntax:
	 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
	 * Returns:
	 *   s.name              - exception name
	 *   s.message           - exception message
	 *   s.stack[i].url      - JavaScript or HTML file URL
	 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
	 *   s.stack[i].args     - arguments passed to the function, if known
	 *   s.stack[i].line     - line number, if known
	 *   s.stack[i].column   - column number, if known
	 *
	 * Supports:
	 *   - Firefox:  full stack trace with line numbers and unreliable column
	 *               number on top frame
	 *   - Opera 10: full stack trace with line and column numbers
	 *   - Opera 9-: full stack trace with line numbers
	 *   - Chrome:   full stack trace with line and column numbers
	 *   - Safari:   line and column number for the topmost stacktrace element
	 *               only
	 *   - IE:       no line numbers whatsoever
	 *
	 * Tries to guess names of anonymous functions by looking for assignments
	 * in the source code. In IE and Safari, we have to guess source file names
	 * by searching for function bodies inside all page scripts. This will not
	 * work for scripts that are loaded cross-domain.
	 * Here be dragons: some function names may be guessed incorrectly, and
	 * duplicate functions may be mismatched.
	 *
	 * TraceKit.computeStackTrace should only be used for tracing purposes.
	 * Logging of unhandled exceptions should be done with TraceKit.report,
	 * which builds on top of TraceKit.computeStackTrace and provides better
	 * IE support by utilizing the window.onerror event to retrieve information
	 * about the top of the stack.
	 *
	 * Note: In IE and Safari, no stack trace is recorded on the Error object,
	 * so computeStackTrace instead walks its *own* chain of callers.
	 * This means that:
	 *  * in Safari, some methods may be missing from the stack trace;
	 *  * in IE, the topmost function in the stack trace will always be the
	 *    caller of computeStackTrace.
	 *
	 * This is okay for tracing (because you are likely to be calling
	 * computeStackTrace from the function you want to be the topmost element
	 * of the stack trace anyway), but not okay for logging unhandled
	 * exceptions (because your catch block will likely be far away from the
	 * inner function that actually caused the exception).
	 *
	 */
	TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
	    /**
	     * Escapes special characters, except for whitespace, in a string to be
	     * used inside a regular expression as a string literal.
	     * @param {string} text The string.
	     * @return {string} The escaped string literal.
	     */
	    function escapeRegExp(text) {
	        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
	    }
	
	    /**
	     * Escapes special characters in a string to be used inside a regular
	     * expression as a string literal. Also ensures that HTML entities will
	     * be matched the same as their literal friends.
	     * @param {string} body The string.
	     * @return {string} The escaped string.
	     */
	    function escapeCodeAsRegExpForMatchingInsideHTML(body) {
	        return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
	    }
	
	    // Contents of Exception in various browsers.
	    //
	    // SAFARI:
	    // ex.message = Can't find variable: qq
	    // ex.line = 59
	    // ex.sourceId = 580238192
	    // ex.sourceURL = http://...
	    // ex.expressionBeginOffset = 96
	    // ex.expressionCaretOffset = 98
	    // ex.expressionEndOffset = 98
	    // ex.name = ReferenceError
	    //
	    // FIREFOX:
	    // ex.message = qq is not defined
	    // ex.fileName = http://...
	    // ex.lineNumber = 59
	    // ex.columnNumber = 69
	    // ex.stack = ...stack trace... (see the example below)
	    // ex.name = ReferenceError
	    //
	    // CHROME:
	    // ex.message = qq is not defined
	    // ex.name = ReferenceError
	    // ex.type = not_defined
	    // ex.arguments = ['aa']
	    // ex.stack = ...stack trace...
	    //
	    // INTERNET EXPLORER:
	    // ex.message = ...
	    // ex.name = ReferenceError
	    //
	    // OPERA:
	    // ex.message = ...message... (see the example below)
	    // ex.name = ReferenceError
	    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
	    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
	
	    /**
	     * Computes stack trace information from the stack property.
	     * Chrome and Gecko use this property.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceFromStackProp(ex) {
	        if (typeof ex.stack === 'undefined' || !ex.stack) return;
	
	        var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|<anonymous>).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
	            gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i,
	            winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
	            lines = ex.stack.split('\n'),
	            stack = [],
	            parts,
	            element,
	            reference = /^(.*) is undefined$/.exec(ex.message);
	
	        for (var i = 0, j = lines.length; i < j; ++i) {
	            if ((parts = chrome.exec(lines[i]))) {
	                var isNative = parts[2] && parts[2].indexOf('native') !== -1;
	                element = {
	                    'url': !isNative ? parts[2] : null,
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': isNative ? [parts[2]] : [],
	                    'line': parts[3] ? +parts[3] : null,
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if ( parts = winjs.exec(lines[i]) ) {
	                element = {
	                    'url': parts[2],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': [],
	                    'line': +parts[3],
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if ((parts = gecko.exec(lines[i]))) {
	                element = {
	                    'url': parts[3],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': parts[2] ? parts[2].split(',') : [],
	                    'line': parts[4] ? +parts[4] : null,
	                    'column': parts[5] ? +parts[5] : null
	                };
	            } else {
	                continue;
	            }
	
	            if (!element.func && element.line) {
	                element.func = UNKNOWN_FUNCTION;
	            }
	
	            stack.push(element);
	        }
	
	        if (!stack.length) {
	            return null;
	        }
	
	        if (!stack[0].column && typeof ex.columnNumber !== 'undefined') {
	            // FireFox uses this awesome columnNumber property for its top frame
	            // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	            // so adding 1
	            stack[0].column = ex.columnNumber + 1;
	        }
	
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	    }
	
	    /**
	     * Adds information about the first frame to incomplete stack traces.
	     * Safari and IE require this to get complete data on the first frame.
	     * @param {Object.<string, *>} stackInfo Stack trace information from
	     * one of the compute* methods.
	     * @param {string} url The URL of the script that caused an error.
	     * @param {(number|string)} lineNo The line number of the script that
	     * caused an error.
	     * @param {string=} message The error generated by the browser, which
	     * hopefully contains the name of the object that caused the error.
	     * @return {boolean} Whether or not the stack information was
	     * augmented.
	     */
	    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
	        var initial = {
	            'url': url,
	            'line': lineNo
	        };
	
	        if (initial.url && initial.line) {
	            stackInfo.incomplete = false;
	
	            if (!initial.func) {
	                initial.func = UNKNOWN_FUNCTION;
	            }
	
	            if (stackInfo.stack.length > 0) {
	                if (stackInfo.stack[0].url === initial.url) {
	                    if (stackInfo.stack[0].line === initial.line) {
	                        return false; // already in stack trace
	                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
	                        stackInfo.stack[0].line = initial.line;
	                        return false;
	                    }
	                }
	            }
	
	            stackInfo.stack.unshift(initial);
	            stackInfo.partial = true;
	            return true;
	        } else {
	            stackInfo.incomplete = true;
	        }
	
	        return false;
	    }
	
	    /**
	     * Computes stack trace information by walking the arguments.caller
	     * chain at the time the exception occurred. This will cause earlier
	     * frames to be missed but is the only way to get any stack trace in
	     * Safari and IE. The top frame is restored by
	     * {@link augmentStackTraceWithInitialElement}.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceByWalkingCallerChain(ex, depth) {
	        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
	            stack = [],
	            funcs = {},
	            recursion = false,
	            parts,
	            item,
	            source;
	
	        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
	            if (curr === computeStackTrace || curr === TraceKit.report) {
	                // console.log('skipping internal function');
	                continue;
	            }
	
	            item = {
	                'url': null,
	                'func': UNKNOWN_FUNCTION,
	                'line': null,
	                'column': null
	            };
	
	            if (curr.name) {
	                item.func = curr.name;
	            } else if ((parts = functionName.exec(curr.toString()))) {
	                item.func = parts[1];
	            }
	
	            if (typeof item.func === 'undefined') {
	              try {
	                item.func = parts.input.substring(0, parts.input.indexOf('{'));
	              } catch (e) { }
	            }
	
	            if (funcs['' + curr]) {
	                recursion = true;
	            }else{
	                funcs['' + curr] = true;
	            }
	
	            stack.push(item);
	        }
	
	        if (depth) {
	            // console.log('depth is ' + depth);
	            // console.log('stack is ' + stack.length);
	            stack.splice(0, depth);
	        }
	
	        var result = {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
	        return result;
	    }
	
	    /**
	     * Computes a stack trace for an exception.
	     * @param {Error} ex
	     * @param {(string|number)=} depth
	     */
	    function computeStackTrace(ex, depth) {
	        var stack = null;
	        depth = (depth == null ? 0 : +depth);
	
	        try {
	            stack = computeStackTraceFromStackProp(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        try {
	            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref()
	        };
	    }
	
	    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
	    computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
	
	    return computeStackTrace;
	}());
	
	module.exports = TraceKit;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domAlign = __webpack_require__(505);
	
	var _domAlign2 = _interopRequireDefault(_domAlign);
	
	var _addEventListener = __webpack_require__(323);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _isWindow = __webpack_require__(652);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function buffer(fn, ms) {
	  var timer = void 0;
	
	  function clear() {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  }
	
	  function bufferFn() {
	    clear();
	    timer = setTimeout(fn, ms);
	  }
	
	  bufferFn.clear = clear;
	
	  return bufferFn;
	}
	
	var Align = _react2["default"].createClass({
	  displayName: 'Align',
	
	  propTypes: {
	    childrenProps: _react.PropTypes.object,
	    align: _react.PropTypes.object.isRequired,
	    target: _react.PropTypes.func,
	    onAlign: _react.PropTypes.func,
	    monitorBufferTime: _react.PropTypes.number,
	    monitorWindowResize: _react.PropTypes.bool,
	    disabled: _react.PropTypes.bool,
	    children: _react.PropTypes.any
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      target: function target() {
	        return window;
	      },
	      onAlign: function onAlign() {},
	
	      monitorBufferTime: 50,
	      monitorWindowResize: false,
	      disabled: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var props = this.props;
	    // if parent ref not attached .... use document.getElementById
	    this.forceAlign();
	    if (!props.disabled && props.monitorWindowResize) {
	      this.startMonitorWindowResize();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var reAlign = false;
	    var props = this.props;
	
	    if (!props.disabled) {
	      if (prevProps.disabled || prevProps.align !== props.align) {
	        reAlign = true;
	      } else {
	        var lastTarget = prevProps.target();
	        var currentTarget = props.target();
	        if ((0, _isWindow2["default"])(lastTarget) && (0, _isWindow2["default"])(currentTarget)) {
	          reAlign = false;
	        } else if (lastTarget !== currentTarget) {
	          reAlign = true;
	        }
	      }
	    }
	
	    if (reAlign) {
	      this.forceAlign();
	    }
	
	    if (props.monitorWindowResize && !props.disabled) {
	      this.startMonitorWindowResize();
	    } else {
	      this.stopMonitorWindowResize();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.stopMonitorWindowResize();
	  },
	  startMonitorWindowResize: function startMonitorWindowResize() {
	    if (!this.resizeHandler) {
	      this.bufferMonitor = buffer(this.forceAlign, this.props.monitorBufferTime);
	      this.resizeHandler = (0, _addEventListener2["default"])(window, 'resize', this.bufferMonitor);
	    }
	  },
	  stopMonitorWindowResize: function stopMonitorWindowResize() {
	    if (this.resizeHandler) {
	      this.bufferMonitor.clear();
	      this.resizeHandler.remove();
	      this.resizeHandler = null;
	    }
	  },
	  forceAlign: function forceAlign() {
	    var props = this.props;
	    if (!props.disabled) {
	      var source = _reactDom2["default"].findDOMNode(this);
	      props.onAlign(source, (0, _domAlign2["default"])(source, props.target(), props.align));
	    }
	  },
	  render: function render() {
	    var _props = this.props,
	        childrenProps = _props.childrenProps,
	        children = _props.children;
	
	    var child = _react2["default"].Children.only(children);
	    if (childrenProps) {
	      var newProps = {};
	      for (var prop in childrenProps) {
	        if (childrenProps.hasOwnProperty(prop)) {
	          newProps[prop] = this.props[childrenProps[prop]];
	        }
	      }
	      return _react2["default"].cloneElement(child, newProps);
	    }
	    return child;
	  }
	});
	
	exports["default"] = Align;
	module.exports = exports['default'];

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Align = __webpack_require__(650);
	
	var _Align2 = _interopRequireDefault(_Align);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _Align2["default"]; // export this package's api
	
	module.exports = exports['default'];

/***/ },
/* 652 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isWindow;
	function isWindow(obj) {
	  /* eslint no-eq-null: 0 */
	  /* eslint eqeqeq: 0 */
	  return obj != null && obj == obj.window;
	}
	module.exports = exports['default'];

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChildrenUtils = __webpack_require__(655);
	
	var _AnimateChild = __webpack_require__(654);
	
	var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
	
	var _util = __webpack_require__(321);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultKey = 'rc_animate_' + Date.now();
	
	
	function getChildrenFromProps(props) {
	  var children = props.children;
	  if (_react2["default"].isValidElement(children)) {
	    if (!children.key) {
	      return _react2["default"].cloneElement(children, {
	        key: defaultKey
	      });
	    }
	  }
	  return children;
	}
	
	function noop() {}
	
	var Animate = _react2["default"].createClass({
	  displayName: 'Animate',
	
	  propTypes: {
	    component: _react2["default"].PropTypes.any,
	    animation: _react2["default"].PropTypes.object,
	    transitionName: _react2["default"].PropTypes.oneOfType([_react2["default"].PropTypes.string, _react2["default"].PropTypes.object]),
	    transitionEnter: _react2["default"].PropTypes.bool,
	    transitionAppear: _react2["default"].PropTypes.bool,
	    exclusive: _react2["default"].PropTypes.bool,
	    transitionLeave: _react2["default"].PropTypes.bool,
	    onEnd: _react2["default"].PropTypes.func,
	    onEnter: _react2["default"].PropTypes.func,
	    onLeave: _react2["default"].PropTypes.func,
	    onAppear: _react2["default"].PropTypes.func,
	    showProp: _react2["default"].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      animation: {},
	      component: 'span',
	      transitionEnter: true,
	      transitionLeave: true,
	      transitionAppear: false,
	      onEnd: noop,
	      onEnter: noop,
	      onLeave: noop,
	      onAppear: noop
	    };
	  },
	  getInitialState: function getInitialState() {
	    this.currentlyAnimatingKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	    return {
	      children: (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(this.props))
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var showProp = this.props.showProp;
	    var children = this.state.children;
	    if (showProp) {
	      children = children.filter(function (child) {
	        return !!child.props[showProp];
	      });
	    }
	    children.forEach(function (child) {
	      if (child) {
	        _this.performAppear(child.key);
	      }
	    });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    this.nextProps = nextProps;
	    var nextChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(nextProps));
	    var props = this.props;
	    // exclusive needs immediate response
	    if (props.exclusive) {
	      Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
	        _this2.stop(key);
	      });
	    }
	    var showProp = props.showProp;
	    var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
	    // last props children if exclusive
	    var currentChildren = props.exclusive ? (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props)) : this.state.children;
	    // in case destroy in showProp mode
	    var newChildren = [];
	    if (showProp) {
	      currentChildren.forEach(function (currentChild) {
	        var nextChild = currentChild && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, currentChild.key);
	        var newChild = void 0;
	        if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
	          newChild = _react2["default"].cloneElement(nextChild || currentChild, _defineProperty({}, showProp, true));
	        } else {
	          newChild = nextChild;
	        }
	        if (newChild) {
	          newChildren.push(newChild);
	        }
	      });
	      nextChildren.forEach(function (nextChild) {
	        if (!nextChild || !(0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, nextChild.key)) {
	          newChildren.push(nextChild);
	        }
	      });
	    } else {
	      newChildren = (0, _ChildrenUtils.mergeChildren)(currentChildren, nextChildren);
	    }
	
	    // need render to avoid update
	    this.setState({
	      children: newChildren
	    });
	
	    nextChildren.forEach(function (child) {
	      var key = child && child.key;
	      if (child && currentlyAnimatingKeys[key]) {
	        return;
	      }
	      var hasPrev = child && (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	      if (showProp) {
	        var showInNext = child.props[showProp];
	        if (hasPrev) {
	          var showInNow = (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	          if (!showInNow && showInNext) {
	            _this2.keysToEnter.push(key);
	          }
	        } else if (showInNext) {
	          _this2.keysToEnter.push(key);
	        }
	      } else if (!hasPrev) {
	        _this2.keysToEnter.push(key);
	      }
	    });
	
	    currentChildren.forEach(function (child) {
	      var key = child && child.key;
	      if (child && currentlyAnimatingKeys[key]) {
	        return;
	      }
	      var hasNext = child && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, key);
	      if (showProp) {
	        var showInNow = child.props[showProp];
	        if (hasNext) {
	          var showInNext = (0, _ChildrenUtils.findShownChildInChildrenByKey)(nextChildren, key, showProp);
	          if (!showInNext && showInNow) {
	            _this2.keysToLeave.push(key);
	          }
	        } else if (showInNow) {
	          _this2.keysToLeave.push(key);
	        }
	      } else if (!hasNext) {
	        _this2.keysToLeave.push(key);
	      }
	    });
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  },
	  performEnter: function performEnter(key) {
	    // may already remove by exclusive
	    if (this.refs[key]) {
	      this.currentlyAnimatingKeys[key] = true;
	      this.refs[key].componentWillEnter(this.handleDoneAdding.bind(this, key, 'enter'));
	    }
	  },
	  performAppear: function performAppear(key) {
	    if (this.refs[key]) {
	      this.currentlyAnimatingKeys[key] = true;
	      this.refs[key].componentWillAppear(this.handleDoneAdding.bind(this, key, 'appear'));
	    }
	  },
	  handleDoneAdding: function handleDoneAdding(key, type) {
	    var props = this.props;
	    delete this.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== this.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    if (!this.isValidChildByKey(currentChildren, key)) {
	      // exclusive will not need this
	      this.performLeave(key);
	    } else {
	      if (type === 'appear') {
	        if (_util2["default"].allowAppearCallback(props)) {
	          props.onAppear(key);
	          props.onEnd(key, true);
	        }
	      } else {
	        if (_util2["default"].allowEnterCallback(props)) {
	          props.onEnter(key);
	          props.onEnd(key, true);
	        }
	      }
	    }
	  },
	  performLeave: function performLeave(key) {
	    // may already remove by exclusive
	    if (this.refs[key]) {
	      this.currentlyAnimatingKeys[key] = true;
	      this.refs[key].componentWillLeave(this.handleDoneLeaving.bind(this, key));
	    }
	  },
	  handleDoneLeaving: function handleDoneLeaving(key) {
	    var props = this.props;
	    delete this.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== this.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    // in case state change is too fast
	    if (this.isValidChildByKey(currentChildren, key)) {
	      this.performEnter(key);
	    } else {
	      var end = function end() {
	        if (_util2["default"].allowLeaveCallback(props)) {
	          props.onLeave(key);
	          props.onEnd(key, false);
	        }
	      };
	      /* eslint react/no-is-mounted:0 */
	      if (this.isMounted() && !(0, _ChildrenUtils.isSameChildren)(this.state.children, currentChildren, props.showProp)) {
	        this.setState({
	          children: currentChildren
	        }, end);
	      } else {
	        end();
	      }
	    }
	  },
	  isValidChildByKey: function isValidChildByKey(currentChildren, key) {
	    var showProp = this.props.showProp;
	    if (showProp) {
	      return (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	    }
	    return (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	  },
	  stop: function stop(key) {
	    delete this.currentlyAnimatingKeys[key];
	    var component = this.refs[key];
	    if (component) {
	      component.stop();
	    }
	  },
	  render: function render() {
	    var props = this.props;
	    this.nextProps = props;
	    var stateChildren = this.state.children;
	    var children = null;
	    if (stateChildren) {
	      children = stateChildren.map(function (child) {
	        if (child === null || child === undefined) {
	          return child;
	        }
	        if (!child.key) {
	          throw new Error('must set key for <rc-animate> children');
	        }
	        return _react2["default"].createElement(
	          _AnimateChild2["default"],
	          {
	            key: child.key,
	            ref: child.key,
	            animation: props.animation,
	            transitionName: props.transitionName,
	            transitionEnter: props.transitionEnter,
	            transitionAppear: props.transitionAppear,
	            transitionLeave: props.transitionLeave
	          },
	          child
	        );
	      });
	    }
	    var Component = props.component;
	    if (Component) {
	      var passedProps = props;
	      if (typeof Component === 'string') {
	        passedProps = {
	          className: props.className,
	          style: props.style
	        };
	      }
	      return _react2["default"].createElement(
	        Component,
	        passedProps,
	        children
	      );
	    }
	    return children[0] || null;
	  }
	});
	
	exports["default"] = Animate;
	module.exports = exports['default'];

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _cssAnimation = __webpack_require__(489);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	var _util = __webpack_require__(321);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var transitionMap = {
	  enter: 'transitionEnter',
	  appear: 'transitionAppear',
	  leave: 'transitionLeave'
	};
	
	var AnimateChild = _react2["default"].createClass({
	  displayName: 'AnimateChild',
	
	  propTypes: {
	    children: _react2["default"].PropTypes.any
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.stop();
	  },
	  componentWillEnter: function componentWillEnter(done) {
	    if (_util2["default"].isEnterSupported(this.props)) {
	      this.transition('enter', done);
	    } else {
	      done();
	    }
	  },
	  componentWillAppear: function componentWillAppear(done) {
	    if (_util2["default"].isAppearSupported(this.props)) {
	      this.transition('appear', done);
	    } else {
	      done();
	    }
	  },
	  componentWillLeave: function componentWillLeave(done) {
	    if (_util2["default"].isLeaveSupported(this.props)) {
	      this.transition('leave', done);
	    } else {
	      // always sync, do not interupt with react component life cycle
	      // update hidden -> animate hidden ->
	      // didUpdate -> animate leave -> unmount (if animate is none)
	      done();
	    }
	  },
	  transition: function transition(animationType, finishCallback) {
	    var _this = this;
	
	    var node = _reactDom2["default"].findDOMNode(this);
	    var props = this.props;
	    var transitionName = props.transitionName;
	    var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : _typeof(transitionName)) === 'object';
	    this.stop();
	    var end = function end() {
	      _this.stopper = null;
	      finishCallback();
	    };
	    if ((_cssAnimation.isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
	      var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
	      var activeName = name + '-active';
	      if (nameIsObj && transitionName[animationType + 'Active']) {
	        activeName = transitionName[animationType + 'Active'];
	      }
	      this.stopper = (0, _cssAnimation2["default"])(node, {
	        name: name,
	        active: activeName
	      }, end);
	    } else {
	      this.stopper = props.animation[animationType](node, end);
	    }
	  },
	  stop: function stop() {
	    var stopper = this.stopper;
	    if (stopper) {
	      this.stopper = null;
	      stopper.stop();
	    }
	  },
	  render: function render() {
	    return this.props.children;
	  }
	});
	
	exports["default"] = AnimateChild;
	module.exports = exports['default'];

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toArrayChildren = toArrayChildren;
	exports.findChildInChildrenByKey = findChildInChildrenByKey;
	exports.findShownChildInChildrenByKey = findShownChildInChildrenByKey;
	exports.findHiddenChildInChildrenByKey = findHiddenChildInChildrenByKey;
	exports.isSameChildren = isSameChildren;
	exports.mergeChildren = mergeChildren;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function toArrayChildren(children) {
	  var ret = [];
	  _react2["default"].Children.forEach(children, function (child) {
	    ret.push(child);
	  });
	  return ret;
	}
	
	function findChildInChildrenByKey(children, key) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (ret) {
	        return;
	      }
	      if (child && child.key === key) {
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findShownChildInChildrenByKey(children, key, showProp) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (child && child.key === key && child.props[showProp]) {
	        if (ret) {
	          throw new Error('two child with same key for <rc-animate> children');
	        }
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findHiddenChildInChildrenByKey(children, key, showProp) {
	  var found = 0;
	  if (children) {
	    children.forEach(function (child) {
	      if (found) {
	        return;
	      }
	      found = child && child.key === key && !child.props[showProp];
	    });
	  }
	  return found;
	}
	
	function isSameChildren(c1, c2, showProp) {
	  var same = c1.length === c2.length;
	  if (same) {
	    c1.forEach(function (child, index) {
	      var child2 = c2[index];
	      if (child && child2) {
	        if (child && !child2 || !child && child2) {
	          same = false;
	        } else if (child.key !== child2.key) {
	          same = false;
	        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
	          same = false;
	        }
	      }
	    });
	  }
	  return same;
	}
	
	function mergeChildren(prev, next) {
	  var ret = [];
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextChildrenPending = {};
	  var pendingChildren = [];
	  prev.forEach(function (child) {
	    if (child && findChildInChildrenByKey(next, child.key)) {
	      if (pendingChildren.length) {
	        nextChildrenPending[child.key] = pendingChildren;
	        pendingChildren = [];
	      }
	    } else {
	      pendingChildren.push(child);
	    }
	  });
	
	  next.forEach(function (child) {
	    if (child && nextChildrenPending.hasOwnProperty(child.key)) {
	      ret = ret.concat(nextChildrenPending[child.key]);
	    }
	    ret.push(child);
	  });
	
	  ret = ret.concat(pendingChildren);
	
	  return ret;
	}

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// export this package's api
	module.exports = __webpack_require__(653);

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _placements = __webpack_require__(658);
	
	var _rcTrigger = __webpack_require__(662);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Tooltip = _react2["default"].createClass({
	  displayName: 'Tooltip',
	
	  propTypes: {
	    trigger: _react.PropTypes.any,
	    children: _react.PropTypes.any,
	    defaultVisible: _react.PropTypes.bool,
	    visible: _react.PropTypes.bool,
	    placement: _react.PropTypes.string,
	    transitionName: _react.PropTypes.string,
	    animation: _react.PropTypes.any,
	    onVisibleChange: _react.PropTypes.func,
	    afterVisibleChange: _react.PropTypes.func,
	    overlay: _react.PropTypes.oneOfType([_react2["default"].PropTypes.node, _react2["default"].PropTypes.func]).isRequired,
	    overlayStyle: _react.PropTypes.object,
	    overlayClassName: _react.PropTypes.string,
	    prefixCls: _react.PropTypes.string,
	    mouseEnterDelay: _react.PropTypes.number,
	    mouseLeaveDelay: _react.PropTypes.number,
	    getTooltipContainer: _react.PropTypes.func,
	    destroyTooltipOnHide: _react.PropTypes.bool,
	    align: _react.PropTypes.object,
	    arrowContent: _react.PropTypes.any
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      prefixCls: 'rc-tooltip',
	      mouseEnterDelay: 0,
	      destroyTooltipOnHide: false,
	      mouseLeaveDelay: 0.1,
	      align: {},
	      placement: 'right',
	      trigger: ['hover'],
	      arrowContent: null
	    };
	  },
	  getPopupElement: function getPopupElement() {
	    var _props = this.props;
	    var arrowContent = _props.arrowContent;
	    var overlay = _props.overlay;
	    var prefixCls = _props.prefixCls;
	
	    return [_react2["default"].createElement(
	      'div',
	      { className: prefixCls + '-arrow', key: 'arrow' },
	      arrowContent
	    ), _react2["default"].createElement(
	      'div',
	      { className: prefixCls + '-inner', key: 'content' },
	      typeof overlay === 'function' ? overlay() : overlay
	    )];
	  },
	  getPopupDomNode: function getPopupDomNode() {
	    return this.refs.trigger.getPopupDomNode();
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var overlayClassName = _props2.overlayClassName;
	    var trigger = _props2.trigger;
	    var mouseEnterDelay = _props2.mouseEnterDelay;
	    var mouseLeaveDelay = _props2.mouseLeaveDelay;
	    var overlayStyle = _props2.overlayStyle;
	    var prefixCls = _props2.prefixCls;
	    var children = _props2.children;
	    var onVisibleChange = _props2.onVisibleChange;
	    var transitionName = _props2.transitionName;
	    var animation = _props2.animation;
	    var placement = _props2.placement;
	    var align = _props2.align;
	    var destroyTooltipOnHide = _props2.destroyTooltipOnHide;
	    var defaultVisible = _props2.defaultVisible;
	    var getTooltipContainer = _props2.getTooltipContainer;
	
	    var restProps = _objectWithoutProperties(_props2, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);
	
	    var extraProps = _extends({}, restProps);
	    if ('visible' in this.props) {
	      extraProps.popupVisible = this.props.visible;
	    }
	    return _react2["default"].createElement(
	      _rcTrigger2["default"],
	      _extends({
	        popupClassName: overlayClassName,
	        ref: 'trigger',
	        prefixCls: prefixCls,
	        popup: this.getPopupElement,
	        action: trigger,
	        builtinPlacements: _placements.placements,
	        popupPlacement: placement,
	        popupAlign: align,
	        getPopupContainer: getTooltipContainer,
	        onPopupVisibleChange: onVisibleChange,
	        popupTransitionName: transitionName,
	        popupAnimation: animation,
	        defaultPopupVisible: defaultVisible,
	        destroyPopupOnHide: destroyTooltipOnHide,
	        mouseLeaveDelay: mouseLeaveDelay,
	        popupStyle: overlayStyle,
	        mouseEnterDelay: mouseEnterDelay
	      }, extraProps),
	      children
	    );
	  }
	});
	
	exports["default"] = Tooltip;
	module.exports = exports['default'];

/***/ },
/* 658 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	
	var targetOffset = [0, 0];
	
	var placements = exports.placements = {
	  left: {
	    points: ['cr', 'cl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  right: {
	    points: ['cl', 'cr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  top: {
	    points: ['bc', 'tc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  bottom: {
	    points: ['tc', 'bc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  leftTop: {
	    points: ['tr', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  rightTop: {
	    points: ['tl', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  rightBottom: {
	    points: ['bl', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  leftBottom: {
	    points: ['br', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  }
	};
	
	exports["default"] = placements;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(115);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcAlign = __webpack_require__(651);
	
	var _rcAlign2 = _interopRequireDefault(_rcAlign);
	
	var _rcAnimate = __webpack_require__(656);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _PopupInner = __webpack_require__(660);
	
	var _PopupInner2 = _interopRequireDefault(_PopupInner);
	
	var _LazyRenderBox = __webpack_require__(322);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Popup = _react2["default"].createClass({
	  displayName: 'Popup',
	
	  propTypes: {
	    visible: _react.PropTypes.bool,
	    style: _react.PropTypes.object,
	    getClassNameFromAlign: _react.PropTypes.func,
	    onAlign: _react.PropTypes.func,
	    getRootDomNode: _react.PropTypes.func,
	    onMouseEnter: _react.PropTypes.func,
	    align: _react.PropTypes.any,
	    destroyPopupOnHide: _react.PropTypes.bool,
	    className: _react.PropTypes.string,
	    prefixCls: _react.PropTypes.string,
	    onMouseLeave: _react.PropTypes.func
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.rootNode = this.getPopupDomNode();
	  },
	  onAlign: function onAlign(popupDomNode, align) {
	    var props = this.props;
	    var alignClassName = props.getClassNameFromAlign(props.align);
	    var currentAlignClassName = props.getClassNameFromAlign(align);
	    if (alignClassName !== currentAlignClassName) {
	      this.currentAlignClassName = currentAlignClassName;
	      popupDomNode.className = this.getClassName(currentAlignClassName);
	    }
	    props.onAlign(popupDomNode, align);
	  },
	  getPopupDomNode: function getPopupDomNode() {
	    return _reactDom2["default"].findDOMNode(this.refs.popup);
	  },
	  getTarget: function getTarget() {
	    return this.props.getRootDomNode();
	  },
	  getMaskTransitionName: function getMaskTransitionName() {
	    var props = this.props;
	    var transitionName = props.maskTransitionName;
	    var animation = props.maskAnimation;
	    if (!transitionName && animation) {
	      transitionName = props.prefixCls + '-' + animation;
	    }
	    return transitionName;
	  },
	  getTransitionName: function getTransitionName() {
	    var props = this.props;
	    var transitionName = props.transitionName;
	    if (!transitionName && props.animation) {
	      transitionName = props.prefixCls + '-' + props.animation;
	    }
	    return transitionName;
	  },
	  getClassName: function getClassName(currentAlignClassName) {
	    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
	  },
	  getPopupElement: function getPopupElement() {
	    var props = this.props;
	    var align = props.align,
	        style = props.style,
	        visible = props.visible,
	        prefixCls = props.prefixCls,
	        destroyPopupOnHide = props.destroyPopupOnHide;
	
	    var className = this.getClassName(this.currentAlignClassName || props.getClassNameFromAlign(align));
	    var hiddenClassName = prefixCls + '-hidden';
	    if (!visible) {
	      this.currentAlignClassName = null;
	    }
	    var newStyle = (0, _extends3["default"])({}, style, this.getZIndexStyle());
	    var popupInnerProps = {
	      className: className,
	      prefixCls: prefixCls,
	      ref: 'popup',
	      onMouseEnter: props.onMouseEnter,
	      onMouseLeave: props.onMouseLeave,
	      style: newStyle
	    };
	    if (destroyPopupOnHide) {
	      return _react2["default"].createElement(
	        _rcAnimate2["default"],
	        {
	          component: '',
	          exclusive: true,
	          transitionAppear: true,
	          transitionName: this.getTransitionName()
	        },
	        visible ? _react2["default"].createElement(
	          _rcAlign2["default"],
	          {
	            target: this.getTarget,
	            key: 'popup',
	            ref: this.saveAlign,
	            monitorWindowResize: true,
	            align: align,
	            onAlign: this.onAlign
	          },
	          _react2["default"].createElement(
	            _PopupInner2["default"],
	            (0, _extends3["default"])({
	              visible: true
	            }, popupInnerProps),
	            props.children
	          )
	        ) : null
	      );
	    }
	    return _react2["default"].createElement(
	      _rcAnimate2["default"],
	      {
	        component: '',
	        exclusive: true,
	        transitionAppear: true,
	        transitionName: this.getTransitionName(),
	        showProp: 'xVisible'
	      },
	      _react2["default"].createElement(
	        _rcAlign2["default"],
	        {
	          target: this.getTarget,
	          key: 'popup',
	          ref: this.saveAlign,
	          monitorWindowResize: true,
	          xVisible: visible,
	          childrenProps: { visible: 'xVisible' },
	          disabled: !visible,
	          align: align,
	          onAlign: this.onAlign
	        },
	        _react2["default"].createElement(
	          _PopupInner2["default"],
	          (0, _extends3["default"])({
	            hiddenClassName: hiddenClassName
	          }, popupInnerProps),
	          props.children
	        )
	      )
	    );
	  },
	  getZIndexStyle: function getZIndexStyle() {
	    var style = {};
	    var props = this.props;
	    if (props.zIndex !== undefined) {
	      style.zIndex = props.zIndex;
	    }
	    return style;
	  },
	  getMaskElement: function getMaskElement() {
	    var props = this.props;
	    var maskElement = void 0;
	    if (props.mask) {
	      var maskTransition = this.getMaskTransitionName();
	      maskElement = _react2["default"].createElement(_LazyRenderBox2["default"], {
	        style: this.getZIndexStyle(),
	        key: 'mask',
	        className: props.prefixCls + '-mask',
	        hiddenClassName: props.prefixCls + '-mask-hidden',
	        visible: props.visible
	      });
	      if (maskTransition) {
	        maskElement = _react2["default"].createElement(
	          _rcAnimate2["default"],
	          {
	            key: 'mask',
	            showProp: 'visible',
	            transitionAppear: true,
	            component: '',
	            transitionName: maskTransition
	          },
	          maskElement
	        );
	      }
	    }
	    return maskElement;
	  },
	  saveAlign: function saveAlign(align) {
	    this.alignInstance = align;
	  },
	  render: function render() {
	    return _react2["default"].createElement(
	      'div',
	      null,
	      this.getMaskElement(),
	      this.getPopupElement()
	    );
	  }
	});
	
	exports["default"] = Popup;
	module.exports = exports['default'];

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LazyRenderBox = __webpack_require__(322);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var PopupInner = _react2["default"].createClass({
	  displayName: 'PopupInner',
	
	  propTypes: {
	    hiddenClassName: _react.PropTypes.string,
	    className: _react.PropTypes.string,
	    prefixCls: _react.PropTypes.string,
	    onMouseEnter: _react.PropTypes.func,
	    onMouseLeave: _react.PropTypes.func,
	    children: _react.PropTypes.any
	  },
	  render: function render() {
	    var props = this.props;
	    var className = props.className;
	    if (!props.visible) {
	      className += ' ' + props.hiddenClassName;
	    }
	    return _react2["default"].createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave,
	        style: props.style
	      },
	      _react2["default"].createElement(
	        _LazyRenderBox2["default"],
	        { className: props.prefixCls + '-content', visible: props.visible },
	        props.children
	      )
	    );
	  }
	});
	
	exports["default"] = PopupInner;
	module.exports = exports['default'];

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(115);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _contains = __webpack_require__(664);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _addEventListener = __webpack_require__(323);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _Popup = __webpack_require__(659);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _utils = __webpack_require__(663);
	
	var _getContainerRenderMixin = __webpack_require__(665);
	
	var _getContainerRenderMixin2 = _interopRequireDefault(_getContainerRenderMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function noop() {}
	
	function returnEmptyString() {
	  return '';
	}
	
	var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur'];
	
	var Trigger = _react2["default"].createClass({
	  displayName: 'Trigger',
	
	  propTypes: {
	    children: _react.PropTypes.any,
	    action: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]),
	    showAction: _react.PropTypes.any,
	    hideAction: _react.PropTypes.any,
	    getPopupClassNameFromAlign: _react.PropTypes.any,
	    onPopupVisibleChange: _react.PropTypes.func,
	    afterPopupVisibleChange: _react.PropTypes.func,
	    popup: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.func]).isRequired,
	    popupStyle: _react.PropTypes.object,
	    prefixCls: _react.PropTypes.string,
	    popupClassName: _react.PropTypes.string,
	    popupPlacement: _react.PropTypes.string,
	    builtinPlacements: _react.PropTypes.object,
	    popupTransitionName: _react.PropTypes.string,
	    popupAnimation: _react.PropTypes.any,
	    mouseEnterDelay: _react.PropTypes.number,
	    mouseLeaveDelay: _react.PropTypes.number,
	    zIndex: _react.PropTypes.number,
	    focusDelay: _react.PropTypes.number,
	    blurDelay: _react.PropTypes.number,
	    getPopupContainer: _react.PropTypes.func,
	    destroyPopupOnHide: _react.PropTypes.bool,
	    mask: _react.PropTypes.bool,
	    maskClosable: _react.PropTypes.bool,
	    onPopupAlign: _react.PropTypes.func,
	    popupAlign: _react.PropTypes.object,
	    popupVisible: _react.PropTypes.bool,
	    maskTransitionName: _react.PropTypes.string,
	    maskAnimation: _react.PropTypes.string
	  },
	
	  mixins: [(0, _getContainerRenderMixin2["default"])({
	    autoMount: false,
	
	    isVisible: function isVisible(instance) {
	      return instance.state.popupVisible;
	    },
	    getContainer: function getContainer(instance) {
	      var popupContainer = document.createElement('div');
	      var mountNode = instance.props.getPopupContainer ? instance.props.getPopupContainer((0, _reactDom.findDOMNode)(instance)) : document.body;
	      mountNode.appendChild(popupContainer);
	      return popupContainer;
	    }
	  })],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      prefixCls: 'rc-trigger-popup',
	      getPopupClassNameFromAlign: returnEmptyString,
	      onPopupVisibleChange: noop,
	      afterPopupVisibleChange: noop,
	      onPopupAlign: noop,
	      popupClassName: '',
	      mouseEnterDelay: 0,
	      mouseLeaveDelay: 0.1,
	      focusDelay: 0,
	      blurDelay: 0.15,
	      popupStyle: {},
	      destroyPopupOnHide: false,
	      popupAlign: {},
	      defaultPopupVisible: false,
	      mask: false,
	      maskClosable: true,
	      action: [],
	      showAction: [],
	      hideAction: []
	    };
	  },
	  getInitialState: function getInitialState() {
	    var props = this.props;
	    var popupVisible = void 0;
	    if ('popupVisible' in props) {
	      popupVisible = !!props.popupVisible;
	    } else {
	      popupVisible = !!props.defaultPopupVisible;
	    }
	    return {
	      popupVisible: popupVisible
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    ALL_HANDLERS.forEach(function (h) {
	      _this['fire' + h] = function (e) {
	        _this.fireEvents(h, e);
	      };
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    this.componentDidUpdate({}, {
	      popupVisible: this.state.popupVisible
	    });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
	    var popupVisible = _ref.popupVisible;
	
	    if (popupVisible !== undefined) {
	      this.setState({
	        popupVisible: popupVisible
	      });
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(_, prevState) {
	    var props = this.props;
	    var state = this.state;
	    this.renderComponent(null, function () {
	      if (prevState.popupVisible !== state.popupVisible) {
	        props.afterPopupVisibleChange(state.popupVisible);
	      }
	    });
	    if (this.isClickToHide()) {
	      if (state.popupVisible) {
	        if (!this.clickOutsideHandler) {
	          this.clickOutsideHandler = (0, _addEventListener2["default"])(document, 'mousedown', this.onDocumentClick);
	          this.touchOutsideHandler = (0, _addEventListener2["default"])(document, 'touchstart', this.onDocumentClick);
	        }
	        return;
	      }
	    }
	    if (this.clickOutsideHandler) {
	      this.clickOutsideHandler.remove();
	      this.touchOutsideHandler.remove();
	      this.clickOutsideHandler = null;
	      this.touchOutsideHandler = null;
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.clearDelayTimer();
	    if (this.clickOutsideHandler) {
	      this.clickOutsideHandler.remove();
	      this.touchOutsideHandler.remove();
	      this.clickOutsideHandler = null;
	      this.touchOutsideHandler = null;
	    }
	  },
	  onMouseEnter: function onMouseEnter(e) {
	    this.fireEvents('onMouseEnter', e);
	    this.delaySetPopupVisible(true, this.props.mouseEnterDelay);
	  },
	  onMouseLeave: function onMouseLeave(e) {
	    this.fireEvents('onMouseLeave', e);
	    this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
	  },
	  onPopupMouseEnter: function onPopupMouseEnter() {
	    this.clearDelayTimer();
	  },
	  onPopupMouseLeave: function onPopupMouseLeave(e) {
	    // https://github.com/react-component/trigger/pull/13
	    // react bug?
	    if (e.relatedTarget && !e.relatedTarget.setTimeout && this._component && (0, _contains2["default"])(this._component.getPopupDomNode(), e.relatedTarget)) {
	      return;
	    }
	    this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
	  },
	  onFocus: function onFocus(e) {
	    this.fireEvents('onFocus', e);
	    // incase focusin and focusout
	    this.clearDelayTimer();
	    if (this.isFocusToShow()) {
	      this.focusTime = Date.now();
	      this.delaySetPopupVisible(true, this.props.focusDelay);
	    }
	  },
	  onMouseDown: function onMouseDown(e) {
	    this.fireEvents('onMouseDown', e);
	    this.preClickTime = Date.now();
	  },
	  onTouchStart: function onTouchStart(e) {
	    this.fireEvents('onTouchStart', e);
	    this.preTouchTime = Date.now();
	  },
	  onBlur: function onBlur(e) {
	    this.fireEvents('onBlur', e);
	    this.clearDelayTimer();
	    if (this.isBlurToHide()) {
	      this.delaySetPopupVisible(false, this.props.blurDelay);
	    }
	  },
	  onClick: function onClick(event) {
	    this.fireEvents('onClick', event);
	    // focus will trigger click
	    if (this.focusTime) {
	      var preTime = void 0;
	      if (this.preClickTime && this.preTouchTime) {
	        preTime = Math.min(this.preClickTime, this.preTouchTime);
	      } else if (this.preClickTime) {
	        preTime = this.preClickTime;
	      } else if (this.preTouchTime) {
	        preTime = this.preTouchTime;
	      }
	      if (Math.abs(preTime - this.focusTime) < 20) {
	        return;
	      }
	      this.focusTime = 0;
	    }
	    this.preClickTime = 0;
	    this.preTouchTime = 0;
	    event.preventDefault();
	    var nextVisible = !this.state.popupVisible;
	    if (this.isClickToHide() && !nextVisible || nextVisible && this.isClickToShow()) {
	      this.setPopupVisible(!this.state.popupVisible);
	    }
	  },
	  onDocumentClick: function onDocumentClick(event) {
	    if (this.props.mask && !this.props.maskClosable) {
	      return;
	    }
	    var target = event.target;
	    var root = (0, _reactDom.findDOMNode)(this);
	    var popupNode = this.getPopupDomNode();
	    if (!(0, _contains2["default"])(root, target) && !(0, _contains2["default"])(popupNode, target)) {
	      this.close();
	    }
	  },
	  getPopupDomNode: function getPopupDomNode() {
	    // for test
	    if (this._component) {
	      return this._component.isMounted() ? this._component.getPopupDomNode() : null;
	    }
	    return null;
	  },
	  getRootDomNode: function getRootDomNode() {
	    return _reactDom2["default"].findDOMNode(this);
	  },
	  getPopupClassNameFromAlign: function getPopupClassNameFromAlign(align) {
	    var className = [];
	    var props = this.props;
	    var popupPlacement = props.popupPlacement,
	        builtinPlacements = props.builtinPlacements,
	        prefixCls = props.prefixCls;
	
	    if (popupPlacement && builtinPlacements) {
	      className.push((0, _utils.getPopupClassNameFromAlign)(builtinPlacements, prefixCls, align));
	    }
	    if (props.getPopupClassNameFromAlign) {
	      className.push(props.getPopupClassNameFromAlign(align));
	    }
	    return className.join(' ');
	  },
	  getPopupAlign: function getPopupAlign() {
	    var props = this.props;
	    var popupPlacement = props.popupPlacement,
	        popupAlign = props.popupAlign,
	        builtinPlacements = props.builtinPlacements;
	
	    if (popupPlacement && builtinPlacements) {
	      return (0, _utils.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
	    }
	    return popupAlign;
	  },
	  getComponent: function getComponent() {
	    var props = this.props,
	        state = this.state;
	
	    var mouseProps = {};
	    if (this.isMouseEnterToShow()) {
	      mouseProps.onMouseEnter = this.onPopupMouseEnter;
	    }
	    if (this.isMouseLeaveToHide()) {
	      mouseProps.onMouseLeave = this.onPopupMouseLeave;
	    }
	    return _react2["default"].createElement(
	      _Popup2["default"],
	      (0, _extends3["default"])({
	        prefixCls: props.prefixCls,
	        destroyPopupOnHide: props.destroyPopupOnHide,
	        visible: state.popupVisible,
	        className: props.popupClassName,
	        action: props.action,
	        align: this.getPopupAlign(),
	        onAlign: props.onPopupAlign,
	        animation: props.popupAnimation,
	        getClassNameFromAlign: this.getPopupClassNameFromAlign
	      }, mouseProps, {
	        getRootDomNode: this.getRootDomNode,
	        style: props.popupStyle,
	        mask: props.mask,
	        zIndex: props.zIndex,
	        transitionName: props.popupTransitionName,
	        maskAnimation: props.maskAnimation,
	        maskTransitionName: props.maskTransitionName
	      }),
	      typeof props.popup === 'function' ? props.popup() : props.popup
	    );
	  },
	  setPopupVisible: function setPopupVisible(popupVisible) {
	    this.clearDelayTimer();
	    if (this.state.popupVisible !== popupVisible) {
	      if (!('popupVisible' in this.props)) {
	        this.setState({
	          popupVisible: popupVisible
	        });
	      }
	      this.props.onPopupVisibleChange(popupVisible);
	    }
	  },
	  delaySetPopupVisible: function delaySetPopupVisible(visible, delayS) {
	    var _this2 = this;
	
	    var delay = delayS * 1000;
	    this.clearDelayTimer();
	    if (delay) {
	      this.delayTimer = setTimeout(function () {
	        _this2.setPopupVisible(visible);
	        _this2.clearDelayTimer();
	      }, delay);
	    } else {
	      this.setPopupVisible(visible);
	    }
	  },
	  clearDelayTimer: function clearDelayTimer() {
	    if (this.delayTimer) {
	      clearTimeout(this.delayTimer);
	      this.delayTimer = null;
	    }
	  },
	  createTwoChains: function createTwoChains(event) {
	    var childPros = this.props.children.props;
	    var props = this.props;
	    if (childPros[event] && props[event]) {
	      return this['fire' + event];
	    }
	    return childPros[event] || props[event];
	  },
	  isClickToShow: function isClickToShow() {
	    var _props = this.props,
	        action = _props.action,
	        showAction = _props.showAction;
	
	    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
	  },
	  isClickToHide: function isClickToHide() {
	    var _props2 = this.props,
	        action = _props2.action,
	        hideAction = _props2.hideAction;
	
	    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
	  },
	  isMouseEnterToShow: function isMouseEnterToShow() {
	    var _props3 = this.props,
	        action = _props3.action,
	        showAction = _props3.showAction;
	
	    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
	  },
	  isMouseLeaveToHide: function isMouseLeaveToHide() {
	    var _props4 = this.props,
	        action = _props4.action,
	        hideAction = _props4.hideAction;
	
	    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
	  },
	  isFocusToShow: function isFocusToShow() {
	    var _props5 = this.props,
	        action = _props5.action,
	        showAction = _props5.showAction;
	
	    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
	  },
	  isBlurToHide: function isBlurToHide() {
	    var _props6 = this.props,
	        action = _props6.action,
	        hideAction = _props6.hideAction;
	
	    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
	  },
	  forcePopupAlign: function forcePopupAlign() {
	    if (this.state.popupVisible && this.popupInstance && this.popupInstance.alignInstance) {
	      this.popupInstance.alignInstance.forceAlign();
	    }
	  },
	  fireEvents: function fireEvents(type, e) {
	    var childCallback = this.props.children.props[type];
	    if (childCallback) {
	      childCallback(e);
	    }
	    var callback = this.props[type];
	    if (callback) {
	      callback(e);
	    }
	  },
	  close: function close() {
	    this.setPopupVisible(false);
	  },
	  render: function render() {
	    var props = this.props;
	    var children = props.children;
	    var child = _react2["default"].Children.only(children);
	    var newChildProps = {};
	
	    if (this.isClickToHide() || this.isClickToShow()) {
	      newChildProps.onClick = this.onClick;
	      newChildProps.onMouseDown = this.onMouseDown;
	      newChildProps.onTouchStart = this.onTouchStart;
	    } else {
	      newChildProps.onClick = this.createTwoChains('onClick');
	      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
	      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
	    }
	    if (this.isMouseEnterToShow()) {
	      newChildProps.onMouseEnter = this.onMouseEnter;
	    } else {
	      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
	    }
	    if (this.isMouseLeaveToHide()) {
	      newChildProps.onMouseLeave = this.onMouseLeave;
	    } else {
	      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
	    }
	    if (this.isFocusToShow() || this.isBlurToHide()) {
	      newChildProps.onFocus = this.onFocus;
	      newChildProps.onBlur = this.onBlur;
	    } else {
	      newChildProps.onFocus = this.createTwoChains('onFocus');
	      newChildProps.onBlur = this.createTwoChains('onBlur');
	    }
	
	    return _react2["default"].cloneElement(child, newChildProps);
	  }
	});
	
	exports["default"] = Trigger;
	module.exports = exports['default'];

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(661);

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(115);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getAlignFromPlacement = getAlignFromPlacement;
	exports.getPopupClassNameFromAlign = getPopupClassNameFromAlign;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function isPointsEq(a1, a2) {
	  return a1[0] === a2[0] && a1[1] === a2[1];
	}
	
	function getAlignFromPlacement(builtinPlacements, placementStr, align) {
	  var baseAlign = builtinPlacements[placementStr] || {};
	  return (0, _extends3["default"])({}, baseAlign, align);
	}
	
	function getPopupClassNameFromAlign(builtinPlacements, prefixCls, align) {
	  var points = align.points;
	  for (var placement in builtinPlacements) {
	    if (builtinPlacements.hasOwnProperty(placement)) {
	      if (isPointsEq(builtinPlacements[placement].points, points)) {
	        return prefixCls + '-placement-' + placement;
	      }
	    }
	  }
	  return '';
	}

/***/ },
/* 664 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = contains;
	function contains(root, n) {
	  var node = n;
	  while (node) {
	    if (node === root) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = getContainerRenderMixin;
	
	var _reactDom = __webpack_require__(46);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function defaultGetContainer() {
	  var container = document.createElement('div');
	  document.body.appendChild(container);
	  return container;
	}
	
	function getContainerRenderMixin(config) {
	  var _config$autoMount = config.autoMount,
	      autoMount = _config$autoMount === undefined ? true : _config$autoMount,
	      _config$autoDestroy = config.autoDestroy,
	      autoDestroy = _config$autoDestroy === undefined ? true : _config$autoDestroy,
	      isVisible = config.isVisible,
	      getComponent = config.getComponent,
	      _config$getContainer = config.getContainer,
	      getContainer = _config$getContainer === undefined ? defaultGetContainer : _config$getContainer;
	
	
	  var mixin = void 0;
	
	  function _renderComponent(instance, componentArg, ready) {
	    if (!isVisible || instance._component || isVisible(instance)) {
	      if (!instance._container) {
	        instance._container = getContainer(instance);
	      }
	      var component = void 0;
	      if (instance.getComponent) {
	        component = instance.getComponent(componentArg);
	      } else {
	        component = getComponent(instance, componentArg);
	      }
	      _reactDom2["default"].unstable_renderSubtreeIntoContainer(instance, component, instance._container, function callback() {
	        instance._component = this;
	        if (ready) {
	          ready.call(this);
	        }
	      });
	    }
	  }
	
	  if (autoMount) {
	    mixin = _extends({}, mixin, {
	      componentDidMount: function componentDidMount() {
	        _renderComponent(this);
	      },
	      componentDidUpdate: function componentDidUpdate() {
	        _renderComponent(this);
	      }
	    });
	  }
	
	  if (!autoMount || !autoDestroy) {
	    mixin = _extends({}, mixin, {
	      renderComponent: function renderComponent(componentArg, ready) {
	        _renderComponent(this, componentArg, ready);
	      }
	    });
	  }
	
	  function _removeContainer(instance) {
	    if (instance._container) {
	      var container = instance._container;
	      _reactDom2["default"].unmountComponentAtNode(container);
	      container.parentNode.removeChild(container);
	      instance._container = null;
	    }
	  }
	
	  if (autoDestroy) {
	    mixin = _extends({}, mixin, {
	      componentWillUnmount: function componentWillUnmount() {
	        _removeContainer(this);
	      }
	    });
	  } else {
	    mixin = _extends({}, mixin, {
	      removeContainer: function removeContainer() {
	        _removeContainer(this);
	      }
	    });
	  }
	
	  return mixin;
	}
	module.exports = exports['default'];

/***/ },
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(637);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var MultiToggle = function MultiToggle(_ref) {
	  var selectedOption = _ref.selectedOption,
	      options = _ref.options,
	      onSelectOption = _ref.onSelectOption,
	      className = _ref.className,
	      label = _ref.label;
	
	  // If required variables aren't passed, return empty
	  if (!options || selectedOption === null) return null;
	
	  var numOptions = options.length;
	
	  var columnWidth = numOptions ? 100 / numOptions : numOptions;
	
	  var isSelectedOption = function isSelectedOption(option) {
	    return option.value == selectedOption;
	  };
	
	  var getSelectedIndex = function getSelectedIndex() {
	    var indexFound = options.findIndex(function (option) {
	      return isSelectedOption(option);
	    });
	    return indexFound > -1 ? indexFound : 0;
	  };
	
	  var createToggleOption = function createToggleOption() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var selectOption = function selectOption() {
	      return onSelectOption(args[0].value);
	    };
	
	    var optionClass = (0, _classnames2.default)('toggleOption', { selected: isSelectedOption(args[0]) });
	    var optionStyle = {
	      width: columnWidth + '%'
	    };
	    return React.createElement(
	      'div',
	      {
	        key: args[1],
	        onClick: selectOption,
	        className: optionClass,
	        style: optionStyle
	      },
	      args[0].displayName || args[0].value
	    );
	  };
	
	  var toggleClass = (0, _classnames2.default)('toggleContainer', className);
	  var toggleStyle = {
	    width: columnWidth + '%',
	    transform: 'translateX(' + 100 * getSelectedIndex() + '%)',
	    WebkitTransform: 'translateX(' + 100 * getSelectedIndex() + '%)',
	    MozTransform: 'translateX(' + 100 * getSelectedIndex() + '%)',
	    msTransform: 'translateX(' + 100 * getSelectedIndex() + '%)'
	  };
	
	  var selectedToggleClass = (0, _classnames2.default)('toggle', options[getSelectedIndex()].optionClass);
	
	  var renderLabel = label ? React.createElement(
	    'label',
	    null,
	    label
	  ) : null;
	
	  return React.createElement(
	    'div',
	    { className: 'toggle-wrapper' },
	    renderLabel,
	    React.createElement(
	      'div',
	      { className: toggleClass },
	      options.map(createToggleOption),
	      React.createElement('div', { className: selectedToggleClass, style: toggleStyle })
	    )
	  );
	};
	
	MultiToggle.propTypes = {
	  className: _propTypes2.default.any,
	  options: _propTypes2.default.array.isRequired,
	  selectedOption: _propTypes2.default.any.isRequired,
	  onSelectOption: _propTypes2.default.func,
	  label: _propTypes2.default.any
	};
	
	exports.default = MultiToggle;


/***/ },
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'svg',
	    { width: '14', height: '11', viewBox: '0 0 14 11' },
	    _react2.default.createElement(
	      'title',
	      null,
	      'switch-check'
	    ),
	    _react2.default.createElement('path', { d: 'M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0', fill: '#fff', fillRule: 'evenodd' })
	  );
	};

/***/ },
/* 718 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pointerCoord = pointerCoord;
	// Copyright 2015-present Drifty Co.
	// http://drifty.com/
	// from: https://github.com/driftyco/ionic/blob/master/src/util/dom.ts
	
	function pointerCoord(event) {
	  // get coordinates for either a mouse click
	  // or a touch depending on the given event
	  if (event) {
	    var changedTouches = event.changedTouches;
	    if (changedTouches && changedTouches.length > 0) {
	      var touch = changedTouches[0];
	      return { x: touch.clientX, y: touch.clientY };
	    }
	    var pageX = event.pageX;
	    if (pageX !== undefined) {
	      return { x: pageX, y: event.pageY };
	    }
	  }
	  return { x: 0, y: 0 };
	}

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'svg',
	    { width: '10', height: '10', viewBox: '0 0 10 10' },
	    _react2.default.createElement(
	      'title',
	      null,
	      'switch-x'
	    ),
	    _react2.default.createElement('path', { d: 'M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12', fill: '#fff', fillRule: 'evenodd' })
	  );
	};

/***/ },
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "images/66ee7409200351021b29f8e298a1601f.png";

/***/ },
/* 875 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 876 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }
]);


/** WEBPACK FOOTER **
 ** index.min.e6e52258.js
 **/